const menu=[
    // 20241225224258
// https://www.swiggy.com/mapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=20.2959847&lng=85.8246101&restaurantId=559248

{
    "statusCode": 0,
    "data": {
      "statusMessage": "done successfully",
      "cards": [
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2",
              "text": "Domino's Pizza",
              "headerStyling": {
                "textColor": "text_Highest_Emphasis",
                "textVariant": "header_H3_Black"
              }
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.RestaurantBlTab",
              "tabs": [
                {
                  "id": "Order Online",
                  "title": "Order Online"
                }
              ]
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
              "info": {
                "id": "559248",
                "name": "Domino's Pizza",
                "city": "Bhubaneswar",
                "slugs": {
                  "restaurant": "dominos-pizza-pal-heights-sahid-nagar",
                  "city": "bhubaneswar"
                },
                "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
                "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/11/29/31c3b0a6-17ff-4afd-8c96-7b9a7aba1e51_559248.jpg",
                "locality": "Jayadev Vihar",
                "areaName": "Saheed Nagar",
                "costForTwo": "40000",
                "costForTwoMessage": "₹400 for two",
                "cuisines": [
                  "Pizzas",
                  "Italian"
                ],
                "avgRating": 4.5,
                "feeDetails": {
                  "restaurantId": "559248",
                  "icon": "dominos_cod_xc6inc"
                },
                "parentId": "2456",
                "avgRatingString": "4.5",
                "totalRatingsString": "1.7K+ ratings",
                "sla": {
                  "restaurantId": "559248",
                  "deliveryTime": 25,
                  "minDeliveryTime": 20,
                  "maxDeliveryTime": 25,
                  "lastMileTravel": 0.4,
                  "serviceability": "SERVICEABLE",
                  "rainMode": "RAIN_MODE_LIGHT",
                  "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                  "zoneId": 692,
                  "slaString": "20-25 MINS",
                  "lastMileTravelString": "0.4 km",
                  "iconType": "ICON_TYPE_EMPTY"
                },
                "availability": {
                  "nextCloseTime": "2024-12-26 02:57:00",
                  "visibility": true,
                  "opened": true,
                  "restaurantClosedMeta": {
                    
                  }
                },
                "aggregatedDiscountInfo": {
                  "header": "Get items under 89",
                  "shortDescriptionList": [
                    {
                      "meta": "Get items under 89",
                      "discountType": "FinalPrice",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "Flat ₹200 off on orders above ₹1099",
                      "discountType": "Flat",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "descriptionList": [
                    {
                      "meta": "Get items under 89",
                      "discountType": "FinalPrice",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "Flat ₹200 off on orders above ₹1099| Use code CELEBRATION",
                      "discountType": "Flat",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "visible": true
                },
                "badges": {
                  
                },
                "slugString": "dominos-pizza-pal-heights-sahid-nagar",
                "isOpen": true,
                "labels": [
                  {
                    "title": "Timings",
                    "message": "null"
                  },
                  {
                    "title": "Address",
                    "message": "First Floor, PAL Heights, J/7, Jayadev Vihar,Bhubaneswar 751013, Odisha"
                  },
                  {
                    "title": "Cuisines",
                    "message": "Pizzas,Italian"
                  }
                ],
                "totalRatings": 1700,
                "aggregatedDiscountInfoV2": {
                  "header": "Get items under 89",
                  "shortDescriptionList": [
                    {
                      "meta": "Get items under 89",
                      "discountType": "FinalPrice",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "Flat ₹200 off on orders above ₹1099",
                      "discountType": "Flat",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "descriptionList": [
                    {
                      "meta": "Get items under 89",
                      "discountType": "FinalPrice",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "Flat ₹200 off on orders above ₹1099| Use code CELEBRATION",
                      "discountType": "Flat",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "couponDetailsCta": "View coupon details"
                },
                "type": "F",
                "nudgeBanners": [
                  {
                    "minValue": 769,
                    "maxValue": 1099,
                    "priority": 4,
                    "couponCode": "CELEBRATIONS",
                    "discountInfo": {
                      "discountType": "Flat",
                      "value": 200
                    },
                    "lockedMessage": "Add items worth ₹<amount> to save ₹200 | Code CELEBRATIONS",
                    "unlockedMessage": "CELEBRATIONS Coupon Unlocked! Use it to save ₹200",
                    "logoCtx": {
                      
                    }
                  },
                  {
                    "minValue": 1749,
                    "maxValue": 2499,
                    "priority": 5,
                    "couponCode": "XTRAPARTY",
                    "discountInfo": {
                      "discountType": "Percentage",
                      "value": 20
                    },
                    "lockedMessage": "Add items worth ₹<amount> to unlock flat 20% off | Code XTRAPARTY",
                    "unlockedMessage": "XTRAPARTY Coupon Unlocked! Use it to save flat 20% off",
                    "logoCtx": {
                      
                    }
                  }
                ],
                "headerBanner": {
                  "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/559248"
                },
                "ratingSlab": "RATING_SLAB_5",
                "orderabilityCommunication": {
                  "title": {
                    
                  },
                  "subTitle": {
                    
                  },
                  "message": {
                    
                  },
                  "customIcon": {
                    
                  },
                  "commsStyling": {
                    
                  }
                },
                "hasBestsellerItems": true,
                "cartOrderabilityNudgeBanner": {
                  "parameters": {
                    
                  },
                  "presentation": {
                    
                  }
                },
                "latLong": "20.299203,85.823148",
                "backgroundImageOverlayInfo": {
                  
                },
                "featuredSectionInfo": {
                  
                }
              },
              "analytics": {
                
              }
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
              "layout": {
                "rows": 1,
                "columns": 5,
                "horizontalScrollEnabled": true,
                "itemSpacing": 12,
                "lineSpacing": 10,
                "widgetPadding": {
                  
                },
                "containerStyle": {
                  "containerPadding": {
                    "left": 10,
                    "right": 10
                  }
                },
                "scrollBar": {
                  "scrollThumbColor": "#E46D47",
                  "scrollTrackColor": "#e4e4e4",
                  "width": 54,
                  "height": 4,
                  "scrollStyling": {
                    "padding": {
                      "top": 20,
                      "bottom": 20
                    }
                  }
                }
              },
              "id": "offerCollectionWidget",
              "gridElements": {
                "infoWithStyle": {
                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                  "offers": [
                    {
                      "info": {
                        "header": "ITEMS AT ₹89",
                        "offerTag": "DEAL OF DAY",
                        "offerTagColor": "#E46D47",
                        "offerIds": [
                          "52e79f9e-aa2a-4de7-8224-9a004d3bffc0"
                        ],
                        "expiryTime": "1970-01-01T05:16:08Z",
                        "description": "ON SELECT ITEMS |",
                        "offerType": "offers",
                        "restId": "559248",
                        "offerLogo": "offers/deal-of-day",
                        "descriptionTextColor": "#7302060C",
                        "showExpiryTimer": true
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "FLAT ₹200 OFF",
                        "offerTag": "FLAT DEAL",
                        "offerTagColor": "#E46D47",
                        "offerIds": [
                          "9e068ff6-faeb-42c9-b158-02aa5ddb59d2"
                        ],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE CELEBRATIONS",
                        "description": "ABOVE ₹1099",
                        "offerType": "offers",
                        "restId": "559248",
                        "offerLogo": "offers/generic",
                        "descriptionTextColor": "#7302060C"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "FLAT 20% OFF",
                        "offerTag": "FLAT DEAL",
                        "offerTagColor": "#E46D47",
                        "offerIds": [
                          "d7861ccc-57b9-4444-83b5-5e49e0b9ea88"
                        ],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE XTRAPARTY",
                        "description": "ABOVE ₹2499",
                        "offerType": "offers",
                        "restId": "559248",
                        "offerLogo": "offers/generic",
                        "descriptionTextColor": "#7302060C"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "15% OFF UPTO ₹150",
                        "offerTagColor": "#E46D47",
                        "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2024/12/18/3af21c4c-e42a-4ed7-93f0-53458f60edda_HSBC.png",
                        "offerIds": [
                          "773fb69b-3a7c-4bfe-a4b1-5ab0fa7ca8dd"
                        ],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE HSBCDELIGHTS",
                        "description": "ABOVE ₹499",
                        "offerType": "offers",
                        "restId": "559248",
                        "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2024/12/18/3af21c4c-e42a-4ed7-93f0-53458f60edda_HSBC.png",
                        "descriptionTextColor": "#7302060C"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "10% OFF UPTO ₹150",
                        "offerTagColor": "#E46D47",
                        "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2024/11/30/3125048a-92eb-48ea-991c-fd25fe159d24_HSBC.png",
                        "offerIds": [
                          "f2aa5806-6b90-43c8-9c37-8cd046879568"
                        ],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE HSBCFEST",
                        "description": "ABOVE ₹499",
                        "offerType": "offers",
                        "restId": "559248",
                        "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2024/11/30/3125048a-92eb-48ea-991c-fd25fe159d24_HSBC.png",
                        "descriptionTextColor": "#7302060C"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    }
                  ],
                  "habitMilestoneInfo": {
                    "callout": {
                      
                    }
                  },
                  "loyaltyDiscoverPresentationInfo": {
                    "logoCtx": {
                      
                    }
                  }
                }
              }
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuTab",
              "tabs": [
                {
                  "id": "REGULAR",
                  "title": "Full Menu",
                  "selected": true,
                  "analytics": {
                    
                  },
                  "selectedImage": "v1594205104/fullMenuActive_qcsdzt.png",
                  "unselectedImage": "v1594205107/fullMenuInactive_fbdtp2.png"
                }
              ]
            }
          }
        },
        {
          "groupedCard": {
            "cardGroupMap": {
              "REGULAR": {
                "cards": [
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                        "badges": {
                          
                        },
                        "vegOnlyDetails": {
                          "imageId": "AutoVegOnly_qkjowj",
                          "title": "Showing only vegetarian options.",
                          "description": "Tap on the VEG ONLY button to turn off the setting"
                        },
                        "topRatedFilter": {
                          "attributes": {
                            "displayText": "Ratings 4.0+"
                          }
                        },
                        "kidsCategoryFilter": {
                          "attributes": {
                            "displayText": "Kids Favourites",
                            "tooltip": {
                              "enabled": true,
                              "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                            }
                          }
                        },
                        "vegFilter": {
                          "attributes": {
                            "displayText": "VEG"
                          },
                          "isSelected": true
                        },
                        "nonvegFilter": {
                          "attributes": {
                            "displayText": "NONVEG"
                          }
                        }
                      },
                      "relevance": {
                        "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                        "sectionId": "MENU_FILTER_TOGGLE"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                        "title": "Top Picks",
                        "carousel": [
                          {
                            "type": "TopCarousel",
                            "subtype": "image",
                            "bannerId": "4134126",
                            "creativeId": "TopPicks/FmC1",
                            "title": "Farmhouse Cheese Burst",
                            "description": "  ",
                            "fontColor": "#FFFFFF",
                            "dish": {
                              "info": {
                                "id": "153334589",
                                "name": "Farmhouse Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with combination of onion, capsicum, tomato & grilled mushroom",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/75e4a60b-8bec-47ab-90c9-b4e70df170d7_06d705be-4b9f-4e93-b1cb-5c97123bfb12.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617947",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661297",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617948",
                                            "variationId": "155661301"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661298",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617948",
                                            "variationId": "155661301"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661299",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617948",
                                            "variationId": "155661301"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661300",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617948",
                                            "variationId": "155661301"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617948",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661301",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661302",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617947",
                                          "variationId": "155661298"
                                        },
                                        {
                                          "groupId": "49617948",
                                          "variationId": "155661301"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882388",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617947",
                                          "variationId": "155661298"
                                        },
                                        {
                                          "groupId": "49617948",
                                          "variationId": "155661302"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882394",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617947",
                                          "variationId": "155661299"
                                        },
                                        {
                                          "groupId": "49617948",
                                          "variationId": "155661301"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882388",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617947",
                                          "variationId": "155661299"
                                        },
                                        {
                                          "groupId": "49617948",
                                          "variationId": "155661302"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882394",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617947",
                                          "variationId": "155661300"
                                        },
                                        {
                                          "groupId": "49617948",
                                          "variationId": "155661301"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882388",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617947",
                                          "variationId": "155661300"
                                        },
                                        {
                                          "groupId": "49617948",
                                          "variationId": "155661302"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882394",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617947",
                                          "variationId": "155661297"
                                        },
                                        {
                                          "groupId": "49617948",
                                          "variationId": "155661301"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882388",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617947",
                                          "variationId": "155661297"
                                        },
                                        {
                                          "groupId": "49617948",
                                          "variationId": "155661302"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882394",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882388",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882389",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882392",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882394",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882396",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882399",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 35400,
                                "ribbon": {
                                  
                                },
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "type": "TopCarousel",
                            "subtype": "image",
                            "bannerId": "4134637",
                            "creativeId": "TopPicks/ICTB3",
                            "title": "Indi Chicken Tikka Cheese Burst",
                            "description": "  ",
                            "fontColor": "#FFFFFF",
                            "dish": {
                              "info": {
                                "id": "153334573",
                                "name": "Indi Chicken Tikka Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with wholesome flavour of tandoori masala topped with Chicken tikka, onion, red paprika & mint mayo",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/6b860839-56b2-4729-a0cb-ab5086fa49d4_5cac9a1b-ed2c-4a95-bb30-8586499e4f01.jpg",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617916",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661194",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617917",
                                            "variationId": "155661202"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661197",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617917",
                                            "variationId": "155661202"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661199",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617917",
                                            "variationId": "155661202"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661200",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617917",
                                            "variationId": "155661202"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617917",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661202",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661203",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617916",
                                          "variationId": "155661200"
                                        },
                                        {
                                          "groupId": "49617917",
                                          "variationId": "155661203"
                                        }
                                      ],
                                      "price": 72800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882297",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617916",
                                          "variationId": "155661194"
                                        },
                                        {
                                          "groupId": "49617917",
                                          "variationId": "155661202"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882302",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617916",
                                          "variationId": "155661194"
                                        },
                                        {
                                          "groupId": "49617917",
                                          "variationId": "155661203"
                                        }
                                      ],
                                      "price": 72800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882297",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617916",
                                          "variationId": "155661197"
                                        },
                                        {
                                          "groupId": "49617917",
                                          "variationId": "155661202"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882302",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617916",
                                          "variationId": "155661197"
                                        },
                                        {
                                          "groupId": "49617917",
                                          "variationId": "155661203"
                                        }
                                      ],
                                      "price": 72800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882297",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617916",
                                          "variationId": "155661199"
                                        },
                                        {
                                          "groupId": "49617917",
                                          "variationId": "155661202"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882302",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617916",
                                          "variationId": "155661199"
                                        },
                                        {
                                          "groupId": "49617917",
                                          "variationId": "155661203"
                                        }
                                      ],
                                      "price": 72800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882297",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617916",
                                          "variationId": "155661200"
                                        },
                                        {
                                          "groupId": "49617917",
                                          "variationId": "155661202"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882302",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882297",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882298",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882300",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882302",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882303",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882304",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 45400,
                                "ribbon": {
                                  
                                },
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "type": "TopCarousel",
                            "subtype": "image",
                            "bannerId": "4149788",
                            "creativeId": "TopPicks/MGaC4",
                            "title": "Mini Garlic Cheesiken Rice",
                            "description": "  ",
                            "fontColor": "#FFFFFF",
                            "dish": {
                              "info": {
                                "id": "155058597",
                                "name": "Mini Garlic Cheesiken Rice",
                                "category": "Chicken Fiesta",
                                "description": "Juicy Chicken| Creamy Garlic Sauce| Molten Cheese with Rice & Veggies - Onion, Jalapeno & Capsicum",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/18/198338bb-6f4f-4be5-a34b-cd4d16c7aea2_d93f02a0-fecb-4274-8788-4832d15be689.jpg",
                                "inStock": 1,
                                "price": 10900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "type": "TopCarousel",
                            "subtype": "image",
                            "bannerId": "4136990",
                            "creativeId": "TopPicks/ChM4",
                            "title": "Choco Lava Cake Gift Hamper",
                            "description": "  ",
                            "fontColor": "#FFFFFF",
                            "dish": {
                              "info": {
                                "id": "151984660",
                                "name": "Choco Lava Cake Gift Hamper",
                                "category": "DESSERTS",
                                "description": "Dive into the ultimate dessert experience with our Lavalicious Combo that’s Made to Share. \n*We don't include a spoon or napkin to support sustainability",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/29/d5e06efa-1d18-4955-b228-d59f8be72347_1a9248a1-9e49-49d7-bb98-3e75101a2de4.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 34500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "type": "TopCarousel",
                            "subtype": "image",
                            "bannerId": "4135925",
                            "creativeId": "TopPicks/CChV6",
                            "title": "Corn & Cheese Volcano",
                            "description": "  ",
                            "fontColor": "#FFFFFF",
                            "dish": {
                              "info": {
                                "id": "146311239",
                                "name": "Corn & Cheese Volcano",
                                "category": "Cheese Volcano",
                                "description": "Centre loaded with Molten Cheese & topped with juicy Golden Corn\n*Contains non-edible container under the Pizza",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/375ae4df-de00-4235-97c5-3de32ebd969c_c7ea4a4e-86a9-467b-a42d-13e058670d28.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "48415148",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Cheese Volcano Crust",
                                          "default": 1,
                                          "id": "152760277",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "48415149",
                                            "variationId": "152760278"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "48415149",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular Plus",
                                          "default": 1,
                                          "id": "152760278",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium Plus",
                                          "id": "152760279",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "48415148",
                                          "variationId": "152760277"
                                        },
                                        {
                                          "groupId": "48415149",
                                          "variationId": "152760278"
                                        }
                                      ],
                                      "price": 31900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "176969691",
                                          "addonId": "121101498"
                                        },
                                        {
                                          "groupId": "176969691",
                                          "addonId": "121101486"
                                        },
                                        {
                                          "groupId": "176969691",
                                          "addonId": "121101500"
                                        },
                                        {
                                          "groupId": "176969691",
                                          "addonId": "121101494"
                                        },
                                        {
                                          "groupId": "176969691",
                                          "addonId": "121101487"
                                        },
                                        {
                                          "groupId": "176969691",
                                          "addonId": "121101502"
                                        },
                                        {
                                          "groupId": "176969691",
                                          "addonId": "121101490"
                                        },
                                        {
                                          "groupId": "176969691",
                                          "addonId": "121101504"
                                        },
                                        {
                                          "groupId": "176969692",
                                          "addonId": "121101485"
                                        },
                                        {
                                          "groupId": "176969692",
                                          "addonId": "121101509"
                                        },
                                        {
                                          "groupId": "176969692",
                                          "addonId": "121101488"
                                        },
                                        {
                                          "groupId": "176969692",
                                          "addonId": "121101489"
                                        },
                                        {
                                          "groupId": "176969692",
                                          "addonId": "121101503"
                                        },
                                        {
                                          "groupId": "176969692",
                                          "addonId": "121101491"
                                        },
                                        {
                                          "groupId": "176969692",
                                          "addonId": "121101505"
                                        },
                                        {
                                          "groupId": "176969690",
                                          "addonId": "121101480"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "48415148",
                                          "variationId": "152760277"
                                        },
                                        {
                                          "groupId": "48415149",
                                          "variationId": "152760279"
                                        }
                                      ],
                                      "price": 52900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "176969693",
                                          "addonId": "121101506"
                                        },
                                        {
                                          "groupId": "176969693",
                                          "addonId": "121101481"
                                        },
                                        {
                                          "groupId": "176969693",
                                          "addonId": "121101493"
                                        },
                                        {
                                          "groupId": "176969693",
                                          "addonId": "121101483"
                                        },
                                        {
                                          "groupId": "176969693",
                                          "addonId": "121101507"
                                        },
                                        {
                                          "groupId": "176969693",
                                          "addonId": "121101478"
                                        },
                                        {
                                          "groupId": "176969693",
                                          "addonId": "121101501"
                                        },
                                        {
                                          "groupId": "176969693",
                                          "addonId": "121101496"
                                        },
                                        {
                                          "groupId": "176969695",
                                          "addonId": "121101497"
                                        },
                                        {
                                          "groupId": "176969695",
                                          "addonId": "121101492"
                                        },
                                        {
                                          "groupId": "176969695",
                                          "addonId": "121101482"
                                        },
                                        {
                                          "groupId": "176969695",
                                          "addonId": "121101508"
                                        },
                                        {
                                          "groupId": "176969695",
                                          "addonId": "121101484"
                                        },
                                        {
                                          "groupId": "176969695",
                                          "addonId": "121101479"
                                        },
                                        {
                                          "groupId": "176969695",
                                          "addonId": "121101495"
                                        },
                                        {
                                          "groupId": "176969694",
                                          "addonId": "121101499"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "176969690",
                                    "groupName": "Extra Cheese Regular Plus",
                                    "choices": [
                                      {
                                        "id": "121101480",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969691",
                                    "groupName": "Veg Toppings Regular Plus",
                                    "choices": [
                                      {
                                        "id": "121101498",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101486",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101500",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101494",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101487",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101502",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101490",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101504",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969692",
                                    "groupName": "Non-Veg Toppings Regular Plus",
                                    "choices": [
                                      {
                                        "id": "121101485",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101509",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101488",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101489",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101503",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101491",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101505",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969693",
                                    "groupName": "Veg Toppings Medium Plus",
                                    "choices": [
                                      {
                                        "id": "121101506",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101481",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101493",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101483",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101507",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101478",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101501",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101496",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969694",
                                    "groupName": "Extra Cheese Medium Plus",
                                    "choices": [
                                      {
                                        "id": "121101499",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969695",
                                    "groupName": "Non-Veg Toppings Medium Plus",
                                    "choices": [
                                      {
                                        "id": "121101497",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101492",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101482",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101508",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101484",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101479",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101495",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 31900,
                                "ribbon": {
                                  
                                },
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "type": "TopCarousel",
                            "subtype": "image",
                            "bannerId": "4153187",
                            "creativeId": "TopPicks/PPnC2",
                            "title": "Peppy Paneer Cheese Burst",
                            "description": "  ",
                            "fontColor": "#FFFFFF",
                            "dish": {
                              "info": {
                                "id": "153334595",
                                "name": "Peppy Paneer Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with Flavorful trio of juicy paneer, crisp capsicum & spicy red paprika",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/a85a5e4f-7a9a-4eb6-b491-dab24001e15c_b2d956ee-4518-4491-8c5a-99eab6db298e.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617960",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661345",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617961",
                                            "variationId": "155661349"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661346",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617961",
                                            "variationId": "155661349"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661347",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617961",
                                            "variationId": "155661349"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661348",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617961",
                                            "variationId": "155661349"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617961",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661349",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661350",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617960",
                                          "variationId": "155661346"
                                        },
                                        {
                                          "groupId": "49617961",
                                          "variationId": "155661350"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882426",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617960",
                                          "variationId": "155661346"
                                        },
                                        {
                                          "groupId": "49617961",
                                          "variationId": "155661349"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882430",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617960",
                                          "variationId": "155661347"
                                        },
                                        {
                                          "groupId": "49617961",
                                          "variationId": "155661349"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882430",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617960",
                                          "variationId": "155661347"
                                        },
                                        {
                                          "groupId": "49617961",
                                          "variationId": "155661350"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882426",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617960",
                                          "variationId": "155661348"
                                        },
                                        {
                                          "groupId": "49617961",
                                          "variationId": "155661349"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882430",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617960",
                                          "variationId": "155661348"
                                        },
                                        {
                                          "groupId": "49617961",
                                          "variationId": "155661350"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882426",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617960",
                                          "variationId": "155661345"
                                        },
                                        {
                                          "groupId": "49617961",
                                          "variationId": "155661349"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882430",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617960",
                                          "variationId": "155661345"
                                        },
                                        {
                                          "groupId": "49617961",
                                          "variationId": "155661350"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882426",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882426",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882427",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882428",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882430",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882431",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882432",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 35400,
                                "ribbon": {
                                  
                                },
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Recommended",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334595",
                                "name": "Peppy Paneer Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with Flavorful trio of juicy paneer, crisp capsicum & spicy red paprika",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/a85a5e4f-7a9a-4eb6-b491-dab24001e15c_b2d956ee-4518-4491-8c5a-99eab6db298e.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617960",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661345",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617961",
                                            "variationId": "155661349"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661346",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617961",
                                            "variationId": "155661349"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661347",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617961",
                                            "variationId": "155661349"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661348",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617961",
                                            "variationId": "155661349"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617961",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661349",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661350",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617960",
                                          "variationId": "155661346"
                                        },
                                        {
                                          "groupId": "49617961",
                                          "variationId": "155661350"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882426",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617960",
                                          "variationId": "155661346"
                                        },
                                        {
                                          "groupId": "49617961",
                                          "variationId": "155661349"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882430",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617960",
                                          "variationId": "155661347"
                                        },
                                        {
                                          "groupId": "49617961",
                                          "variationId": "155661349"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882430",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617960",
                                          "variationId": "155661347"
                                        },
                                        {
                                          "groupId": "49617961",
                                          "variationId": "155661350"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882426",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617960",
                                          "variationId": "155661348"
                                        },
                                        {
                                          "groupId": "49617961",
                                          "variationId": "155661349"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882430",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617960",
                                          "variationId": "155661348"
                                        },
                                        {
                                          "groupId": "49617961",
                                          "variationId": "155661350"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882426",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617960",
                                          "variationId": "155661345"
                                        },
                                        {
                                          "groupId": "49617961",
                                          "variationId": "155661349"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882430",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617960",
                                          "variationId": "155661345"
                                        },
                                        {
                                          "groupId": "49617961",
                                          "variationId": "155661350"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882426",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882426",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882427",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882428",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882430",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882431",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882432",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 35400,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334589",
                                "name": "Farmhouse Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with combination of onion, capsicum, tomato & grilled mushroom",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/75e4a60b-8bec-47ab-90c9-b4e70df170d7_06d705be-4b9f-4e93-b1cb-5c97123bfb12.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617947",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661297",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617948",
                                            "variationId": "155661301"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661298",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617948",
                                            "variationId": "155661301"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661299",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617948",
                                            "variationId": "155661301"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661300",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617948",
                                            "variationId": "155661301"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617948",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661301",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661302",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617947",
                                          "variationId": "155661298"
                                        },
                                        {
                                          "groupId": "49617948",
                                          "variationId": "155661301"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882388",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617947",
                                          "variationId": "155661298"
                                        },
                                        {
                                          "groupId": "49617948",
                                          "variationId": "155661302"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882394",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617947",
                                          "variationId": "155661299"
                                        },
                                        {
                                          "groupId": "49617948",
                                          "variationId": "155661301"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882388",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617947",
                                          "variationId": "155661299"
                                        },
                                        {
                                          "groupId": "49617948",
                                          "variationId": "155661302"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882394",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617947",
                                          "variationId": "155661300"
                                        },
                                        {
                                          "groupId": "49617948",
                                          "variationId": "155661301"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882388",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617947",
                                          "variationId": "155661300"
                                        },
                                        {
                                          "groupId": "49617948",
                                          "variationId": "155661302"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882394",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617947",
                                          "variationId": "155661297"
                                        },
                                        {
                                          "groupId": "49617948",
                                          "variationId": "155661301"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882388",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617947",
                                          "variationId": "155661297"
                                        },
                                        {
                                          "groupId": "49617948",
                                          "variationId": "155661302"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882394",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882388",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882389",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882392",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882394",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882396",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882399",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 35400,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334598",
                                "name": "Veggie Paradise Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with Golden corn, black olives, capsicum & red paprika",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/64261820-53d1-4c02-83b7-3695fb145d8f_0878efe9-eb9a-4414-a5b8-869668e1ed3f.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617967",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661369",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617968",
                                            "variationId": "155661373"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661370",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617968",
                                            "variationId": "155661373"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661371",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617968",
                                            "variationId": "155661373"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661372",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617968",
                                            "variationId": "155661373"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617968",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661373",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661374",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617967",
                                          "variationId": "155661370"
                                        },
                                        {
                                          "groupId": "49617968",
                                          "variationId": "155661373"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882439",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617967",
                                          "variationId": "155661370"
                                        },
                                        {
                                          "groupId": "49617968",
                                          "variationId": "155661374"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882442",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617967",
                                          "variationId": "155661371"
                                        },
                                        {
                                          "groupId": "49617968",
                                          "variationId": "155661373"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882439",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617967",
                                          "variationId": "155661371"
                                        },
                                        {
                                          "groupId": "49617968",
                                          "variationId": "155661374"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882442",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617967",
                                          "variationId": "155661372"
                                        },
                                        {
                                          "groupId": "49617968",
                                          "variationId": "155661373"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882439",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617967",
                                          "variationId": "155661372"
                                        },
                                        {
                                          "groupId": "49617968",
                                          "variationId": "155661374"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882442",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617967",
                                          "variationId": "155661369"
                                        },
                                        {
                                          "groupId": "49617968",
                                          "variationId": "155661373"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882439",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617967",
                                          "variationId": "155661369"
                                        },
                                        {
                                          "groupId": "49617968",
                                          "variationId": "155661374"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882442",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882439",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882440",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882441",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882442",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882443",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882444",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 35400,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334575",
                                "name": "Margherita Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with delight of 100% real mozzarella cheese",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/ccc30e06-ab70-45b6-9825-adf3150441af_3f3d3a2e-855b-4158-bcec-7615525e44b0.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617921",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661211",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617922",
                                            "variationId": "155661215"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661212",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617922",
                                            "variationId": "155661215"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661213",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617922",
                                            "variationId": "155661215"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661214",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617922",
                                            "variationId": "155661215"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617922",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661215",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661216",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617921",
                                          "variationId": "155661212"
                                        },
                                        {
                                          "groupId": "49617922",
                                          "variationId": "155661215"
                                        }
                                      ],
                                      "price": 18400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882312",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617921",
                                          "variationId": "155661212"
                                        },
                                        {
                                          "groupId": "49617922",
                                          "variationId": "155661216"
                                        }
                                      ],
                                      "price": 36400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882317",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617921",
                                          "variationId": "155661213"
                                        },
                                        {
                                          "groupId": "49617922",
                                          "variationId": "155661215"
                                        }
                                      ],
                                      "price": 18400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882312",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617921",
                                          "variationId": "155661213"
                                        },
                                        {
                                          "groupId": "49617922",
                                          "variationId": "155661216"
                                        }
                                      ],
                                      "price": 36400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882317",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617921",
                                          "variationId": "155661214"
                                        },
                                        {
                                          "groupId": "49617922",
                                          "variationId": "155661215"
                                        }
                                      ],
                                      "price": 18400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882312",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617921",
                                          "variationId": "155661214"
                                        },
                                        {
                                          "groupId": "49617922",
                                          "variationId": "155661216"
                                        }
                                      ],
                                      "price": 36400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882317",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617921",
                                          "variationId": "155661211"
                                        },
                                        {
                                          "groupId": "49617922",
                                          "variationId": "155661215"
                                        }
                                      ],
                                      "price": 18400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882312",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617921",
                                          "variationId": "155661211"
                                        },
                                        {
                                          "groupId": "49617922",
                                          "variationId": "155661216"
                                        }
                                      ],
                                      "price": 36400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882317",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882312",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882314",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882315",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882317",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882318",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882319",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 18400,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334607",
                                "name": "Spiced Double Chicken Pizza",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Molten Cheese Indulgence with combination of Pepper Barbecue Chicken & Peri Peri Chicken for Chicken lovers",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/bad67b37-0721-45a7-990d-3987f4464e06_62453978-9a8e-4a49-bc81-0ba84e842b65.jpg",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617980",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661404",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617981",
                                            "variationId": "155661408"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661405",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617981",
                                            "variationId": "155661408"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661406",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617981",
                                            "variationId": "155661408"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661407",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617981",
                                            "variationId": "155661408"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617981",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661408",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661409",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617980",
                                          "variationId": "155661404"
                                        },
                                        {
                                          "groupId": "49617981",
                                          "variationId": "155661408"
                                        }
                                      ],
                                      "price": 39000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882459",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617980",
                                          "variationId": "155661404"
                                        },
                                        {
                                          "groupId": "49617981",
                                          "variationId": "155661409"
                                        }
                                      ],
                                      "price": 65800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882464",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617980",
                                          "variationId": "155661405"
                                        },
                                        {
                                          "groupId": "49617981",
                                          "variationId": "155661409"
                                        }
                                      ],
                                      "price": 65800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882464",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617980",
                                          "variationId": "155661405"
                                        },
                                        {
                                          "groupId": "49617981",
                                          "variationId": "155661408"
                                        }
                                      ],
                                      "price": 39000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882459",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617980",
                                          "variationId": "155661406"
                                        },
                                        {
                                          "groupId": "49617981",
                                          "variationId": "155661408"
                                        }
                                      ],
                                      "price": 39000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882459",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617980",
                                          "variationId": "155661406"
                                        },
                                        {
                                          "groupId": "49617981",
                                          "variationId": "155661409"
                                        }
                                      ],
                                      "price": 65800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882464",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617980",
                                          "variationId": "155661407"
                                        },
                                        {
                                          "groupId": "49617981",
                                          "variationId": "155661408"
                                        }
                                      ],
                                      "price": 39000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882459",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617980",
                                          "variationId": "155661407"
                                        },
                                        {
                                          "groupId": "49617981",
                                          "variationId": "155661409"
                                        }
                                      ],
                                      "price": 65800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882464",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882459",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882461",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882462",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882464",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882466",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882467",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 39000,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334585",
                                "name": "Mexican Green Wave Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with Mexican herbs sprinkled on onion, capsicum, tomato & jalapeno",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/6aef4814-ce61-484e-a7d5-7f3e5d003288_be08f225-0fb1-498f-854a-1ba936aa8d60.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617938",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661267",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617939",
                                            "variationId": "155661272"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661268",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617939",
                                            "variationId": "155661272"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661269",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617939",
                                            "variationId": "155661272"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661270",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617939",
                                            "variationId": "155661272"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617939",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661272",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661274",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617938",
                                          "variationId": "155661268"
                                        },
                                        {
                                          "groupId": "49617939",
                                          "variationId": "155661272"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882361",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617938",
                                          "variationId": "155661268"
                                        },
                                        {
                                          "groupId": "49617939",
                                          "variationId": "155661274"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882365",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617938",
                                          "variationId": "155661269"
                                        },
                                        {
                                          "groupId": "49617939",
                                          "variationId": "155661272"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882361",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617938",
                                          "variationId": "155661269"
                                        },
                                        {
                                          "groupId": "49617939",
                                          "variationId": "155661274"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882365",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617938",
                                          "variationId": "155661270"
                                        },
                                        {
                                          "groupId": "49617939",
                                          "variationId": "155661272"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882361",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617938",
                                          "variationId": "155661270"
                                        },
                                        {
                                          "groupId": "49617939",
                                          "variationId": "155661274"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882365",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617938",
                                          "variationId": "155661267"
                                        },
                                        {
                                          "groupId": "49617939",
                                          "variationId": "155661272"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882361",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617938",
                                          "variationId": "155661267"
                                        },
                                        {
                                          "groupId": "49617939",
                                          "variationId": "155661274"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882365",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882361",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882362",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882363",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882365",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882367",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882369",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 35400,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334608",
                                "name": "Pepper Barbecue Chicken Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with Pepper Barbecue chicken for that extra zing",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/b99b241a-b4c7-438f-8d14-3f704dbe1cd4_eb4c709d-ebab-4291-be25-9900ab6b45e1.jpg",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617984",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661415",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617985",
                                            "variationId": "155661419"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661416",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617985",
                                            "variationId": "155661419"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661417",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617985",
                                            "variationId": "155661419"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661418",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617985",
                                            "variationId": "155661419"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617985",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661419",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661420",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617984",
                                          "variationId": "155661416"
                                        },
                                        {
                                          "groupId": "49617985",
                                          "variationId": "155661419"
                                        }
                                      ],
                                      "price": 34400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882469",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617984",
                                          "variationId": "155661416"
                                        },
                                        {
                                          "groupId": "49617985",
                                          "variationId": "155661420"
                                        }
                                      ],
                                      "price": 57800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882472",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617984",
                                          "variationId": "155661417"
                                        },
                                        {
                                          "groupId": "49617985",
                                          "variationId": "155661419"
                                        }
                                      ],
                                      "price": 34400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882469",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617984",
                                          "variationId": "155661417"
                                        },
                                        {
                                          "groupId": "49617985",
                                          "variationId": "155661420"
                                        }
                                      ],
                                      "price": 57800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882472",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617984",
                                          "variationId": "155661418"
                                        },
                                        {
                                          "groupId": "49617985",
                                          "variationId": "155661419"
                                        }
                                      ],
                                      "price": 34400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882469",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617984",
                                          "variationId": "155661418"
                                        },
                                        {
                                          "groupId": "49617985",
                                          "variationId": "155661420"
                                        }
                                      ],
                                      "price": 57800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882472",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617984",
                                          "variationId": "155661415"
                                        },
                                        {
                                          "groupId": "49617985",
                                          "variationId": "155661419"
                                        }
                                      ],
                                      "price": 34400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882469",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617984",
                                          "variationId": "155661415"
                                        },
                                        {
                                          "groupId": "49617985",
                                          "variationId": "155661420"
                                        }
                                      ],
                                      "price": 57800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882472",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882469",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882470",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882471",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882472",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882473",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882475",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 34400,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334587",
                                "name": "Indi Tandoori Paneer Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with spicy tandoori paneer, capsicum, red paprika & mint mayo",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/52268a6e-00c2-4a08-99b6-2ddee4f3bdd3_32c8ad06-4578-43da-9c45-e5848c1b9b43.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617944",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661284",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617945",
                                            "variationId": "155661288"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661285",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617945",
                                            "variationId": "155661288"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661286",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617945",
                                            "variationId": "155661288"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661287",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617945",
                                            "variationId": "155661288"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617945",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661288",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661289",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617944",
                                          "variationId": "155661287"
                                        },
                                        {
                                          "groupId": "49617945",
                                          "variationId": "155661288"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882378",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617944",
                                          "variationId": "155661287"
                                        },
                                        {
                                          "groupId": "49617945",
                                          "variationId": "155661289"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882382",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617944",
                                          "variationId": "155661284"
                                        },
                                        {
                                          "groupId": "49617945",
                                          "variationId": "155661288"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882378",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617944",
                                          "variationId": "155661284"
                                        },
                                        {
                                          "groupId": "49617945",
                                          "variationId": "155661289"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882382",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617944",
                                          "variationId": "155661285"
                                        },
                                        {
                                          "groupId": "49617945",
                                          "variationId": "155661288"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882378",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617944",
                                          "variationId": "155661285"
                                        },
                                        {
                                          "groupId": "49617945",
                                          "variationId": "155661289"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882382",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617944",
                                          "variationId": "155661286"
                                        },
                                        {
                                          "groupId": "49617945",
                                          "variationId": "155661288"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882378",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617944",
                                          "variationId": "155661286"
                                        },
                                        {
                                          "groupId": "49617945",
                                          "variationId": "155661289"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882382",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882378",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882380",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882381",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882382",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882383",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882384",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 39400,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334573",
                                "name": "Indi Chicken Tikka Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with wholesome flavour of tandoori masala topped with Chicken tikka, onion, red paprika & mint mayo",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/6b860839-56b2-4729-a0cb-ab5086fa49d4_5cac9a1b-ed2c-4a95-bb30-8586499e4f01.jpg",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617916",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661194",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617917",
                                            "variationId": "155661202"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661197",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617917",
                                            "variationId": "155661202"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661199",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617917",
                                            "variationId": "155661202"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661200",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617917",
                                            "variationId": "155661202"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617917",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661202",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661203",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617916",
                                          "variationId": "155661200"
                                        },
                                        {
                                          "groupId": "49617917",
                                          "variationId": "155661203"
                                        }
                                      ],
                                      "price": 72800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882297",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617916",
                                          "variationId": "155661194"
                                        },
                                        {
                                          "groupId": "49617917",
                                          "variationId": "155661202"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882302",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617916",
                                          "variationId": "155661194"
                                        },
                                        {
                                          "groupId": "49617917",
                                          "variationId": "155661203"
                                        }
                                      ],
                                      "price": 72800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882297",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617916",
                                          "variationId": "155661197"
                                        },
                                        {
                                          "groupId": "49617917",
                                          "variationId": "155661202"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882302",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617916",
                                          "variationId": "155661197"
                                        },
                                        {
                                          "groupId": "49617917",
                                          "variationId": "155661203"
                                        }
                                      ],
                                      "price": 72800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882297",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617916",
                                          "variationId": "155661199"
                                        },
                                        {
                                          "groupId": "49617917",
                                          "variationId": "155661202"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882302",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617916",
                                          "variationId": "155661199"
                                        },
                                        {
                                          "groupId": "49617917",
                                          "variationId": "155661203"
                                        }
                                      ],
                                      "price": 72800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882297",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617916",
                                          "variationId": "155661200"
                                        },
                                        {
                                          "groupId": "49617917",
                                          "variationId": "155661202"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882302",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882297",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882298",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882300",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882302",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882303",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882304",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 45400,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334578",
                                "name": "Double Cheese Margherita Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with loaded delight of 100% real mozzarella cheese",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/b07475c1-97a8-49d3-bba0-9696253d44ca_eb8e4fe6-f157-4e5e-ab8a-173ecb88d9c9.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617924",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661219",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617926",
                                            "variationId": "155661229"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661222",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617926",
                                            "variationId": "155661229"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661225",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617926",
                                            "variationId": "155661229"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661227",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617926",
                                            "variationId": "155661229"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617926",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661229",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661231",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617924",
                                          "variationId": "155661222"
                                        },
                                        {
                                          "groupId": "49617926",
                                          "variationId": "155661229"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882323",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617924",
                                          "variationId": "155661222"
                                        },
                                        {
                                          "groupId": "49617926",
                                          "variationId": "155661231"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882329",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617924",
                                          "variationId": "155661225"
                                        },
                                        {
                                          "groupId": "49617926",
                                          "variationId": "155661229"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882323",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617924",
                                          "variationId": "155661225"
                                        },
                                        {
                                          "groupId": "49617926",
                                          "variationId": "155661231"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882329",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617924",
                                          "variationId": "155661227"
                                        },
                                        {
                                          "groupId": "49617926",
                                          "variationId": "155661229"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882323",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617924",
                                          "variationId": "155661227"
                                        },
                                        {
                                          "groupId": "49617926",
                                          "variationId": "155661231"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882329",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617924",
                                          "variationId": "155661219"
                                        },
                                        {
                                          "groupId": "49617926",
                                          "variationId": "155661229"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882323",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617924",
                                          "variationId": "155661219"
                                        },
                                        {
                                          "groupId": "49617926",
                                          "variationId": "155661231"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882329",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882323",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882325",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882327",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882329",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882332",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882335",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 30400,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334561",
                                "name": "Cheese n Corn Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Molten Cheese Indulgence with a delectable combination of sweet & juicy golden corn",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/00fb90e9-6c94-41b6-98d4-7812cca42c1c_1331e26c-c671-4caa-82c4-1fcf90c55696.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617899",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661137",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617900",
                                            "variationId": "155661141"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661138",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617900",
                                            "variationId": "155661141"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661139",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617900",
                                            "variationId": "155661141"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661140",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617900",
                                            "variationId": "155661141"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617900",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661141",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661142",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617899",
                                          "variationId": "155661140"
                                        },
                                        {
                                          "groupId": "49617900",
                                          "variationId": "155661141"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882248",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617899",
                                          "variationId": "155661140"
                                        },
                                        {
                                          "groupId": "49617900",
                                          "variationId": "155661142"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882251",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617899",
                                          "variationId": "155661137"
                                        },
                                        {
                                          "groupId": "49617900",
                                          "variationId": "155661141"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882248",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617899",
                                          "variationId": "155661137"
                                        },
                                        {
                                          "groupId": "49617900",
                                          "variationId": "155661142"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882251",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617899",
                                          "variationId": "155661138"
                                        },
                                        {
                                          "groupId": "49617900",
                                          "variationId": "155661142"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882251",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617899",
                                          "variationId": "155661138"
                                        },
                                        {
                                          "groupId": "49617900",
                                          "variationId": "155661141"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882248",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617899",
                                          "variationId": "155661139"
                                        },
                                        {
                                          "groupId": "49617900",
                                          "variationId": "155661141"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882248",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617899",
                                          "variationId": "155661139"
                                        },
                                        {
                                          "groupId": "49617900",
                                          "variationId": "155661142"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882251",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882248",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882249",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882250",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882251",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882252",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882253",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 30400,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334571",
                                "name": "Chicken Golden Delight Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with Double pepper Barbecue chicken, golden corn and extra cheese",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/83cc07f2-9ae3-4bbd-a303-1c26d87a2bbc_ae0da352-da9d-4942-a23b-332e554b03c9.jpg",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617913",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661188",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617914",
                                            "variationId": "155661192"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661189",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617914",
                                            "variationId": "155661192"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661190",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617914",
                                            "variationId": "155661192"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661191",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617914",
                                            "variationId": "155661192"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617914",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661192",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661193",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617913",
                                          "variationId": "155661190"
                                        },
                                        {
                                          "groupId": "49617914",
                                          "variationId": "155661193"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882288",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617913",
                                          "variationId": "155661191"
                                        },
                                        {
                                          "groupId": "49617914",
                                          "variationId": "155661192"
                                        }
                                      ],
                                      "price": 40400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882293",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617913",
                                          "variationId": "155661191"
                                        },
                                        {
                                          "groupId": "49617914",
                                          "variationId": "155661193"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882288",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617913",
                                          "variationId": "155661188"
                                        },
                                        {
                                          "groupId": "49617914",
                                          "variationId": "155661192"
                                        }
                                      ],
                                      "price": 40400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882293",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617913",
                                          "variationId": "155661188"
                                        },
                                        {
                                          "groupId": "49617914",
                                          "variationId": "155661193"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882288",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617913",
                                          "variationId": "155661189"
                                        },
                                        {
                                          "groupId": "49617914",
                                          "variationId": "155661192"
                                        }
                                      ],
                                      "price": 40400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882293",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617913",
                                          "variationId": "155661189"
                                        },
                                        {
                                          "groupId": "49617914",
                                          "variationId": "155661193"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882288",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617913",
                                          "variationId": "155661190"
                                        },
                                        {
                                          "groupId": "49617914",
                                          "variationId": "155661192"
                                        }
                                      ],
                                      "price": 40400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882293",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882288",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882290",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882291",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882293",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882294",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882295",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 40400,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334582",
                                "name": "Chicken Fiesta Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with Grilled chicken rashers, peri-peri chicken, onion & capsicum",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/2d270ed3-34d4-49ed-8ad2-de66252fb494_cf81e686-25f5-49ab-90eb-59cb1ace9151.jpg",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617932",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661249",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617933",
                                            "variationId": "155661254"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661251",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617933",
                                            "variationId": "155661254"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661252",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617933",
                                            "variationId": "155661254"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661253",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617933",
                                            "variationId": "155661254"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617933",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661254",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661255",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617932",
                                          "variationId": "155661251"
                                        },
                                        {
                                          "groupId": "49617933",
                                          "variationId": "155661255"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882342",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617932",
                                          "variationId": "155661251"
                                        },
                                        {
                                          "groupId": "49617933",
                                          "variationId": "155661254"
                                        }
                                      ],
                                      "price": 40400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882349",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617932",
                                          "variationId": "155661252"
                                        },
                                        {
                                          "groupId": "49617933",
                                          "variationId": "155661254"
                                        }
                                      ],
                                      "price": 40400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882349",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617932",
                                          "variationId": "155661252"
                                        },
                                        {
                                          "groupId": "49617933",
                                          "variationId": "155661255"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882342",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617932",
                                          "variationId": "155661253"
                                        },
                                        {
                                          "groupId": "49617933",
                                          "variationId": "155661254"
                                        }
                                      ],
                                      "price": 40400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882349",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617932",
                                          "variationId": "155661253"
                                        },
                                        {
                                          "groupId": "49617933",
                                          "variationId": "155661255"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882342",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617932",
                                          "variationId": "155661249"
                                        },
                                        {
                                          "groupId": "49617933",
                                          "variationId": "155661254"
                                        }
                                      ],
                                      "price": 40400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882349",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617932",
                                          "variationId": "155661249"
                                        },
                                        {
                                          "groupId": "49617933",
                                          "variationId": "155661255"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882342",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882342",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882344",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882346",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882349",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882350",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882352",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 40400,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334569",
                                "name": "Fresh Veggie Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with combination of onion & capsicum",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/9b5b0373-4569-416b-b289-6dd546a21a7f_3f47169f-7fc6-4a59-8ec9-afc5992542cc.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617909",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661173",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617910",
                                            "variationId": "155661177"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661174",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617910",
                                            "variationId": "155661177"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661175",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617910",
                                            "variationId": "155661177"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661176",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617910",
                                            "variationId": "155661177"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617910",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661177",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661178",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617909",
                                          "variationId": "155661175"
                                        },
                                        {
                                          "groupId": "49617910",
                                          "variationId": "155661177"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882278",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617909",
                                          "variationId": "155661175"
                                        },
                                        {
                                          "groupId": "49617910",
                                          "variationId": "155661178"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882281",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617909",
                                          "variationId": "155661176"
                                        },
                                        {
                                          "groupId": "49617910",
                                          "variationId": "155661177"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882278",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617909",
                                          "variationId": "155661176"
                                        },
                                        {
                                          "groupId": "49617910",
                                          "variationId": "155661178"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882281",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617909",
                                          "variationId": "155661173"
                                        },
                                        {
                                          "groupId": "49617910",
                                          "variationId": "155661177"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882278",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617909",
                                          "variationId": "155661173"
                                        },
                                        {
                                          "groupId": "49617910",
                                          "variationId": "155661178"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882281",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617909",
                                          "variationId": "155661174"
                                        },
                                        {
                                          "groupId": "49617910",
                                          "variationId": "155661178"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882281",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617909",
                                          "variationId": "155661174"
                                        },
                                        {
                                          "groupId": "49617910",
                                          "variationId": "155661177"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882278",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882278",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882279",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882280",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882281",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882282",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882283",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 30400,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334568",
                                "name": "Chicken Pepperoni Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with American classic flavored Chicken Pepperoni, topped with extra cheese",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/82e80d82-8d85-4543-bb7e-4dc2b71d7188_e66fc751-937b-4ec1-99a1-86caba8f2420.jpg",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617907",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661167",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617908",
                                            "variationId": "155661171"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661168",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617908",
                                            "variationId": "155661171"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661169",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617908",
                                            "variationId": "155661171"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661170",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617908",
                                            "variationId": "155661171"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617908",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661171",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661172",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617907",
                                          "variationId": "155661168"
                                        },
                                        {
                                          "groupId": "49617908",
                                          "variationId": "155661172"
                                        }
                                      ],
                                      "price": 72800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882270",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617907",
                                          "variationId": "155661168"
                                        },
                                        {
                                          "groupId": "49617908",
                                          "variationId": "155661171"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882275",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617907",
                                          "variationId": "155661169"
                                        },
                                        {
                                          "groupId": "49617908",
                                          "variationId": "155661171"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882275",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617907",
                                          "variationId": "155661169"
                                        },
                                        {
                                          "groupId": "49617908",
                                          "variationId": "155661172"
                                        }
                                      ],
                                      "price": 72800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882270",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617907",
                                          "variationId": "155661170"
                                        },
                                        {
                                          "groupId": "49617908",
                                          "variationId": "155661171"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882275",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617907",
                                          "variationId": "155661170"
                                        },
                                        {
                                          "groupId": "49617908",
                                          "variationId": "155661172"
                                        }
                                      ],
                                      "price": 72800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882270",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617907",
                                          "variationId": "155661167"
                                        },
                                        {
                                          "groupId": "49617908",
                                          "variationId": "155661171"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882275",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617907",
                                          "variationId": "155661167"
                                        },
                                        {
                                          "groupId": "49617908",
                                          "variationId": "155661172"
                                        }
                                      ],
                                      "price": 72800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882270",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882270",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882272",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882274",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882275",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882276",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882277",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 45400,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334612",
                                "name": "Achari Do Pyaza Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with tangy & spicy achari flavours on a super cheesy onion pizza",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/eff260f3-7e8c-4a2a-9b55-bcde4f0522dd_7f54d7d9-96fc-4638-8d2d-c953a79aa5d3.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617997",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661444",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617998",
                                            "variationId": "155661450"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661445",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617998",
                                            "variationId": "155661450"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661447",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617998",
                                            "variationId": "155661450"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661448",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617998",
                                            "variationId": "155661450"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617998",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661450",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661451",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617997",
                                          "variationId": "155661445"
                                        },
                                        {
                                          "groupId": "49617998",
                                          "variationId": "155661451"
                                        }
                                      ],
                                      "price": 44800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882487",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617997",
                                          "variationId": "155661445"
                                        },
                                        {
                                          "groupId": "49617998",
                                          "variationId": "155661450"
                                        }
                                      ],
                                      "price": 27400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882492",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617997",
                                          "variationId": "155661447"
                                        },
                                        {
                                          "groupId": "49617998",
                                          "variationId": "155661450"
                                        }
                                      ],
                                      "price": 27400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882492",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617997",
                                          "variationId": "155661447"
                                        },
                                        {
                                          "groupId": "49617998",
                                          "variationId": "155661451"
                                        }
                                      ],
                                      "price": 44800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882487",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617997",
                                          "variationId": "155661448"
                                        },
                                        {
                                          "groupId": "49617998",
                                          "variationId": "155661450"
                                        }
                                      ],
                                      "price": 27400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882492",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617997",
                                          "variationId": "155661448"
                                        },
                                        {
                                          "groupId": "49617998",
                                          "variationId": "155661451"
                                        }
                                      ],
                                      "price": 44800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882487",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617997",
                                          "variationId": "155661444"
                                        },
                                        {
                                          "groupId": "49617998",
                                          "variationId": "155661450"
                                        }
                                      ],
                                      "price": 27400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882492",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617997",
                                          "variationId": "155661444"
                                        },
                                        {
                                          "groupId": "49617998",
                                          "variationId": "155661451"
                                        }
                                      ],
                                      "price": 44800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882487",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882487",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882488",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882490",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882492",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882493",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882495",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 27400,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334615",
                                "name": "The 5 Chicken Feast Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Molten Cheese Indulgence Loaded with 5 different Chicken toppings - grilled Chicken Rashers, Chicken MeatBalls, Chicken Tikka, herby Chicken Sausage & Chicken Keema",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/55cf2f2a-4fe1-4f67-9967-4d260747a5f1_9d96ecf0-9923-428b-baac-c558dfd84d2e.jpg",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49618005",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661469",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49618006",
                                            "variationId": "155661473"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661470",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49618006",
                                            "variationId": "155661473"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661471",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49618006",
                                            "variationId": "155661473"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661472",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49618006",
                                            "variationId": "155661473"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49618006",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661473",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661474",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49618005",
                                          "variationId": "155661469"
                                        },
                                        {
                                          "groupId": "49618006",
                                          "variationId": "155661474"
                                        }
                                      ],
                                      "price": 80800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882502",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49618005",
                                          "variationId": "155661470"
                                        },
                                        {
                                          "groupId": "49618006",
                                          "variationId": "155661474"
                                        }
                                      ],
                                      "price": 80800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882502",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49618005",
                                          "variationId": "155661470"
                                        },
                                        {
                                          "groupId": "49618006",
                                          "variationId": "155661473"
                                        }
                                      ],
                                      "price": 48000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882508",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49618005",
                                          "variationId": "155661471"
                                        },
                                        {
                                          "groupId": "49618006",
                                          "variationId": "155661473"
                                        }
                                      ],
                                      "price": 48000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882508",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49618005",
                                          "variationId": "155661471"
                                        },
                                        {
                                          "groupId": "49618006",
                                          "variationId": "155661474"
                                        }
                                      ],
                                      "price": 80800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882502",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49618005",
                                          "variationId": "155661472"
                                        },
                                        {
                                          "groupId": "49618006",
                                          "variationId": "155661473"
                                        }
                                      ],
                                      "price": 48000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882508",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49618005",
                                          "variationId": "155661472"
                                        },
                                        {
                                          "groupId": "49618006",
                                          "variationId": "155661474"
                                        }
                                      ],
                                      "price": 80800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882502",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49618005",
                                          "variationId": "155661469"
                                        },
                                        {
                                          "groupId": "49618006",
                                          "variationId": "155661473"
                                        }
                                      ],
                                      "price": 48000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882508",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882502",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882504",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882506",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882508",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882509",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882510",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 48000,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334610",
                                "name": "Chicken Sausage Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with American classic herbed chicken sausage",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/d8ed092e-1e47-413c-927e-b332ef507097_ed5ffcac-15b7-4ab8-8ba7-51317eefe42c.jpg",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617991",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661433",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617992",
                                            "variationId": "155661437"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661434",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617992",
                                            "variationId": "155661437"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661435",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617992",
                                            "variationId": "155661437"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661436",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617992",
                                            "variationId": "155661437"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617992",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661437",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661438",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617991",
                                          "variationId": "155661434"
                                        },
                                        {
                                          "groupId": "49617992",
                                          "variationId": "155661437"
                                        }
                                      ],
                                      "price": 29400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882481",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617991",
                                          "variationId": "155661434"
                                        },
                                        {
                                          "groupId": "49617992",
                                          "variationId": "155661438"
                                        }
                                      ],
                                      "price": 48800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882484",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617991",
                                          "variationId": "155661435"
                                        },
                                        {
                                          "groupId": "49617992",
                                          "variationId": "155661437"
                                        }
                                      ],
                                      "price": 29400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882481",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617991",
                                          "variationId": "155661435"
                                        },
                                        {
                                          "groupId": "49617992",
                                          "variationId": "155661438"
                                        }
                                      ],
                                      "price": 48800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882484",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617991",
                                          "variationId": "155661436"
                                        },
                                        {
                                          "groupId": "49617992",
                                          "variationId": "155661437"
                                        }
                                      ],
                                      "price": 29400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882481",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617991",
                                          "variationId": "155661436"
                                        },
                                        {
                                          "groupId": "49617992",
                                          "variationId": "155661438"
                                        }
                                      ],
                                      "price": 48800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882484",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617991",
                                          "variationId": "155661433"
                                        },
                                        {
                                          "groupId": "49617992",
                                          "variationId": "155661437"
                                        }
                                      ],
                                      "price": 29400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882481",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617991",
                                          "variationId": "155661433"
                                        },
                                        {
                                          "groupId": "49617992",
                                          "variationId": "155661438"
                                        }
                                      ],
                                      "price": 48800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882484",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882481",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882482",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882483",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882484",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882485",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882486",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 29400,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334603",
                                "name": "Fiery Jalapeno & Paprika Pizza",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Molten Cheese Indulgence with jalapeno & red paprika toppings along with spicy peri peri sauce",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/82a43df5-5cdd-4073-971f-b20c3cfa7f4d_5173638b-6513-482b-b0df-9a743ab90496.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617974",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661384",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617975",
                                            "variationId": "155661388"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661385",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617975",
                                            "variationId": "155661388"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661386",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617975",
                                            "variationId": "155661388"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661387",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617975",
                                            "variationId": "155661388"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617975",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661388",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661389",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617974",
                                          "variationId": "155661386"
                                        },
                                        {
                                          "groupId": "49617975",
                                          "variationId": "155661388"
                                        }
                                      ],
                                      "price": 26000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882447",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617974",
                                          "variationId": "155661386"
                                        },
                                        {
                                          "groupId": "49617975",
                                          "variationId": "155661389"
                                        }
                                      ],
                                      "price": 43400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882451",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617974",
                                          "variationId": "155661387"
                                        },
                                        {
                                          "groupId": "49617975",
                                          "variationId": "155661388"
                                        }
                                      ],
                                      "price": 26000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882447",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617974",
                                          "variationId": "155661387"
                                        },
                                        {
                                          "groupId": "49617975",
                                          "variationId": "155661389"
                                        }
                                      ],
                                      "price": 43400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882451",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617974",
                                          "variationId": "155661384"
                                        },
                                        {
                                          "groupId": "49617975",
                                          "variationId": "155661388"
                                        }
                                      ],
                                      "price": 26000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882447",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617974",
                                          "variationId": "155661384"
                                        },
                                        {
                                          "groupId": "49617975",
                                          "variationId": "155661389"
                                        }
                                      ],
                                      "price": 43400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882451",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617974",
                                          "variationId": "155661385"
                                        },
                                        {
                                          "groupId": "49617975",
                                          "variationId": "155661388"
                                        }
                                      ],
                                      "price": 26000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882447",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617974",
                                          "variationId": "155661385"
                                        },
                                        {
                                          "groupId": "49617975",
                                          "variationId": "155661389"
                                        }
                                      ],
                                      "price": 43400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882451",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882447",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882448",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882450",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882451",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882453",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882455",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 26000,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334563",
                                "name": "Fiery Sausage & Paprika Pizza",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Molten Cheese Indulgence with spicy & herby chicken sausage and red paprika toppings along with spicy peri peri sauce",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/70dea34a-f906-4a28-8f3c-52271b2383d9_e3804e5e-5b4e-40b5-9199-61b4e8b622af.jpg",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617903",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661149",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617904",
                                            "variationId": "155661153"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661150",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617904",
                                            "variationId": "155661153"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661151",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617904",
                                            "variationId": "155661153"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661152",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617904",
                                            "variationId": "155661153"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617904",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661153",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661154",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617903",
                                          "variationId": "155661150"
                                        },
                                        {
                                          "groupId": "49617904",
                                          "variationId": "155661153"
                                        }
                                      ],
                                      "price": 33000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882260",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617903",
                                          "variationId": "155661150"
                                        },
                                        {
                                          "groupId": "49617904",
                                          "variationId": "155661154"
                                        }
                                      ],
                                      "price": 55400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882263",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617903",
                                          "variationId": "155661151"
                                        },
                                        {
                                          "groupId": "49617904",
                                          "variationId": "155661153"
                                        }
                                      ],
                                      "price": 33000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882260",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617903",
                                          "variationId": "155661151"
                                        },
                                        {
                                          "groupId": "49617904",
                                          "variationId": "155661154"
                                        }
                                      ],
                                      "price": 55400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882263",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617903",
                                          "variationId": "155661152"
                                        },
                                        {
                                          "groupId": "49617904",
                                          "variationId": "155661153"
                                        }
                                      ],
                                      "price": 33000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882260",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617903",
                                          "variationId": "155661152"
                                        },
                                        {
                                          "groupId": "49617904",
                                          "variationId": "155661154"
                                        }
                                      ],
                                      "price": 55400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882263",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617903",
                                          "variationId": "155661149"
                                        },
                                        {
                                          "groupId": "49617904",
                                          "variationId": "155661153"
                                        }
                                      ],
                                      "price": 33000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882260",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617903",
                                          "variationId": "155661149"
                                        },
                                        {
                                          "groupId": "49617904",
                                          "variationId": "155661154"
                                        }
                                      ],
                                      "price": 55400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882263",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882260",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882261",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882262",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882263",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882264",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882265",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 33000,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "type": "CATEGORY_TYPE_RECOMMENDED",
                        "subtitleSuffix": {
                          
                        }
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Cheese Burst - 3 New Flavours",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334595",
                                "name": "Peppy Paneer Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with Flavorful trio of juicy paneer, crisp capsicum & spicy red paprika",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/a85a5e4f-7a9a-4eb6-b491-dab24001e15c_b2d956ee-4518-4491-8c5a-99eab6db298e.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617960",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661345",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617961",
                                            "variationId": "155661349"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661346",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617961",
                                            "variationId": "155661349"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661347",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617961",
                                            "variationId": "155661349"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661348",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617961",
                                            "variationId": "155661349"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617961",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661349",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661350",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617960",
                                          "variationId": "155661346"
                                        },
                                        {
                                          "groupId": "49617961",
                                          "variationId": "155661350"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882426",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617960",
                                          "variationId": "155661346"
                                        },
                                        {
                                          "groupId": "49617961",
                                          "variationId": "155661349"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882430",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617960",
                                          "variationId": "155661347"
                                        },
                                        {
                                          "groupId": "49617961",
                                          "variationId": "155661349"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882430",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617960",
                                          "variationId": "155661347"
                                        },
                                        {
                                          "groupId": "49617961",
                                          "variationId": "155661350"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882426",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617960",
                                          "variationId": "155661348"
                                        },
                                        {
                                          "groupId": "49617961",
                                          "variationId": "155661349"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882430",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617960",
                                          "variationId": "155661348"
                                        },
                                        {
                                          "groupId": "49617961",
                                          "variationId": "155661350"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882426",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617960",
                                          "variationId": "155661345"
                                        },
                                        {
                                          "groupId": "49617961",
                                          "variationId": "155661349"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882430",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882432",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882431",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617960",
                                          "variationId": "155661345"
                                        },
                                        {
                                          "groupId": "49617961",
                                          "variationId": "155661350"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882427",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882428",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882426",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882426",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882427",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882428",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882430",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882431",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882432",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 35400,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334589",
                                "name": "Farmhouse Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with combination of onion, capsicum, tomato & grilled mushroom",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/75e4a60b-8bec-47ab-90c9-b4e70df170d7_06d705be-4b9f-4e93-b1cb-5c97123bfb12.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617947",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661297",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617948",
                                            "variationId": "155661301"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661298",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617948",
                                            "variationId": "155661301"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661299",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617948",
                                            "variationId": "155661301"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661300",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617948",
                                            "variationId": "155661301"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617948",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661301",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661302",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617947",
                                          "variationId": "155661298"
                                        },
                                        {
                                          "groupId": "49617948",
                                          "variationId": "155661301"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882388",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617947",
                                          "variationId": "155661298"
                                        },
                                        {
                                          "groupId": "49617948",
                                          "variationId": "155661302"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882394",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617947",
                                          "variationId": "155661299"
                                        },
                                        {
                                          "groupId": "49617948",
                                          "variationId": "155661301"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882388",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617947",
                                          "variationId": "155661299"
                                        },
                                        {
                                          "groupId": "49617948",
                                          "variationId": "155661302"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882394",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617947",
                                          "variationId": "155661300"
                                        },
                                        {
                                          "groupId": "49617948",
                                          "variationId": "155661301"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882388",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617947",
                                          "variationId": "155661300"
                                        },
                                        {
                                          "groupId": "49617948",
                                          "variationId": "155661302"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882394",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617947",
                                          "variationId": "155661297"
                                        },
                                        {
                                          "groupId": "49617948",
                                          "variationId": "155661301"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882388",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882392",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882389",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617947",
                                          "variationId": "155661297"
                                        },
                                        {
                                          "groupId": "49617948",
                                          "variationId": "155661302"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882396",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882399",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882394",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882388",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882389",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882392",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882394",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882396",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882399",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 35400,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334598",
                                "name": "Veggie Paradise Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with Golden corn, black olives, capsicum & red paprika",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/64261820-53d1-4c02-83b7-3695fb145d8f_0878efe9-eb9a-4414-a5b8-869668e1ed3f.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617967",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661369",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617968",
                                            "variationId": "155661373"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661370",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617968",
                                            "variationId": "155661373"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661371",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617968",
                                            "variationId": "155661373"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661372",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617968",
                                            "variationId": "155661373"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617968",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661373",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661374",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617967",
                                          "variationId": "155661370"
                                        },
                                        {
                                          "groupId": "49617968",
                                          "variationId": "155661373"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882439",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617967",
                                          "variationId": "155661370"
                                        },
                                        {
                                          "groupId": "49617968",
                                          "variationId": "155661374"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882442",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617967",
                                          "variationId": "155661371"
                                        },
                                        {
                                          "groupId": "49617968",
                                          "variationId": "155661373"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882439",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617967",
                                          "variationId": "155661371"
                                        },
                                        {
                                          "groupId": "49617968",
                                          "variationId": "155661374"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882442",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617967",
                                          "variationId": "155661372"
                                        },
                                        {
                                          "groupId": "49617968",
                                          "variationId": "155661373"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882439",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617967",
                                          "variationId": "155661372"
                                        },
                                        {
                                          "groupId": "49617968",
                                          "variationId": "155661374"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882442",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617967",
                                          "variationId": "155661369"
                                        },
                                        {
                                          "groupId": "49617968",
                                          "variationId": "155661373"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882439",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882441",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882440",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617967",
                                          "variationId": "155661369"
                                        },
                                        {
                                          "groupId": "49617968",
                                          "variationId": "155661374"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882443",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882444",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882442",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882439",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882440",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882441",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882442",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882443",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882444",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 35400,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334575",
                                "name": "Margherita Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with delight of 100% real mozzarella cheese",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/ccc30e06-ab70-45b6-9825-adf3150441af_3f3d3a2e-855b-4158-bcec-7615525e44b0.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617921",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661211",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617922",
                                            "variationId": "155661215"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661212",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617922",
                                            "variationId": "155661215"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661213",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617922",
                                            "variationId": "155661215"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661214",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617922",
                                            "variationId": "155661215"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617922",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661215",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661216",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617921",
                                          "variationId": "155661212"
                                        },
                                        {
                                          "groupId": "49617922",
                                          "variationId": "155661215"
                                        }
                                      ],
                                      "price": 18400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882312",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617921",
                                          "variationId": "155661212"
                                        },
                                        {
                                          "groupId": "49617922",
                                          "variationId": "155661216"
                                        }
                                      ],
                                      "price": 36400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882317",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617921",
                                          "variationId": "155661213"
                                        },
                                        {
                                          "groupId": "49617922",
                                          "variationId": "155661215"
                                        }
                                      ],
                                      "price": 18400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882312",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617921",
                                          "variationId": "155661213"
                                        },
                                        {
                                          "groupId": "49617922",
                                          "variationId": "155661216"
                                        }
                                      ],
                                      "price": 36400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882317",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617921",
                                          "variationId": "155661214"
                                        },
                                        {
                                          "groupId": "49617922",
                                          "variationId": "155661215"
                                        }
                                      ],
                                      "price": 18400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882312",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617921",
                                          "variationId": "155661214"
                                        },
                                        {
                                          "groupId": "49617922",
                                          "variationId": "155661216"
                                        }
                                      ],
                                      "price": 36400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882317",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617921",
                                          "variationId": "155661211"
                                        },
                                        {
                                          "groupId": "49617922",
                                          "variationId": "155661215"
                                        }
                                      ],
                                      "price": 18400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882312",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882315",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882314",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617921",
                                          "variationId": "155661211"
                                        },
                                        {
                                          "groupId": "49617922",
                                          "variationId": "155661216"
                                        }
                                      ],
                                      "price": 36400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882318",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882319",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882317",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882312",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882314",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882315",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882317",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882318",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882319",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 18400,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334607",
                                "name": "Spiced Double Chicken Pizza",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Molten Cheese Indulgence with combination of Pepper Barbecue Chicken & Peri Peri Chicken for Chicken lovers",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/bad67b37-0721-45a7-990d-3987f4464e06_62453978-9a8e-4a49-bc81-0ba84e842b65.jpg",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617980",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661404",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617981",
                                            "variationId": "155661408"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661405",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617981",
                                            "variationId": "155661408"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661406",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617981",
                                            "variationId": "155661408"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661407",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617981",
                                            "variationId": "155661408"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617981",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661408",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661409",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617980",
                                          "variationId": "155661404"
                                        },
                                        {
                                          "groupId": "49617981",
                                          "variationId": "155661408"
                                        }
                                      ],
                                      "price": 39000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882459",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617980",
                                          "variationId": "155661404"
                                        },
                                        {
                                          "groupId": "49617981",
                                          "variationId": "155661409"
                                        }
                                      ],
                                      "price": 65800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882464",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617980",
                                          "variationId": "155661405"
                                        },
                                        {
                                          "groupId": "49617981",
                                          "variationId": "155661409"
                                        }
                                      ],
                                      "price": 65800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882464",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617980",
                                          "variationId": "155661405"
                                        },
                                        {
                                          "groupId": "49617981",
                                          "variationId": "155661408"
                                        }
                                      ],
                                      "price": 39000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882459",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617980",
                                          "variationId": "155661406"
                                        },
                                        {
                                          "groupId": "49617981",
                                          "variationId": "155661408"
                                        }
                                      ],
                                      "price": 39000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882459",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617980",
                                          "variationId": "155661406"
                                        },
                                        {
                                          "groupId": "49617981",
                                          "variationId": "155661409"
                                        }
                                      ],
                                      "price": 65800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882464",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617980",
                                          "variationId": "155661407"
                                        },
                                        {
                                          "groupId": "49617981",
                                          "variationId": "155661408"
                                        }
                                      ],
                                      "price": 39000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882459",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882462",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882461",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617980",
                                          "variationId": "155661407"
                                        },
                                        {
                                          "groupId": "49617981",
                                          "variationId": "155661409"
                                        }
                                      ],
                                      "price": 65800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882466",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882467",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882464",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882459",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882461",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882462",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882464",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882466",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882467",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 39000,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334585",
                                "name": "Mexican Green Wave Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with Mexican herbs sprinkled on onion, capsicum, tomato & jalapeno",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/6aef4814-ce61-484e-a7d5-7f3e5d003288_be08f225-0fb1-498f-854a-1ba936aa8d60.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617938",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661267",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617939",
                                            "variationId": "155661272"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661268",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617939",
                                            "variationId": "155661272"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661269",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617939",
                                            "variationId": "155661272"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661270",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617939",
                                            "variationId": "155661272"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617939",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661272",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661274",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617938",
                                          "variationId": "155661268"
                                        },
                                        {
                                          "groupId": "49617939",
                                          "variationId": "155661272"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882361",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617938",
                                          "variationId": "155661268"
                                        },
                                        {
                                          "groupId": "49617939",
                                          "variationId": "155661274"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882365",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617938",
                                          "variationId": "155661269"
                                        },
                                        {
                                          "groupId": "49617939",
                                          "variationId": "155661272"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882361",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617938",
                                          "variationId": "155661269"
                                        },
                                        {
                                          "groupId": "49617939",
                                          "variationId": "155661274"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882365",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617938",
                                          "variationId": "155661270"
                                        },
                                        {
                                          "groupId": "49617939",
                                          "variationId": "155661272"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882361",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617938",
                                          "variationId": "155661270"
                                        },
                                        {
                                          "groupId": "49617939",
                                          "variationId": "155661274"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882365",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617938",
                                          "variationId": "155661267"
                                        },
                                        {
                                          "groupId": "49617939",
                                          "variationId": "155661272"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882361",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882363",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882362",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617938",
                                          "variationId": "155661267"
                                        },
                                        {
                                          "groupId": "49617939",
                                          "variationId": "155661274"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882367",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882369",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882365",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882361",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882362",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882363",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882365",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882367",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882369",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 35400,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334608",
                                "name": "Pepper Barbecue Chicken Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with Pepper Barbecue chicken for that extra zing",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/b99b241a-b4c7-438f-8d14-3f704dbe1cd4_eb4c709d-ebab-4291-be25-9900ab6b45e1.jpg",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617984",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661415",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617985",
                                            "variationId": "155661419"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661416",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617985",
                                            "variationId": "155661419"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661417",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617985",
                                            "variationId": "155661419"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661418",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617985",
                                            "variationId": "155661419"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617985",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661419",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661420",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617984",
                                          "variationId": "155661416"
                                        },
                                        {
                                          "groupId": "49617985",
                                          "variationId": "155661419"
                                        }
                                      ],
                                      "price": 34400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882469",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617984",
                                          "variationId": "155661416"
                                        },
                                        {
                                          "groupId": "49617985",
                                          "variationId": "155661420"
                                        }
                                      ],
                                      "price": 57800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882472",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617984",
                                          "variationId": "155661417"
                                        },
                                        {
                                          "groupId": "49617985",
                                          "variationId": "155661419"
                                        }
                                      ],
                                      "price": 34400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882469",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617984",
                                          "variationId": "155661417"
                                        },
                                        {
                                          "groupId": "49617985",
                                          "variationId": "155661420"
                                        }
                                      ],
                                      "price": 57800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882472",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617984",
                                          "variationId": "155661418"
                                        },
                                        {
                                          "groupId": "49617985",
                                          "variationId": "155661419"
                                        }
                                      ],
                                      "price": 34400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882469",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617984",
                                          "variationId": "155661418"
                                        },
                                        {
                                          "groupId": "49617985",
                                          "variationId": "155661420"
                                        }
                                      ],
                                      "price": 57800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882472",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617984",
                                          "variationId": "155661415"
                                        },
                                        {
                                          "groupId": "49617985",
                                          "variationId": "155661419"
                                        }
                                      ],
                                      "price": 34400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882469",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882471",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882470",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617984",
                                          "variationId": "155661415"
                                        },
                                        {
                                          "groupId": "49617985",
                                          "variationId": "155661420"
                                        }
                                      ],
                                      "price": 57800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882473",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882475",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882472",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882469",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882470",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882471",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882472",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882473",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882475",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 34400,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334587",
                                "name": "Indi Tandoori Paneer Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with spicy tandoori paneer, capsicum, red paprika & mint mayo",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/52268a6e-00c2-4a08-99b6-2ddee4f3bdd3_32c8ad06-4578-43da-9c45-e5848c1b9b43.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617944",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661284",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617945",
                                            "variationId": "155661288"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661285",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617945",
                                            "variationId": "155661288"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661286",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617945",
                                            "variationId": "155661288"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661287",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617945",
                                            "variationId": "155661288"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617945",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661288",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661289",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617944",
                                          "variationId": "155661287"
                                        },
                                        {
                                          "groupId": "49617945",
                                          "variationId": "155661288"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882378",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617944",
                                          "variationId": "155661287"
                                        },
                                        {
                                          "groupId": "49617945",
                                          "variationId": "155661289"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882382",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617944",
                                          "variationId": "155661284"
                                        },
                                        {
                                          "groupId": "49617945",
                                          "variationId": "155661288"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882378",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617944",
                                          "variationId": "155661284"
                                        },
                                        {
                                          "groupId": "49617945",
                                          "variationId": "155661289"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882382",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617944",
                                          "variationId": "155661285"
                                        },
                                        {
                                          "groupId": "49617945",
                                          "variationId": "155661288"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882378",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617944",
                                          "variationId": "155661285"
                                        },
                                        {
                                          "groupId": "49617945",
                                          "variationId": "155661289"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882382",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617944",
                                          "variationId": "155661286"
                                        },
                                        {
                                          "groupId": "49617945",
                                          "variationId": "155661288"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882378",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882381",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882380",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617944",
                                          "variationId": "155661286"
                                        },
                                        {
                                          "groupId": "49617945",
                                          "variationId": "155661289"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882383",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882384",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882382",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882378",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882380",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882381",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882382",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882383",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882384",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 39400,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334573",
                                "name": "Indi Chicken Tikka Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with wholesome flavour of tandoori masala topped with Chicken tikka, onion, red paprika & mint mayo",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/6b860839-56b2-4729-a0cb-ab5086fa49d4_5cac9a1b-ed2c-4a95-bb30-8586499e4f01.jpg",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617916",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661194",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617917",
                                            "variationId": "155661202"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661197",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617917",
                                            "variationId": "155661202"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661199",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617917",
                                            "variationId": "155661202"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661200",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617917",
                                            "variationId": "155661202"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617917",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661202",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661203",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617916",
                                          "variationId": "155661200"
                                        },
                                        {
                                          "groupId": "49617917",
                                          "variationId": "155661203"
                                        }
                                      ],
                                      "price": 72800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882297",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617916",
                                          "variationId": "155661194"
                                        },
                                        {
                                          "groupId": "49617917",
                                          "variationId": "155661202"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882302",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617916",
                                          "variationId": "155661194"
                                        },
                                        {
                                          "groupId": "49617917",
                                          "variationId": "155661203"
                                        }
                                      ],
                                      "price": 72800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882297",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617916",
                                          "variationId": "155661197"
                                        },
                                        {
                                          "groupId": "49617917",
                                          "variationId": "155661202"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882302",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617916",
                                          "variationId": "155661197"
                                        },
                                        {
                                          "groupId": "49617917",
                                          "variationId": "155661203"
                                        }
                                      ],
                                      "price": 72800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882297",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617916",
                                          "variationId": "155661199"
                                        },
                                        {
                                          "groupId": "49617917",
                                          "variationId": "155661202"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882302",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617916",
                                          "variationId": "155661199"
                                        },
                                        {
                                          "groupId": "49617917",
                                          "variationId": "155661203"
                                        }
                                      ],
                                      "price": 72800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882298",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882300",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882297",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617916",
                                          "variationId": "155661200"
                                        },
                                        {
                                          "groupId": "49617917",
                                          "variationId": "155661202"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882302",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882304",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882303",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882297",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882298",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882300",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882302",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882303",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882304",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 45400,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334578",
                                "name": "Double Cheese Margherita Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with loaded delight of 100% real mozzarella cheese",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/b07475c1-97a8-49d3-bba0-9696253d44ca_eb8e4fe6-f157-4e5e-ab8a-173ecb88d9c9.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617924",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661219",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617926",
                                            "variationId": "155661229"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661222",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617926",
                                            "variationId": "155661229"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661225",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617926",
                                            "variationId": "155661229"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661227",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617926",
                                            "variationId": "155661229"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617926",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661229",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661231",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617924",
                                          "variationId": "155661222"
                                        },
                                        {
                                          "groupId": "49617926",
                                          "variationId": "155661229"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882323",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617924",
                                          "variationId": "155661222"
                                        },
                                        {
                                          "groupId": "49617926",
                                          "variationId": "155661231"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882329",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617924",
                                          "variationId": "155661225"
                                        },
                                        {
                                          "groupId": "49617926",
                                          "variationId": "155661229"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882323",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617924",
                                          "variationId": "155661225"
                                        },
                                        {
                                          "groupId": "49617926",
                                          "variationId": "155661231"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882329",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617924",
                                          "variationId": "155661227"
                                        },
                                        {
                                          "groupId": "49617926",
                                          "variationId": "155661229"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882323",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617924",
                                          "variationId": "155661227"
                                        },
                                        {
                                          "groupId": "49617926",
                                          "variationId": "155661231"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882329",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617924",
                                          "variationId": "155661219"
                                        },
                                        {
                                          "groupId": "49617926",
                                          "variationId": "155661229"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882323",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882327",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882325",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617924",
                                          "variationId": "155661219"
                                        },
                                        {
                                          "groupId": "49617926",
                                          "variationId": "155661231"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882332",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882335",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882329",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882323",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882325",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882327",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882329",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882332",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882335",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 30400,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334561",
                                "name": "Cheese n Corn Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Molten Cheese Indulgence with a delectable combination of sweet & juicy golden corn",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/00fb90e9-6c94-41b6-98d4-7812cca42c1c_1331e26c-c671-4caa-82c4-1fcf90c55696.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617899",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661137",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617900",
                                            "variationId": "155661141"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661138",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617900",
                                            "variationId": "155661141"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661139",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617900",
                                            "variationId": "155661141"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661140",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617900",
                                            "variationId": "155661141"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617900",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661141",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661142",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617899",
                                          "variationId": "155661140"
                                        },
                                        {
                                          "groupId": "49617900",
                                          "variationId": "155661141"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882248",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617899",
                                          "variationId": "155661140"
                                        },
                                        {
                                          "groupId": "49617900",
                                          "variationId": "155661142"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882251",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617899",
                                          "variationId": "155661137"
                                        },
                                        {
                                          "groupId": "49617900",
                                          "variationId": "155661141"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882248",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617899",
                                          "variationId": "155661137"
                                        },
                                        {
                                          "groupId": "49617900",
                                          "variationId": "155661142"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882251",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617899",
                                          "variationId": "155661138"
                                        },
                                        {
                                          "groupId": "49617900",
                                          "variationId": "155661142"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882251",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617899",
                                          "variationId": "155661138"
                                        },
                                        {
                                          "groupId": "49617900",
                                          "variationId": "155661141"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882248",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617899",
                                          "variationId": "155661139"
                                        },
                                        {
                                          "groupId": "49617900",
                                          "variationId": "155661141"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882248",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882250",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882249",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617899",
                                          "variationId": "155661139"
                                        },
                                        {
                                          "groupId": "49617900",
                                          "variationId": "155661142"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882252",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882253",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882251",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882248",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882249",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882250",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882251",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882252",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882253",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 30400,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334571",
                                "name": "Chicken Golden Delight Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with Double pepper Barbecue chicken, golden corn and extra cheese",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/83cc07f2-9ae3-4bbd-a303-1c26d87a2bbc_ae0da352-da9d-4942-a23b-332e554b03c9.jpg",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617913",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661188",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617914",
                                            "variationId": "155661192"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661189",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617914",
                                            "variationId": "155661192"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661190",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617914",
                                            "variationId": "155661192"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661191",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617914",
                                            "variationId": "155661192"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617914",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661192",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661193",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617913",
                                          "variationId": "155661190"
                                        },
                                        {
                                          "groupId": "49617914",
                                          "variationId": "155661193"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882288",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617913",
                                          "variationId": "155661191"
                                        },
                                        {
                                          "groupId": "49617914",
                                          "variationId": "155661192"
                                        }
                                      ],
                                      "price": 40400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882293",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617913",
                                          "variationId": "155661191"
                                        },
                                        {
                                          "groupId": "49617914",
                                          "variationId": "155661193"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882288",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617913",
                                          "variationId": "155661188"
                                        },
                                        {
                                          "groupId": "49617914",
                                          "variationId": "155661192"
                                        }
                                      ],
                                      "price": 40400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882293",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617913",
                                          "variationId": "155661188"
                                        },
                                        {
                                          "groupId": "49617914",
                                          "variationId": "155661193"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882288",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617913",
                                          "variationId": "155661189"
                                        },
                                        {
                                          "groupId": "49617914",
                                          "variationId": "155661192"
                                        }
                                      ],
                                      "price": 40400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882293",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617913",
                                          "variationId": "155661189"
                                        },
                                        {
                                          "groupId": "49617914",
                                          "variationId": "155661193"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882290",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882291",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882288",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617913",
                                          "variationId": "155661190"
                                        },
                                        {
                                          "groupId": "49617914",
                                          "variationId": "155661192"
                                        }
                                      ],
                                      "price": 40400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882293",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882295",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882294",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882288",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882290",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882291",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882293",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882294",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882295",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 40400,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334582",
                                "name": "Chicken Fiesta Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with Grilled chicken rashers, peri-peri chicken, onion & capsicum",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/2d270ed3-34d4-49ed-8ad2-de66252fb494_cf81e686-25f5-49ab-90eb-59cb1ace9151.jpg",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617932",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661249",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617933",
                                            "variationId": "155661254"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661251",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617933",
                                            "variationId": "155661254"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661252",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617933",
                                            "variationId": "155661254"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661253",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617933",
                                            "variationId": "155661254"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617933",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661254",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661255",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617932",
                                          "variationId": "155661251"
                                        },
                                        {
                                          "groupId": "49617933",
                                          "variationId": "155661255"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882342",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617932",
                                          "variationId": "155661251"
                                        },
                                        {
                                          "groupId": "49617933",
                                          "variationId": "155661254"
                                        }
                                      ],
                                      "price": 40400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882349",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617932",
                                          "variationId": "155661252"
                                        },
                                        {
                                          "groupId": "49617933",
                                          "variationId": "155661254"
                                        }
                                      ],
                                      "price": 40400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882349",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617932",
                                          "variationId": "155661252"
                                        },
                                        {
                                          "groupId": "49617933",
                                          "variationId": "155661255"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882342",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617932",
                                          "variationId": "155661253"
                                        },
                                        {
                                          "groupId": "49617933",
                                          "variationId": "155661254"
                                        }
                                      ],
                                      "price": 40400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882349",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617932",
                                          "variationId": "155661253"
                                        },
                                        {
                                          "groupId": "49617933",
                                          "variationId": "155661255"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882342",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617932",
                                          "variationId": "155661249"
                                        },
                                        {
                                          "groupId": "49617933",
                                          "variationId": "155661254"
                                        }
                                      ],
                                      "price": 40400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882349",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882352",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882350",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617932",
                                          "variationId": "155661249"
                                        },
                                        {
                                          "groupId": "49617933",
                                          "variationId": "155661255"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882344",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882346",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882342",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882342",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882344",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882346",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882349",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882350",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882352",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 40400,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334569",
                                "name": "Fresh Veggie Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with combination of onion & capsicum",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/9b5b0373-4569-416b-b289-6dd546a21a7f_3f47169f-7fc6-4a59-8ec9-afc5992542cc.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617909",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661173",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617910",
                                            "variationId": "155661177"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661174",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617910",
                                            "variationId": "155661177"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661175",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617910",
                                            "variationId": "155661177"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661176",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617910",
                                            "variationId": "155661177"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617910",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661177",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661178",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617909",
                                          "variationId": "155661175"
                                        },
                                        {
                                          "groupId": "49617910",
                                          "variationId": "155661177"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882278",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617909",
                                          "variationId": "155661175"
                                        },
                                        {
                                          "groupId": "49617910",
                                          "variationId": "155661178"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882281",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617909",
                                          "variationId": "155661176"
                                        },
                                        {
                                          "groupId": "49617910",
                                          "variationId": "155661177"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882278",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617909",
                                          "variationId": "155661176"
                                        },
                                        {
                                          "groupId": "49617910",
                                          "variationId": "155661178"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882281",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617909",
                                          "variationId": "155661173"
                                        },
                                        {
                                          "groupId": "49617910",
                                          "variationId": "155661177"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882278",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617909",
                                          "variationId": "155661173"
                                        },
                                        {
                                          "groupId": "49617910",
                                          "variationId": "155661178"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882281",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617909",
                                          "variationId": "155661174"
                                        },
                                        {
                                          "groupId": "49617910",
                                          "variationId": "155661178"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882282",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882283",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882281",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617909",
                                          "variationId": "155661174"
                                        },
                                        {
                                          "groupId": "49617910",
                                          "variationId": "155661177"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882278",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882280",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882279",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882278",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882279",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882280",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882281",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882282",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882283",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 30400,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334568",
                                "name": "Chicken Pepperoni Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with American classic flavored Chicken Pepperoni, topped with extra cheese",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/82e80d82-8d85-4543-bb7e-4dc2b71d7188_e66fc751-937b-4ec1-99a1-86caba8f2420.jpg",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617907",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661167",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617908",
                                            "variationId": "155661171"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661168",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617908",
                                            "variationId": "155661171"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661169",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617908",
                                            "variationId": "155661171"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661170",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617908",
                                            "variationId": "155661171"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617908",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661171",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661172",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617907",
                                          "variationId": "155661168"
                                        },
                                        {
                                          "groupId": "49617908",
                                          "variationId": "155661172"
                                        }
                                      ],
                                      "price": 72800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882270",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617907",
                                          "variationId": "155661168"
                                        },
                                        {
                                          "groupId": "49617908",
                                          "variationId": "155661171"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882275",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617907",
                                          "variationId": "155661169"
                                        },
                                        {
                                          "groupId": "49617908",
                                          "variationId": "155661171"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882275",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617907",
                                          "variationId": "155661169"
                                        },
                                        {
                                          "groupId": "49617908",
                                          "variationId": "155661172"
                                        }
                                      ],
                                      "price": 72800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882270",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617907",
                                          "variationId": "155661170"
                                        },
                                        {
                                          "groupId": "49617908",
                                          "variationId": "155661171"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882275",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617907",
                                          "variationId": "155661170"
                                        },
                                        {
                                          "groupId": "49617908",
                                          "variationId": "155661172"
                                        }
                                      ],
                                      "price": 72800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882270",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617907",
                                          "variationId": "155661167"
                                        },
                                        {
                                          "groupId": "49617908",
                                          "variationId": "155661171"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882275",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882277",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882276",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617907",
                                          "variationId": "155661167"
                                        },
                                        {
                                          "groupId": "49617908",
                                          "variationId": "155661172"
                                        }
                                      ],
                                      "price": 72800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882272",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882274",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882270",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882270",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882272",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882274",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882275",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882276",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882277",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 45400,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334612",
                                "name": "Achari Do Pyaza Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with tangy & spicy achari flavours on a super cheesy onion pizza",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/eff260f3-7e8c-4a2a-9b55-bcde4f0522dd_7f54d7d9-96fc-4638-8d2d-c953a79aa5d3.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617997",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661444",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617998",
                                            "variationId": "155661450"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661445",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617998",
                                            "variationId": "155661450"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661447",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617998",
                                            "variationId": "155661450"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661448",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617998",
                                            "variationId": "155661450"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617998",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661450",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661451",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617997",
                                          "variationId": "155661445"
                                        },
                                        {
                                          "groupId": "49617998",
                                          "variationId": "155661451"
                                        }
                                      ],
                                      "price": 44800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882487",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617997",
                                          "variationId": "155661445"
                                        },
                                        {
                                          "groupId": "49617998",
                                          "variationId": "155661450"
                                        }
                                      ],
                                      "price": 27400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882492",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617997",
                                          "variationId": "155661447"
                                        },
                                        {
                                          "groupId": "49617998",
                                          "variationId": "155661450"
                                        }
                                      ],
                                      "price": 27400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882492",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617997",
                                          "variationId": "155661447"
                                        },
                                        {
                                          "groupId": "49617998",
                                          "variationId": "155661451"
                                        }
                                      ],
                                      "price": 44800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882487",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617997",
                                          "variationId": "155661448"
                                        },
                                        {
                                          "groupId": "49617998",
                                          "variationId": "155661450"
                                        }
                                      ],
                                      "price": 27400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882492",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617997",
                                          "variationId": "155661448"
                                        },
                                        {
                                          "groupId": "49617998",
                                          "variationId": "155661451"
                                        }
                                      ],
                                      "price": 44800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882487",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617997",
                                          "variationId": "155661444"
                                        },
                                        {
                                          "groupId": "49617998",
                                          "variationId": "155661450"
                                        }
                                      ],
                                      "price": 27400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882492",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882495",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882493",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617997",
                                          "variationId": "155661444"
                                        },
                                        {
                                          "groupId": "49617998",
                                          "variationId": "155661451"
                                        }
                                      ],
                                      "price": 44800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882488",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882490",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882487",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882487",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882488",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882490",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882492",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882493",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882495",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 27400,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334615",
                                "name": "The 5 Chicken Feast Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Molten Cheese Indulgence Loaded with 5 different Chicken toppings - grilled Chicken Rashers, Chicken MeatBalls, Chicken Tikka, herby Chicken Sausage & Chicken Keema",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/55cf2f2a-4fe1-4f67-9967-4d260747a5f1_9d96ecf0-9923-428b-baac-c558dfd84d2e.jpg",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49618005",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661469",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49618006",
                                            "variationId": "155661473"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661470",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49618006",
                                            "variationId": "155661473"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661471",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49618006",
                                            "variationId": "155661473"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661472",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49618006",
                                            "variationId": "155661473"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49618006",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661473",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661474",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49618005",
                                          "variationId": "155661469"
                                        },
                                        {
                                          "groupId": "49618006",
                                          "variationId": "155661474"
                                        }
                                      ],
                                      "price": 80800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882502",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49618005",
                                          "variationId": "155661470"
                                        },
                                        {
                                          "groupId": "49618006",
                                          "variationId": "155661474"
                                        }
                                      ],
                                      "price": 80800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882502",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49618005",
                                          "variationId": "155661470"
                                        },
                                        {
                                          "groupId": "49618006",
                                          "variationId": "155661473"
                                        }
                                      ],
                                      "price": 48000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882508",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49618005",
                                          "variationId": "155661471"
                                        },
                                        {
                                          "groupId": "49618006",
                                          "variationId": "155661473"
                                        }
                                      ],
                                      "price": 48000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882508",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49618005",
                                          "variationId": "155661471"
                                        },
                                        {
                                          "groupId": "49618006",
                                          "variationId": "155661474"
                                        }
                                      ],
                                      "price": 80800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882502",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49618005",
                                          "variationId": "155661472"
                                        },
                                        {
                                          "groupId": "49618006",
                                          "variationId": "155661473"
                                        }
                                      ],
                                      "price": 48000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882508",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49618005",
                                          "variationId": "155661472"
                                        },
                                        {
                                          "groupId": "49618006",
                                          "variationId": "155661474"
                                        }
                                      ],
                                      "price": 80800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882504",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882506",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882502",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49618005",
                                          "variationId": "155661469"
                                        },
                                        {
                                          "groupId": "49618006",
                                          "variationId": "155661473"
                                        }
                                      ],
                                      "price": 48000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882508",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882510",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882509",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882502",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882504",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882506",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882508",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882509",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882510",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 48000,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334610",
                                "name": "Chicken Sausage Cheese Burst",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Now in 3 New Flavours - Molten Cheese Indulgence with American classic herbed chicken sausage",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/d8ed092e-1e47-413c-927e-b332ef507097_ed5ffcac-15b7-4ab8-8ba7-51317eefe42c.jpg",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617991",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661433",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617992",
                                            "variationId": "155661437"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661434",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617992",
                                            "variationId": "155661437"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661435",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617992",
                                            "variationId": "155661437"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661436",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617992",
                                            "variationId": "155661437"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617992",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661437",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661438",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617991",
                                          "variationId": "155661434"
                                        },
                                        {
                                          "groupId": "49617992",
                                          "variationId": "155661437"
                                        }
                                      ],
                                      "price": 29400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882481",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617991",
                                          "variationId": "155661434"
                                        },
                                        {
                                          "groupId": "49617992",
                                          "variationId": "155661438"
                                        }
                                      ],
                                      "price": 48800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882484",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617991",
                                          "variationId": "155661435"
                                        },
                                        {
                                          "groupId": "49617992",
                                          "variationId": "155661437"
                                        }
                                      ],
                                      "price": 29400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882481",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617991",
                                          "variationId": "155661435"
                                        },
                                        {
                                          "groupId": "49617992",
                                          "variationId": "155661438"
                                        }
                                      ],
                                      "price": 48800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882484",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617991",
                                          "variationId": "155661436"
                                        },
                                        {
                                          "groupId": "49617992",
                                          "variationId": "155661437"
                                        }
                                      ],
                                      "price": 29400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882481",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617991",
                                          "variationId": "155661436"
                                        },
                                        {
                                          "groupId": "49617992",
                                          "variationId": "155661438"
                                        }
                                      ],
                                      "price": 48800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882484",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617991",
                                          "variationId": "155661433"
                                        },
                                        {
                                          "groupId": "49617992",
                                          "variationId": "155661437"
                                        }
                                      ],
                                      "price": 29400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882481",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882483",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882482",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617991",
                                          "variationId": "155661433"
                                        },
                                        {
                                          "groupId": "49617992",
                                          "variationId": "155661438"
                                        }
                                      ],
                                      "price": 48800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882485",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882486",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882484",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882481",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882482",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882483",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882484",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882485",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882486",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 29400,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334603",
                                "name": "Fiery Jalapeno & Paprika Pizza",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Molten Cheese Indulgence with jalapeno & red paprika toppings along with spicy peri peri sauce",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/82a43df5-5cdd-4073-971f-b20c3cfa7f4d_5173638b-6513-482b-b0df-9a743ab90496.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617974",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661384",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617975",
                                            "variationId": "155661388"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661385",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617975",
                                            "variationId": "155661388"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661386",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617975",
                                            "variationId": "155661388"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661387",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617975",
                                            "variationId": "155661388"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617975",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661388",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661389",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617974",
                                          "variationId": "155661386"
                                        },
                                        {
                                          "groupId": "49617975",
                                          "variationId": "155661388"
                                        }
                                      ],
                                      "price": 26000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882447",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617974",
                                          "variationId": "155661386"
                                        },
                                        {
                                          "groupId": "49617975",
                                          "variationId": "155661389"
                                        }
                                      ],
                                      "price": 43400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882451",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617974",
                                          "variationId": "155661387"
                                        },
                                        {
                                          "groupId": "49617975",
                                          "variationId": "155661388"
                                        }
                                      ],
                                      "price": 26000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882447",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617974",
                                          "variationId": "155661387"
                                        },
                                        {
                                          "groupId": "49617975",
                                          "variationId": "155661389"
                                        }
                                      ],
                                      "price": 43400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882451",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617974",
                                          "variationId": "155661384"
                                        },
                                        {
                                          "groupId": "49617975",
                                          "variationId": "155661388"
                                        }
                                      ],
                                      "price": 26000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882447",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617974",
                                          "variationId": "155661384"
                                        },
                                        {
                                          "groupId": "49617975",
                                          "variationId": "155661389"
                                        }
                                      ],
                                      "price": 43400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882451",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617974",
                                          "variationId": "155661385"
                                        },
                                        {
                                          "groupId": "49617975",
                                          "variationId": "155661388"
                                        }
                                      ],
                                      "price": 26000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882447",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882450",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882448",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617974",
                                          "variationId": "155661385"
                                        },
                                        {
                                          "groupId": "49617975",
                                          "variationId": "155661389"
                                        }
                                      ],
                                      "price": 43400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882453",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882455",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882451",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882447",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882448",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882450",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882451",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882453",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882455",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 26000,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334563",
                                "name": "Fiery Sausage & Paprika Pizza",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Molten Cheese Indulgence with spicy & herby chicken sausage and red paprika toppings along with spicy peri peri sauce",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/70dea34a-f906-4a28-8f3c-52271b2383d9_e3804e5e-5b4e-40b5-9199-61b4e8b622af.jpg",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617903",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661149",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617904",
                                            "variationId": "155661153"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661150",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617904",
                                            "variationId": "155661153"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661151",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617904",
                                            "variationId": "155661153"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661152",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617904",
                                            "variationId": "155661153"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617904",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661153",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661154",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617903",
                                          "variationId": "155661150"
                                        },
                                        {
                                          "groupId": "49617904",
                                          "variationId": "155661153"
                                        }
                                      ],
                                      "price": 33000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882260",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617903",
                                          "variationId": "155661150"
                                        },
                                        {
                                          "groupId": "49617904",
                                          "variationId": "155661154"
                                        }
                                      ],
                                      "price": 55400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882263",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617903",
                                          "variationId": "155661151"
                                        },
                                        {
                                          "groupId": "49617904",
                                          "variationId": "155661153"
                                        }
                                      ],
                                      "price": 33000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882260",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617903",
                                          "variationId": "155661151"
                                        },
                                        {
                                          "groupId": "49617904",
                                          "variationId": "155661154"
                                        }
                                      ],
                                      "price": 55400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882263",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617903",
                                          "variationId": "155661152"
                                        },
                                        {
                                          "groupId": "49617904",
                                          "variationId": "155661153"
                                        }
                                      ],
                                      "price": 33000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882260",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617903",
                                          "variationId": "155661152"
                                        },
                                        {
                                          "groupId": "49617904",
                                          "variationId": "155661154"
                                        }
                                      ],
                                      "price": 55400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882263",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617903",
                                          "variationId": "155661149"
                                        },
                                        {
                                          "groupId": "49617904",
                                          "variationId": "155661153"
                                        }
                                      ],
                                      "price": 33000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882260",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882262",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882261",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617903",
                                          "variationId": "155661149"
                                        },
                                        {
                                          "groupId": "49617904",
                                          "variationId": "155661154"
                                        }
                                      ],
                                      "price": 55400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882264",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882265",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882263",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882260",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882261",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882262",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882263",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882264",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882265",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 33000,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334560",
                                "name": "Blazing Onion & Paprika Pizza",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Molten Cheese Indulgence with onion & red paprika toppings along with spicy peri peri sauce",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/670e0759-e3b2-470d-963f-124a362528bf_0dba27c7-1b9c-40c3-8b41-d9a16d3fd02e.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617897",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661131",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617898",
                                            "variationId": "155661135"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661132",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617898",
                                            "variationId": "155661135"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661133",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617898",
                                            "variationId": "155661135"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661134",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617898",
                                            "variationId": "155661135"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617898",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661135",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661136",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617897",
                                          "variationId": "155661132"
                                        },
                                        {
                                          "groupId": "49617898",
                                          "variationId": "155661136"
                                        }
                                      ],
                                      "price": 43400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882239",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882239",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882239",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882239",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882239",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882239",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882239",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882239",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882241",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882241",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882241",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882241",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882241",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882241",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882241",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882238",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617897",
                                          "variationId": "155661133"
                                        },
                                        {
                                          "groupId": "49617898",
                                          "variationId": "155661135"
                                        }
                                      ],
                                      "price": 26000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882242",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882246",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882246",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882246",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882246",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882246",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882246",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882246",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882246",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882244",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882244",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882244",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882244",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882244",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882244",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882244",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617897",
                                          "variationId": "155661133"
                                        },
                                        {
                                          "groupId": "49617898",
                                          "variationId": "155661136"
                                        }
                                      ],
                                      "price": 43400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882239",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882239",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882239",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882239",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882239",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882239",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882239",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882239",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882241",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882241",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882241",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882241",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882241",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882241",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882241",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882238",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617897",
                                          "variationId": "155661134"
                                        },
                                        {
                                          "groupId": "49617898",
                                          "variationId": "155661135"
                                        }
                                      ],
                                      "price": 26000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882242",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882246",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882246",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882246",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882246",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882246",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882246",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882246",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882246",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882244",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882244",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882244",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882244",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882244",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882244",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882244",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617897",
                                          "variationId": "155661134"
                                        },
                                        {
                                          "groupId": "49617898",
                                          "variationId": "155661136"
                                        }
                                      ],
                                      "price": 43400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882239",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882239",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882239",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882239",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882239",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882239",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882239",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882239",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882241",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882241",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882241",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882241",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882241",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882241",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882241",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882238",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617897",
                                          "variationId": "155661131"
                                        },
                                        {
                                          "groupId": "49617898",
                                          "variationId": "155661135"
                                        }
                                      ],
                                      "price": 26000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882242",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882246",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882246",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882246",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882246",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882246",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882246",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882246",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882246",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882244",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882244",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882244",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882244",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882244",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882244",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882244",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617897",
                                          "variationId": "155661131"
                                        },
                                        {
                                          "groupId": "49617898",
                                          "variationId": "155661136"
                                        }
                                      ],
                                      "price": 43400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882239",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882239",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882239",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882239",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882239",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882239",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882239",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882239",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882241",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882241",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882241",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882241",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882241",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882241",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882241",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882238",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617897",
                                          "variationId": "155661132"
                                        },
                                        {
                                          "groupId": "49617898",
                                          "variationId": "155661135"
                                        }
                                      ],
                                      "price": 26000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882242",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882246",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882246",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882246",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882246",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882246",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882246",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882246",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882246",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882244",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882244",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882244",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882244",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882244",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882244",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882244",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882238",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882239",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882241",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882242",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882244",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882246",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 26000,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334592",
                                "name": "Blazing Chicken & Paprika Pizza",
                                "category": "Cheese Burst - 3 New Flavours",
                                "description": "Molten Cheese Indulgence with a combination of chicken keema & red paprika toppings along with spicy peri peri sauce",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/ac6f8b27-ee28-46b6-b106-226976ad2008_5e3d3531-285b-472c-8a89-94b69b24337c.jpg",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49617954",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661322",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617955",
                                            "variationId": "155661326"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "155661323",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617955",
                                            "variationId": "155661326"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661324",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617955",
                                            "variationId": "155661326"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661325",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "49617955",
                                            "variationId": "155661326"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "49617955",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "155661326",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "155661327",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617954",
                                          "variationId": "155661324"
                                        },
                                        {
                                          "groupId": "49617955",
                                          "variationId": "155661327"
                                        }
                                      ],
                                      "price": 55400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882407",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882407",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882407",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882407",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882407",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882407",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882407",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882407",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882410",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882410",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882410",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882410",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882410",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882410",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882410",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882405",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617954",
                                          "variationId": "155661325"
                                        },
                                        {
                                          "groupId": "49617955",
                                          "variationId": "155661326"
                                        }
                                      ],
                                      "price": 33000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882413",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882416",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882416",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882416",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882416",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882416",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882416",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882416",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882416",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882415",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882415",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882415",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882415",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882415",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882415",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882415",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617954",
                                          "variationId": "155661325"
                                        },
                                        {
                                          "groupId": "49617955",
                                          "variationId": "155661327"
                                        }
                                      ],
                                      "price": 55400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882407",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882407",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882407",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882407",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882407",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882407",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882407",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882407",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882410",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882410",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882410",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882410",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882410",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882410",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882410",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882405",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617954",
                                          "variationId": "155661322"
                                        },
                                        {
                                          "groupId": "49617955",
                                          "variationId": "155661326"
                                        }
                                      ],
                                      "price": 33000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882413",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882416",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882416",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882416",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882416",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882416",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882416",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882416",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882416",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882415",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882415",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882415",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882415",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882415",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882415",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882415",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617954",
                                          "variationId": "155661322"
                                        },
                                        {
                                          "groupId": "49617955",
                                          "variationId": "155661327"
                                        }
                                      ],
                                      "price": 55400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882407",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882407",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882407",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882407",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882407",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882407",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882407",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882407",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882410",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882410",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882410",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882410",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882410",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882410",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882410",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882405",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617954",
                                          "variationId": "155661323"
                                        },
                                        {
                                          "groupId": "49617955",
                                          "variationId": "155661327"
                                        }
                                      ],
                                      "price": 55400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882407",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "180882407",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "180882407",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "180882407",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "180882407",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "180882407",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "180882407",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "180882407",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "180882410",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "180882410",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "180882410",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "180882410",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "180882410",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "180882410",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "180882410",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "180882405",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617954",
                                          "variationId": "155661323"
                                        },
                                        {
                                          "groupId": "49617955",
                                          "variationId": "155661326"
                                        }
                                      ],
                                      "price": 33000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882413",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882416",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882416",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882416",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882416",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882416",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882416",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882416",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882416",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882415",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882415",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882415",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882415",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882415",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882415",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882415",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "49617954",
                                          "variationId": "155661324"
                                        },
                                        {
                                          "groupId": "49617955",
                                          "variationId": "155661326"
                                        }
                                      ],
                                      "price": 33000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "180882413",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "180882416",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "180882416",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "180882416",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "180882416",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "180882416",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "180882416",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "180882416",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "180882416",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "180882415",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "180882415",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "180882415",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "180882415",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "180882415",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "180882415",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "180882415",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "180882405",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882407",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882410",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882413",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882415",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "180882416",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 33000,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {
                          
                        }
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Cheese Volcano",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "146311238",
                                "name": "Cheese Volcano Peppy Paneer",
                                "category": "Cheese Volcano",
                                "description": "Centre loaded with Molten Cheese & topped with peppy Paneer, Capsicum & Red Paprika\n*Contains non-edible container under the Pizza",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/3ab84285-8164-4447-b534-f371913491c6_f91a0f02-a155-4a2a-8567-ae9d56ec5b2b.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "48415150",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Cheese Volcano Crust",
                                          "default": 1,
                                          "id": "152760280",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "48415151",
                                            "variationId": "152760281"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "48415151",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular Plus",
                                          "default": 1,
                                          "id": "152760281",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium Plus",
                                          "id": "152760282",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "48415150",
                                          "variationId": "152760280"
                                        },
                                        {
                                          "groupId": "48415151",
                                          "variationId": "152760281"
                                        }
                                      ],
                                      "price": 31900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "176969697",
                                          "addonId": "121101498"
                                        },
                                        {
                                          "groupId": "176969697",
                                          "addonId": "121101486"
                                        },
                                        {
                                          "groupId": "176969697",
                                          "addonId": "121101500"
                                        },
                                        {
                                          "groupId": "176969697",
                                          "addonId": "121101494"
                                        },
                                        {
                                          "groupId": "176969697",
                                          "addonId": "121101487"
                                        },
                                        {
                                          "groupId": "176969697",
                                          "addonId": "121101502"
                                        },
                                        {
                                          "groupId": "176969697",
                                          "addonId": "121101490"
                                        },
                                        {
                                          "groupId": "176969697",
                                          "addonId": "121101504"
                                        },
                                        {
                                          "groupId": "176969698",
                                          "addonId": "121101485"
                                        },
                                        {
                                          "groupId": "176969698",
                                          "addonId": "121101509"
                                        },
                                        {
                                          "groupId": "176969698",
                                          "addonId": "121101488"
                                        },
                                        {
                                          "groupId": "176969698",
                                          "addonId": "121101489"
                                        },
                                        {
                                          "groupId": "176969698",
                                          "addonId": "121101503"
                                        },
                                        {
                                          "groupId": "176969698",
                                          "addonId": "121101491"
                                        },
                                        {
                                          "groupId": "176969698",
                                          "addonId": "121101505"
                                        },
                                        {
                                          "groupId": "176969696",
                                          "addonId": "121101480"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "48415150",
                                          "variationId": "152760280"
                                        },
                                        {
                                          "groupId": "48415151",
                                          "variationId": "152760282"
                                        }
                                      ],
                                      "price": 52900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "176969699",
                                          "addonId": "121101506"
                                        },
                                        {
                                          "groupId": "176969699",
                                          "addonId": "121101481"
                                        },
                                        {
                                          "groupId": "176969699",
                                          "addonId": "121101493"
                                        },
                                        {
                                          "groupId": "176969699",
                                          "addonId": "121101483"
                                        },
                                        {
                                          "groupId": "176969699",
                                          "addonId": "121101507"
                                        },
                                        {
                                          "groupId": "176969699",
                                          "addonId": "121101478"
                                        },
                                        {
                                          "groupId": "176969699",
                                          "addonId": "121101501"
                                        },
                                        {
                                          "groupId": "176969699",
                                          "addonId": "121101496"
                                        },
                                        {
                                          "groupId": "176969701",
                                          "addonId": "121101497"
                                        },
                                        {
                                          "groupId": "176969701",
                                          "addonId": "121101492"
                                        },
                                        {
                                          "groupId": "176969701",
                                          "addonId": "121101482"
                                        },
                                        {
                                          "groupId": "176969701",
                                          "addonId": "121101508"
                                        },
                                        {
                                          "groupId": "176969701",
                                          "addonId": "121101484"
                                        },
                                        {
                                          "groupId": "176969701",
                                          "addonId": "121101479"
                                        },
                                        {
                                          "groupId": "176969701",
                                          "addonId": "121101495"
                                        },
                                        {
                                          "groupId": "176969700",
                                          "addonId": "121101499"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "176969696",
                                    "groupName": "Extra Cheese Regular Plus",
                                    "choices": [
                                      {
                                        "id": "121101480",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969697",
                                    "groupName": "Veg Toppings Regular Plus",
                                    "choices": [
                                      {
                                        "id": "121101498",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101486",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101500",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101494",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101487",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101502",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101490",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101504",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969698",
                                    "groupName": "Non-Veg Toppings Regular Plus",
                                    "choices": [
                                      {
                                        "id": "121101485",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101509",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101488",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101489",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101503",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101491",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101505",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969699",
                                    "groupName": "Veg Toppings Medium Plus",
                                    "choices": [
                                      {
                                        "id": "121101506",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101481",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101493",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101483",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101507",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101478",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101501",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101496",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969700",
                                    "groupName": "Extra Cheese Medium Plus",
                                    "choices": [
                                      {
                                        "id": "121101499",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969701",
                                    "groupName": "Non-Veg Toppings Medium Plus",
                                    "choices": [
                                      {
                                        "id": "121101497",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101492",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101482",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101508",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101484",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101479",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101495",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 31900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.7",
                                    "ratingCount": "11 ratings",
                                    "ratingCountV2": "11"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "146311240",
                                "name": "Cheese Volcano Farmhouse",
                                "category": "Cheese Volcano",
                                "description": "Centre loaded with Molten Cheese & topped with Onion, Capsicum, Tomato & Grilled Mushroom\n*Contains non-edible container under the Pizza",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/4e30b1ff-dbe8-41d3-b083-d46b9d742ffc_636d161e-7f34-4371-b63c-bf9e3d091a0f.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "48415176",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Cheese Volcano Crust",
                                          "default": 1,
                                          "id": "152760319",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "48415177",
                                            "variationId": "152760320"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "48415177",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular Plus",
                                          "default": 1,
                                          "id": "152760320",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium Plus",
                                          "id": "152760321",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "48415176",
                                          "variationId": "152760319"
                                        },
                                        {
                                          "groupId": "48415177",
                                          "variationId": "152760320"
                                        }
                                      ],
                                      "price": 31900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "176969773",
                                          "addonId": "121101498"
                                        },
                                        {
                                          "groupId": "176969773",
                                          "addonId": "121101486"
                                        },
                                        {
                                          "groupId": "176969773",
                                          "addonId": "121101500"
                                        },
                                        {
                                          "groupId": "176969773",
                                          "addonId": "121101494"
                                        },
                                        {
                                          "groupId": "176969773",
                                          "addonId": "121101487"
                                        },
                                        {
                                          "groupId": "176969773",
                                          "addonId": "121101502"
                                        },
                                        {
                                          "groupId": "176969773",
                                          "addonId": "121101490"
                                        },
                                        {
                                          "groupId": "176969773",
                                          "addonId": "121101504"
                                        },
                                        {
                                          "groupId": "176969776",
                                          "addonId": "121101485"
                                        },
                                        {
                                          "groupId": "176969776",
                                          "addonId": "121101509"
                                        },
                                        {
                                          "groupId": "176969776",
                                          "addonId": "121101488"
                                        },
                                        {
                                          "groupId": "176969776",
                                          "addonId": "121101489"
                                        },
                                        {
                                          "groupId": "176969776",
                                          "addonId": "121101503"
                                        },
                                        {
                                          "groupId": "176969776",
                                          "addonId": "121101491"
                                        },
                                        {
                                          "groupId": "176969776",
                                          "addonId": "121101505"
                                        },
                                        {
                                          "groupId": "176969771",
                                          "addonId": "121101480"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "48415176",
                                          "variationId": "152760319"
                                        },
                                        {
                                          "groupId": "48415177",
                                          "variationId": "152760321"
                                        }
                                      ],
                                      "price": 52900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "176969777",
                                          "addonId": "121101506"
                                        },
                                        {
                                          "groupId": "176969777",
                                          "addonId": "121101481"
                                        },
                                        {
                                          "groupId": "176969777",
                                          "addonId": "121101493"
                                        },
                                        {
                                          "groupId": "176969777",
                                          "addonId": "121101483"
                                        },
                                        {
                                          "groupId": "176969777",
                                          "addonId": "121101507"
                                        },
                                        {
                                          "groupId": "176969777",
                                          "addonId": "121101478"
                                        },
                                        {
                                          "groupId": "176969777",
                                          "addonId": "121101501"
                                        },
                                        {
                                          "groupId": "176969777",
                                          "addonId": "121101496"
                                        },
                                        {
                                          "groupId": "176969781",
                                          "addonId": "121101497"
                                        },
                                        {
                                          "groupId": "176969781",
                                          "addonId": "121101492"
                                        },
                                        {
                                          "groupId": "176969781",
                                          "addonId": "121101482"
                                        },
                                        {
                                          "groupId": "176969781",
                                          "addonId": "121101508"
                                        },
                                        {
                                          "groupId": "176969781",
                                          "addonId": "121101484"
                                        },
                                        {
                                          "groupId": "176969781",
                                          "addonId": "121101479"
                                        },
                                        {
                                          "groupId": "176969781",
                                          "addonId": "121101495"
                                        },
                                        {
                                          "groupId": "176969780",
                                          "addonId": "121101499"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "176969771",
                                    "groupName": "Extra Cheese Regular Plus",
                                    "choices": [
                                      {
                                        "id": "121101480",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969773",
                                    "groupName": "Veg Toppings Regular Plus",
                                    "choices": [
                                      {
                                        "id": "121101498",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101486",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101500",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101494",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101487",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101502",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101490",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101504",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969776",
                                    "groupName": "Non-Veg Toppings Regular Plus",
                                    "choices": [
                                      {
                                        "id": "121101485",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101509",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101488",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101489",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101503",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101491",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101505",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969777",
                                    "groupName": "Veg Toppings Medium Plus",
                                    "choices": [
                                      {
                                        "id": "121101506",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101481",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101493",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101483",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101507",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101478",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101501",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101496",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969780",
                                    "groupName": "Extra Cheese Medium Plus",
                                    "choices": [
                                      {
                                        "id": "121101499",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969781",
                                    "groupName": "Non-Veg Toppings Medium Plus",
                                    "choices": [
                                      {
                                        "id": "121101497",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101492",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101482",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101508",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101484",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101479",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101495",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 31900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.5",
                                    "ratingCount": "10 ratings",
                                    "ratingCountV2": "10"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "146311245",
                                "name": "Cheese Volcano Veg Paradise",
                                "category": "Cheese Volcano",
                                "description": "Centre loaded with Molten Cheese & topped with Golden Corn, Black Olives, Capsicum & Red Paprika\n*Contains non-edible container under the Pizza",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/3e08f33d-98b7-41d2-acca-182da98e80f4_dd0b2e67-2a47-4a5e-b906-63e1277e7fa2.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "48415154",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Cheese Volcano Crust",
                                          "default": 1,
                                          "id": "152760286",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "48415155",
                                            "variationId": "152760287"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "48415155",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular Plus",
                                          "default": 1,
                                          "id": "152760287",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium Plus",
                                          "id": "152760288",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "48415154",
                                          "variationId": "152760286"
                                        },
                                        {
                                          "groupId": "48415155",
                                          "variationId": "152760287"
                                        }
                                      ],
                                      "price": 31900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "176969709",
                                          "addonId": "121101498"
                                        },
                                        {
                                          "groupId": "176969709",
                                          "addonId": "121101486"
                                        },
                                        {
                                          "groupId": "176969709",
                                          "addonId": "121101500"
                                        },
                                        {
                                          "groupId": "176969709",
                                          "addonId": "121101494"
                                        },
                                        {
                                          "groupId": "176969709",
                                          "addonId": "121101487"
                                        },
                                        {
                                          "groupId": "176969709",
                                          "addonId": "121101502"
                                        },
                                        {
                                          "groupId": "176969709",
                                          "addonId": "121101490"
                                        },
                                        {
                                          "groupId": "176969709",
                                          "addonId": "121101504"
                                        },
                                        {
                                          "groupId": "176969710",
                                          "addonId": "121101485"
                                        },
                                        {
                                          "groupId": "176969710",
                                          "addonId": "121101509"
                                        },
                                        {
                                          "groupId": "176969710",
                                          "addonId": "121101488"
                                        },
                                        {
                                          "groupId": "176969710",
                                          "addonId": "121101489"
                                        },
                                        {
                                          "groupId": "176969710",
                                          "addonId": "121101503"
                                        },
                                        {
                                          "groupId": "176969710",
                                          "addonId": "121101491"
                                        },
                                        {
                                          "groupId": "176969710",
                                          "addonId": "121101505"
                                        },
                                        {
                                          "groupId": "176969708",
                                          "addonId": "121101480"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "48415154",
                                          "variationId": "152760286"
                                        },
                                        {
                                          "groupId": "48415155",
                                          "variationId": "152760288"
                                        }
                                      ],
                                      "price": 52900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "176969711",
                                          "addonId": "121101506"
                                        },
                                        {
                                          "groupId": "176969711",
                                          "addonId": "121101481"
                                        },
                                        {
                                          "groupId": "176969711",
                                          "addonId": "121101493"
                                        },
                                        {
                                          "groupId": "176969711",
                                          "addonId": "121101483"
                                        },
                                        {
                                          "groupId": "176969711",
                                          "addonId": "121101507"
                                        },
                                        {
                                          "groupId": "176969711",
                                          "addonId": "121101478"
                                        },
                                        {
                                          "groupId": "176969711",
                                          "addonId": "121101501"
                                        },
                                        {
                                          "groupId": "176969711",
                                          "addonId": "121101496"
                                        },
                                        {
                                          "groupId": "176969713",
                                          "addonId": "121101497"
                                        },
                                        {
                                          "groupId": "176969713",
                                          "addonId": "121101492"
                                        },
                                        {
                                          "groupId": "176969713",
                                          "addonId": "121101482"
                                        },
                                        {
                                          "groupId": "176969713",
                                          "addonId": "121101508"
                                        },
                                        {
                                          "groupId": "176969713",
                                          "addonId": "121101484"
                                        },
                                        {
                                          "groupId": "176969713",
                                          "addonId": "121101479"
                                        },
                                        {
                                          "groupId": "176969713",
                                          "addonId": "121101495"
                                        },
                                        {
                                          "groupId": "176969712",
                                          "addonId": "121101499"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "176969708",
                                    "groupName": "Extra Cheese Regular Plus",
                                    "choices": [
                                      {
                                        "id": "121101480",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969709",
                                    "groupName": "Veg Toppings Regular Plus",
                                    "choices": [
                                      {
                                        "id": "121101498",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101486",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101500",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101494",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101487",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101502",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101490",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101504",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969710",
                                    "groupName": "Non-Veg Toppings Regular Plus",
                                    "choices": [
                                      {
                                        "id": "121101485",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101509",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101488",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101489",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101503",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101491",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101505",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969711",
                                    "groupName": "Veg Toppings Medium Plus",
                                    "choices": [
                                      {
                                        "id": "121101506",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101481",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101493",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101483",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101507",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101478",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101501",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101496",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969712",
                                    "groupName": "Extra Cheese Medium Plus",
                                    "choices": [
                                      {
                                        "id": "121101499",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969713",
                                    "groupName": "Non-Veg Toppings Medium Plus",
                                    "choices": [
                                      {
                                        "id": "121101497",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101492",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101482",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101508",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101484",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101479",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101495",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 31900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.9",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "146311239",
                                "name": "Corn & Cheese Volcano",
                                "category": "Cheese Volcano",
                                "description": "Centre loaded with Molten Cheese & topped with juicy Golden Corn\n*Contains non-edible container under the Pizza",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/375ae4df-de00-4235-97c5-3de32ebd969c_c7ea4a4e-86a9-467b-a42d-13e058670d28.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "48415148",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Cheese Volcano Crust",
                                          "default": 1,
                                          "id": "152760277",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "48415149",
                                            "variationId": "152760278"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "48415149",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular Plus",
                                          "default": 1,
                                          "id": "152760278",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium Plus",
                                          "id": "152760279",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "48415148",
                                          "variationId": "152760277"
                                        },
                                        {
                                          "groupId": "48415149",
                                          "variationId": "152760278"
                                        }
                                      ],
                                      "price": 31900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "176969691",
                                          "addonId": "121101498"
                                        },
                                        {
                                          "groupId": "176969691",
                                          "addonId": "121101486"
                                        },
                                        {
                                          "groupId": "176969691",
                                          "addonId": "121101500"
                                        },
                                        {
                                          "groupId": "176969691",
                                          "addonId": "121101494"
                                        },
                                        {
                                          "groupId": "176969691",
                                          "addonId": "121101487"
                                        },
                                        {
                                          "groupId": "176969691",
                                          "addonId": "121101502"
                                        },
                                        {
                                          "groupId": "176969691",
                                          "addonId": "121101490"
                                        },
                                        {
                                          "groupId": "176969691",
                                          "addonId": "121101504"
                                        },
                                        {
                                          "groupId": "176969692",
                                          "addonId": "121101485"
                                        },
                                        {
                                          "groupId": "176969692",
                                          "addonId": "121101509"
                                        },
                                        {
                                          "groupId": "176969692",
                                          "addonId": "121101488"
                                        },
                                        {
                                          "groupId": "176969692",
                                          "addonId": "121101489"
                                        },
                                        {
                                          "groupId": "176969692",
                                          "addonId": "121101503"
                                        },
                                        {
                                          "groupId": "176969692",
                                          "addonId": "121101491"
                                        },
                                        {
                                          "groupId": "176969692",
                                          "addonId": "121101505"
                                        },
                                        {
                                          "groupId": "176969690",
                                          "addonId": "121101480"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "48415148",
                                          "variationId": "152760277"
                                        },
                                        {
                                          "groupId": "48415149",
                                          "variationId": "152760279"
                                        }
                                      ],
                                      "price": 52900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "176969693",
                                          "addonId": "121101506"
                                        },
                                        {
                                          "groupId": "176969693",
                                          "addonId": "121101481"
                                        },
                                        {
                                          "groupId": "176969693",
                                          "addonId": "121101493"
                                        },
                                        {
                                          "groupId": "176969693",
                                          "addonId": "121101483"
                                        },
                                        {
                                          "groupId": "176969693",
                                          "addonId": "121101507"
                                        },
                                        {
                                          "groupId": "176969693",
                                          "addonId": "121101478"
                                        },
                                        {
                                          "groupId": "176969693",
                                          "addonId": "121101501"
                                        },
                                        {
                                          "groupId": "176969693",
                                          "addonId": "121101496"
                                        },
                                        {
                                          "groupId": "176969695",
                                          "addonId": "121101497"
                                        },
                                        {
                                          "groupId": "176969695",
                                          "addonId": "121101492"
                                        },
                                        {
                                          "groupId": "176969695",
                                          "addonId": "121101482"
                                        },
                                        {
                                          "groupId": "176969695",
                                          "addonId": "121101508"
                                        },
                                        {
                                          "groupId": "176969695",
                                          "addonId": "121101484"
                                        },
                                        {
                                          "groupId": "176969695",
                                          "addonId": "121101479"
                                        },
                                        {
                                          "groupId": "176969695",
                                          "addonId": "121101495"
                                        },
                                        {
                                          "groupId": "176969694",
                                          "addonId": "121101499"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "176969690",
                                    "groupName": "Extra Cheese Regular Plus",
                                    "choices": [
                                      {
                                        "id": "121101480",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969691",
                                    "groupName": "Veg Toppings Regular Plus",
                                    "choices": [
                                      {
                                        "id": "121101498",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101486",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101500",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101494",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101487",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101502",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101490",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101504",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969692",
                                    "groupName": "Non-Veg Toppings Regular Plus",
                                    "choices": [
                                      {
                                        "id": "121101485",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101509",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101488",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101489",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101503",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101491",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101505",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969693",
                                    "groupName": "Veg Toppings Medium Plus",
                                    "choices": [
                                      {
                                        "id": "121101506",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101481",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101493",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101483",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101507",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101478",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101501",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101496",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969694",
                                    "groupName": "Extra Cheese Medium Plus",
                                    "choices": [
                                      {
                                        "id": "121101499",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969695",
                                    "groupName": "Non-Veg Toppings Medium Plus",
                                    "choices": [
                                      {
                                        "id": "121101497",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101492",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101482",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101508",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101484",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101479",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101495",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 31900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "146311244",
                                "name": "Cheese Volcano BBQ Chicken",
                                "category": "Cheese Volcano",
                                "description": "Centre loaded with Molten Cheese & topped with Pepper BBQ Chicken\n*Contains non-edible container under the Pizza",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/bb8bf7b5-d084-4690-893e-ea5af460ad5d_fd69db19-9923-4ab7-936c-e2b1300a9b25.jpg",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "48415162",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Cheese Volcano Crust",
                                          "default": 1,
                                          "id": "152760298",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "48415163",
                                            "variationId": "152760299"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "48415163",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular Plus",
                                          "default": 1,
                                          "id": "152760299",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium Plus",
                                          "id": "152760300",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "48415162",
                                          "variationId": "152760298"
                                        },
                                        {
                                          "groupId": "48415163",
                                          "variationId": "152760299"
                                        }
                                      ],
                                      "price": 36900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "176969730",
                                          "addonId": "121101498"
                                        },
                                        {
                                          "groupId": "176969730",
                                          "addonId": "121101486"
                                        },
                                        {
                                          "groupId": "176969730",
                                          "addonId": "121101500"
                                        },
                                        {
                                          "groupId": "176969730",
                                          "addonId": "121101494"
                                        },
                                        {
                                          "groupId": "176969730",
                                          "addonId": "121101487"
                                        },
                                        {
                                          "groupId": "176969730",
                                          "addonId": "121101502"
                                        },
                                        {
                                          "groupId": "176969730",
                                          "addonId": "121101490"
                                        },
                                        {
                                          "groupId": "176969730",
                                          "addonId": "121101504"
                                        },
                                        {
                                          "groupId": "176969732",
                                          "addonId": "121101485"
                                        },
                                        {
                                          "groupId": "176969732",
                                          "addonId": "121101509"
                                        },
                                        {
                                          "groupId": "176969732",
                                          "addonId": "121101488"
                                        },
                                        {
                                          "groupId": "176969732",
                                          "addonId": "121101489"
                                        },
                                        {
                                          "groupId": "176969732",
                                          "addonId": "121101503"
                                        },
                                        {
                                          "groupId": "176969732",
                                          "addonId": "121101491"
                                        },
                                        {
                                          "groupId": "176969732",
                                          "addonId": "121101505"
                                        },
                                        {
                                          "groupId": "176969728",
                                          "addonId": "121101480"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "48415162",
                                          "variationId": "152760298"
                                        },
                                        {
                                          "groupId": "48415163",
                                          "variationId": "152760300"
                                        }
                                      ],
                                      "price": 57900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "176969734",
                                          "addonId": "121101506"
                                        },
                                        {
                                          "groupId": "176969734",
                                          "addonId": "121101481"
                                        },
                                        {
                                          "groupId": "176969734",
                                          "addonId": "121101493"
                                        },
                                        {
                                          "groupId": "176969734",
                                          "addonId": "121101483"
                                        },
                                        {
                                          "groupId": "176969734",
                                          "addonId": "121101507"
                                        },
                                        {
                                          "groupId": "176969734",
                                          "addonId": "121101478"
                                        },
                                        {
                                          "groupId": "176969734",
                                          "addonId": "121101501"
                                        },
                                        {
                                          "groupId": "176969734",
                                          "addonId": "121101496"
                                        },
                                        {
                                          "groupId": "176969737",
                                          "addonId": "121101497"
                                        },
                                        {
                                          "groupId": "176969737",
                                          "addonId": "121101492"
                                        },
                                        {
                                          "groupId": "176969737",
                                          "addonId": "121101482"
                                        },
                                        {
                                          "groupId": "176969737",
                                          "addonId": "121101508"
                                        },
                                        {
                                          "groupId": "176969737",
                                          "addonId": "121101484"
                                        },
                                        {
                                          "groupId": "176969737",
                                          "addonId": "121101479"
                                        },
                                        {
                                          "groupId": "176969737",
                                          "addonId": "121101495"
                                        },
                                        {
                                          "groupId": "176969736",
                                          "addonId": "121101499"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "176969728",
                                    "groupName": "Extra Cheese Regular Plus",
                                    "choices": [
                                      {
                                        "id": "121101480",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969730",
                                    "groupName": "Veg Toppings Regular Plus",
                                    "choices": [
                                      {
                                        "id": "121101498",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101486",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101500",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101494",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101487",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101502",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101490",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101504",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969732",
                                    "groupName": "Non-Veg Toppings Regular Plus",
                                    "choices": [
                                      {
                                        "id": "121101485",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101509",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101488",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101489",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101503",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101491",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101505",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969734",
                                    "groupName": "Veg Toppings Medium Plus",
                                    "choices": [
                                      {
                                        "id": "121101506",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101481",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101493",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101483",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101507",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101478",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101501",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101496",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969736",
                                    "groupName": "Extra Cheese Medium Plus",
                                    "choices": [
                                      {
                                        "id": "121101499",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969737",
                                    "groupName": "Non-Veg Toppings Medium Plus",
                                    "choices": [
                                      {
                                        "id": "121101497",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101492",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101482",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101508",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101484",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101479",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101495",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 36900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "146311241",
                                "name": "Cheese Volcano Chicken Delight",
                                "category": "Cheese Volcano",
                                "description": "Centre loaded with Molten Cheese & topped with Pepper BBQ Chicken & Golden Corn\n*Contains non-edible container under the Pizza",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/ec91a814-b0f9-4911-b972-3c2a3583c684_d8de24fd-5109-4870-bf74-66f9ebb4ace5.jpg",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "48415170",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Cheese Volcano Crust",
                                          "default": 1,
                                          "id": "152760310",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "48415171",
                                            "variationId": "152760311"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "48415171",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular Plus",
                                          "default": 1,
                                          "id": "152760311",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium Plus",
                                          "id": "152760312",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "48415170",
                                          "variationId": "152760310"
                                        },
                                        {
                                          "groupId": "48415171",
                                          "variationId": "152760311"
                                        }
                                      ],
                                      "price": 36900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "176969754",
                                          "addonId": "121101498"
                                        },
                                        {
                                          "groupId": "176969754",
                                          "addonId": "121101486"
                                        },
                                        {
                                          "groupId": "176969754",
                                          "addonId": "121101500"
                                        },
                                        {
                                          "groupId": "176969754",
                                          "addonId": "121101494"
                                        },
                                        {
                                          "groupId": "176969754",
                                          "addonId": "121101487"
                                        },
                                        {
                                          "groupId": "176969754",
                                          "addonId": "121101502"
                                        },
                                        {
                                          "groupId": "176969754",
                                          "addonId": "121101490"
                                        },
                                        {
                                          "groupId": "176969754",
                                          "addonId": "121101504"
                                        },
                                        {
                                          "groupId": "176969756",
                                          "addonId": "121101485"
                                        },
                                        {
                                          "groupId": "176969756",
                                          "addonId": "121101509"
                                        },
                                        {
                                          "groupId": "176969756",
                                          "addonId": "121101488"
                                        },
                                        {
                                          "groupId": "176969756",
                                          "addonId": "121101489"
                                        },
                                        {
                                          "groupId": "176969756",
                                          "addonId": "121101503"
                                        },
                                        {
                                          "groupId": "176969756",
                                          "addonId": "121101491"
                                        },
                                        {
                                          "groupId": "176969756",
                                          "addonId": "121101505"
                                        },
                                        {
                                          "groupId": "176969752",
                                          "addonId": "121101480"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "48415170",
                                          "variationId": "152760310"
                                        },
                                        {
                                          "groupId": "48415171",
                                          "variationId": "152760312"
                                        }
                                      ],
                                      "price": 57900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "176969758",
                                          "addonId": "121101506"
                                        },
                                        {
                                          "groupId": "176969758",
                                          "addonId": "121101481"
                                        },
                                        {
                                          "groupId": "176969758",
                                          "addonId": "121101493"
                                        },
                                        {
                                          "groupId": "176969758",
                                          "addonId": "121101483"
                                        },
                                        {
                                          "groupId": "176969758",
                                          "addonId": "121101507"
                                        },
                                        {
                                          "groupId": "176969758",
                                          "addonId": "121101478"
                                        },
                                        {
                                          "groupId": "176969758",
                                          "addonId": "121101501"
                                        },
                                        {
                                          "groupId": "176969758",
                                          "addonId": "121101496"
                                        },
                                        {
                                          "groupId": "176969763",
                                          "addonId": "121101497"
                                        },
                                        {
                                          "groupId": "176969763",
                                          "addonId": "121101492"
                                        },
                                        {
                                          "groupId": "176969763",
                                          "addonId": "121101482"
                                        },
                                        {
                                          "groupId": "176969763",
                                          "addonId": "121101508"
                                        },
                                        {
                                          "groupId": "176969763",
                                          "addonId": "121101484"
                                        },
                                        {
                                          "groupId": "176969763",
                                          "addonId": "121101479"
                                        },
                                        {
                                          "groupId": "176969763",
                                          "addonId": "121101495"
                                        },
                                        {
                                          "groupId": "176969761",
                                          "addonId": "121101499"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "176969752",
                                    "groupName": "Extra Cheese Regular Plus",
                                    "choices": [
                                      {
                                        "id": "121101480",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969754",
                                    "groupName": "Veg Toppings Regular Plus",
                                    "choices": [
                                      {
                                        "id": "121101498",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101486",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101500",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101494",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101487",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101502",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101490",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101504",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969756",
                                    "groupName": "Non-Veg Toppings Regular Plus",
                                    "choices": [
                                      {
                                        "id": "121101485",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101509",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101488",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101489",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101503",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101491",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101505",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969758",
                                    "groupName": "Veg Toppings Medium Plus",
                                    "choices": [
                                      {
                                        "id": "121101506",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101481",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101493",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101483",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101507",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101478",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101501",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101496",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969761",
                                    "groupName": "Extra Cheese Medium Plus",
                                    "choices": [
                                      {
                                        "id": "121101499",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969763",
                                    "groupName": "Non-Veg Toppings Medium Plus",
                                    "choices": [
                                      {
                                        "id": "121101497",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101492",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101482",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101508",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101484",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101479",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101495",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 36900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "146311243",
                                "name": "Cheese Volcano Double Chicken",
                                "category": "Cheese Volcano",
                                "description": "Centre loaded with Molten Cheese & topped with Pepper BBQ Chicken & Peri Peri Chicken.\n*Contains non-edible container under the Pizza",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/a842381d-5d56-4a1e-99b8-4594170ae2c1_6d79c2a4-5aec-4067-acea-0afdfd875830.jpg",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "48415158",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Cheese Volcano Crust",
                                          "default": 1,
                                          "id": "152760292",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "48415159",
                                            "variationId": "152760293"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "48415159",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular Plus",
                                          "default": 1,
                                          "id": "152760293",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium Plus",
                                          "id": "152760294",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "48415158",
                                          "variationId": "152760292"
                                        },
                                        {
                                          "groupId": "48415159",
                                          "variationId": "152760293"
                                        }
                                      ],
                                      "price": 36900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "176969718",
                                          "addonId": "121101498"
                                        },
                                        {
                                          "groupId": "176969718",
                                          "addonId": "121101486"
                                        },
                                        {
                                          "groupId": "176969718",
                                          "addonId": "121101500"
                                        },
                                        {
                                          "groupId": "176969718",
                                          "addonId": "121101494"
                                        },
                                        {
                                          "groupId": "176969718",
                                          "addonId": "121101487"
                                        },
                                        {
                                          "groupId": "176969718",
                                          "addonId": "121101502"
                                        },
                                        {
                                          "groupId": "176969718",
                                          "addonId": "121101490"
                                        },
                                        {
                                          "groupId": "176969718",
                                          "addonId": "121101504"
                                        },
                                        {
                                          "groupId": "176969720",
                                          "addonId": "121101485"
                                        },
                                        {
                                          "groupId": "176969720",
                                          "addonId": "121101509"
                                        },
                                        {
                                          "groupId": "176969720",
                                          "addonId": "121101488"
                                        },
                                        {
                                          "groupId": "176969720",
                                          "addonId": "121101489"
                                        },
                                        {
                                          "groupId": "176969720",
                                          "addonId": "121101503"
                                        },
                                        {
                                          "groupId": "176969720",
                                          "addonId": "121101491"
                                        },
                                        {
                                          "groupId": "176969720",
                                          "addonId": "121101505"
                                        },
                                        {
                                          "groupId": "176969716",
                                          "addonId": "121101480"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "48415158",
                                          "variationId": "152760292"
                                        },
                                        {
                                          "groupId": "48415159",
                                          "variationId": "152760294"
                                        }
                                      ],
                                      "price": 57900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "176969722",
                                          "addonId": "121101506"
                                        },
                                        {
                                          "groupId": "176969722",
                                          "addonId": "121101481"
                                        },
                                        {
                                          "groupId": "176969722",
                                          "addonId": "121101493"
                                        },
                                        {
                                          "groupId": "176969722",
                                          "addonId": "121101483"
                                        },
                                        {
                                          "groupId": "176969722",
                                          "addonId": "121101507"
                                        },
                                        {
                                          "groupId": "176969722",
                                          "addonId": "121101478"
                                        },
                                        {
                                          "groupId": "176969722",
                                          "addonId": "121101501"
                                        },
                                        {
                                          "groupId": "176969722",
                                          "addonId": "121101496"
                                        },
                                        {
                                          "groupId": "176969725",
                                          "addonId": "121101497"
                                        },
                                        {
                                          "groupId": "176969725",
                                          "addonId": "121101492"
                                        },
                                        {
                                          "groupId": "176969725",
                                          "addonId": "121101482"
                                        },
                                        {
                                          "groupId": "176969725",
                                          "addonId": "121101508"
                                        },
                                        {
                                          "groupId": "176969725",
                                          "addonId": "121101484"
                                        },
                                        {
                                          "groupId": "176969725",
                                          "addonId": "121101479"
                                        },
                                        {
                                          "groupId": "176969725",
                                          "addonId": "121101495"
                                        },
                                        {
                                          "groupId": "176969724",
                                          "addonId": "121101499"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "176969716",
                                    "groupName": "Extra Cheese Regular Plus",
                                    "choices": [
                                      {
                                        "id": "121101480",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969718",
                                    "groupName": "Veg Toppings Regular Plus",
                                    "choices": [
                                      {
                                        "id": "121101498",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101486",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101500",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101494",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101487",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101502",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101490",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101504",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969720",
                                    "groupName": "Non-Veg Toppings Regular Plus",
                                    "choices": [
                                      {
                                        "id": "121101485",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101509",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101488",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101489",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101503",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101491",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101505",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969722",
                                    "groupName": "Veg Toppings Medium Plus",
                                    "choices": [
                                      {
                                        "id": "121101506",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101481",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101493",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101483",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101507",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101478",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101501",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101496",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969724",
                                    "groupName": "Extra Cheese Medium Plus",
                                    "choices": [
                                      {
                                        "id": "121101499",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969725",
                                    "groupName": "Non-Veg Toppings Medium Plus",
                                    "choices": [
                                      {
                                        "id": "121101497",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101492",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101482",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101508",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101484",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101479",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101495",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 36900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "7 ratings",
                                    "ratingCountV2": "7"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "146311242",
                                "name": "Cheese Volcano Blazing Chicken",
                                "category": "Cheese Volcano",
                                "description": "Centre loaded with Molten Cheese & topped with Chicken Keema & Red Paprika with our spicy Peri Peri Sauce\n*Contains non-edible container under the Pizza",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/e0d6d213-d5ac-45a7-b53f-d6c836d53659_33957602-94cc-4a32-9a21-6b65d35815fc.jpg",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "48415166",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Cheese Volcano Crust",
                                          "default": 1,
                                          "id": "152760304",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "48415167",
                                            "variationId": "152760305"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "48415167",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular Plus",
                                          "default": 1,
                                          "id": "152760305",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium Plus",
                                          "id": "152760306",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "48415166",
                                          "variationId": "152760304"
                                        },
                                        {
                                          "groupId": "48415167",
                                          "variationId": "152760305"
                                        }
                                      ],
                                      "price": 36900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "176969742",
                                          "addonId": "121101498"
                                        },
                                        {
                                          "groupId": "176969742",
                                          "addonId": "121101486"
                                        },
                                        {
                                          "groupId": "176969742",
                                          "addonId": "121101500"
                                        },
                                        {
                                          "groupId": "176969742",
                                          "addonId": "121101494"
                                        },
                                        {
                                          "groupId": "176969742",
                                          "addonId": "121101487"
                                        },
                                        {
                                          "groupId": "176969742",
                                          "addonId": "121101502"
                                        },
                                        {
                                          "groupId": "176969742",
                                          "addonId": "121101490"
                                        },
                                        {
                                          "groupId": "176969742",
                                          "addonId": "121101504"
                                        },
                                        {
                                          "groupId": "176969744",
                                          "addonId": "121101485"
                                        },
                                        {
                                          "groupId": "176969744",
                                          "addonId": "121101509"
                                        },
                                        {
                                          "groupId": "176969744",
                                          "addonId": "121101488"
                                        },
                                        {
                                          "groupId": "176969744",
                                          "addonId": "121101489"
                                        },
                                        {
                                          "groupId": "176969744",
                                          "addonId": "121101503"
                                        },
                                        {
                                          "groupId": "176969744",
                                          "addonId": "121101491"
                                        },
                                        {
                                          "groupId": "176969744",
                                          "addonId": "121101505"
                                        },
                                        {
                                          "groupId": "176969740",
                                          "addonId": "121101480"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "48415166",
                                          "variationId": "152760304"
                                        },
                                        {
                                          "groupId": "48415167",
                                          "variationId": "152760306"
                                        }
                                      ],
                                      "price": 57900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "176969746",
                                          "addonId": "121101506"
                                        },
                                        {
                                          "groupId": "176969746",
                                          "addonId": "121101481"
                                        },
                                        {
                                          "groupId": "176969746",
                                          "addonId": "121101493"
                                        },
                                        {
                                          "groupId": "176969746",
                                          "addonId": "121101483"
                                        },
                                        {
                                          "groupId": "176969746",
                                          "addonId": "121101507"
                                        },
                                        {
                                          "groupId": "176969746",
                                          "addonId": "121101478"
                                        },
                                        {
                                          "groupId": "176969746",
                                          "addonId": "121101501"
                                        },
                                        {
                                          "groupId": "176969746",
                                          "addonId": "121101496"
                                        },
                                        {
                                          "groupId": "176969749",
                                          "addonId": "121101497"
                                        },
                                        {
                                          "groupId": "176969749",
                                          "addonId": "121101492"
                                        },
                                        {
                                          "groupId": "176969749",
                                          "addonId": "121101482"
                                        },
                                        {
                                          "groupId": "176969749",
                                          "addonId": "121101508"
                                        },
                                        {
                                          "groupId": "176969749",
                                          "addonId": "121101484"
                                        },
                                        {
                                          "groupId": "176969749",
                                          "addonId": "121101479"
                                        },
                                        {
                                          "groupId": "176969749",
                                          "addonId": "121101495"
                                        },
                                        {
                                          "groupId": "176969748",
                                          "addonId": "121101499"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "176969740",
                                    "groupName": "Extra Cheese Regular Plus",
                                    "choices": [
                                      {
                                        "id": "121101480",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969742",
                                    "groupName": "Veg Toppings Regular Plus",
                                    "choices": [
                                      {
                                        "id": "121101498",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101486",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101500",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101494",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101487",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101502",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101490",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101504",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969744",
                                    "groupName": "Non-Veg Toppings Regular Plus",
                                    "choices": [
                                      {
                                        "id": "121101485",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101509",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101488",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101489",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101503",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101491",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101505",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969746",
                                    "groupName": "Veg Toppings Medium Plus",
                                    "choices": [
                                      {
                                        "id": "121101506",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101481",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101493",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101483",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101507",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101478",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101501",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101496",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969748",
                                    "groupName": "Extra Cheese Medium Plus",
                                    "choices": [
                                      {
                                        "id": "121101499",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "176969749",
                                    "groupName": "Non-Veg Toppings Medium Plus",
                                    "choices": [
                                      {
                                        "id": "121101497",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101492",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101482",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101508",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101484",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101479",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121101495",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 36900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {
                          
                        }
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Party Combo",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "113943670",
                                "name": "Special Party for 4 (Veg) @Rs. 180 off",
                                "category": "Party Combo",
                                "description": "Medium Peppy Paneer + Medium Farmhouse + Garlic Bread + 2 Pepsi",
                                "imageId": "4dfd02271e979bdcbed7737473d930c5",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 102500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "119171145",
                                "name": "Pizza Party for 4 (Veg) @Rs. 180 Off",
                                "category": "Party Combo",
                                "description": "Meal for 4: Regular Veg Extravaganza + Regular Indi Tandoori Paneer + Regular Farmhouse + Regular Veggie Paradise",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/31/99380be1-e010-42b9-ac5f-18eca2c4df13_8817bc9d-8a29-4e7e-ab1f-2be79a8a3441.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 101900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "119171144",
                                "name": "Party for 4 (Veg) @Rs. 130 off",
                                "category": "Party Combo",
                                "description": "Meal for 4: Medium Margherita + Medium Farmhouse with Garlic Bread & 2 Pepsi",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/31/1d4d5779-0945-4804-8156-1346d4cc708d_0df4edfa-f7da-4a74-87e8-69b66a894b79.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 85100,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "113943672",
                                "name": "Extravaganza Party for 2 (Veg) @Rs. 110 off",
                                "category": "Party Combo",
                                "description": "Regular Veg Extravaganza + Regular Indi Tandoori Paneer + Garlic Bread + Pepsi",
                                "imageId": "0cbd92945fdc750f47e0b6c38ad7108b",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 70500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "119171143",
                                "name": "Dominator Party for 2 (Non-Veg) @Rs. 140 off",
                                "category": "Party Combo",
                                "description": "Meal for 2: Regular Non Veg Supreme + Regular Chicken Dominator with Garlic Bread & Pepsi",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/31/524f9cd4-1390-4805-996b-f17800529004_4b1eb214-7d4d-46b6-873c-17cebe117543.jpg",
                                "inStock": 1,
                                "price": 79500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "125889585",
                                "name": "Special Party for 2 (Veg) @Rs. 105 off",
                                "category": "Party Combo",
                                "description": "Regular Farmhouse + Regular Peppy Paneer + Garlic Bread + Pepsi",
                                "imageId": "fbdef2d7dcfc5374f48cce734867aa30",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 62500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "4 ratings",
                                    "ratingCountV2": "4"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "131414961",
                                "name": "Match Day Veg Combo @Rs. 110 off",
                                "category": "Party Combo",
                                "description": "Meal for 2: Regular Veg Extravaganza + Regular Indi Tandoori Paneer with Chocolava Cake & Pepsi",
                                "imageId": "80c0a378d5a09f45ca7881518ab276dd",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 70500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "119171142",
                                "name": "Special Party for 2 (Non-Veg) @Rs. 115 off",
                                "category": "Party Combo",
                                "description": "Meal for 2: Regular Pepper BBQ Chicken + Regular Chicken Dominator with Garlic Bread & Pepsi",
                                "imageId": "c314a5711c2c1d6cfa607e452abb9719",
                                "inStock": 1,
                                "price": 70500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "113943669",
                                "name": "Party for 2 (Non-Veg) @Rs. 85 off",
                                "category": "Party Combo",
                                "description": "Regular Pepper BBQ Chicken + Regular Chicken Sausage + Garlic Bread + Pepsi",
                                "imageId": "fc7ff3ec875af65564f55a00ce69560e",
                                "inStock": 1,
                                "price": 57500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "113943668",
                                "name": "Party for 2 (Veg) @Rs. 75 off",
                                "category": "Party Combo",
                                "description": "Regular Margherita +Regular  Farmhouse + Garlic Bread + Pepsi",
                                "imageId": "71650740c571a88037477e3293612212",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 48500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "4 ratings",
                                    "ratingCountV2": "4"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "113943673",
                                "name": "Dominator Party for 4 (Non-Veg) @Rs. 300 off",
                                "category": "Party Combo",
                                "description": "Medium Non Veg Supreme + Medium Chicken Dominator + Garlic Bread + 2 Pepsi",
                                "imageId": "38bfe017ea257a74608088f0c33e2232",
                                "inStock": 1,
                                "price": 118500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {
                          
                        }
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Value Meals",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "107334750",
                                "name": "Meal for 4: Veg Loaded Pizza",
                                "category": "Value Meals",
                                "description": "Regular Veg Extravaganza + Regular Veg Paradise Pizza + Regular Indi Tandoori Paneer + Regular Farmhouse",
                                "imageId": "cec2c497598bb14d08214e28b4beb672",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 97300,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "133928410",
                                "name": "Meal for 2: Pepper BBQ Chicken & Chicken Dominator",
                                "category": "Value Meals",
                                "description": "Regular Pepper BBQ Chicken + Regular Chicken Dominator + Garlic Bread + Pepsi",
                                "imageId": "eaee2535b8e10b2d2c5204f0af014c62",
                                "inStock": 1,
                                "price": 67700,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "107334633",
                                "name": "Meal for 2: Pepper BBQ Chicken & Spiced Double Chicken",
                                "category": "Value Meals",
                                "description": "Regular Pepper BBQ Chicken + Regular Spiced Double Chicken + Garlic Bread + Pepsi",
                                "imageId": "db7b7c52258c9b4d15f5a20841907c6f",
                                "inStock": 1,
                                "price": 63700,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "107334704",
                                "name": "Meal for 4: Veg Extravaganza & Indi Tandoori Paneer",
                                "category": "Value Meals",
                                "description": "Medium Veg Extravaganza + Medium Indi Tandoori Paneer + Garlic Bread + 2 Pepsi",
                                "imageId": "7e1f7ba41599d73a1bd694f43800d30d",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 114500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.9",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "117822940",
                                "name": "Choco Lava Cake + Pepsi",
                                "category": "Value Meals",
                                "description": "Get the indulgent Choco Lava Cake & a Pepsi (475 ml) for just INR 149",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/31/89478d05-215b-454a-b1da-9fdc51814bdd_39e2d28a-812d-4bba-a9ef-5814c349f321.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 15500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.7",
                                    "ratingCount": "13 ratings",
                                    "ratingCountV2": "13"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "121331277",
                                "name": "Spicy Non Veg Combo @ Rs. 95 Off",
                                "category": "Value Meals",
                                "description": "Reg Blazing ChK & Paprika + Reg Fiery Sausage & Paprika + GB + Pepsi",
                                "imageId": "75ed6c50e47f28f1ba1cd70fd422a9ca",
                                "inStock": 1,
                                "price": 58700,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "107334682",
                                "name": "Meal for 4: Margherita & Peppy Paneer",
                                "category": "Value Meals",
                                "description": "Medium Margherita + Medium Peppy Paneer + Garlic Bread + 2 Pepsi",
                                "imageId": "211f75f7fb418271095f26a3d56caac1",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 81100,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "107334561",
                                "name": "Meal for 2: Farmhouse & Veg Extravaganza",
                                "category": "Value Meals",
                                "description": "Regular Farmhouse + Regular Veg Extravaganza + Garlic Bread + Pepsi",
                                "imageId": "996ed7334940ce4431e6415b9e31779d",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 63700,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.9",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "115659213",
                                "name": "Garlic Breadsticks + Pepsi",
                                "category": "Value Meals",
                                "description": "Enjoy the all time favourite Garlic Breadsticks with Pepsi (475 ml)",
                                "imageId": "d4864ae8923187096385912dcc16a5bb",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 15500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.5",
                                    "ratingCount": "4 ratings",
                                    "ratingCountV2": "4"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "107334748",
                                "name": "Meal for 4: Veg Cheesy Pizza",
                                "category": "Value Meals",
                                "description": "Regular Fresh Veggie + Regular Peppy Paneer + Regular Corn n Cheese + Regular Farmhouse",
                                "imageId": "4fee651233047ae8a2f077c90c35cc33",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 82300,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "121331282",
                                "name": "Spicy Veg Party Combo @ Rs. 140 off",
                                "category": "Value Meals",
                                "description": "Med Blazing On & Paprika + Med Fiery Jalapeno & Paprika + 2GB + 2 Pepsi",
                                "imageId": "29101a5eb18045c038a511e60bee27a9",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 87300,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "107335136",
                                "name": "Meal for 4: Non Veg Pizza Mania Value",
                                "category": "Value Meals",
                                "description": "2 PM Pepper Barbecue Chicken + PM Chicken Sausage + PM Non Veg Loaded",
                                "imageId": "db9a1aa724ad79b6a20efb5b311a7af0",
                                "inStock": 1,
                                "price": 49900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.9",
                                    "ratingCount": "10 ratings",
                                    "ratingCountV2": "10"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "121331284",
                                "name": "Spicy Non Veg Party Combo @ Rs. 180 off",
                                "category": "Value Meals",
                                "description": "Med Blazing ChK & Paprika + Med Fiery Sausage & Paprika + 2GB + 2 Pepsi",
                                "imageId": "7c99650aff626b15071078b319a0c84b",
                                "inStock": 1,
                                "price": 107300,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "107334578",
                                "name": "Meal for 2: Veg Paradise & Farmhouse",
                                "category": "Value Meals",
                                "description": "Regular Veg Paradise + Regular Farmhouse + Garlic Bread + Pepsi",
                                "imageId": "0b454e29d106da0decaf20ad5aeb175a",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 60700,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "121331275",
                                "name": "Spicy Veg Combo @ Rs. 75 Off",
                                "category": "Value Meals",
                                "description": "Reg Blazing On & Paprika + Reg Fiery Jalapeno & Paprika + GB + Pepsi",
                                "imageId": "c10f93bce05019d15b4244f800ee9830",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 46700,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "121331273",
                                "name": "Garlic Breadsticks + Cheesy Dip",
                                "category": "Value Meals",
                                "description": "Enjoy the all-time favorite Garlic Breadsticks with the indulgent Cheesy Dip",
                                "imageId": "c74e28521828e6654a5ecffff1de9735",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 14357,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "19 ratings",
                                    "ratingCountV2": "19"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "121331279",
                                "name": "Hot and Sweet Veg Combo @ Rs. 75 Off",
                                "category": "Value Meals",
                                "description": "Reg Blazing On & Paprika + Reg Fiery Jalapeno & Paprika + CLC + Pepsi",
                                "imageId": "47f24436d2ba7718d6d1d9dd79560c77",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 46700,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {
                          
                        }
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Chicken Fiesta",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "155058597",
                                "name": "Mini Garlic Cheesiken Rice",
                                "category": "Chicken Fiesta",
                                "description": "Juicy Chicken| Creamy Garlic Sauce| Molten Cheese with Rice & Veggies - Onion, Jalapeno & Capsicum",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/18/198338bb-6f4f-4be5-a34b-cd4d16c7aea2_d93f02a0-fecb-4274-8788-4832d15be689.jpg",
                                "inStock": 1,
                                "price": 10900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "155058599",
                                "name": "Mini Tangy Tomato Cheesiken Rice",
                                "category": "Chicken Fiesta",
                                "description": "Tender Chicken| Zesty Tomato Sauce| Molten Cheese with Rice & Veggies - Onion, Paprika & Capsicum",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/18/4c04c7d4-5b9d-4ad4-bc65-66214176cb40_f6352515-2a22-4df1-89b0-c577a8daef01.jpg",
                                "inStock": 1,
                                "price": 10900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "155058604",
                                "name": "Mini Hot & Fiery Cheesiken Rice",
                                "category": "Chicken Fiesta",
                                "description": "Tender Chicken| Guntur Chilli Sauce| Molten Cheese with Rice & Veggies - Onion, Olive & Capsicum",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/18/dd8c73b5-c23a-4427-842c-98850a063080_dc3dbb4d-1e51-4add-90bd-5366f9794a64.jpg",
                                "inStock": 1,
                                "price": 10900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "154752759",
                                "name": "Spicy Chicken Pops",
                                "category": "Chicken Fiesta",
                                "description": "Crispy Chicken Popcorn| Bold Chilli sprinkle| Fiery burst of flavour",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/18/f9671ef2-830c-44d0-95e3-147a1bd26ae0_907cb02a-cafd-4f47-8d01-02f2823e4fd7.jpg",
                                "inStock": 1,
                                "price": 11900,
                                "finalPrice": 8900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "154752756",
                                "name": "Spicy Chicken Meatballs",
                                "category": "Chicken Fiesta",
                                "description": "Tender & Juicy Meat Balls| Guntur Chilli Seasoning | Bliss for Chicken Lovers",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/18/eb5898df-71d2-4e68-bdae-d7b7688a5f83_cd931a58-6fe4-4916-8dbe-5c6295d176cd.jpg",
                                "inStock": 1,
                                "price": 11900,
                                "finalPrice": 8900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "154752755",
                                "name": "Spicy Roasted Chicken Wings",
                                "category": "Chicken Fiesta",
                                "description": "Crispy roasted Chicken Wings| Fiery Guntur Seasoning| Spicy burst of flavour",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/18/5f011766-8dfb-4867-b503-1e4b1fda1547_f53d975e-11f5-4d58-8ffb-9baf8064d617.jpg",
                                "inStock": 1,
                                "price": 14900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "154752760",
                                "name": "Saucy Chicken Pops",
                                "category": "Chicken Fiesta",
                                "description": "Juicy Chicken Popcorn| Bold Guntur Chilli sprinkle| Fiery kick in every bite",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/3/05f951e6-65e2-4644-82f0-29ff7805ac05_71ae8a69-d936-418e-b011-2142b76b740e.jpg",
                                "inStock": 1,
                                "price": 14900,
                                "finalPrice": 8900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "154752757",
                                "name": "Saucy Chicken Meatballs",
                                "category": "Chicken Fiesta",
                                "description": "Juicy meat balls| Creamy Garlic & Guntur Chilli sauce| Bliss for Chicken Lovers",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/18/2463cdb0-c1dd-4a3c-8bb1-449c5f587008_8561339a-aaee-4595-a8f1-2c51499bc92b.jpg",
                                "inStock": 1,
                                "price": 14900,
                                "finalPrice": 8900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "154752758",
                                "name": "Saucy Roasted Chicken Wings",
                                "category": "Chicken Fiesta",
                                "description": "Juicy Chicken Wings| Creamy Garlic & Guntur Chilli sauce| A fiery treat",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/18/3fa2b21a-5ac9-43a8-9c83-46160d33fa55_dc4b5ac7-afb8-48e4-9c12-d1063e0b237a.jpg",
                                "inStock": 1,
                                "price": 17900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "155058596",
                                "name": "Tangy Tomato Cheesiken",
                                "category": "Chicken Fiesta",
                                "description": "Tender Chicken| Tangy Tomato Sauce| Molten Cheese| Crunchy Veggies - Onion, Paprika & Capsicum",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/3/d8774178-ddc5-4320-9fbc-44bf43a805d9_43276d31-0e2a-40ef-8557-e8602aa6c1cc.jpg",
                                "inStock": 1,
                                "price": 16900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "155058601",
                                "name": "Garlic Cheesiken",
                                "category": "Chicken Fiesta",
                                "description": "Tender Chicken| Creamy Garlic Sauce| Molten cheese| Crunchy Veggies - Onion, Paprika & Capsicum",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/3/08bfbefd-8719-408a-bc6c-859cce09f4c4_5ecf4ed8-e555-48e6-b289-eddd3f84a267.jpg",
                                "inStock": 1,
                                "price": 16900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "155058602",
                                "name": "Hot & Fiery Cheesiken",
                                "category": "Chicken Fiesta",
                                "description": "Juicy Chicken| Guntur Chilli sauce| Molten cheese| Crunchy Veggies - Onion, Paprika & Capsicum",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/3/1c1cec53-26eb-4652-8be4-e8d2e6a63f6c_2597dee4-ae78-432b-a177-627db957800a.jpg",
                                "inStock": 1,
                                "price": 16900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "155058600",
                                "name": "Tangy Tomato Cheesiken Rice",
                                "category": "Chicken Fiesta",
                                "description": "Tender Chicken| Zesty Tomato Sauce| Molten Cheese with Rice & Veggies - Onion, Paprika & Capsicum",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/3/7a843328-03eb-4c13-bb1c-41491d22ce5f_bca4e59c-c2f8-44b3-8405-e657d087f9bc.jpg",
                                "inStock": 1,
                                "price": 20900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "155058603",
                                "name": "Garlic Cheesiken Rice",
                                "category": "Chicken Fiesta",
                                "description": "Juicy Chicken| Creamy Garlic Sauce| Molten Cheese with Rice & Veggies - Onion, Jalapeno & Capsicum",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/3/5abe2298-bdbd-4652-85d6-f9e8a41d8f17_452b56f3-e9cc-4e72-9431-2cdc1b371da1.jpg",
                                "inStock": 1,
                                "price": 20900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "155058598",
                                "name": "Hot & Fiery Cheesiken Rice",
                                "category": "Chicken Fiesta",
                                "description": "Tender Chicken| Guntur Chilli Sauce| Molten Cheese with Rice & Veggies - Onion, Olive & Capsicum",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/3/687b7bdb-ca74-4eed-918f-aebb06d018c5_67303b13-2db3-4cfe-9f72-32f75f5872bf.jpg",
                                "inStock": 1,
                                "price": 20900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {
                          
                        }
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Dominos Classics",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520657",
                                "name": "Margherita Pizza",
                                "category": "Dominos Classics",
                                "description": "Classic delight with 100% real mozzarella cheese. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                                "imageId": "7850b115687ee8594f9d7f0a66c2ee84",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732220",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "114432001",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732222",
                                            "variationId": "114432008"
                                          }
                                        },
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "id": "114432002",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732222",
                                            "variationId": "114432008"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "id": "114432004",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732222",
                                            "variationId": "114432008"
                                          }
                                        },
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114432005",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732222",
                                            "variationId": "114432008"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "id": "114432007",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732222",
                                            "variationId": "114432008"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155660624",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732222",
                                            "variationId": "114432008"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155660625",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732222",
                                            "variationId": "114432008"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155660627",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732222",
                                            "variationId": "114432008"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732222",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114432008",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "114432010",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large",
                                          "id": "114432012",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732220",
                                          "variationId": "155660625"
                                        },
                                        {
                                          "groupId": "36732222",
                                          "variationId": "114432008"
                                        }
                                      ],
                                      "price": 18400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847143",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732220",
                                          "variationId": "155660625"
                                        },
                                        {
                                          "groupId": "36732222",
                                          "variationId": "114432010"
                                        }
                                      ],
                                      "price": 36400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847147",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732220",
                                          "variationId": "155660627"
                                        },
                                        {
                                          "groupId": "36732222",
                                          "variationId": "114432008"
                                        }
                                      ],
                                      "price": 18400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847143",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732220",
                                          "variationId": "155660627"
                                        },
                                        {
                                          "groupId": "36732222",
                                          "variationId": "114432010"
                                        }
                                      ],
                                      "price": 36400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847147",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732220",
                                          "variationId": "155660624"
                                        },
                                        {
                                          "groupId": "36732222",
                                          "variationId": "114432008"
                                        }
                                      ],
                                      "price": 18400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847143",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732220",
                                          "variationId": "155660624"
                                        },
                                        {
                                          "groupId": "36732222",
                                          "variationId": "114432010"
                                        }
                                      ],
                                      "price": 36400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847147",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732220",
                                          "variationId": "114432002"
                                        },
                                        {
                                          "groupId": "36732222",
                                          "variationId": "114432008"
                                        }
                                      ],
                                      "price": 13900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847143",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732220",
                                          "variationId": "114432002"
                                        },
                                        {
                                          "groupId": "36732222",
                                          "variationId": "114432010"
                                        }
                                      ],
                                      "price": 31500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847147",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732220",
                                          "variationId": "114432001"
                                        },
                                        {
                                          "groupId": "36732222",
                                          "variationId": "114432008"
                                        }
                                      ],
                                      "price": 10900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847143",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732220",
                                          "variationId": "114432001"
                                        },
                                        {
                                          "groupId": "36732222",
                                          "variationId": "114432012"
                                        }
                                      ],
                                      "price": 48500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "166640755",
                                          "addonId": "121424326"
                                        },
                                        {
                                          "groupId": "166640755",
                                          "addonId": "121424344"
                                        },
                                        {
                                          "groupId": "166640755",
                                          "addonId": "121424339"
                                        },
                                        {
                                          "groupId": "166640755",
                                          "addonId": "121424330"
                                        },
                                        {
                                          "groupId": "166640755",
                                          "addonId": "121424342"
                                        },
                                        {
                                          "groupId": "166640755",
                                          "addonId": "121424333"
                                        },
                                        {
                                          "groupId": "166640755",
                                          "addonId": "121424336"
                                        },
                                        {
                                          "groupId": "131847150",
                                          "addonId": "100000673"
                                        },
                                        {
                                          "groupId": "131847151",
                                          "addonId": "100000685"
                                        },
                                        {
                                          "groupId": "131847151",
                                          "addonId": "100000699"
                                        },
                                        {
                                          "groupId": "131847151",
                                          "addonId": "100000695"
                                        },
                                        {
                                          "groupId": "131847151",
                                          "addonId": "100000698"
                                        },
                                        {
                                          "groupId": "131847151",
                                          "addonId": "100000684"
                                        },
                                        {
                                          "groupId": "131847151",
                                          "addonId": "100000697"
                                        },
                                        {
                                          "groupId": "131847151",
                                          "addonId": "100000679"
                                        },
                                        {
                                          "groupId": "131847151",
                                          "addonId": "100000681"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732220",
                                          "variationId": "114432001"
                                        },
                                        {
                                          "groupId": "36732222",
                                          "variationId": "114432010"
                                        }
                                      ],
                                      "price": 26500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847147",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732220",
                                          "variationId": "114432004"
                                        },
                                        {
                                          "groupId": "36732222",
                                          "variationId": "114432010"
                                        }
                                      ],
                                      "price": 36400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847147",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732220",
                                          "variationId": "114432004"
                                        },
                                        {
                                          "groupId": "36732222",
                                          "variationId": "114432008"
                                        }
                                      ],
                                      "price": 18400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847143",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732220",
                                          "variationId": "114432007"
                                        },
                                        {
                                          "groupId": "36732222",
                                          "variationId": "114432008"
                                        }
                                      ],
                                      "price": 10900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847143",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732220",
                                          "variationId": "114432005"
                                        },
                                        {
                                          "groupId": "36732222",
                                          "variationId": "114432008"
                                        }
                                      ],
                                      "price": 13900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847143",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847145",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640753",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732220",
                                          "variationId": "114432005"
                                        },
                                        {
                                          "groupId": "36732222",
                                          "variationId": "114432010"
                                        }
                                      ],
                                      "price": 31500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847148",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640754",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847147",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "131847143",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640753",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847145",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847147",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847148",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640754",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847150",
                                    "groupName": "Extra Cheese Large",
                                    "choices": [
                                      {
                                        "id": "100000673",
                                        "name": "Extra Cheese",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847151",
                                    "groupName": "Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "100000685",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000699",
                                        "name": "Black Olive",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000695",
                                        "name": "Grilled Mushrooms",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000698",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000684",
                                        "name": "Crisp Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000697",
                                        "name": "Fresh Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000679",
                                        "name": "Red Pepper",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000681",
                                        "name": "Paneer",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640755",
                                    "groupName": "Non-Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "121424326",
                                        "name": "Chicken Pepperoni",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424344",
                                        "name": "Chicken Keema",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424339",
                                        "name": "Peri - Peri Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424330",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424342",
                                        "name": "Chicken Sausage",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424333",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424336",
                                        "name": "Chicken Tikka",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 10900,
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "112 ratings",
                                    "ratingCountV2": "112"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "117107599",
                                "name": "Blazing Onion & Paprika",
                                "category": "Dominos Classics",
                                "description": "Hot & spicy pizza with onion & red paprika toppings and a new spicy peri peri sauce on a Domino's cheesy base.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/8/2/e3db1171-0df9-4c02-b6eb-ba8423630c71_28876d94-adb0-4cae-a1cd-06ab38b1a31c.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732225",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "114432021",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732226",
                                            "variationId": "114432025"
                                          }
                                        },
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "id": "114432022",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732226",
                                            "variationId": "114432025"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "id": "114432023",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732226",
                                            "variationId": "114432025"
                                          }
                                        },
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114432024",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732226",
                                            "variationId": "114432025"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661005",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732226",
                                            "variationId": "114432025"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661006",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732226",
                                            "variationId": "114432025"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661007",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732226",
                                            "variationId": "114432025"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732226",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114432025",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "114432026",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large",
                                          "id": "114432027",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732225",
                                          "variationId": "155661007"
                                        },
                                        {
                                          "groupId": "36732226",
                                          "variationId": "114432026"
                                        }
                                      ],
                                      "price": 43400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "145349896",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732225",
                                          "variationId": "155661005"
                                        },
                                        {
                                          "groupId": "36732226",
                                          "variationId": "114432025"
                                        }
                                      ],
                                      "price": 26000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349892",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732225",
                                          "variationId": "155661005"
                                        },
                                        {
                                          "groupId": "36732226",
                                          "variationId": "114432026"
                                        }
                                      ],
                                      "price": 43400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "145349896",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732225",
                                          "variationId": "155661006"
                                        },
                                        {
                                          "groupId": "36732226",
                                          "variationId": "114432025"
                                        }
                                      ],
                                      "price": 26000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349892",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732225",
                                          "variationId": "155661006"
                                        },
                                        {
                                          "groupId": "36732226",
                                          "variationId": "114432026"
                                        }
                                      ],
                                      "price": 43400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "145349896",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732225",
                                          "variationId": "155661007"
                                        },
                                        {
                                          "groupId": "36732226",
                                          "variationId": "114432025"
                                        }
                                      ],
                                      "price": 26000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349892",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732225",
                                          "variationId": "114432021"
                                        },
                                        {
                                          "groupId": "36732226",
                                          "variationId": "114432025"
                                        }
                                      ],
                                      "price": 18500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349892",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732225",
                                          "variationId": "114432021"
                                        },
                                        {
                                          "groupId": "36732226",
                                          "variationId": "114432027"
                                        }
                                      ],
                                      "price": 55900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "166640787",
                                          "addonId": "121424326"
                                        },
                                        {
                                          "groupId": "166640787",
                                          "addonId": "121424344"
                                        },
                                        {
                                          "groupId": "166640787",
                                          "addonId": "121424339"
                                        },
                                        {
                                          "groupId": "166640787",
                                          "addonId": "121424330"
                                        },
                                        {
                                          "groupId": "166640787",
                                          "addonId": "121424342"
                                        },
                                        {
                                          "groupId": "166640787",
                                          "addonId": "121424333"
                                        },
                                        {
                                          "groupId": "166640787",
                                          "addonId": "121424336"
                                        },
                                        {
                                          "groupId": "145349894",
                                          "addonId": "100000673"
                                        },
                                        {
                                          "groupId": "145349895",
                                          "addonId": "100000685"
                                        },
                                        {
                                          "groupId": "145349895",
                                          "addonId": "100000699"
                                        },
                                        {
                                          "groupId": "145349895",
                                          "addonId": "100000695"
                                        },
                                        {
                                          "groupId": "145349895",
                                          "addonId": "100000698"
                                        },
                                        {
                                          "groupId": "145349895",
                                          "addonId": "100000684"
                                        },
                                        {
                                          "groupId": "145349895",
                                          "addonId": "100000697"
                                        },
                                        {
                                          "groupId": "145349895",
                                          "addonId": "100000679"
                                        },
                                        {
                                          "groupId": "145349895",
                                          "addonId": "100000681"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732225",
                                          "variationId": "114432021"
                                        },
                                        {
                                          "groupId": "36732226",
                                          "variationId": "114432026"
                                        }
                                      ],
                                      "price": 33500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "145349896",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732225",
                                          "variationId": "114432023"
                                        },
                                        {
                                          "groupId": "36732226",
                                          "variationId": "114432026"
                                        }
                                      ],
                                      "price": 43400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "145349896",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732225",
                                          "variationId": "114432023"
                                        },
                                        {
                                          "groupId": "36732226",
                                          "variationId": "114432025"
                                        }
                                      ],
                                      "price": 26000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349892",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732225",
                                          "variationId": "114432024"
                                        },
                                        {
                                          "groupId": "36732226",
                                          "variationId": "114432025"
                                        }
                                      ],
                                      "price": 21500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349892",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732225",
                                          "variationId": "114432024"
                                        },
                                        {
                                          "groupId": "36732226",
                                          "variationId": "114432026"
                                        }
                                      ],
                                      "price": 38500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "145349896",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732225",
                                          "variationId": "114432022"
                                        },
                                        {
                                          "groupId": "36732226",
                                          "variationId": "114432025"
                                        }
                                      ],
                                      "price": 21500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349892",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "145349893",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640786",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732225",
                                          "variationId": "114432022"
                                        },
                                        {
                                          "groupId": "36732226",
                                          "variationId": "114432026"
                                        }
                                      ],
                                      "price": 38500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "145349897",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640788",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "145349896",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "145349896",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "145349897",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640788",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "145349892",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640786",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "145349893",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "145349894",
                                    "groupName": "Extra Cheese Large",
                                    "choices": [
                                      {
                                        "id": "100000673",
                                        "name": "Extra Cheese",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "145349895",
                                    "groupName": "Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "100000685",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000699",
                                        "name": "Black Olive",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000695",
                                        "name": "Grilled Mushrooms",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000698",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000684",
                                        "name": "Crisp Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000697",
                                        "name": "Fresh Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000679",
                                        "name": "Red Pepper",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000681",
                                        "name": "Paneer",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640787",
                                    "groupName": "Non-Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "121424326",
                                        "name": "Chicken Pepperoni",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424344",
                                        "name": "Chicken Keema",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424339",
                                        "name": "Peri - Peri Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424330",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424342",
                                        "name": "Chicken Sausage",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424333",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424336",
                                        "name": "Chicken Tikka",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 18500,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "117107600",
                                "name": "Fiery Jalapeno & Paprika",
                                "category": "Dominos Classics",
                                "description": "Spiciest veg pizza with jalapeno & red paprika toppings and a new spicy peri peri sauce.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/8/2/57446390-3a0f-4606-bb8d-68e4b9a7766e_dcfe16e1-64c1-4860-9e1a-1c505f5caaae.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732010",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "114431375",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732011",
                                            "variationId": "114431379"
                                          }
                                        },
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "id": "114431376",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732011",
                                            "variationId": "114431379"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "id": "114431377",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732011",
                                            "variationId": "114431379"
                                          }
                                        },
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114431378",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732011",
                                            "variationId": "114431379"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155660891",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732011",
                                            "variationId": "114431379"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155660892",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732011",
                                            "variationId": "114431379"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155660893",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732011",
                                            "variationId": "114431379"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732011",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114431379",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "114431380",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large",
                                          "id": "114431381",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732010",
                                          "variationId": "155660892"
                                        },
                                        {
                                          "groupId": "36732011",
                                          "variationId": "114431379"
                                        }
                                      ],
                                      "price": 26000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349908",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732010",
                                          "variationId": "155660892"
                                        },
                                        {
                                          "groupId": "36732011",
                                          "variationId": "114431380"
                                        }
                                      ],
                                      "price": 43400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "145349904",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732010",
                                          "variationId": "155660893"
                                        },
                                        {
                                          "groupId": "36732011",
                                          "variationId": "114431379"
                                        }
                                      ],
                                      "price": 26000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349908",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732010",
                                          "variationId": "155660893"
                                        },
                                        {
                                          "groupId": "36732011",
                                          "variationId": "114431380"
                                        }
                                      ],
                                      "price": 43400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "145349904",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732010",
                                          "variationId": "155660891"
                                        },
                                        {
                                          "groupId": "36732011",
                                          "variationId": "114431379"
                                        }
                                      ],
                                      "price": 26000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349908",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732010",
                                          "variationId": "155660891"
                                        },
                                        {
                                          "groupId": "36732011",
                                          "variationId": "114431380"
                                        }
                                      ],
                                      "price": 43400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "145349904",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732010",
                                          "variationId": "114431375"
                                        },
                                        {
                                          "groupId": "36732011",
                                          "variationId": "114431381"
                                        }
                                      ],
                                      "price": 55900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "166640833",
                                          "addonId": "121424326"
                                        },
                                        {
                                          "groupId": "166640833",
                                          "addonId": "121424344"
                                        },
                                        {
                                          "groupId": "166640833",
                                          "addonId": "121424339"
                                        },
                                        {
                                          "groupId": "166640833",
                                          "addonId": "121424330"
                                        },
                                        {
                                          "groupId": "166640833",
                                          "addonId": "121424342"
                                        },
                                        {
                                          "groupId": "166640833",
                                          "addonId": "121424333"
                                        },
                                        {
                                          "groupId": "166640833",
                                          "addonId": "121424336"
                                        },
                                        {
                                          "groupId": "145349900",
                                          "addonId": "100000673"
                                        },
                                        {
                                          "groupId": "145349902",
                                          "addonId": "100000685"
                                        },
                                        {
                                          "groupId": "145349902",
                                          "addonId": "100000699"
                                        },
                                        {
                                          "groupId": "145349902",
                                          "addonId": "100000695"
                                        },
                                        {
                                          "groupId": "145349902",
                                          "addonId": "100000698"
                                        },
                                        {
                                          "groupId": "145349902",
                                          "addonId": "100000684"
                                        },
                                        {
                                          "groupId": "145349902",
                                          "addonId": "100000697"
                                        },
                                        {
                                          "groupId": "145349902",
                                          "addonId": "100000679"
                                        },
                                        {
                                          "groupId": "145349902",
                                          "addonId": "100000681"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732010",
                                          "variationId": "114431375"
                                        },
                                        {
                                          "groupId": "36732011",
                                          "variationId": "114431380"
                                        }
                                      ],
                                      "price": 33500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "145349904",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732010",
                                          "variationId": "114431377"
                                        },
                                        {
                                          "groupId": "36732011",
                                          "variationId": "114431380"
                                        }
                                      ],
                                      "price": 43400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "145349904",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732010",
                                          "variationId": "114431377"
                                        },
                                        {
                                          "groupId": "36732011",
                                          "variationId": "114431379"
                                        }
                                      ],
                                      "price": 26000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349908",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732010",
                                          "variationId": "114431378"
                                        },
                                        {
                                          "groupId": "36732011",
                                          "variationId": "114431379"
                                        }
                                      ],
                                      "price": 21500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349908",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732010",
                                          "variationId": "114431378"
                                        },
                                        {
                                          "groupId": "36732011",
                                          "variationId": "114431380"
                                        }
                                      ],
                                      "price": 38500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "145349904",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732010",
                                          "variationId": "114431376"
                                        },
                                        {
                                          "groupId": "36732011",
                                          "variationId": "114431379"
                                        }
                                      ],
                                      "price": 21500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349908",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732010",
                                          "variationId": "114431376"
                                        },
                                        {
                                          "groupId": "36732011",
                                          "variationId": "114431380"
                                        }
                                      ],
                                      "price": 38500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "145349906",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640834",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "145349904",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732010",
                                          "variationId": "114431375"
                                        },
                                        {
                                          "groupId": "36732011",
                                          "variationId": "114431379"
                                        }
                                      ],
                                      "price": 18500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349908",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "145349910",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640835",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "145349908",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640835",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "145349910",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "145349904",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "145349906",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640834",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "145349900",
                                    "groupName": "Extra Cheese Large",
                                    "choices": [
                                      {
                                        "id": "100000673",
                                        "name": "Extra Cheese",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "145349902",
                                    "groupName": "Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "100000685",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000699",
                                        "name": "Black Olive",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000695",
                                        "name": "Grilled Mushrooms",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000698",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000684",
                                        "name": "Crisp Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000697",
                                        "name": "Fresh Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000679",
                                        "name": "Red Pepper",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000681",
                                        "name": "Paneer",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640833",
                                    "groupName": "Non-Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "121424326",
                                        "name": "Chicken Pepperoni",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424344",
                                        "name": "Chicken Keema",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424339",
                                        "name": "Peri - Peri Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424330",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424342",
                                        "name": "Chicken Sausage",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424333",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424336",
                                        "name": "Chicken Tikka",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 18500,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520658",
                                "name": "Double Cheese Margherita Pizza",
                                "category": "Dominos Classics",
                                "description": "A classic delight loaded with extra 100% real mozzarella cheese",
                                "imageId": "15c3a34b64ec4298f2a0778d1b008919",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732014",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "114431384",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732015",
                                            "variationId": "114431389"
                                          }
                                        },
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "id": "114431385",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732015",
                                            "variationId": "114431389"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "id": "114431386",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732015",
                                            "variationId": "114431389"
                                          }
                                        },
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114431387",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732015",
                                            "variationId": "114431389"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "id": "114431388",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732015",
                                            "variationId": "114431389"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155660908",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732015",
                                            "variationId": "114431389"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155660909",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732015",
                                            "variationId": "114431389"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155660911",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732015",
                                            "variationId": "114431389"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732015",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114431389",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "114431390",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large",
                                          "id": "114431391",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732014",
                                          "variationId": "155660909"
                                        },
                                        {
                                          "groupId": "36732015",
                                          "variationId": "114431389"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846742",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732014",
                                          "variationId": "155660909"
                                        },
                                        {
                                          "groupId": "36732015",
                                          "variationId": "114431390"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846746",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732014",
                                          "variationId": "155660911"
                                        },
                                        {
                                          "groupId": "36732015",
                                          "variationId": "114431389"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846742",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732014",
                                          "variationId": "155660911"
                                        },
                                        {
                                          "groupId": "36732015",
                                          "variationId": "114431390"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846746",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732014",
                                          "variationId": "155660908"
                                        },
                                        {
                                          "groupId": "36732015",
                                          "variationId": "114431389"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846742",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732014",
                                          "variationId": "155660908"
                                        },
                                        {
                                          "groupId": "36732015",
                                          "variationId": "114431390"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846746",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732014",
                                          "variationId": "114431384"
                                        },
                                        {
                                          "groupId": "36732015",
                                          "variationId": "114431389"
                                        }
                                      ],
                                      "price": 22900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846742",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732014",
                                          "variationId": "114431384"
                                        },
                                        {
                                          "groupId": "36732015",
                                          "variationId": "114431391"
                                        }
                                      ],
                                      "price": 64900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "166640745",
                                          "addonId": "121424326"
                                        },
                                        {
                                          "groupId": "166640745",
                                          "addonId": "121424344"
                                        },
                                        {
                                          "groupId": "166640745",
                                          "addonId": "121424339"
                                        },
                                        {
                                          "groupId": "166640745",
                                          "addonId": "121424330"
                                        },
                                        {
                                          "groupId": "166640745",
                                          "addonId": "121424342"
                                        },
                                        {
                                          "groupId": "166640745",
                                          "addonId": "121424333"
                                        },
                                        {
                                          "groupId": "166640745",
                                          "addonId": "121424336"
                                        },
                                        {
                                          "groupId": "131846744",
                                          "addonId": "100000673"
                                        },
                                        {
                                          "groupId": "131846745",
                                          "addonId": "100000685"
                                        },
                                        {
                                          "groupId": "131846745",
                                          "addonId": "100000699"
                                        },
                                        {
                                          "groupId": "131846745",
                                          "addonId": "100000695"
                                        },
                                        {
                                          "groupId": "131846745",
                                          "addonId": "100000698"
                                        },
                                        {
                                          "groupId": "131846745",
                                          "addonId": "100000684"
                                        },
                                        {
                                          "groupId": "131846745",
                                          "addonId": "100000697"
                                        },
                                        {
                                          "groupId": "131846745",
                                          "addonId": "100000679"
                                        },
                                        {
                                          "groupId": "131846745",
                                          "addonId": "100000681"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732014",
                                          "variationId": "114431384"
                                        },
                                        {
                                          "groupId": "36732015",
                                          "variationId": "114431390"
                                        }
                                      ],
                                      "price": 40900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846746",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732014",
                                          "variationId": "114431386"
                                        },
                                        {
                                          "groupId": "36732015",
                                          "variationId": "114431390"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846746",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732014",
                                          "variationId": "114431386"
                                        },
                                        {
                                          "groupId": "36732015",
                                          "variationId": "114431389"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846742",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732014",
                                          "variationId": "114431388"
                                        },
                                        {
                                          "groupId": "36732015",
                                          "variationId": "114431389"
                                        }
                                      ],
                                      "price": 22900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846742",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732014",
                                          "variationId": "114431387"
                                        },
                                        {
                                          "groupId": "36732015",
                                          "variationId": "114431389"
                                        }
                                      ],
                                      "price": 25900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846742",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732014",
                                          "variationId": "114431387"
                                        },
                                        {
                                          "groupId": "36732015",
                                          "variationId": "114431390"
                                        }
                                      ],
                                      "price": 45900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846746",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732014",
                                          "variationId": "114431385"
                                        },
                                        {
                                          "groupId": "36732015",
                                          "variationId": "114431389"
                                        }
                                      ],
                                      "price": 25900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846742",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846743",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640744",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732014",
                                          "variationId": "114431385"
                                        },
                                        {
                                          "groupId": "36732015",
                                          "variationId": "114431390"
                                        }
                                      ],
                                      "price": 45900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846747",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640746",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846746",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "131846742",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640744",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131846743",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131846746",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131846747",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640746",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131846744",
                                    "groupName": "Extra Cheese Large",
                                    "choices": [
                                      {
                                        "id": "100000673",
                                        "name": "Extra Cheese",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131846745",
                                    "groupName": "Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "100000685",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000699",
                                        "name": "Black Olive",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000695",
                                        "name": "Grilled Mushrooms",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000698",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000684",
                                        "name": "Crisp Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000697",
                                        "name": "Fresh Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000679",
                                        "name": "Red Pepper",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000681",
                                        "name": "Paneer",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640745",
                                    "groupName": "Non-Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "121424326",
                                        "name": "Chicken Pepperoni",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424344",
                                        "name": "Chicken Keema",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424339",
                                        "name": "Peri - Peri Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424330",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424342",
                                        "name": "Chicken Sausage",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424333",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424336",
                                        "name": "Chicken Tikka",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 22900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "17 ratings",
                                    "ratingCountV2": "17"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520665",
                                "name": "Fresh Veggie Pizza",
                                "category": "Dominos Classics",
                                "description": "Delectable combination of onion & capsicum, a veggie lovers pick",
                                "imageId": "d9c548f1cb841844f151ffa3de873e4b",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732289",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "114432226",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732292",
                                            "variationId": "114432235"
                                          }
                                        },
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "id": "114432229",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732292",
                                            "variationId": "114432235"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "id": "114432230",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732292",
                                            "variationId": "114432235"
                                          }
                                        },
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114432232",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732292",
                                            "variationId": "114432235"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "id": "114432234",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732292",
                                            "variationId": "114432235"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661017",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732292",
                                            "variationId": "114432235"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661018",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732292",
                                            "variationId": "114432235"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661019",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732292",
                                            "variationId": "114432235"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732292",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114432235",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "114432236",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large",
                                          "id": "114432237",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732289",
                                          "variationId": "155661018"
                                        },
                                        {
                                          "groupId": "36732292",
                                          "variationId": "114432235"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847302",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732289",
                                          "variationId": "155661018"
                                        },
                                        {
                                          "groupId": "36732292",
                                          "variationId": "114432236"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847314",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732289",
                                          "variationId": "155661019"
                                        },
                                        {
                                          "groupId": "36732292",
                                          "variationId": "114432235"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847302",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732289",
                                          "variationId": "155661019"
                                        },
                                        {
                                          "groupId": "36732292",
                                          "variationId": "114432236"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847314",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732289",
                                          "variationId": "155661017"
                                        },
                                        {
                                          "groupId": "36732292",
                                          "variationId": "114432235"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847302",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732289",
                                          "variationId": "155661017"
                                        },
                                        {
                                          "groupId": "36732292",
                                          "variationId": "114432236"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847314",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732289",
                                          "variationId": "114432226"
                                        },
                                        {
                                          "groupId": "36732292",
                                          "variationId": "114432235"
                                        }
                                      ],
                                      "price": 22900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847302",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732289",
                                          "variationId": "114432226"
                                        },
                                        {
                                          "groupId": "36732292",
                                          "variationId": "114432237"
                                        }
                                      ],
                                      "price": 64900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "166640796",
                                          "addonId": "121424326"
                                        },
                                        {
                                          "groupId": "166640796",
                                          "addonId": "121424344"
                                        },
                                        {
                                          "groupId": "166640796",
                                          "addonId": "121424339"
                                        },
                                        {
                                          "groupId": "166640796",
                                          "addonId": "121424330"
                                        },
                                        {
                                          "groupId": "166640796",
                                          "addonId": "121424342"
                                        },
                                        {
                                          "groupId": "166640796",
                                          "addonId": "121424333"
                                        },
                                        {
                                          "groupId": "166640796",
                                          "addonId": "121424336"
                                        },
                                        {
                                          "groupId": "131847306",
                                          "addonId": "100000673"
                                        },
                                        {
                                          "groupId": "131847310",
                                          "addonId": "100000685"
                                        },
                                        {
                                          "groupId": "131847310",
                                          "addonId": "100000699"
                                        },
                                        {
                                          "groupId": "131847310",
                                          "addonId": "100000695"
                                        },
                                        {
                                          "groupId": "131847310",
                                          "addonId": "100000698"
                                        },
                                        {
                                          "groupId": "131847310",
                                          "addonId": "100000684"
                                        },
                                        {
                                          "groupId": "131847310",
                                          "addonId": "100000697"
                                        },
                                        {
                                          "groupId": "131847310",
                                          "addonId": "100000679"
                                        },
                                        {
                                          "groupId": "131847310",
                                          "addonId": "100000681"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732289",
                                          "variationId": "114432226"
                                        },
                                        {
                                          "groupId": "36732292",
                                          "variationId": "114432236"
                                        }
                                      ],
                                      "price": 40900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847314",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732289",
                                          "variationId": "114432230"
                                        },
                                        {
                                          "groupId": "36732292",
                                          "variationId": "114432236"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847314",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732289",
                                          "variationId": "114432230"
                                        },
                                        {
                                          "groupId": "36732292",
                                          "variationId": "114432235"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847302",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732289",
                                          "variationId": "114432234"
                                        },
                                        {
                                          "groupId": "36732292",
                                          "variationId": "114432235"
                                        }
                                      ],
                                      "price": 22900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847302",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732289",
                                          "variationId": "114432232"
                                        },
                                        {
                                          "groupId": "36732292",
                                          "variationId": "114432235"
                                        }
                                      ],
                                      "price": 25900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847302",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732289",
                                          "variationId": "114432232"
                                        },
                                        {
                                          "groupId": "36732292",
                                          "variationId": "114432236"
                                        }
                                      ],
                                      "price": 45900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847314",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732289",
                                          "variationId": "114432229"
                                        },
                                        {
                                          "groupId": "36732292",
                                          "variationId": "114432235"
                                        }
                                      ],
                                      "price": 25900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847302",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847304",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640795",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732289",
                                          "variationId": "114432229"
                                        },
                                        {
                                          "groupId": "36732292",
                                          "variationId": "114432236"
                                        }
                                      ],
                                      "price": 45900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847318",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640798",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847314",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "131847302",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640795",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847304",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847314",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847318",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640798",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847306",
                                    "groupName": "Extra Cheese Large",
                                    "choices": [
                                      {
                                        "id": "100000673",
                                        "name": "Extra Cheese",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847310",
                                    "groupName": "Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "100000685",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000699",
                                        "name": "Black Olive",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000695",
                                        "name": "Grilled Mushrooms",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000698",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000684",
                                        "name": "Crisp Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000697",
                                        "name": "Fresh Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000679",
                                        "name": "Red Pepper",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000681",
                                        "name": "Paneer",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640796",
                                    "groupName": "Non-Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "121424326",
                                        "name": "Chicken Pepperoni",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424344",
                                        "name": "Chicken Keema",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424339",
                                        "name": "Peri - Peri Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424330",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424342",
                                        "name": "Chicken Sausage",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424333",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424336",
                                        "name": "Chicken Tikka",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 22900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "7 ratings",
                                    "ratingCountV2": "7"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520667",
                                "name": "Cheese n Corn Pizza",
                                "category": "Dominos Classics",
                                "description": "A delectable combination of sweet & juicy golden corn",
                                "imageId": "25f8cd12a914066c7c9627d42eafd926",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732101",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "114431641",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732102",
                                            "variationId": "114431646"
                                          }
                                        },
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "id": "114431642",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732102",
                                            "variationId": "114431646"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "id": "114431643",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732102",
                                            "variationId": "114431646"
                                          }
                                        },
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114431644",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732102",
                                            "variationId": "114431646"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "id": "114431645",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732102",
                                            "variationId": "114431646"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155660838",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732102",
                                            "variationId": "114431646"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155660841",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732102",
                                            "variationId": "114431646"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155660844",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732102",
                                            "variationId": "114431646"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732102",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114431646",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "114431647",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large",
                                          "id": "114431648",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732101",
                                          "variationId": "155660844"
                                        },
                                        {
                                          "groupId": "36732102",
                                          "variationId": "114431646"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846909",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732101",
                                          "variationId": "155660844"
                                        },
                                        {
                                          "groupId": "36732102",
                                          "variationId": "114431647"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846905",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732101",
                                          "variationId": "155660838"
                                        },
                                        {
                                          "groupId": "36732102",
                                          "variationId": "114431646"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846909",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732101",
                                          "variationId": "155660838"
                                        },
                                        {
                                          "groupId": "36732102",
                                          "variationId": "114431647"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846905",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732101",
                                          "variationId": "155660841"
                                        },
                                        {
                                          "groupId": "36732102",
                                          "variationId": "114431646"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846909",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732101",
                                          "variationId": "155660841"
                                        },
                                        {
                                          "groupId": "36732102",
                                          "variationId": "114431647"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846905",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732101",
                                          "variationId": "114431643"
                                        },
                                        {
                                          "groupId": "36732102",
                                          "variationId": "114431647"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846905",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732101",
                                          "variationId": "114431643"
                                        },
                                        {
                                          "groupId": "36732102",
                                          "variationId": "114431646"
                                        }
                                      ],
                                      "price": 30400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846909",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732101",
                                          "variationId": "114431645"
                                        },
                                        {
                                          "groupId": "36732102",
                                          "variationId": "114431646"
                                        }
                                      ],
                                      "price": 22900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846909",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732101",
                                          "variationId": "114431644"
                                        },
                                        {
                                          "groupId": "36732102",
                                          "variationId": "114431646"
                                        }
                                      ],
                                      "price": 25900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846909",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732101",
                                          "variationId": "114431644"
                                        },
                                        {
                                          "groupId": "36732102",
                                          "variationId": "114431647"
                                        }
                                      ],
                                      "price": 45900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846905",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732101",
                                          "variationId": "114431642"
                                        },
                                        {
                                          "groupId": "36732102",
                                          "variationId": "114431646"
                                        }
                                      ],
                                      "price": 25900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846909",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732101",
                                          "variationId": "114431642"
                                        },
                                        {
                                          "groupId": "36732102",
                                          "variationId": "114431647"
                                        }
                                      ],
                                      "price": 45900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846905",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732101",
                                          "variationId": "114431641"
                                        },
                                        {
                                          "groupId": "36732102",
                                          "variationId": "114431646"
                                        }
                                      ],
                                      "price": 22900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846909",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846910",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640772",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732101",
                                          "variationId": "114431641"
                                        },
                                        {
                                          "groupId": "36732102",
                                          "variationId": "114431648"
                                        }
                                      ],
                                      "price": 64900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "166640773",
                                          "addonId": "121424326"
                                        },
                                        {
                                          "groupId": "166640773",
                                          "addonId": "121424344"
                                        },
                                        {
                                          "groupId": "166640773",
                                          "addonId": "121424339"
                                        },
                                        {
                                          "groupId": "166640773",
                                          "addonId": "121424330"
                                        },
                                        {
                                          "groupId": "166640773",
                                          "addonId": "121424342"
                                        },
                                        {
                                          "groupId": "166640773",
                                          "addonId": "121424333"
                                        },
                                        {
                                          "groupId": "166640773",
                                          "addonId": "121424336"
                                        },
                                        {
                                          "groupId": "131846911",
                                          "addonId": "100000673"
                                        },
                                        {
                                          "groupId": "131846912",
                                          "addonId": "100000685"
                                        },
                                        {
                                          "groupId": "131846912",
                                          "addonId": "100000699"
                                        },
                                        {
                                          "groupId": "131846912",
                                          "addonId": "100000695"
                                        },
                                        {
                                          "groupId": "131846912",
                                          "addonId": "100000698"
                                        },
                                        {
                                          "groupId": "131846912",
                                          "addonId": "100000684"
                                        },
                                        {
                                          "groupId": "131846912",
                                          "addonId": "100000697"
                                        },
                                        {
                                          "groupId": "131846912",
                                          "addonId": "100000679"
                                        },
                                        {
                                          "groupId": "131846912",
                                          "addonId": "100000681"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732101",
                                          "variationId": "114431641"
                                        },
                                        {
                                          "groupId": "36732102",
                                          "variationId": "114431647"
                                        }
                                      ],
                                      "price": 40900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846907",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640771",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846905",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "131846909",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640772",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131846910",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131846905",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131846907",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640771",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131846911",
                                    "groupName": "Extra Cheese Large",
                                    "choices": [
                                      {
                                        "id": "100000673",
                                        "name": "Extra Cheese",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131846912",
                                    "groupName": "Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "100000685",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000699",
                                        "name": "Black Olive",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000695",
                                        "name": "Grilled Mushrooms",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000698",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000684",
                                        "name": "Crisp Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000697",
                                        "name": "Fresh Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000679",
                                        "name": "Red Pepper",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000681",
                                        "name": "Paneer",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640773",
                                    "groupName": "Non-Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "121424326",
                                        "name": "Chicken Pepperoni",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424344",
                                        "name": "Chicken Keema",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424339",
                                        "name": "Peri - Peri Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424330",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424342",
                                        "name": "Chicken Sausage",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424333",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424336",
                                        "name": "Chicken Tikka",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 22900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "15 ratings",
                                    "ratingCountV2": "15"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520660",
                                "name": "Peppy Paneer Pizza",
                                "category": "Dominos Classics",
                                "description": "Flavorful trio of juicy paneer, crisp capsicum with spicy red paprika",
                                "imageId": "0581f2e3b7d0b3ede4b476c1d64a6434",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732199",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "114431949",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732200",
                                            "variationId": "114431954"
                                          }
                                        },
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "id": "114431950",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732200",
                                            "variationId": "114431954"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "id": "114431951",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732200",
                                            "variationId": "114431954"
                                          }
                                        },
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114431952",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732200",
                                            "variationId": "114431954"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "id": "114431953",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732200",
                                            "variationId": "114431954"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155660981",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732200",
                                            "variationId": "114431954"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155660982",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732200",
                                            "variationId": "114431954"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155660983",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732200",
                                            "variationId": "114431954"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732200",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114431954",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "114431955",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large",
                                          "id": "114431956",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732199",
                                          "variationId": "155660981"
                                        },
                                        {
                                          "groupId": "36732200",
                                          "variationId": "114431955"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847122",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732199",
                                          "variationId": "155660982"
                                        },
                                        {
                                          "groupId": "36732200",
                                          "variationId": "114431954"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847119",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732199",
                                          "variationId": "155660982"
                                        },
                                        {
                                          "groupId": "36732200",
                                          "variationId": "114431955"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847122",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732199",
                                          "variationId": "155660983"
                                        },
                                        {
                                          "groupId": "36732200",
                                          "variationId": "114431954"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847119",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732199",
                                          "variationId": "155660983"
                                        },
                                        {
                                          "groupId": "36732200",
                                          "variationId": "114431955"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847122",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732199",
                                          "variationId": "155660981"
                                        },
                                        {
                                          "groupId": "36732200",
                                          "variationId": "114431954"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847119",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732199",
                                          "variationId": "114431951"
                                        },
                                        {
                                          "groupId": "36732200",
                                          "variationId": "114431954"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847119",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732199",
                                          "variationId": "114431953"
                                        },
                                        {
                                          "groupId": "36732200",
                                          "variationId": "114431954"
                                        }
                                      ],
                                      "price": 27900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847119",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732199",
                                          "variationId": "114431952"
                                        },
                                        {
                                          "groupId": "36732200",
                                          "variationId": "114431954"
                                        }
                                      ],
                                      "price": 30900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847119",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732199",
                                          "variationId": "114431952"
                                        },
                                        {
                                          "groupId": "36732200",
                                          "variationId": "114431955"
                                        }
                                      ],
                                      "price": 53900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847122",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732199",
                                          "variationId": "114431950"
                                        },
                                        {
                                          "groupId": "36732200",
                                          "variationId": "114431954"
                                        }
                                      ],
                                      "price": 30900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847119",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732199",
                                          "variationId": "114431950"
                                        },
                                        {
                                          "groupId": "36732200",
                                          "variationId": "114431955"
                                        }
                                      ],
                                      "price": 53900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847122",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732199",
                                          "variationId": "114431949"
                                        },
                                        {
                                          "groupId": "36732200",
                                          "variationId": "114431954"
                                        }
                                      ],
                                      "price": 27900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847119",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847120",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640824",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732199",
                                          "variationId": "114431949"
                                        },
                                        {
                                          "groupId": "36732200",
                                          "variationId": "114431956"
                                        }
                                      ],
                                      "price": 73900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "166640826",
                                          "addonId": "121424326"
                                        },
                                        {
                                          "groupId": "166640826",
                                          "addonId": "121424344"
                                        },
                                        {
                                          "groupId": "166640826",
                                          "addonId": "121424339"
                                        },
                                        {
                                          "groupId": "166640826",
                                          "addonId": "121424330"
                                        },
                                        {
                                          "groupId": "166640826",
                                          "addonId": "121424342"
                                        },
                                        {
                                          "groupId": "166640826",
                                          "addonId": "121424333"
                                        },
                                        {
                                          "groupId": "166640826",
                                          "addonId": "121424336"
                                        },
                                        {
                                          "groupId": "131847124",
                                          "addonId": "100000673"
                                        },
                                        {
                                          "groupId": "131847125",
                                          "addonId": "100000685"
                                        },
                                        {
                                          "groupId": "131847125",
                                          "addonId": "100000699"
                                        },
                                        {
                                          "groupId": "131847125",
                                          "addonId": "100000695"
                                        },
                                        {
                                          "groupId": "131847125",
                                          "addonId": "100000698"
                                        },
                                        {
                                          "groupId": "131847125",
                                          "addonId": "100000684"
                                        },
                                        {
                                          "groupId": "131847125",
                                          "addonId": "100000697"
                                        },
                                        {
                                          "groupId": "131847125",
                                          "addonId": "100000679"
                                        },
                                        {
                                          "groupId": "131847125",
                                          "addonId": "100000681"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732199",
                                          "variationId": "114431949"
                                        },
                                        {
                                          "groupId": "36732200",
                                          "variationId": "114431955"
                                        }
                                      ],
                                      "price": 48900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847122",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732199",
                                          "variationId": "114431951"
                                        },
                                        {
                                          "groupId": "36732200",
                                          "variationId": "114431955"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847123",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640825",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847122",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "131847122",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847123",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640825",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847119",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640824",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847120",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847124",
                                    "groupName": "Extra Cheese Large",
                                    "choices": [
                                      {
                                        "id": "100000673",
                                        "name": "Extra Cheese",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847125",
                                    "groupName": "Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "100000685",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000699",
                                        "name": "Black Olive",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000695",
                                        "name": "Grilled Mushrooms",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000698",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000684",
                                        "name": "Crisp Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000697",
                                        "name": "Fresh Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000679",
                                        "name": "Red Pepper",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000681",
                                        "name": "Paneer",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640826",
                                    "groupName": "Non-Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "121424326",
                                        "name": "Chicken Pepperoni",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424344",
                                        "name": "Chicken Keema",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424339",
                                        "name": "Peri - Peri Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424330",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424342",
                                        "name": "Chicken Sausage",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424333",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424336",
                                        "name": "Chicken Tikka",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 27900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "57 ratings",
                                    "ratingCountV2": "57"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520690",
                                "name": "Chicken Sausage Pizza",
                                "category": "Dominos Classics",
                                "description": "American classic! Spicy, herbed chicken sausage on pizza",
                                "imageId": "5779285fbfb3c04730f0b71ba4132255",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732397",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "114432558",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732398",
                                            "variationId": "114432565"
                                          }
                                        },
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "id": "114432560",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732398",
                                            "variationId": "114432565"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "id": "114432562",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732398",
                                            "variationId": "114432565"
                                          }
                                        },
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114432563",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732398",
                                            "variationId": "114432565"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "id": "114432564",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732398",
                                            "variationId": "114432565"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155660966",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732398",
                                            "variationId": "114432565"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155660967",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732398",
                                            "variationId": "114432565"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155660968",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732398",
                                            "variationId": "114432565"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732398",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114432565",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "114432566",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large",
                                          "id": "114432567",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732397",
                                          "variationId": "155660967"
                                        },
                                        {
                                          "groupId": "36732398",
                                          "variationId": "114432565"
                                        }
                                      ],
                                      "price": 29400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847522",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732397",
                                          "variationId": "155660967"
                                        },
                                        {
                                          "groupId": "36732398",
                                          "variationId": "114432566"
                                        }
                                      ],
                                      "price": 48800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847524",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732397",
                                          "variationId": "155660968"
                                        },
                                        {
                                          "groupId": "36732398",
                                          "variationId": "114432565"
                                        }
                                      ],
                                      "price": 29400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847522",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732397",
                                          "variationId": "155660968"
                                        },
                                        {
                                          "groupId": "36732398",
                                          "variationId": "114432566"
                                        }
                                      ],
                                      "price": 48800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847524",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732397",
                                          "variationId": "155660966"
                                        },
                                        {
                                          "groupId": "36732398",
                                          "variationId": "114432565"
                                        }
                                      ],
                                      "price": 29400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847522",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732397",
                                          "variationId": "155660966"
                                        },
                                        {
                                          "groupId": "36732398",
                                          "variationId": "114432566"
                                        }
                                      ],
                                      "price": 48800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847524",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732397",
                                          "variationId": "114432560"
                                        },
                                        {
                                          "groupId": "36732398",
                                          "variationId": "114432565"
                                        }
                                      ],
                                      "price": 24900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847522",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732397",
                                          "variationId": "114432560"
                                        },
                                        {
                                          "groupId": "36732398",
                                          "variationId": "114432566"
                                        }
                                      ],
                                      "price": 43900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847524",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732397",
                                          "variationId": "114432558"
                                        },
                                        {
                                          "groupId": "36732398",
                                          "variationId": "114432565"
                                        }
                                      ],
                                      "price": 21900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847522",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732397",
                                          "variationId": "114432558"
                                        },
                                        {
                                          "groupId": "36732398",
                                          "variationId": "114432567"
                                        }
                                      ],
                                      "price": 62900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "166640782",
                                          "addonId": "121424326"
                                        },
                                        {
                                          "groupId": "166640782",
                                          "addonId": "121424344"
                                        },
                                        {
                                          "groupId": "166640782",
                                          "addonId": "121424339"
                                        },
                                        {
                                          "groupId": "166640782",
                                          "addonId": "121424330"
                                        },
                                        {
                                          "groupId": "166640782",
                                          "addonId": "121424342"
                                        },
                                        {
                                          "groupId": "166640782",
                                          "addonId": "121424333"
                                        },
                                        {
                                          "groupId": "166640782",
                                          "addonId": "121424336"
                                        },
                                        {
                                          "groupId": "131847527",
                                          "addonId": "100000673"
                                        },
                                        {
                                          "groupId": "131847529",
                                          "addonId": "100000685"
                                        },
                                        {
                                          "groupId": "131847529",
                                          "addonId": "100000699"
                                        },
                                        {
                                          "groupId": "131847529",
                                          "addonId": "100000695"
                                        },
                                        {
                                          "groupId": "131847529",
                                          "addonId": "100000698"
                                        },
                                        {
                                          "groupId": "131847529",
                                          "addonId": "100000684"
                                        },
                                        {
                                          "groupId": "131847529",
                                          "addonId": "100000697"
                                        },
                                        {
                                          "groupId": "131847529",
                                          "addonId": "100000679"
                                        },
                                        {
                                          "groupId": "131847529",
                                          "addonId": "100000681"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732397",
                                          "variationId": "114432558"
                                        },
                                        {
                                          "groupId": "36732398",
                                          "variationId": "114432566"
                                        }
                                      ],
                                      "price": 38900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847524",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732397",
                                          "variationId": "114432562"
                                        },
                                        {
                                          "groupId": "36732398",
                                          "variationId": "114432566"
                                        }
                                      ],
                                      "price": 48800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847524",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732397",
                                          "variationId": "114432562"
                                        },
                                        {
                                          "groupId": "36732398",
                                          "variationId": "114432565"
                                        }
                                      ],
                                      "price": 29400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847522",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732397",
                                          "variationId": "114432564"
                                        },
                                        {
                                          "groupId": "36732398",
                                          "variationId": "114432565"
                                        }
                                      ],
                                      "price": 21900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847522",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732397",
                                          "variationId": "114432563"
                                        },
                                        {
                                          "groupId": "36732398",
                                          "variationId": "114432565"
                                        }
                                      ],
                                      "price": 24900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847522",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847523",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640780",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732397",
                                          "variationId": "114432563"
                                        },
                                        {
                                          "groupId": "36732398",
                                          "variationId": "114432566"
                                        }
                                      ],
                                      "price": 43900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847525",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640781",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847524",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "131847522",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640780",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847523",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847524",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847525",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640781",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847527",
                                    "groupName": "Extra Cheese Large",
                                    "choices": [
                                      {
                                        "id": "100000673",
                                        "name": "Extra Cheese",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847529",
                                    "groupName": "Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "100000685",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000699",
                                        "name": "Black Olive",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000695",
                                        "name": "Grilled Mushrooms",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000698",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000684",
                                        "name": "Crisp Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000697",
                                        "name": "Fresh Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000679",
                                        "name": "Red Pepper",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000681",
                                        "name": "Paneer",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640782",
                                    "groupName": "Non-Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "121424326",
                                        "name": "Chicken Pepperoni",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424344",
                                        "name": "Chicken Keema",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424339",
                                        "name": "Peri - Peri Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424330",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424342",
                                        "name": "Chicken Sausage",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424333",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424336",
                                        "name": "Chicken Tikka",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 21900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520691",
                                "name": "Pepper Barbecue Chicken Pizza",
                                "category": "Dominos Classics",
                                "description": "Pepper barbecue chicken for that extra zing. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                                "imageId": "7602a3d88b2aeb0053954d96be9a9829",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732547",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "114433045",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732548",
                                            "variationId": "114433053"
                                          }
                                        },
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "id": "114433049",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732548",
                                            "variationId": "114433053"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "id": "114433050",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732548",
                                            "variationId": "114433053"
                                          }
                                        },
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114433051",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732548",
                                            "variationId": "114433053"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "id": "114433052",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732548",
                                            "variationId": "114433053"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155660924",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732548",
                                            "variationId": "114433053"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155660925",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732548",
                                            "variationId": "114433053"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155660926",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732548",
                                            "variationId": "114433053"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732548",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114433053",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "114433054",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large",
                                          "id": "114433055",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732547",
                                          "variationId": "155660925"
                                        },
                                        {
                                          "groupId": "36732548",
                                          "variationId": "114433053"
                                        }
                                      ],
                                      "price": 34400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847851",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732547",
                                          "variationId": "155660925"
                                        },
                                        {
                                          "groupId": "36732548",
                                          "variationId": "114433054"
                                        }
                                      ],
                                      "price": 57800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847843",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732547",
                                          "variationId": "155660926"
                                        },
                                        {
                                          "groupId": "36732548",
                                          "variationId": "114433053"
                                        }
                                      ],
                                      "price": 34400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847851",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732547",
                                          "variationId": "155660926"
                                        },
                                        {
                                          "groupId": "36732548",
                                          "variationId": "114433054"
                                        }
                                      ],
                                      "price": 57800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847843",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732547",
                                          "variationId": "155660924"
                                        },
                                        {
                                          "groupId": "36732548",
                                          "variationId": "114433053"
                                        }
                                      ],
                                      "price": 34400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847851",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732547",
                                          "variationId": "155660924"
                                        },
                                        {
                                          "groupId": "36732548",
                                          "variationId": "114433054"
                                        }
                                      ],
                                      "price": 57800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847843",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732547",
                                          "variationId": "114433051"
                                        },
                                        {
                                          "groupId": "36732548",
                                          "variationId": "114433054"
                                        }
                                      ],
                                      "price": 52900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847843",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732547",
                                          "variationId": "114433049"
                                        },
                                        {
                                          "groupId": "36732548",
                                          "variationId": "114433053"
                                        }
                                      ],
                                      "price": 29900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847851",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732547",
                                          "variationId": "114433049"
                                        },
                                        {
                                          "groupId": "36732548",
                                          "variationId": "114433054"
                                        }
                                      ],
                                      "price": 52900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847843",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732547",
                                          "variationId": "114433045"
                                        },
                                        {
                                          "groupId": "36732548",
                                          "variationId": "114433053"
                                        }
                                      ],
                                      "price": 26900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847851",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732547",
                                          "variationId": "114433045"
                                        },
                                        {
                                          "groupId": "36732548",
                                          "variationId": "114433055"
                                        }
                                      ],
                                      "price": 70900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "166640841",
                                          "addonId": "121424326"
                                        },
                                        {
                                          "groupId": "166640841",
                                          "addonId": "121424344"
                                        },
                                        {
                                          "groupId": "166640841",
                                          "addonId": "121424339"
                                        },
                                        {
                                          "groupId": "166640841",
                                          "addonId": "121424330"
                                        },
                                        {
                                          "groupId": "166640841",
                                          "addonId": "121424342"
                                        },
                                        {
                                          "groupId": "166640841",
                                          "addonId": "121424333"
                                        },
                                        {
                                          "groupId": "166640841",
                                          "addonId": "121424336"
                                        },
                                        {
                                          "groupId": "131847860",
                                          "addonId": "100000673"
                                        },
                                        {
                                          "groupId": "131847863",
                                          "addonId": "100000685"
                                        },
                                        {
                                          "groupId": "131847863",
                                          "addonId": "100000699"
                                        },
                                        {
                                          "groupId": "131847863",
                                          "addonId": "100000695"
                                        },
                                        {
                                          "groupId": "131847863",
                                          "addonId": "100000698"
                                        },
                                        {
                                          "groupId": "131847863",
                                          "addonId": "100000684"
                                        },
                                        {
                                          "groupId": "131847863",
                                          "addonId": "100000697"
                                        },
                                        {
                                          "groupId": "131847863",
                                          "addonId": "100000679"
                                        },
                                        {
                                          "groupId": "131847863",
                                          "addonId": "100000681"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732547",
                                          "variationId": "114433045"
                                        },
                                        {
                                          "groupId": "36732548",
                                          "variationId": "114433054"
                                        }
                                      ],
                                      "price": 47900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847843",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732547",
                                          "variationId": "114433050"
                                        },
                                        {
                                          "groupId": "36732548",
                                          "variationId": "114433054"
                                        }
                                      ],
                                      "price": 57800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847847",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640839",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847843",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732547",
                                          "variationId": "114433050"
                                        },
                                        {
                                          "groupId": "36732548",
                                          "variationId": "114433053"
                                        }
                                      ],
                                      "price": 34400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847851",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732547",
                                          "variationId": "114433052"
                                        },
                                        {
                                          "groupId": "36732548",
                                          "variationId": "114433053"
                                        }
                                      ],
                                      "price": 26900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847851",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732547",
                                          "variationId": "114433051"
                                        },
                                        {
                                          "groupId": "36732548",
                                          "variationId": "114433053"
                                        }
                                      ],
                                      "price": 29900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847851",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847855",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640840",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "131847851",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640840",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847855",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847843",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847847",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640839",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847860",
                                    "groupName": "Extra Cheese Large",
                                    "choices": [
                                      {
                                        "id": "100000673",
                                        "name": "Extra Cheese",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847863",
                                    "groupName": "Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "100000685",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000699",
                                        "name": "Black Olive",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000695",
                                        "name": "Grilled Mushrooms",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000698",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000684",
                                        "name": "Crisp Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000697",
                                        "name": "Fresh Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000679",
                                        "name": "Red Pepper",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000681",
                                        "name": "Paneer",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640841",
                                    "groupName": "Non-Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "121424326",
                                        "name": "Chicken Pepperoni",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424344",
                                        "name": "Chicken Keema",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424339",
                                        "name": "Peri - Peri Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424330",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424342",
                                        "name": "Chicken Sausage",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424333",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424336",
                                        "name": "Chicken Tikka",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 26900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "31 ratings",
                                    "ratingCountV2": "31"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "117107603",
                                "name": "Blazing Chicken & Paprika",
                                "category": "Dominos Classics",
                                "description": "Hot & spicy chicken pizza with a combination of chicken keema & red paprika toppings and a new spicy peri peri sauce.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/8/2/381126cc-5ec8-4475-9e13-7100a1238287_f147bac1-9e8e-43fa-921d-3a8f3958c8e8.jpg",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732453",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "114432731",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732454",
                                            "variationId": "114432735"
                                          }
                                        },
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "id": "114432732",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732454",
                                            "variationId": "114432735"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "id": "114432733",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732454",
                                            "variationId": "114432735"
                                          }
                                        },
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114432734",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732454",
                                            "variationId": "114432735"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661080",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732454",
                                            "variationId": "114432735"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661081",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732454",
                                            "variationId": "114432735"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661082",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732454",
                                            "variationId": "114432735"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732454",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114432735",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "114432737",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large",
                                          "id": "114432739",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732453",
                                          "variationId": "155661081"
                                        },
                                        {
                                          "groupId": "36732454",
                                          "variationId": "114432737"
                                        }
                                      ],
                                      "price": 55400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "145349866",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732453",
                                          "variationId": "155661082"
                                        },
                                        {
                                          "groupId": "36732454",
                                          "variationId": "114432735"
                                        }
                                      ],
                                      "price": 33000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349862",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732453",
                                          "variationId": "155661082"
                                        },
                                        {
                                          "groupId": "36732454",
                                          "variationId": "114432737"
                                        }
                                      ],
                                      "price": 55400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "145349866",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732453",
                                          "variationId": "155661080"
                                        },
                                        {
                                          "groupId": "36732454",
                                          "variationId": "114432735"
                                        }
                                      ],
                                      "price": 33000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349862",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732453",
                                          "variationId": "155661080"
                                        },
                                        {
                                          "groupId": "36732454",
                                          "variationId": "114432737"
                                        }
                                      ],
                                      "price": 55400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "145349866",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732453",
                                          "variationId": "155661081"
                                        },
                                        {
                                          "groupId": "36732454",
                                          "variationId": "114432735"
                                        }
                                      ],
                                      "price": 33000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349862",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732453",
                                          "variationId": "114432731"
                                        },
                                        {
                                          "groupId": "36732454",
                                          "variationId": "114432735"
                                        }
                                      ],
                                      "price": 25500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349862",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732453",
                                          "variationId": "114432731"
                                        },
                                        {
                                          "groupId": "36732454",
                                          "variationId": "114432739"
                                        }
                                      ],
                                      "price": 67900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "166640822",
                                          "addonId": "121424326"
                                        },
                                        {
                                          "groupId": "166640822",
                                          "addonId": "121424344"
                                        },
                                        {
                                          "groupId": "166640822",
                                          "addonId": "121424339"
                                        },
                                        {
                                          "groupId": "166640822",
                                          "addonId": "121424330"
                                        },
                                        {
                                          "groupId": "166640822",
                                          "addonId": "121424342"
                                        },
                                        {
                                          "groupId": "166640822",
                                          "addonId": "121424333"
                                        },
                                        {
                                          "groupId": "166640822",
                                          "addonId": "121424336"
                                        },
                                        {
                                          "groupId": "145349864",
                                          "addonId": "100000673"
                                        },
                                        {
                                          "groupId": "145349865",
                                          "addonId": "100000685"
                                        },
                                        {
                                          "groupId": "145349865",
                                          "addonId": "100000699"
                                        },
                                        {
                                          "groupId": "145349865",
                                          "addonId": "100000695"
                                        },
                                        {
                                          "groupId": "145349865",
                                          "addonId": "100000698"
                                        },
                                        {
                                          "groupId": "145349865",
                                          "addonId": "100000684"
                                        },
                                        {
                                          "groupId": "145349865",
                                          "addonId": "100000697"
                                        },
                                        {
                                          "groupId": "145349865",
                                          "addonId": "100000679"
                                        },
                                        {
                                          "groupId": "145349865",
                                          "addonId": "100000681"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732453",
                                          "variationId": "114432731"
                                        },
                                        {
                                          "groupId": "36732454",
                                          "variationId": "114432737"
                                        }
                                      ],
                                      "price": 45500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "145349866",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732453",
                                          "variationId": "114432733"
                                        },
                                        {
                                          "groupId": "36732454",
                                          "variationId": "114432737"
                                        }
                                      ],
                                      "price": 55400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "145349866",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732453",
                                          "variationId": "114432733"
                                        },
                                        {
                                          "groupId": "36732454",
                                          "variationId": "114432735"
                                        }
                                      ],
                                      "price": 33000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349862",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732453",
                                          "variationId": "114432734"
                                        },
                                        {
                                          "groupId": "36732454",
                                          "variationId": "114432735"
                                        }
                                      ],
                                      "price": 28500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349862",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732453",
                                          "variationId": "114432734"
                                        },
                                        {
                                          "groupId": "36732454",
                                          "variationId": "114432737"
                                        }
                                      ],
                                      "price": 50500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "145349866",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732453",
                                          "variationId": "114432732"
                                        },
                                        {
                                          "groupId": "36732454",
                                          "variationId": "114432735"
                                        }
                                      ],
                                      "price": 28500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349862",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "145349863",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640821",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732453",
                                          "variationId": "114432732"
                                        },
                                        {
                                          "groupId": "36732454",
                                          "variationId": "114432737"
                                        }
                                      ],
                                      "price": 50500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "145349867",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640823",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "145349866",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "145349866",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "145349867",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640823",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "145349862",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640821",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "145349863",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "145349864",
                                    "groupName": "Extra Cheese Large",
                                    "choices": [
                                      {
                                        "id": "100000673",
                                        "name": "Extra Cheese",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "145349865",
                                    "groupName": "Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "100000685",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000699",
                                        "name": "Black Olive",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000695",
                                        "name": "Grilled Mushrooms",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000698",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000684",
                                        "name": "Crisp Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000697",
                                        "name": "Fresh Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000679",
                                        "name": "Red Pepper",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000681",
                                        "name": "Paneer",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640822",
                                    "groupName": "Non-Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "121424326",
                                        "name": "Chicken Pepperoni",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424344",
                                        "name": "Chicken Keema",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424339",
                                        "name": "Peri - Peri Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424330",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424342",
                                        "name": "Chicken Sausage",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424333",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424336",
                                        "name": "Chicken Tikka",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 25500,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "117107601",
                                "name": "Fiery Sausage & Paprika",
                                "category": "Dominos Classics",
                                "description": "Spiciest non veg pizza with spicy & herby chicken sausage and red paprika toppings on a new spicy peri peri sauce base.",
                                "imageId": "2190eb54162d9a61e34e6970d53cbcc2",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732417",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "114432617",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732418",
                                            "variationId": "114432621"
                                          }
                                        },
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "id": "114432618",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732418",
                                            "variationId": "114432621"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "id": "114432619",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732418",
                                            "variationId": "114432621"
                                          }
                                        },
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114432620",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732418",
                                            "variationId": "114432621"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155660975",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732418",
                                            "variationId": "114432621"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155660976",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732418",
                                            "variationId": "114432621"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155660977",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732418",
                                            "variationId": "114432621"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732418",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114432621",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "114432622",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large",
                                          "id": "114432623",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732417",
                                          "variationId": "155660976"
                                        },
                                        {
                                          "groupId": "36732418",
                                          "variationId": "114432621"
                                        }
                                      ],
                                      "price": 33000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349868",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732417",
                                          "variationId": "155660976"
                                        },
                                        {
                                          "groupId": "36732418",
                                          "variationId": "114432622"
                                        }
                                      ],
                                      "price": 55400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "145349872",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732417",
                                          "variationId": "155660977"
                                        },
                                        {
                                          "groupId": "36732418",
                                          "variationId": "114432621"
                                        }
                                      ],
                                      "price": 33000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349868",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732417",
                                          "variationId": "155660977"
                                        },
                                        {
                                          "groupId": "36732418",
                                          "variationId": "114432622"
                                        }
                                      ],
                                      "price": 55400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "145349872",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732417",
                                          "variationId": "155660975"
                                        },
                                        {
                                          "groupId": "36732418",
                                          "variationId": "114432621"
                                        }
                                      ],
                                      "price": 33000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349868",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732417",
                                          "variationId": "155660975"
                                        },
                                        {
                                          "groupId": "36732418",
                                          "variationId": "114432622"
                                        }
                                      ],
                                      "price": 55400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "145349872",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732417",
                                          "variationId": "114432617"
                                        },
                                        {
                                          "groupId": "36732418",
                                          "variationId": "114432621"
                                        }
                                      ],
                                      "price": 25500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349868",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732417",
                                          "variationId": "114432617"
                                        },
                                        {
                                          "groupId": "36732418",
                                          "variationId": "114432623"
                                        }
                                      ],
                                      "price": 67900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "166640831",
                                          "addonId": "121424326"
                                        },
                                        {
                                          "groupId": "166640831",
                                          "addonId": "121424344"
                                        },
                                        {
                                          "groupId": "166640831",
                                          "addonId": "121424339"
                                        },
                                        {
                                          "groupId": "166640831",
                                          "addonId": "121424330"
                                        },
                                        {
                                          "groupId": "166640831",
                                          "addonId": "121424342"
                                        },
                                        {
                                          "groupId": "166640831",
                                          "addonId": "121424333"
                                        },
                                        {
                                          "groupId": "166640831",
                                          "addonId": "121424336"
                                        },
                                        {
                                          "groupId": "145349870",
                                          "addonId": "100000673"
                                        },
                                        {
                                          "groupId": "145349871",
                                          "addonId": "100000685"
                                        },
                                        {
                                          "groupId": "145349871",
                                          "addonId": "100000699"
                                        },
                                        {
                                          "groupId": "145349871",
                                          "addonId": "100000695"
                                        },
                                        {
                                          "groupId": "145349871",
                                          "addonId": "100000698"
                                        },
                                        {
                                          "groupId": "145349871",
                                          "addonId": "100000684"
                                        },
                                        {
                                          "groupId": "145349871",
                                          "addonId": "100000697"
                                        },
                                        {
                                          "groupId": "145349871",
                                          "addonId": "100000679"
                                        },
                                        {
                                          "groupId": "145349871",
                                          "addonId": "100000681"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732417",
                                          "variationId": "114432617"
                                        },
                                        {
                                          "groupId": "36732418",
                                          "variationId": "114432622"
                                        }
                                      ],
                                      "price": 45500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "145349872",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732417",
                                          "variationId": "114432619"
                                        },
                                        {
                                          "groupId": "36732418",
                                          "variationId": "114432622"
                                        }
                                      ],
                                      "price": 55400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "145349872",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732417",
                                          "variationId": "114432619"
                                        },
                                        {
                                          "groupId": "36732418",
                                          "variationId": "114432621"
                                        }
                                      ],
                                      "price": 33000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349868",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732417",
                                          "variationId": "114432620"
                                        },
                                        {
                                          "groupId": "36732418",
                                          "variationId": "114432621"
                                        }
                                      ],
                                      "price": 28500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349868",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732417",
                                          "variationId": "114432620"
                                        },
                                        {
                                          "groupId": "36732418",
                                          "variationId": "114432622"
                                        }
                                      ],
                                      "price": 50500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "145349872",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732417",
                                          "variationId": "114432618"
                                        },
                                        {
                                          "groupId": "36732418",
                                          "variationId": "114432621"
                                        }
                                      ],
                                      "price": 28500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349868",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "145349869",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640830",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732417",
                                          "variationId": "114432618"
                                        },
                                        {
                                          "groupId": "36732418",
                                          "variationId": "114432622"
                                        }
                                      ],
                                      "price": 50500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "145349873",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640832",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "145349872",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "145349868",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640830",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "145349869",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "145349872",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "145349873",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640832",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "145349870",
                                    "groupName": "Extra Cheese Large",
                                    "choices": [
                                      {
                                        "id": "100000673",
                                        "name": "Extra Cheese",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "145349871",
                                    "groupName": "Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "100000685",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000699",
                                        "name": "Black Olive",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000695",
                                        "name": "Grilled Mushrooms",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000698",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000684",
                                        "name": "Crisp Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000697",
                                        "name": "Fresh Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000679",
                                        "name": "Red Pepper",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000681",
                                        "name": "Paneer",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640831",
                                    "groupName": "Non-Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "121424326",
                                        "name": "Chicken Pepperoni",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424344",
                                        "name": "Chicken Keema",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424339",
                                        "name": "Peri - Peri Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424330",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424342",
                                        "name": "Chicken Sausage",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424333",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424336",
                                        "name": "Chicken Tikka",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 25500,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520646",
                                "name": "Spiced Double Chicken",
                                "category": "Dominos Classics",
                                "description": "Delightful combination of our spicy duo- Pepper Barbecue Chicken and Peri Peri Chicken for Chicken Lovers.",
                                "imageId": "613401a1232b2bd8ba3c5ecb6173dc38",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732469",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "114432774",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732470",
                                            "variationId": "114432779"
                                          }
                                        },
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "id": "114432775",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732470",
                                            "variationId": "114432779"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "id": "114432776",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732470",
                                            "variationId": "114432779"
                                          }
                                        },
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114432777",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732470",
                                            "variationId": "114432779"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "id": "114432778",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732470",
                                            "variationId": "114432779"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661098",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732470",
                                            "variationId": "114432779"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661099",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732470",
                                            "variationId": "114432779"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661100",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732470",
                                            "variationId": "114432779"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732470",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114432779",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "114432781",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large",
                                          "id": "114432783",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732469",
                                          "variationId": "155661100"
                                        },
                                        {
                                          "groupId": "36732470",
                                          "variationId": "114432779"
                                        }
                                      ],
                                      "price": 39000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847649",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732469",
                                          "variationId": "155661100"
                                        },
                                        {
                                          "groupId": "36732470",
                                          "variationId": "114432781"
                                        }
                                      ],
                                      "price": 65800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847655",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732469",
                                          "variationId": "155661098"
                                        },
                                        {
                                          "groupId": "36732470",
                                          "variationId": "114432779"
                                        }
                                      ],
                                      "price": 39000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847649",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732469",
                                          "variationId": "155661098"
                                        },
                                        {
                                          "groupId": "36732470",
                                          "variationId": "114432781"
                                        }
                                      ],
                                      "price": 65800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847655",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732469",
                                          "variationId": "155661099"
                                        },
                                        {
                                          "groupId": "36732470",
                                          "variationId": "114432779"
                                        }
                                      ],
                                      "price": 39000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847649",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732469",
                                          "variationId": "155661099"
                                        },
                                        {
                                          "groupId": "36732470",
                                          "variationId": "114432781"
                                        }
                                      ],
                                      "price": 65800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847655",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732469",
                                          "variationId": "114432777"
                                        },
                                        {
                                          "groupId": "36732470",
                                          "variationId": "114432779"
                                        }
                                      ],
                                      "price": 34500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847649",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732469",
                                          "variationId": "114432777"
                                        },
                                        {
                                          "groupId": "36732470",
                                          "variationId": "114432781"
                                        }
                                      ],
                                      "price": 60900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847655",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732469",
                                          "variationId": "114432775"
                                        },
                                        {
                                          "groupId": "36732470",
                                          "variationId": "114432779"
                                        }
                                      ],
                                      "price": 34500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847649",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732469",
                                          "variationId": "114432775"
                                        },
                                        {
                                          "groupId": "36732470",
                                          "variationId": "114432781"
                                        }
                                      ],
                                      "price": 60900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847655",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732469",
                                          "variationId": "114432774"
                                        },
                                        {
                                          "groupId": "36732470",
                                          "variationId": "114432779"
                                        }
                                      ],
                                      "price": 31500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847649",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732469",
                                          "variationId": "114432774"
                                        },
                                        {
                                          "groupId": "36732470",
                                          "variationId": "114432783"
                                        }
                                      ],
                                      "price": 84500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "166640767",
                                          "addonId": "121424326"
                                        },
                                        {
                                          "groupId": "166640767",
                                          "addonId": "121424344"
                                        },
                                        {
                                          "groupId": "166640767",
                                          "addonId": "121424339"
                                        },
                                        {
                                          "groupId": "166640767",
                                          "addonId": "121424330"
                                        },
                                        {
                                          "groupId": "166640767",
                                          "addonId": "121424342"
                                        },
                                        {
                                          "groupId": "166640767",
                                          "addonId": "121424333"
                                        },
                                        {
                                          "groupId": "166640767",
                                          "addonId": "121424336"
                                        },
                                        {
                                          "groupId": "131847662",
                                          "addonId": "100000673"
                                        },
                                        {
                                          "groupId": "131847666",
                                          "addonId": "100000685"
                                        },
                                        {
                                          "groupId": "131847666",
                                          "addonId": "100000699"
                                        },
                                        {
                                          "groupId": "131847666",
                                          "addonId": "100000695"
                                        },
                                        {
                                          "groupId": "131847666",
                                          "addonId": "100000698"
                                        },
                                        {
                                          "groupId": "131847666",
                                          "addonId": "100000684"
                                        },
                                        {
                                          "groupId": "131847666",
                                          "addonId": "100000697"
                                        },
                                        {
                                          "groupId": "131847666",
                                          "addonId": "100000679"
                                        },
                                        {
                                          "groupId": "131847666",
                                          "addonId": "100000681"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732469",
                                          "variationId": "114432774"
                                        },
                                        {
                                          "groupId": "36732470",
                                          "variationId": "114432781"
                                        }
                                      ],
                                      "price": 56900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847655",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732469",
                                          "variationId": "114432776"
                                        },
                                        {
                                          "groupId": "36732470",
                                          "variationId": "114432781"
                                        }
                                      ],
                                      "price": 65800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847658",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640766",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847655",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732469",
                                          "variationId": "114432776"
                                        },
                                        {
                                          "groupId": "36732470",
                                          "variationId": "114432779"
                                        }
                                      ],
                                      "price": 39000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847649",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732469",
                                          "variationId": "114432778"
                                        },
                                        {
                                          "groupId": "36732470",
                                          "variationId": "114432779"
                                        }
                                      ],
                                      "price": 31500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847649",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847651",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640765",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "131847649",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640765",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847651",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847655",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847658",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640766",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847662",
                                    "groupName": "Extra Cheese Large",
                                    "choices": [
                                      {
                                        "id": "100000673",
                                        "name": "Extra Cheese",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847666",
                                    "groupName": "Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "100000685",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000699",
                                        "name": "Black Olive",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000695",
                                        "name": "Grilled Mushrooms",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000698",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000684",
                                        "name": "Crisp Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000697",
                                        "name": "Fresh Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000679",
                                        "name": "Red Pepper",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000681",
                                        "name": "Paneer",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640767",
                                    "groupName": "Non-Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "121424326",
                                        "name": "Chicken Pepperoni",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424344",
                                        "name": "Chicken Keema",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424339",
                                        "name": "Peri - Peri Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424330",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424342",
                                        "name": "Chicken Sausage",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424333",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424336",
                                        "name": "Chicken Tikka",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 31500,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "9 ratings",
                                    "ratingCountV2": "9"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520694",
                                "name": "Chicken Golden Delight Pizza",
                                "category": "Dominos Classics",
                                "description": "Double pepper barbecue chicken, golden corn and extra cheese, true delight",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/27/3d22946c-ef95-495c-bedf-658566549a56_e29b66d9-60a0-4a1e-abe3-bec70737fab1.jpg",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732306",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "114432279",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732308",
                                            "variationId": "114432288"
                                          }
                                        },
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "id": "114432281",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732308",
                                            "variationId": "114432288"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "id": "114432284",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732308",
                                            "variationId": "114432288"
                                          }
                                        },
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114432286",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732308",
                                            "variationId": "114432288"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "id": "114432287",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732308",
                                            "variationId": "114432288"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155660813",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732308",
                                            "variationId": "114432288"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155660814",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732308",
                                            "variationId": "114432288"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155660815",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732308",
                                            "variationId": "114432288"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732308",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114432288",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "114432289",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large",
                                          "id": "114432290",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732306",
                                          "variationId": "155660814"
                                        },
                                        {
                                          "groupId": "36732308",
                                          "variationId": "114432289"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847333",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732306",
                                          "variationId": "155660815"
                                        },
                                        {
                                          "groupId": "36732308",
                                          "variationId": "114432288"
                                        }
                                      ],
                                      "price": 40400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847343",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732306",
                                          "variationId": "155660815"
                                        },
                                        {
                                          "groupId": "36732308",
                                          "variationId": "114432289"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847333",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732306",
                                          "variationId": "155660813"
                                        },
                                        {
                                          "groupId": "36732308",
                                          "variationId": "114432288"
                                        }
                                      ],
                                      "price": 40400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847343",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732306",
                                          "variationId": "155660813"
                                        },
                                        {
                                          "groupId": "36732308",
                                          "variationId": "114432289"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847333",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732306",
                                          "variationId": "155660814"
                                        },
                                        {
                                          "groupId": "36732308",
                                          "variationId": "114432288"
                                        }
                                      ],
                                      "price": 40400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847343",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732306",
                                          "variationId": "114432281"
                                        },
                                        {
                                          "groupId": "36732308",
                                          "variationId": "114432289"
                                        }
                                      ],
                                      "price": 63900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847333",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732306",
                                          "variationId": "114432279"
                                        },
                                        {
                                          "groupId": "36732308",
                                          "variationId": "114432288"
                                        }
                                      ],
                                      "price": 32900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847343",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732306",
                                          "variationId": "114432279"
                                        },
                                        {
                                          "groupId": "36732308",
                                          "variationId": "114432290"
                                        }
                                      ],
                                      "price": 87900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "166640752",
                                          "addonId": "121424326"
                                        },
                                        {
                                          "groupId": "166640752",
                                          "addonId": "121424344"
                                        },
                                        {
                                          "groupId": "166640752",
                                          "addonId": "121424339"
                                        },
                                        {
                                          "groupId": "166640752",
                                          "addonId": "121424330"
                                        },
                                        {
                                          "groupId": "166640752",
                                          "addonId": "121424342"
                                        },
                                        {
                                          "groupId": "166640752",
                                          "addonId": "121424333"
                                        },
                                        {
                                          "groupId": "166640752",
                                          "addonId": "121424336"
                                        },
                                        {
                                          "groupId": "131847348",
                                          "addonId": "100000673"
                                        },
                                        {
                                          "groupId": "131847350",
                                          "addonId": "100000685"
                                        },
                                        {
                                          "groupId": "131847350",
                                          "addonId": "100000699"
                                        },
                                        {
                                          "groupId": "131847350",
                                          "addonId": "100000695"
                                        },
                                        {
                                          "groupId": "131847350",
                                          "addonId": "100000698"
                                        },
                                        {
                                          "groupId": "131847350",
                                          "addonId": "100000684"
                                        },
                                        {
                                          "groupId": "131847350",
                                          "addonId": "100000697"
                                        },
                                        {
                                          "groupId": "131847350",
                                          "addonId": "100000679"
                                        },
                                        {
                                          "groupId": "131847350",
                                          "addonId": "100000681"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732306",
                                          "variationId": "114432279"
                                        },
                                        {
                                          "groupId": "36732308",
                                          "variationId": "114432289"
                                        }
                                      ],
                                      "price": 58900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847333",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732306",
                                          "variationId": "114432284"
                                        },
                                        {
                                          "groupId": "36732308",
                                          "variationId": "114432289"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847333",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732306",
                                          "variationId": "114432284"
                                        },
                                        {
                                          "groupId": "36732308",
                                          "variationId": "114432288"
                                        }
                                      ],
                                      "price": 40400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847343",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732306",
                                          "variationId": "114432287"
                                        },
                                        {
                                          "groupId": "36732308",
                                          "variationId": "114432288"
                                        }
                                      ],
                                      "price": 32900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847343",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732306",
                                          "variationId": "114432286"
                                        },
                                        {
                                          "groupId": "36732308",
                                          "variationId": "114432288"
                                        }
                                      ],
                                      "price": 35900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847343",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732306",
                                          "variationId": "114432286"
                                        },
                                        {
                                          "groupId": "36732308",
                                          "variationId": "114432289"
                                        }
                                      ],
                                      "price": 63900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847337",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640750",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847333",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732306",
                                          "variationId": "114432281"
                                        },
                                        {
                                          "groupId": "36732308",
                                          "variationId": "114432288"
                                        }
                                      ],
                                      "price": 35900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847343",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847346",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640751",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "131847333",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847337",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640750",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847343",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640751",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847346",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847348",
                                    "groupName": "Extra Cheese Large",
                                    "choices": [
                                      {
                                        "id": "100000673",
                                        "name": "Extra Cheese",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847350",
                                    "groupName": "Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "100000685",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000699",
                                        "name": "Black Olive",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000695",
                                        "name": "Grilled Mushrooms",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000698",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000684",
                                        "name": "Crisp Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000697",
                                        "name": "Fresh Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000679",
                                        "name": "Red Pepper",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000681",
                                        "name": "Paneer",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640752",
                                    "groupName": "Non-Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "121424326",
                                        "name": "Chicken Pepperoni",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424344",
                                        "name": "Chicken Keema",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424339",
                                        "name": "Peri - Peri Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424330",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424342",
                                        "name": "Chicken Sausage",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424333",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424336",
                                        "name": "Chicken Tikka",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 32900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520695",
                                "name": "Chicken Pepperoni Pizza",
                                "category": "Dominos Classics",
                                "description": "A classic American taste! Relish the delectable flavor of Chicken Pepperoni, topped with extra cheese",
                                "imageId": "973d3c0fcc111b4c92bc49fbb775266c",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732028",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "114431418",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732029",
                                            "variationId": "114431423"
                                          }
                                        },
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "id": "114431419",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732029",
                                            "variationId": "114431423"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "id": "114431420",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732029",
                                            "variationId": "114431423"
                                          }
                                        },
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114431421",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732029",
                                            "variationId": "114431423"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "id": "114431422",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732029",
                                            "variationId": "114431423"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155660945",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732029",
                                            "variationId": "114431423"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155660946",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732029",
                                            "variationId": "114431423"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155660947",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732029",
                                            "variationId": "114431423"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732029",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114431423",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "114431424",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large",
                                          "id": "114431425",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732028",
                                          "variationId": "155660946"
                                        },
                                        {
                                          "groupId": "36732029",
                                          "variationId": "114431423"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846766",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732028",
                                          "variationId": "155660946"
                                        },
                                        {
                                          "groupId": "36732029",
                                          "variationId": "114431424"
                                        }
                                      ],
                                      "price": 72800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846768",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732028",
                                          "variationId": "155660947"
                                        },
                                        {
                                          "groupId": "36732029",
                                          "variationId": "114431423"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846766",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732028",
                                          "variationId": "155660947"
                                        },
                                        {
                                          "groupId": "36732029",
                                          "variationId": "114431424"
                                        }
                                      ],
                                      "price": 72800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846768",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732028",
                                          "variationId": "155660945"
                                        },
                                        {
                                          "groupId": "36732029",
                                          "variationId": "114431423"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846766",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732028",
                                          "variationId": "155660945"
                                        },
                                        {
                                          "groupId": "36732029",
                                          "variationId": "114431424"
                                        }
                                      ],
                                      "price": 72800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846768",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732028",
                                          "variationId": "114431419"
                                        },
                                        {
                                          "groupId": "36732029",
                                          "variationId": "114431423"
                                        }
                                      ],
                                      "price": 40900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846766",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732028",
                                          "variationId": "114431419"
                                        },
                                        {
                                          "groupId": "36732029",
                                          "variationId": "114431424"
                                        }
                                      ],
                                      "price": 67900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846768",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732028",
                                          "variationId": "114431418"
                                        },
                                        {
                                          "groupId": "36732029",
                                          "variationId": "114431423"
                                        }
                                      ],
                                      "price": 37900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846766",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732028",
                                          "variationId": "114431418"
                                        },
                                        {
                                          "groupId": "36732029",
                                          "variationId": "114431425"
                                        }
                                      ],
                                      "price": 96900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "166640811",
                                          "addonId": "121424326"
                                        },
                                        {
                                          "groupId": "166640811",
                                          "addonId": "121424344"
                                        },
                                        {
                                          "groupId": "166640811",
                                          "addonId": "121424339"
                                        },
                                        {
                                          "groupId": "166640811",
                                          "addonId": "121424330"
                                        },
                                        {
                                          "groupId": "166640811",
                                          "addonId": "121424342"
                                        },
                                        {
                                          "groupId": "166640811",
                                          "addonId": "121424333"
                                        },
                                        {
                                          "groupId": "166640811",
                                          "addonId": "121424336"
                                        },
                                        {
                                          "groupId": "131846770",
                                          "addonId": "100000673"
                                        },
                                        {
                                          "groupId": "131846771",
                                          "addonId": "100000685"
                                        },
                                        {
                                          "groupId": "131846771",
                                          "addonId": "100000699"
                                        },
                                        {
                                          "groupId": "131846771",
                                          "addonId": "100000695"
                                        },
                                        {
                                          "groupId": "131846771",
                                          "addonId": "100000698"
                                        },
                                        {
                                          "groupId": "131846771",
                                          "addonId": "100000684"
                                        },
                                        {
                                          "groupId": "131846771",
                                          "addonId": "100000697"
                                        },
                                        {
                                          "groupId": "131846771",
                                          "addonId": "100000679"
                                        },
                                        {
                                          "groupId": "131846771",
                                          "addonId": "100000681"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732028",
                                          "variationId": "114431418"
                                        },
                                        {
                                          "groupId": "36732029",
                                          "variationId": "114431424"
                                        }
                                      ],
                                      "price": 62900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846768",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732028",
                                          "variationId": "114431420"
                                        },
                                        {
                                          "groupId": "36732029",
                                          "variationId": "114431424"
                                        }
                                      ],
                                      "price": 72800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846768",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732028",
                                          "variationId": "114431420"
                                        },
                                        {
                                          "groupId": "36732029",
                                          "variationId": "114431423"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846766",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732028",
                                          "variationId": "114431422"
                                        },
                                        {
                                          "groupId": "36732029",
                                          "variationId": "114431423"
                                        }
                                      ],
                                      "price": 37900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846766",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732028",
                                          "variationId": "114431421"
                                        },
                                        {
                                          "groupId": "36732029",
                                          "variationId": "114431423"
                                        }
                                      ],
                                      "price": 40900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846766",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846767",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640809",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732028",
                                          "variationId": "114431421"
                                        },
                                        {
                                          "groupId": "36732029",
                                          "variationId": "114431424"
                                        }
                                      ],
                                      "price": 67900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846769",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640810",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846768",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "131846766",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640809",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131846767",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131846768",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131846769",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640810",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131846770",
                                    "groupName": "Extra Cheese Large",
                                    "choices": [
                                      {
                                        "id": "100000673",
                                        "name": "Extra Cheese",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131846771",
                                    "groupName": "Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "100000685",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000699",
                                        "name": "Black Olive",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000695",
                                        "name": "Grilled Mushrooms",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000698",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000684",
                                        "name": "Crisp Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000697",
                                        "name": "Fresh Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000679",
                                        "name": "Red Pepper",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000681",
                                        "name": "Paneer",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640811",
                                    "groupName": "Non-Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "121424326",
                                        "name": "Chicken Pepperoni",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424344",
                                        "name": "Chicken Keema",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424339",
                                        "name": "Peri - Peri Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424330",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424342",
                                        "name": "Chicken Sausage",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424333",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424336",
                                        "name": "Chicken Tikka",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 37900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.9",
                                    "ratingCount": "7 ratings",
                                    "ratingCountV2": "7"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {
                          
                        }
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Loaded Pizza",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520664",
                                "name": "Veggie Paradise Pizza",
                                "category": "Loaded Pizza",
                                "description": "The awesome foursome! Golden corn, black olives, capsicum, red paprika",
                                "imageId": "2a8ea479040d62f82871e1be7470672a",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732421",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "114432626",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732422",
                                            "variationId": "114432631"
                                          }
                                        },
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "id": "114432627",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732422",
                                            "variationId": "114432631"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "id": "114432628",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732422",
                                            "variationId": "114432631"
                                          }
                                        },
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114432629",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732422",
                                            "variationId": "114432631"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "id": "114432630",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732422",
                                            "variationId": "114432631"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661047",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732422",
                                            "variationId": "114432631"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661048",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732422",
                                            "variationId": "114432631"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661049",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732422",
                                            "variationId": "114432631"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732422",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114432631",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "114432632",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large",
                                          "id": "114432633",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732421",
                                          "variationId": "155661048"
                                        },
                                        {
                                          "groupId": "36732422",
                                          "variationId": "114432631"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847564",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732421",
                                          "variationId": "155661048"
                                        },
                                        {
                                          "groupId": "36732422",
                                          "variationId": "114432632"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847576",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732421",
                                          "variationId": "155661049"
                                        },
                                        {
                                          "groupId": "36732422",
                                          "variationId": "114432631"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847564",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732421",
                                          "variationId": "155661049"
                                        },
                                        {
                                          "groupId": "36732422",
                                          "variationId": "114432632"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847576",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732421",
                                          "variationId": "155661047"
                                        },
                                        {
                                          "groupId": "36732422",
                                          "variationId": "114432631"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847564",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732421",
                                          "variationId": "155661047"
                                        },
                                        {
                                          "groupId": "36732422",
                                          "variationId": "114432632"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847576",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732421",
                                          "variationId": "114432626"
                                        },
                                        {
                                          "groupId": "36732422",
                                          "variationId": "114432631"
                                        }
                                      ],
                                      "price": 27900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847564",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732421",
                                          "variationId": "114432626"
                                        },
                                        {
                                          "groupId": "36732422",
                                          "variationId": "114432633"
                                        }
                                      ],
                                      "price": 73900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "166640760",
                                          "addonId": "121424326"
                                        },
                                        {
                                          "groupId": "166640760",
                                          "addonId": "121424344"
                                        },
                                        {
                                          "groupId": "166640760",
                                          "addonId": "121424339"
                                        },
                                        {
                                          "groupId": "166640760",
                                          "addonId": "121424330"
                                        },
                                        {
                                          "groupId": "166640760",
                                          "addonId": "121424342"
                                        },
                                        {
                                          "groupId": "166640760",
                                          "addonId": "121424333"
                                        },
                                        {
                                          "groupId": "166640760",
                                          "addonId": "121424336"
                                        },
                                        {
                                          "groupId": "131847570",
                                          "addonId": "100000673"
                                        },
                                        {
                                          "groupId": "131847573",
                                          "addonId": "100000685"
                                        },
                                        {
                                          "groupId": "131847573",
                                          "addonId": "100000699"
                                        },
                                        {
                                          "groupId": "131847573",
                                          "addonId": "100000695"
                                        },
                                        {
                                          "groupId": "131847573",
                                          "addonId": "100000698"
                                        },
                                        {
                                          "groupId": "131847573",
                                          "addonId": "100000684"
                                        },
                                        {
                                          "groupId": "131847573",
                                          "addonId": "100000697"
                                        },
                                        {
                                          "groupId": "131847573",
                                          "addonId": "100000679"
                                        },
                                        {
                                          "groupId": "131847573",
                                          "addonId": "100000681"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732421",
                                          "variationId": "114432626"
                                        },
                                        {
                                          "groupId": "36732422",
                                          "variationId": "114432632"
                                        }
                                      ],
                                      "price": 48900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847576",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732421",
                                          "variationId": "114432628"
                                        },
                                        {
                                          "groupId": "36732422",
                                          "variationId": "114432632"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847576",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732421",
                                          "variationId": "114432628"
                                        },
                                        {
                                          "groupId": "36732422",
                                          "variationId": "114432631"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847564",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732421",
                                          "variationId": "114432630"
                                        },
                                        {
                                          "groupId": "36732422",
                                          "variationId": "114432631"
                                        }
                                      ],
                                      "price": 27900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847564",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732421",
                                          "variationId": "114432629"
                                        },
                                        {
                                          "groupId": "36732422",
                                          "variationId": "114432631"
                                        }
                                      ],
                                      "price": 30900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847564",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732421",
                                          "variationId": "114432629"
                                        },
                                        {
                                          "groupId": "36732422",
                                          "variationId": "114432632"
                                        }
                                      ],
                                      "price": 53900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847576",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732421",
                                          "variationId": "114432627"
                                        },
                                        {
                                          "groupId": "36732422",
                                          "variationId": "114432631"
                                        }
                                      ],
                                      "price": 30900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847564",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847567",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640759",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732421",
                                          "variationId": "114432627"
                                        },
                                        {
                                          "groupId": "36732422",
                                          "variationId": "114432632"
                                        }
                                      ],
                                      "price": 53900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847578",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640761",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847576",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "131847564",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640759",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847567",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847576",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847578",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640761",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847570",
                                    "groupName": "Extra Cheese Large",
                                    "choices": [
                                      {
                                        "id": "100000673",
                                        "name": "Extra Cheese",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847573",
                                    "groupName": "Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "100000685",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000699",
                                        "name": "Black Olive",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000695",
                                        "name": "Grilled Mushrooms",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000698",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000684",
                                        "name": "Crisp Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000697",
                                        "name": "Fresh Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000679",
                                        "name": "Red Pepper",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000681",
                                        "name": "Paneer",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640760",
                                    "groupName": "Non-Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "121424326",
                                        "name": "Chicken Pepperoni",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424344",
                                        "name": "Chicken Keema",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424339",
                                        "name": "Peri - Peri Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424330",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424342",
                                        "name": "Chicken Sausage",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424333",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424336",
                                        "name": "Chicken Tikka",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 27900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.5",
                                    "ratingCount": "33 ratings",
                                    "ratingCountV2": "33"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520659",
                                "name": "Farmhouse Pizza",
                                "category": "Loaded Pizza",
                                "description": "Delightful combination of onion, capsicum, tomato & grilled mushroom. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                                "imageId": "740a92bd202ffd40813bc354b86005db",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732353",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "114432409",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732354",
                                            "variationId": "114432414"
                                          }
                                        },
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "id": "114432410",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732354",
                                            "variationId": "114432414"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "id": "114432411",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732354",
                                            "variationId": "114432414"
                                          }
                                        },
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114432412",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732354",
                                            "variationId": "114432414"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "id": "114432413",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732354",
                                            "variationId": "114432414"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155661113",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732354",
                                            "variationId": "114432414"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155661114",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732354",
                                            "variationId": "114432414"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155661115",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732354",
                                            "variationId": "114432414"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732354",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114432414",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "114432415",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large",
                                          "id": "114432417",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732353",
                                          "variationId": "155661114"
                                        },
                                        {
                                          "groupId": "36732354",
                                          "variationId": "114432414"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847425",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732353",
                                          "variationId": "155661114"
                                        },
                                        {
                                          "groupId": "36732354",
                                          "variationId": "114432415"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847433",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732353",
                                          "variationId": "155661115"
                                        },
                                        {
                                          "groupId": "36732354",
                                          "variationId": "114432414"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847425",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732353",
                                          "variationId": "155661115"
                                        },
                                        {
                                          "groupId": "36732354",
                                          "variationId": "114432415"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847433",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732353",
                                          "variationId": "155661113"
                                        },
                                        {
                                          "groupId": "36732354",
                                          "variationId": "114432414"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847425",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732353",
                                          "variationId": "155661113"
                                        },
                                        {
                                          "groupId": "36732354",
                                          "variationId": "114432415"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847433",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732353",
                                          "variationId": "114432409"
                                        },
                                        {
                                          "groupId": "36732354",
                                          "variationId": "114432414"
                                        }
                                      ],
                                      "price": 27900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847425",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732353",
                                          "variationId": "114432409"
                                        },
                                        {
                                          "groupId": "36732354",
                                          "variationId": "114432417"
                                        }
                                      ],
                                      "price": 73900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "166640837",
                                          "addonId": "121424326"
                                        },
                                        {
                                          "groupId": "166640837",
                                          "addonId": "121424344"
                                        },
                                        {
                                          "groupId": "166640837",
                                          "addonId": "121424339"
                                        },
                                        {
                                          "groupId": "166640837",
                                          "addonId": "121424330"
                                        },
                                        {
                                          "groupId": "166640837",
                                          "addonId": "121424342"
                                        },
                                        {
                                          "groupId": "166640837",
                                          "addonId": "121424333"
                                        },
                                        {
                                          "groupId": "166640837",
                                          "addonId": "121424336"
                                        },
                                        {
                                          "groupId": "131847430",
                                          "addonId": "100000673"
                                        },
                                        {
                                          "groupId": "131847432",
                                          "addonId": "100000685"
                                        },
                                        {
                                          "groupId": "131847432",
                                          "addonId": "100000699"
                                        },
                                        {
                                          "groupId": "131847432",
                                          "addonId": "100000695"
                                        },
                                        {
                                          "groupId": "131847432",
                                          "addonId": "100000698"
                                        },
                                        {
                                          "groupId": "131847432",
                                          "addonId": "100000684"
                                        },
                                        {
                                          "groupId": "131847432",
                                          "addonId": "100000697"
                                        },
                                        {
                                          "groupId": "131847432",
                                          "addonId": "100000679"
                                        },
                                        {
                                          "groupId": "131847432",
                                          "addonId": "100000681"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732353",
                                          "variationId": "114432409"
                                        },
                                        {
                                          "groupId": "36732354",
                                          "variationId": "114432415"
                                        }
                                      ],
                                      "price": 48900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847433",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732353",
                                          "variationId": "114432411"
                                        },
                                        {
                                          "groupId": "36732354",
                                          "variationId": "114432415"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847433",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732353",
                                          "variationId": "114432411"
                                        },
                                        {
                                          "groupId": "36732354",
                                          "variationId": "114432414"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847425",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732353",
                                          "variationId": "114432413"
                                        },
                                        {
                                          "groupId": "36732354",
                                          "variationId": "114432414"
                                        }
                                      ],
                                      "price": 27900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847425",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732353",
                                          "variationId": "114432412"
                                        },
                                        {
                                          "groupId": "36732354",
                                          "variationId": "114432414"
                                        }
                                      ],
                                      "price": 30900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847425",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732353",
                                          "variationId": "114432412"
                                        },
                                        {
                                          "groupId": "36732354",
                                          "variationId": "114432415"
                                        }
                                      ],
                                      "price": 53900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847433",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732353",
                                          "variationId": "114432410"
                                        },
                                        {
                                          "groupId": "36732354",
                                          "variationId": "114432414"
                                        }
                                      ],
                                      "price": 30900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847425",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847427",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640836",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732353",
                                          "variationId": "114432410"
                                        },
                                        {
                                          "groupId": "36732354",
                                          "variationId": "114432415"
                                        }
                                      ],
                                      "price": 53900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847435",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640838",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847433",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "131847425",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640836",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847427",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847433",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847435",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640838",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847430",
                                    "groupName": "Extra Cheese Large",
                                    "choices": [
                                      {
                                        "id": "100000673",
                                        "name": "Extra Cheese",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847432",
                                    "groupName": "Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "100000685",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000699",
                                        "name": "Black Olive",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000695",
                                        "name": "Grilled Mushrooms",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000698",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000684",
                                        "name": "Crisp Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000697",
                                        "name": "Fresh Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000679",
                                        "name": "Red Pepper",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000681",
                                        "name": "Paneer",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640837",
                                    "groupName": "Non-Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "121424326",
                                        "name": "Chicken Pepperoni",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424344",
                                        "name": "Chicken Keema",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424339",
                                        "name": "Peri - Peri Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424330",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424342",
                                        "name": "Chicken Sausage",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424333",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424336",
                                        "name": "Chicken Tikka",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 27900,
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.5",
                                    "ratingCount": "136 ratings",
                                    "ratingCountV2": "136"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520661",
                                "name": "Mexican Green Wave Pizza",
                                "category": "Loaded Pizza",
                                "description": "Mexican herbs sprinkled on onion, capsicum, tomato & jalapeno",
                                "imageId": "0d1949eef23c572096269d890e438efb",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732533",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "114432999",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732535",
                                            "variationId": "114433006"
                                          }
                                        },
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "id": "114433000",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732535",
                                            "variationId": "114433006"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "id": "114433001",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732535",
                                            "variationId": "114433006"
                                          }
                                        },
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114433002",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732535",
                                            "variationId": "114433006"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "id": "114433003",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732535",
                                            "variationId": "114433006"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155660729",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732535",
                                            "variationId": "114433006"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155660730",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732535",
                                            "variationId": "114433006"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155660731",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732535",
                                            "variationId": "114433006"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732535",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114433006",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "114433008",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large",
                                          "id": "114433010",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732533",
                                          "variationId": "155660730"
                                        },
                                        {
                                          "groupId": "36732535",
                                          "variationId": "114433006"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847829",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732533",
                                          "variationId": "155660730"
                                        },
                                        {
                                          "groupId": "36732535",
                                          "variationId": "114433008"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847823",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732533",
                                          "variationId": "155660731"
                                        },
                                        {
                                          "groupId": "36732535",
                                          "variationId": "114433006"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847829",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732533",
                                          "variationId": "155660731"
                                        },
                                        {
                                          "groupId": "36732535",
                                          "variationId": "114433008"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847823",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732533",
                                          "variationId": "155660729"
                                        },
                                        {
                                          "groupId": "36732535",
                                          "variationId": "114433006"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847829",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732533",
                                          "variationId": "155660729"
                                        },
                                        {
                                          "groupId": "36732535",
                                          "variationId": "114433008"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847823",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732533",
                                          "variationId": "114433000"
                                        },
                                        {
                                          "groupId": "36732535",
                                          "variationId": "114433008"
                                        }
                                      ],
                                      "price": 53900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847823",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732533",
                                          "variationId": "114432999"
                                        },
                                        {
                                          "groupId": "36732535",
                                          "variationId": "114433006"
                                        }
                                      ],
                                      "price": 27900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847829",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732533",
                                          "variationId": "114432999"
                                        },
                                        {
                                          "groupId": "36732535",
                                          "variationId": "114433010"
                                        }
                                      ],
                                      "price": 73900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "166640829",
                                          "addonId": "121424326"
                                        },
                                        {
                                          "groupId": "166640829",
                                          "addonId": "121424344"
                                        },
                                        {
                                          "groupId": "166640829",
                                          "addonId": "121424339"
                                        },
                                        {
                                          "groupId": "166640829",
                                          "addonId": "121424330"
                                        },
                                        {
                                          "groupId": "166640829",
                                          "addonId": "121424342"
                                        },
                                        {
                                          "groupId": "166640829",
                                          "addonId": "121424333"
                                        },
                                        {
                                          "groupId": "166640829",
                                          "addonId": "121424336"
                                        },
                                        {
                                          "groupId": "131847834",
                                          "addonId": "100000673"
                                        },
                                        {
                                          "groupId": "131847836",
                                          "addonId": "100000685"
                                        },
                                        {
                                          "groupId": "131847836",
                                          "addonId": "100000699"
                                        },
                                        {
                                          "groupId": "131847836",
                                          "addonId": "100000695"
                                        },
                                        {
                                          "groupId": "131847836",
                                          "addonId": "100000698"
                                        },
                                        {
                                          "groupId": "131847836",
                                          "addonId": "100000684"
                                        },
                                        {
                                          "groupId": "131847836",
                                          "addonId": "100000697"
                                        },
                                        {
                                          "groupId": "131847836",
                                          "addonId": "100000679"
                                        },
                                        {
                                          "groupId": "131847836",
                                          "addonId": "100000681"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732533",
                                          "variationId": "114432999"
                                        },
                                        {
                                          "groupId": "36732535",
                                          "variationId": "114433008"
                                        }
                                      ],
                                      "price": 48900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847823",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732533",
                                          "variationId": "114433001"
                                        },
                                        {
                                          "groupId": "36732535",
                                          "variationId": "114433008"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847823",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732533",
                                          "variationId": "114433001"
                                        },
                                        {
                                          "groupId": "36732535",
                                          "variationId": "114433006"
                                        }
                                      ],
                                      "price": 35400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847829",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732533",
                                          "variationId": "114433003"
                                        },
                                        {
                                          "groupId": "36732535",
                                          "variationId": "114433006"
                                        }
                                      ],
                                      "price": 27900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847829",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732533",
                                          "variationId": "114433002"
                                        },
                                        {
                                          "groupId": "36732535",
                                          "variationId": "114433006"
                                        }
                                      ],
                                      "price": 30900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847829",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732533",
                                          "variationId": "114433002"
                                        },
                                        {
                                          "groupId": "36732535",
                                          "variationId": "114433008"
                                        }
                                      ],
                                      "price": 53900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847826",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640827",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847823",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732533",
                                          "variationId": "114433000"
                                        },
                                        {
                                          "groupId": "36732535",
                                          "variationId": "114433006"
                                        }
                                      ],
                                      "price": 30900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847829",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847831",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640828",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "131847829",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640828",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847831",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847823",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847826",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640827",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847834",
                                    "groupName": "Extra Cheese Large",
                                    "choices": [
                                      {
                                        "id": "100000673",
                                        "name": "Extra Cheese",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847836",
                                    "groupName": "Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "100000685",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000699",
                                        "name": "Black Olive",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000695",
                                        "name": "Grilled Mushrooms",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000698",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000684",
                                        "name": "Crisp Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000697",
                                        "name": "Fresh Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000679",
                                        "name": "Red Pepper",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000681",
                                        "name": "Paneer",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640829",
                                    "groupName": "Non-Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "121424326",
                                        "name": "Chicken Pepperoni",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424344",
                                        "name": "Chicken Keema",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424339",
                                        "name": "Peri - Peri Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424330",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424342",
                                        "name": "Chicken Sausage",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424333",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424336",
                                        "name": "Chicken Tikka",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 27900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.4",
                                    "ratingCount": "11 ratings",
                                    "ratingCountV2": "11"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520663",
                                "name": "Veg Extravaganza Pizza",
                                "category": "Loaded Pizza",
                                "description": "Black olives, capsicum, onion, grilled mushroom, corn, tomato, jalapeno & extra cheese. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                                "imageId": "80355befb12f52c22eb75c6f865ca328",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732176",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "114431874",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732178",
                                            "variationId": "114431883"
                                          }
                                        },
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "id": "114431876",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732178",
                                            "variationId": "114431883"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "id": "114431879",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732178",
                                            "variationId": "114431883"
                                          }
                                        },
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114431881",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732178",
                                            "variationId": "114431883"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "id": "114431882",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732178",
                                            "variationId": "114431883"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732178",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114431883",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "114431884",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large",
                                          "id": "114431885",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732176",
                                          "variationId": "114431874"
                                        },
                                        {
                                          "groupId": "36732178",
                                          "variationId": "114431884"
                                        }
                                      ],
                                      "price": 58900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847071",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847071",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847071",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847071",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847071",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847071",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847071",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847071",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640806",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640806",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640806",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640806",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640806",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640806",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640806",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847069",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732176",
                                          "variationId": "114431879"
                                        },
                                        {
                                          "groupId": "36732178",
                                          "variationId": "114431884"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847071",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847071",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847071",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847071",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847071",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847071",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847071",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847071",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640806",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640806",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640806",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640806",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640806",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640806",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640806",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847069",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732176",
                                          "variationId": "114431879"
                                        },
                                        {
                                          "groupId": "36732178",
                                          "variationId": "114431883"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847074",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732176",
                                          "variationId": "114431882"
                                        },
                                        {
                                          "groupId": "36732178",
                                          "variationId": "114431883"
                                        }
                                      ],
                                      "price": 31900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847074",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732176",
                                          "variationId": "114431881"
                                        },
                                        {
                                          "groupId": "36732178",
                                          "variationId": "114431883"
                                        }
                                      ],
                                      "price": 34900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847074",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732176",
                                          "variationId": "114431881"
                                        },
                                        {
                                          "groupId": "36732178",
                                          "variationId": "114431884"
                                        }
                                      ],
                                      "price": 63900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847071",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847071",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847071",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847071",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847071",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847071",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847071",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847071",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640806",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640806",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640806",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640806",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640806",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640806",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640806",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847069",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732176",
                                          "variationId": "114431876"
                                        },
                                        {
                                          "groupId": "36732178",
                                          "variationId": "114431883"
                                        }
                                      ],
                                      "price": 34900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847074",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732176",
                                          "variationId": "114431876"
                                        },
                                        {
                                          "groupId": "36732178",
                                          "variationId": "114431884"
                                        }
                                      ],
                                      "price": 63900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847071",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847071",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847071",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847071",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847071",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847071",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847071",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847071",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640806",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640806",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640806",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640806",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640806",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640806",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640806",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847069",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732176",
                                          "variationId": "114431874"
                                        },
                                        {
                                          "groupId": "36732178",
                                          "variationId": "114431883"
                                        }
                                      ],
                                      "price": 31900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847074",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847077",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640807",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732176",
                                          "variationId": "114431874"
                                        },
                                        {
                                          "groupId": "36732178",
                                          "variationId": "114431885"
                                        }
                                      ],
                                      "price": 84900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "166640808",
                                          "addonId": "121424326"
                                        },
                                        {
                                          "groupId": "166640808",
                                          "addonId": "121424344"
                                        },
                                        {
                                          "groupId": "166640808",
                                          "addonId": "121424339"
                                        },
                                        {
                                          "groupId": "166640808",
                                          "addonId": "121424330"
                                        },
                                        {
                                          "groupId": "166640808",
                                          "addonId": "121424342"
                                        },
                                        {
                                          "groupId": "166640808",
                                          "addonId": "121424333"
                                        },
                                        {
                                          "groupId": "166640808",
                                          "addonId": "121424336"
                                        },
                                        {
                                          "groupId": "131847079",
                                          "addonId": "100000673"
                                        },
                                        {
                                          "groupId": "131847080",
                                          "addonId": "100000685"
                                        },
                                        {
                                          "groupId": "131847080",
                                          "addonId": "100000699"
                                        },
                                        {
                                          "groupId": "131847080",
                                          "addonId": "100000695"
                                        },
                                        {
                                          "groupId": "131847080",
                                          "addonId": "100000698"
                                        },
                                        {
                                          "groupId": "131847080",
                                          "addonId": "100000684"
                                        },
                                        {
                                          "groupId": "131847080",
                                          "addonId": "100000697"
                                        },
                                        {
                                          "groupId": "131847080",
                                          "addonId": "100000679"
                                        },
                                        {
                                          "groupId": "131847080",
                                          "addonId": "100000681"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "131847069",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847071",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640806",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847074",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640807",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847077",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847079",
                                    "groupName": "Extra Cheese Large",
                                    "choices": [
                                      {
                                        "id": "100000673",
                                        "name": "Extra Cheese",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847080",
                                    "groupName": "Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "100000685",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000699",
                                        "name": "Black Olive",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000695",
                                        "name": "Grilled Mushrooms",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000698",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000684",
                                        "name": "Crisp Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000697",
                                        "name": "Fresh Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000679",
                                        "name": "Red Pepper",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000681",
                                        "name": "Paneer",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640808",
                                    "groupName": "Non-Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "121424326",
                                        "name": "Chicken Pepperoni",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424344",
                                        "name": "Chicken Keema",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424339",
                                        "name": "Peri - Peri Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424330",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424342",
                                        "name": "Chicken Sausage",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424333",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424336",
                                        "name": "Chicken Tikka",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 31900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "38 ratings",
                                    "ratingCountV2": "38"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520645",
                                "name": "Cheese Overload",
                                "category": "Loaded Pizza",
                                "description": "Cheese Overloaded Pizza with a medley of Mozzarella, Cheddar & Ghost Pepper flavoured Cheese.",
                                "imageId": "fd7f927d5acf2244f17ec2a5b2512773",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732169",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "114431847",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732170",
                                            "variationId": "114431851"
                                          }
                                        },
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "id": "114431848",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732170",
                                            "variationId": "114431851"
                                          }
                                        },
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114431849",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732170",
                                            "variationId": "114431851"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "id": "114431850",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732170",
                                            "variationId": "114431851"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732170",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114431851",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "114431852",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large",
                                          "id": "114431853",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732169",
                                          "variationId": "114431847"
                                        },
                                        {
                                          "groupId": "36732170",
                                          "variationId": "114431851"
                                        }
                                      ],
                                      "price": 35500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847043",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847046",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847046",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847046",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847046",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847046",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847046",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847046",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847046",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640803",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640803",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640803",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640803",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640803",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640803",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640803",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732169",
                                          "variationId": "114431847"
                                        },
                                        {
                                          "groupId": "36732170",
                                          "variationId": "114431853"
                                        }
                                      ],
                                      "price": 97900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "166640804",
                                          "addonId": "121424326"
                                        },
                                        {
                                          "groupId": "166640804",
                                          "addonId": "121424344"
                                        },
                                        {
                                          "groupId": "166640804",
                                          "addonId": "121424339"
                                        },
                                        {
                                          "groupId": "166640804",
                                          "addonId": "121424330"
                                        },
                                        {
                                          "groupId": "166640804",
                                          "addonId": "121424342"
                                        },
                                        {
                                          "groupId": "166640804",
                                          "addonId": "121424333"
                                        },
                                        {
                                          "groupId": "166640804",
                                          "addonId": "121424336"
                                        },
                                        {
                                          "groupId": "131847051",
                                          "addonId": "100000673"
                                        },
                                        {
                                          "groupId": "131847055",
                                          "addonId": "100000685"
                                        },
                                        {
                                          "groupId": "131847055",
                                          "addonId": "100000699"
                                        },
                                        {
                                          "groupId": "131847055",
                                          "addonId": "100000695"
                                        },
                                        {
                                          "groupId": "131847055",
                                          "addonId": "100000698"
                                        },
                                        {
                                          "groupId": "131847055",
                                          "addonId": "100000684"
                                        },
                                        {
                                          "groupId": "131847055",
                                          "addonId": "100000697"
                                        },
                                        {
                                          "groupId": "131847055",
                                          "addonId": "100000679"
                                        },
                                        {
                                          "groupId": "131847055",
                                          "addonId": "100000681"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732169",
                                          "variationId": "114431847"
                                        },
                                        {
                                          "groupId": "36732170",
                                          "variationId": "114431852"
                                        }
                                      ],
                                      "price": 64900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847061",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847061",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847061",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847061",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847061",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847061",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847061",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847061",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640805",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640805",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640805",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640805",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640805",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640805",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640805",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847059",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732169",
                                          "variationId": "114431850"
                                        },
                                        {
                                          "groupId": "36732170",
                                          "variationId": "114431851"
                                        }
                                      ],
                                      "price": 35500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847043",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847046",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847046",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847046",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847046",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847046",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847046",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847046",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847046",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640803",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640803",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640803",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640803",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640803",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640803",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640803",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732169",
                                          "variationId": "114431849"
                                        },
                                        {
                                          "groupId": "36732170",
                                          "variationId": "114431851"
                                        }
                                      ],
                                      "price": 38500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847043",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847046",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847046",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847046",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847046",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847046",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847046",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847046",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847046",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640803",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640803",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640803",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640803",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640803",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640803",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640803",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732169",
                                          "variationId": "114431849"
                                        },
                                        {
                                          "groupId": "36732170",
                                          "variationId": "114431852"
                                        }
                                      ],
                                      "price": 69900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847061",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847061",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847061",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847061",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847061",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847061",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847061",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847061",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640805",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640805",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640805",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640805",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640805",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640805",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640805",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847059",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732169",
                                          "variationId": "114431848"
                                        },
                                        {
                                          "groupId": "36732170",
                                          "variationId": "114431851"
                                        }
                                      ],
                                      "price": 38500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847043",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847046",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847046",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847046",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847046",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847046",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847046",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847046",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847046",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640803",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640803",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640803",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640803",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640803",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640803",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640803",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732169",
                                          "variationId": "114431848"
                                        },
                                        {
                                          "groupId": "36732170",
                                          "variationId": "114431852"
                                        }
                                      ],
                                      "price": 69900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847061",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847061",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847061",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847061",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847061",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847061",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847061",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847061",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640805",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640805",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640805",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640805",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640805",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640805",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640805",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847059",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "131847043",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640803",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847046",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847051",
                                    "groupName": "Extra Cheese Large",
                                    "choices": [
                                      {
                                        "id": "100000673",
                                        "name": "Extra Cheese",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847055",
                                    "groupName": "Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "100000685",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000699",
                                        "name": "Black Olive",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000695",
                                        "name": "Grilled Mushrooms",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000698",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000684",
                                        "name": "Crisp Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000697",
                                        "name": "Fresh Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000679",
                                        "name": "Red Pepper",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000681",
                                        "name": "Paneer",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640804",
                                    "groupName": "Non-Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "121424326",
                                        "name": "Chicken Pepperoni",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424344",
                                        "name": "Chicken Keema",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424339",
                                        "name": "Peri - Peri Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424330",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424342",
                                        "name": "Chicken Sausage",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424333",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424336",
                                        "name": "Chicken Tikka",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847059",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847061",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640805",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 35500,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.9",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520693",
                                "name": "Chicken Fiesta Pizza",
                                "category": "Loaded Pizza",
                                "description": "Grilled chicken rashers, peri-peri chicken, onion & capsicum, a complete fiesta",
                                "imageId": "274348f5f584d2893c654f7880c3eacb",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732407",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "114432583",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732411",
                                            "variationId": "114432598"
                                          }
                                        },
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "id": "114432584",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732411",
                                            "variationId": "114432598"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "id": "114432587",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732411",
                                            "variationId": "114432598"
                                          }
                                        },
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114432591",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732411",
                                            "variationId": "114432598"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "id": "114432594",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732411",
                                            "variationId": "114432598"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155660915",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732411",
                                            "variationId": "114432598"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155660916",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732411",
                                            "variationId": "114432598"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155660917",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732411",
                                            "variationId": "114432598"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732411",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114432598",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "114432601",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large",
                                          "id": "114432603",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732407",
                                          "variationId": "155660917"
                                        },
                                        {
                                          "groupId": "36732411",
                                          "variationId": "114432601"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847543",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732407",
                                          "variationId": "155660915"
                                        },
                                        {
                                          "groupId": "36732411",
                                          "variationId": "114432598"
                                        }
                                      ],
                                      "price": 40400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847536",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732407",
                                          "variationId": "155660915"
                                        },
                                        {
                                          "groupId": "36732411",
                                          "variationId": "114432601"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847543",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732407",
                                          "variationId": "155660916"
                                        },
                                        {
                                          "groupId": "36732411",
                                          "variationId": "114432598"
                                        }
                                      ],
                                      "price": 40400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847536",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732407",
                                          "variationId": "155660916"
                                        },
                                        {
                                          "groupId": "36732411",
                                          "variationId": "114432601"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847543",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732407",
                                          "variationId": "155660917"
                                        },
                                        {
                                          "groupId": "36732411",
                                          "variationId": "114432598"
                                        }
                                      ],
                                      "price": 40400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847536",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732407",
                                          "variationId": "114432587"
                                        },
                                        {
                                          "groupId": "36732411",
                                          "variationId": "114432598"
                                        }
                                      ],
                                      "price": 40400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847536",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732407",
                                          "variationId": "114432594"
                                        },
                                        {
                                          "groupId": "36732411",
                                          "variationId": "114432598"
                                        }
                                      ],
                                      "price": 32900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847536",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732407",
                                          "variationId": "114432591"
                                        },
                                        {
                                          "groupId": "36732411",
                                          "variationId": "114432598"
                                        }
                                      ],
                                      "price": 35900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847536",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732407",
                                          "variationId": "114432591"
                                        },
                                        {
                                          "groupId": "36732411",
                                          "variationId": "114432601"
                                        }
                                      ],
                                      "price": 63900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847543",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732407",
                                          "variationId": "114432584"
                                        },
                                        {
                                          "groupId": "36732411",
                                          "variationId": "114432598"
                                        }
                                      ],
                                      "price": 35900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847536",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732407",
                                          "variationId": "114432584"
                                        },
                                        {
                                          "groupId": "36732411",
                                          "variationId": "114432601"
                                        }
                                      ],
                                      "price": 63900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847543",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732407",
                                          "variationId": "114432583"
                                        },
                                        {
                                          "groupId": "36732411",
                                          "variationId": "114432598"
                                        }
                                      ],
                                      "price": 32900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847536",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847539",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640815",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732407",
                                          "variationId": "114432583"
                                        },
                                        {
                                          "groupId": "36732411",
                                          "variationId": "114432603"
                                        }
                                      ],
                                      "price": 87900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "166640817",
                                          "addonId": "121424326"
                                        },
                                        {
                                          "groupId": "166640817",
                                          "addonId": "121424344"
                                        },
                                        {
                                          "groupId": "166640817",
                                          "addonId": "121424339"
                                        },
                                        {
                                          "groupId": "166640817",
                                          "addonId": "121424330"
                                        },
                                        {
                                          "groupId": "166640817",
                                          "addonId": "121424342"
                                        },
                                        {
                                          "groupId": "166640817",
                                          "addonId": "121424333"
                                        },
                                        {
                                          "groupId": "166640817",
                                          "addonId": "121424336"
                                        },
                                        {
                                          "groupId": "131847550",
                                          "addonId": "100000673"
                                        },
                                        {
                                          "groupId": "131847553",
                                          "addonId": "100000685"
                                        },
                                        {
                                          "groupId": "131847553",
                                          "addonId": "100000699"
                                        },
                                        {
                                          "groupId": "131847553",
                                          "addonId": "100000695"
                                        },
                                        {
                                          "groupId": "131847553",
                                          "addonId": "100000698"
                                        },
                                        {
                                          "groupId": "131847553",
                                          "addonId": "100000684"
                                        },
                                        {
                                          "groupId": "131847553",
                                          "addonId": "100000697"
                                        },
                                        {
                                          "groupId": "131847553",
                                          "addonId": "100000679"
                                        },
                                        {
                                          "groupId": "131847553",
                                          "addonId": "100000681"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732407",
                                          "variationId": "114432583"
                                        },
                                        {
                                          "groupId": "36732411",
                                          "variationId": "114432601"
                                        }
                                      ],
                                      "price": 58900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847543",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732407",
                                          "variationId": "114432587"
                                        },
                                        {
                                          "groupId": "36732411",
                                          "variationId": "114432601"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847546",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640816",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847543",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "131847543",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847546",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640816",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847536",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640815",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847539",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847550",
                                    "groupName": "Extra Cheese Large",
                                    "choices": [
                                      {
                                        "id": "100000673",
                                        "name": "Extra Cheese",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847553",
                                    "groupName": "Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "100000685",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000699",
                                        "name": "Black Olive",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000695",
                                        "name": "Grilled Mushrooms",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000698",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000684",
                                        "name": "Crisp Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000697",
                                        "name": "Fresh Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000679",
                                        "name": "Red Pepper",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000681",
                                        "name": "Paneer",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640817",
                                    "groupName": "Non-Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "121424326",
                                        "name": "Chicken Pepperoni",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424344",
                                        "name": "Chicken Keema",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424339",
                                        "name": "Peri - Peri Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424330",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424342",
                                        "name": "Chicken Sausage",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424333",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424336",
                                        "name": "Chicken Tikka",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 32900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "14 ratings",
                                    "ratingCountV2": "14"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520688",
                                "name": "Chicken Dominator Pizza",
                                "category": "Loaded Pizza",
                                "description": "Loaded with double pepper barbecue chicken, peri-peri chicken, chicken tikka & grilled chicken rashers. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                                "imageId": "22118134ebce9f89b2c12b95c19154db",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732036",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "114431444",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732037",
                                            "variationId": "114431449"
                                          }
                                        },
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "id": "114431445",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732037",
                                            "variationId": "114431449"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "id": "114431446",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732037",
                                            "variationId": "114431449"
                                          }
                                        },
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114431447",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732037",
                                            "variationId": "114431449"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "id": "114431448",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732037",
                                            "variationId": "114431449"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732037",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114431449",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "114431450",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large",
                                          "id": "114431451",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732036",
                                          "variationId": "114431444"
                                        },
                                        {
                                          "groupId": "36732037",
                                          "variationId": "114431449"
                                        }
                                      ],
                                      "price": 37900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846778",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732036",
                                          "variationId": "114431444"
                                        },
                                        {
                                          "groupId": "36732037",
                                          "variationId": "114431451"
                                        }
                                      ],
                                      "price": 96900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "166640775",
                                          "addonId": "121424326"
                                        },
                                        {
                                          "groupId": "166640775",
                                          "addonId": "121424344"
                                        },
                                        {
                                          "groupId": "166640775",
                                          "addonId": "121424339"
                                        },
                                        {
                                          "groupId": "166640775",
                                          "addonId": "121424330"
                                        },
                                        {
                                          "groupId": "166640775",
                                          "addonId": "121424342"
                                        },
                                        {
                                          "groupId": "166640775",
                                          "addonId": "121424333"
                                        },
                                        {
                                          "groupId": "166640775",
                                          "addonId": "121424336"
                                        },
                                        {
                                          "groupId": "131846780",
                                          "addonId": "100000673"
                                        },
                                        {
                                          "groupId": "131846781",
                                          "addonId": "100000685"
                                        },
                                        {
                                          "groupId": "131846781",
                                          "addonId": "100000699"
                                        },
                                        {
                                          "groupId": "131846781",
                                          "addonId": "100000695"
                                        },
                                        {
                                          "groupId": "131846781",
                                          "addonId": "100000698"
                                        },
                                        {
                                          "groupId": "131846781",
                                          "addonId": "100000684"
                                        },
                                        {
                                          "groupId": "131846781",
                                          "addonId": "100000697"
                                        },
                                        {
                                          "groupId": "131846781",
                                          "addonId": "100000679"
                                        },
                                        {
                                          "groupId": "131846781",
                                          "addonId": "100000681"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732036",
                                          "variationId": "114431444"
                                        },
                                        {
                                          "groupId": "36732037",
                                          "variationId": "114431450"
                                        }
                                      ],
                                      "price": 62900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846785",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846785",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846785",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846785",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846785",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846785",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846785",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846785",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640776",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640776",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640776",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640776",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640776",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640776",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640776",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846784",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732036",
                                          "variationId": "114431446"
                                        },
                                        {
                                          "groupId": "36732037",
                                          "variationId": "114431450"
                                        }
                                      ],
                                      "price": 72800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846785",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846785",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846785",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846785",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846785",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846785",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846785",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846785",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640776",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640776",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640776",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640776",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640776",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640776",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640776",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846784",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732036",
                                          "variationId": "114431446"
                                        },
                                        {
                                          "groupId": "36732037",
                                          "variationId": "114431449"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846778",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732036",
                                          "variationId": "114431448"
                                        },
                                        {
                                          "groupId": "36732037",
                                          "variationId": "114431449"
                                        }
                                      ],
                                      "price": 37900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846778",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732036",
                                          "variationId": "114431447"
                                        },
                                        {
                                          "groupId": "36732037",
                                          "variationId": "114431449"
                                        }
                                      ],
                                      "price": 40900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846778",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732036",
                                          "variationId": "114431447"
                                        },
                                        {
                                          "groupId": "36732037",
                                          "variationId": "114431450"
                                        }
                                      ],
                                      "price": 67900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846785",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846785",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846785",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846785",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846785",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846785",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846785",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846785",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640776",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640776",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640776",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640776",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640776",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640776",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640776",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846784",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732036",
                                          "variationId": "114431445"
                                        },
                                        {
                                          "groupId": "36732037",
                                          "variationId": "114431449"
                                        }
                                      ],
                                      "price": 40900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846778",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846779",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640774",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732036",
                                          "variationId": "114431445"
                                        },
                                        {
                                          "groupId": "36732037",
                                          "variationId": "114431450"
                                        }
                                      ],
                                      "price": 67900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846785",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846785",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846785",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846785",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846785",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846785",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846785",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846785",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640776",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640776",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640776",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640776",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640776",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640776",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640776",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846784",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "131846778",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640774",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131846779",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131846780",
                                    "groupName": "Extra Cheese Large",
                                    "choices": [
                                      {
                                        "id": "100000673",
                                        "name": "Extra Cheese",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131846781",
                                    "groupName": "Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "100000685",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000699",
                                        "name": "Black Olive",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000695",
                                        "name": "Grilled Mushrooms",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000698",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000684",
                                        "name": "Crisp Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000697",
                                        "name": "Fresh Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000679",
                                        "name": "Red Pepper",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000681",
                                        "name": "Paneer",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640775",
                                    "groupName": "Non-Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "121424326",
                                        "name": "Chicken Pepperoni",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424344",
                                        "name": "Chicken Keema",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424339",
                                        "name": "Peri - Peri Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424330",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424342",
                                        "name": "Chicken Sausage",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424333",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424336",
                                        "name": "Chicken Tikka",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131846784",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131846785",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640776",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 37900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "46 ratings",
                                    "ratingCountV2": "46"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520689",
                                "name": "Non Veg Supreme Pizza",
                                "category": "Loaded Pizza",
                                "description": "Supreme combination of black olives, onion, capsicum, grilled mushroom, pepper barbecue chicken, peri-peri chicken & grilled chicken rashers",
                                "imageId": "f03bf80c03fa196e84ccb8f2510b2ef8",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732261",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "114432141",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732263",
                                            "variationId": "114432150"
                                          }
                                        },
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "id": "114432142",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732263",
                                            "variationId": "114432150"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "id": "114432144",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732263",
                                            "variationId": "114432150"
                                          }
                                        },
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114432146",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732263",
                                            "variationId": "114432150"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "id": "114432148",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732263",
                                            "variationId": "114432150"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732263",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114432150",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "114432152",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large",
                                          "id": "114432154",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732261",
                                          "variationId": "114432144"
                                        },
                                        {
                                          "groupId": "36732263",
                                          "variationId": "114432152"
                                        }
                                      ],
                                      "price": 72800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847237",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847237",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847237",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847237",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847237",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847237",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847237",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847237",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640812",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640812",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640812",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640812",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640812",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640812",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640812",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847234",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732261",
                                          "variationId": "114432144"
                                        },
                                        {
                                          "groupId": "36732263",
                                          "variationId": "114432150"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847240",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732261",
                                          "variationId": "114432148"
                                        },
                                        {
                                          "groupId": "36732263",
                                          "variationId": "114432150"
                                        }
                                      ],
                                      "price": 37900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847240",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732261",
                                          "variationId": "114432146"
                                        },
                                        {
                                          "groupId": "36732263",
                                          "variationId": "114432150"
                                        }
                                      ],
                                      "price": 40900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847240",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732261",
                                          "variationId": "114432146"
                                        },
                                        {
                                          "groupId": "36732263",
                                          "variationId": "114432152"
                                        }
                                      ],
                                      "price": 67900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847237",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847237",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847237",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847237",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847237",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847237",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847237",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847237",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640812",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640812",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640812",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640812",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640812",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640812",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640812",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847234",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732261",
                                          "variationId": "114432142"
                                        },
                                        {
                                          "groupId": "36732263",
                                          "variationId": "114432150"
                                        }
                                      ],
                                      "price": 40900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847240",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732261",
                                          "variationId": "114432142"
                                        },
                                        {
                                          "groupId": "36732263",
                                          "variationId": "114432152"
                                        }
                                      ],
                                      "price": 67900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847237",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847237",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847237",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847237",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847237",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847237",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847237",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847237",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640812",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640812",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640812",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640812",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640812",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640812",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640812",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847234",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732261",
                                          "variationId": "114432141"
                                        },
                                        {
                                          "groupId": "36732263",
                                          "variationId": "114432150"
                                        }
                                      ],
                                      "price": 37900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847240",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847244",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640813",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732261",
                                          "variationId": "114432141"
                                        },
                                        {
                                          "groupId": "36732263",
                                          "variationId": "114432154"
                                        }
                                      ],
                                      "price": 96900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "166640814",
                                          "addonId": "121424326"
                                        },
                                        {
                                          "groupId": "166640814",
                                          "addonId": "121424344"
                                        },
                                        {
                                          "groupId": "166640814",
                                          "addonId": "121424339"
                                        },
                                        {
                                          "groupId": "166640814",
                                          "addonId": "121424330"
                                        },
                                        {
                                          "groupId": "166640814",
                                          "addonId": "121424342"
                                        },
                                        {
                                          "groupId": "166640814",
                                          "addonId": "121424333"
                                        },
                                        {
                                          "groupId": "166640814",
                                          "addonId": "121424336"
                                        },
                                        {
                                          "groupId": "131847248",
                                          "addonId": "100000673"
                                        },
                                        {
                                          "groupId": "131847252",
                                          "addonId": "100000685"
                                        },
                                        {
                                          "groupId": "131847252",
                                          "addonId": "100000699"
                                        },
                                        {
                                          "groupId": "131847252",
                                          "addonId": "100000695"
                                        },
                                        {
                                          "groupId": "131847252",
                                          "addonId": "100000698"
                                        },
                                        {
                                          "groupId": "131847252",
                                          "addonId": "100000684"
                                        },
                                        {
                                          "groupId": "131847252",
                                          "addonId": "100000697"
                                        },
                                        {
                                          "groupId": "131847252",
                                          "addonId": "100000679"
                                        },
                                        {
                                          "groupId": "131847252",
                                          "addonId": "100000681"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732261",
                                          "variationId": "114432141"
                                        },
                                        {
                                          "groupId": "36732263",
                                          "variationId": "114432152"
                                        }
                                      ],
                                      "price": 62900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847237",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847237",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847237",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847237",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847237",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847237",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847237",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847237",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640812",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640812",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640812",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640812",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640812",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640812",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640812",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847234",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "131847234",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847237",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640812",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847240",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640813",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847244",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847248",
                                    "groupName": "Extra Cheese Large",
                                    "choices": [
                                      {
                                        "id": "100000673",
                                        "name": "Extra Cheese",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847252",
                                    "groupName": "Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "100000685",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000699",
                                        "name": "Black Olive",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000695",
                                        "name": "Grilled Mushrooms",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000698",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000684",
                                        "name": "Crisp Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000697",
                                        "name": "Fresh Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000679",
                                        "name": "Red Pepper",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000681",
                                        "name": "Paneer",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640814",
                                    "groupName": "Non-Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "121424326",
                                        "name": "Chicken Pepperoni",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424344",
                                        "name": "Chicken Keema",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424339",
                                        "name": "Peri - Peri Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424330",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424342",
                                        "name": "Chicken Sausage",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424333",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424336",
                                        "name": "Chicken Tikka",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 37900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.7",
                                    "ratingCount": "21 ratings",
                                    "ratingCountV2": "21"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520648",
                                "name": "The 5 Chicken Feast Pizza",
                                "category": "Loaded Pizza",
                                "description": "Loaded with 5 different Chicken toppings - grilled Chicken Rashers, Chicken Meatballs, Chicken Tikka, herby Chicken Sausage and flavorful Chicken Keema",
                                "imageId": "03998b8a2a364faffde45ceb2bb95812",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732044",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "114431470",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732045",
                                            "variationId": "114431475"
                                          }
                                        },
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "id": "114431471",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732045",
                                            "variationId": "114431475"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "id": "114431472",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732045",
                                            "variationId": "114431475"
                                          }
                                        },
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114431473",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732045",
                                            "variationId": "114431475"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "id": "114431474",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732045",
                                            "variationId": "114431475"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155660564",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732045",
                                            "variationId": "114431475"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155660565",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732045",
                                            "variationId": "114431475"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155660566",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732045",
                                            "variationId": "114431475"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732045",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114431475",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "114431476",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large",
                                          "id": "114431477",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732044",
                                          "variationId": "155660564"
                                        },
                                        {
                                          "groupId": "36732045",
                                          "variationId": "114431476"
                                        }
                                      ],
                                      "price": 80800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846795",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732044",
                                          "variationId": "155660565"
                                        },
                                        {
                                          "groupId": "36732045",
                                          "variationId": "114431475"
                                        }
                                      ],
                                      "price": 48000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846793",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732044",
                                          "variationId": "155660565"
                                        },
                                        {
                                          "groupId": "36732045",
                                          "variationId": "114431476"
                                        }
                                      ],
                                      "price": 80800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846795",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732044",
                                          "variationId": "155660566"
                                        },
                                        {
                                          "groupId": "36732045",
                                          "variationId": "114431475"
                                        }
                                      ],
                                      "price": 48000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846793",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732044",
                                          "variationId": "155660566"
                                        },
                                        {
                                          "groupId": "36732045",
                                          "variationId": "114431476"
                                        }
                                      ],
                                      "price": 80800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846795",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732044",
                                          "variationId": "155660564"
                                        },
                                        {
                                          "groupId": "36732045",
                                          "variationId": "114431475"
                                        }
                                      ],
                                      "price": 48000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846793",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732044",
                                          "variationId": "114431473"
                                        },
                                        {
                                          "groupId": "36732045",
                                          "variationId": "114431475"
                                        }
                                      ],
                                      "price": 43500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846793",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732044",
                                          "variationId": "114431473"
                                        },
                                        {
                                          "groupId": "36732045",
                                          "variationId": "114431476"
                                        }
                                      ],
                                      "price": 75900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846795",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732044",
                                          "variationId": "114431471"
                                        },
                                        {
                                          "groupId": "36732045",
                                          "variationId": "114431475"
                                        }
                                      ],
                                      "price": 43500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846793",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732044",
                                          "variationId": "114431471"
                                        },
                                        {
                                          "groupId": "36732045",
                                          "variationId": "114431476"
                                        }
                                      ],
                                      "price": 75900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846795",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732044",
                                          "variationId": "114431470"
                                        },
                                        {
                                          "groupId": "36732045",
                                          "variationId": "114431475"
                                        }
                                      ],
                                      "price": 40500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846793",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732044",
                                          "variationId": "114431470"
                                        },
                                        {
                                          "groupId": "36732045",
                                          "variationId": "114431477"
                                        }
                                      ],
                                      "price": 104900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "166640749",
                                          "addonId": "121424326"
                                        },
                                        {
                                          "groupId": "166640749",
                                          "addonId": "121424344"
                                        },
                                        {
                                          "groupId": "166640749",
                                          "addonId": "121424339"
                                        },
                                        {
                                          "groupId": "166640749",
                                          "addonId": "121424330"
                                        },
                                        {
                                          "groupId": "166640749",
                                          "addonId": "121424342"
                                        },
                                        {
                                          "groupId": "166640749",
                                          "addonId": "121424333"
                                        },
                                        {
                                          "groupId": "166640749",
                                          "addonId": "121424336"
                                        },
                                        {
                                          "groupId": "131846797",
                                          "addonId": "100000673"
                                        },
                                        {
                                          "groupId": "131846798",
                                          "addonId": "100000685"
                                        },
                                        {
                                          "groupId": "131846798",
                                          "addonId": "100000699"
                                        },
                                        {
                                          "groupId": "131846798",
                                          "addonId": "100000695"
                                        },
                                        {
                                          "groupId": "131846798",
                                          "addonId": "100000698"
                                        },
                                        {
                                          "groupId": "131846798",
                                          "addonId": "100000684"
                                        },
                                        {
                                          "groupId": "131846798",
                                          "addonId": "100000697"
                                        },
                                        {
                                          "groupId": "131846798",
                                          "addonId": "100000679"
                                        },
                                        {
                                          "groupId": "131846798",
                                          "addonId": "100000681"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732044",
                                          "variationId": "114431470"
                                        },
                                        {
                                          "groupId": "36732045",
                                          "variationId": "114431476"
                                        }
                                      ],
                                      "price": 70900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846795",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732044",
                                          "variationId": "114431472"
                                        },
                                        {
                                          "groupId": "36732045",
                                          "variationId": "114431476"
                                        }
                                      ],
                                      "price": 80800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846796",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640748",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846795",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732044",
                                          "variationId": "114431472"
                                        },
                                        {
                                          "groupId": "36732045",
                                          "variationId": "114431475"
                                        }
                                      ],
                                      "price": 48000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846793",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732044",
                                          "variationId": "114431474"
                                        },
                                        {
                                          "groupId": "36732045",
                                          "variationId": "114431475"
                                        }
                                      ],
                                      "price": 40500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846793",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846794",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640747",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "131846795",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131846796",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640748",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131846793",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640747",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131846794",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131846797",
                                    "groupName": "Extra Cheese Large",
                                    "choices": [
                                      {
                                        "id": "100000673",
                                        "name": "Extra Cheese",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131846798",
                                    "groupName": "Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "100000685",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000699",
                                        "name": "Black Olive",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000695",
                                        "name": "Grilled Mushrooms",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000698",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000684",
                                        "name": "Crisp Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000697",
                                        "name": "Fresh Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000679",
                                        "name": "Red Pepper",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000681",
                                        "name": "Paneer",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640749",
                                    "groupName": "Non-Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "121424326",
                                        "name": "Chicken Pepperoni",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424344",
                                        "name": "Chicken Keema",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424339",
                                        "name": "Peri - Peri Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424330",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424342",
                                        "name": "Chicken Sausage",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424333",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424336",
                                        "name": "Chicken Tikka",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 40500,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.9",
                                    "ratingCount": "10 ratings",
                                    "ratingCountV2": "10"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {
                          
                        }
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Flavours of India",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520670",
                                "name": "Achari Do Pyaza Pizza",
                                "category": "Flavours of India",
                                "description": "Tangy & spicy achari flavours on a super cheesy onion pizza- as desi as it gets!",
                                "imageId": "14d8197b31ae36df0b697ba52b204d17",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732187",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "114431902",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732188",
                                            "variationId": "114431907"
                                          }
                                        },
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "id": "114431903",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732188",
                                            "variationId": "114431907"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "id": "114431904",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732188",
                                            "variationId": "114431907"
                                          }
                                        },
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114431905",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732188",
                                            "variationId": "114431907"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "id": "114431906",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732188",
                                            "variationId": "114431907"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155660936",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732188",
                                            "variationId": "114431907"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155660937",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732188",
                                            "variationId": "114431907"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155660938",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732188",
                                            "variationId": "114431907"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732188",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114431907",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "114431908",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large",
                                          "id": "114431909",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732187",
                                          "variationId": "155660937"
                                        },
                                        {
                                          "groupId": "36732188",
                                          "variationId": "114431907"
                                        }
                                      ],
                                      "price": 27400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847081",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732187",
                                          "variationId": "155660937"
                                        },
                                        {
                                          "groupId": "36732188",
                                          "variationId": "114431908"
                                        }
                                      ],
                                      "price": 44800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847090",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732187",
                                          "variationId": "155660938"
                                        },
                                        {
                                          "groupId": "36732188",
                                          "variationId": "114431907"
                                        }
                                      ],
                                      "price": 27400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847081",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732187",
                                          "variationId": "155660938"
                                        },
                                        {
                                          "groupId": "36732188",
                                          "variationId": "114431908"
                                        }
                                      ],
                                      "price": 44800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847090",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732187",
                                          "variationId": "155660936"
                                        },
                                        {
                                          "groupId": "36732188",
                                          "variationId": "114431907"
                                        }
                                      ],
                                      "price": 27400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847081",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732187",
                                          "variationId": "155660936"
                                        },
                                        {
                                          "groupId": "36732188",
                                          "variationId": "114431908"
                                        }
                                      ],
                                      "price": 44800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847090",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732187",
                                          "variationId": "114431902"
                                        },
                                        {
                                          "groupId": "36732188",
                                          "variationId": "114431907"
                                        }
                                      ],
                                      "price": 19900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847081",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732187",
                                          "variationId": "114431902"
                                        },
                                        {
                                          "groupId": "36732188",
                                          "variationId": "114431909"
                                        }
                                      ],
                                      "price": 58900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "166640778",
                                          "addonId": "121424326"
                                        },
                                        {
                                          "groupId": "166640778",
                                          "addonId": "121424344"
                                        },
                                        {
                                          "groupId": "166640778",
                                          "addonId": "121424339"
                                        },
                                        {
                                          "groupId": "166640778",
                                          "addonId": "121424330"
                                        },
                                        {
                                          "groupId": "166640778",
                                          "addonId": "121424342"
                                        },
                                        {
                                          "groupId": "166640778",
                                          "addonId": "121424333"
                                        },
                                        {
                                          "groupId": "166640778",
                                          "addonId": "121424336"
                                        },
                                        {
                                          "groupId": "131847083",
                                          "addonId": "100000673"
                                        },
                                        {
                                          "groupId": "131847085",
                                          "addonId": "100000685"
                                        },
                                        {
                                          "groupId": "131847085",
                                          "addonId": "100000699"
                                        },
                                        {
                                          "groupId": "131847085",
                                          "addonId": "100000695"
                                        },
                                        {
                                          "groupId": "131847085",
                                          "addonId": "100000698"
                                        },
                                        {
                                          "groupId": "131847085",
                                          "addonId": "100000684"
                                        },
                                        {
                                          "groupId": "131847085",
                                          "addonId": "100000697"
                                        },
                                        {
                                          "groupId": "131847085",
                                          "addonId": "100000679"
                                        },
                                        {
                                          "groupId": "131847085",
                                          "addonId": "100000681"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732187",
                                          "variationId": "114431902"
                                        },
                                        {
                                          "groupId": "36732188",
                                          "variationId": "114431908"
                                        }
                                      ],
                                      "price": 34900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847090",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732187",
                                          "variationId": "114431904"
                                        },
                                        {
                                          "groupId": "36732188",
                                          "variationId": "114431908"
                                        }
                                      ],
                                      "price": 44800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847090",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732187",
                                          "variationId": "114431904"
                                        },
                                        {
                                          "groupId": "36732188",
                                          "variationId": "114431907"
                                        }
                                      ],
                                      "price": 27400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847081",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732187",
                                          "variationId": "114431906"
                                        },
                                        {
                                          "groupId": "36732188",
                                          "variationId": "114431907"
                                        }
                                      ],
                                      "price": 19900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847081",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732187",
                                          "variationId": "114431905"
                                        },
                                        {
                                          "groupId": "36732188",
                                          "variationId": "114431907"
                                        }
                                      ],
                                      "price": 22900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847081",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732187",
                                          "variationId": "114431905"
                                        },
                                        {
                                          "groupId": "36732188",
                                          "variationId": "114431908"
                                        }
                                      ],
                                      "price": 39900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847090",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732187",
                                          "variationId": "114431903"
                                        },
                                        {
                                          "groupId": "36732188",
                                          "variationId": "114431907"
                                        }
                                      ],
                                      "price": 22900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847081",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847082",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640777",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732187",
                                          "variationId": "114431903"
                                        },
                                        {
                                          "groupId": "36732188",
                                          "variationId": "114431908"
                                        }
                                      ],
                                      "price": 39900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847094",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640779",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847090",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "131847081",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640777",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847082",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847090",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847094",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640779",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847083",
                                    "groupName": "Extra Cheese Large",
                                    "choices": [
                                      {
                                        "id": "100000673",
                                        "name": "Extra Cheese",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847085",
                                    "groupName": "Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "100000685",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000699",
                                        "name": "Black Olive",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000695",
                                        "name": "Grilled Mushrooms",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000698",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000684",
                                        "name": "Crisp Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000697",
                                        "name": "Fresh Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000679",
                                        "name": "Red Pepper",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000681",
                                        "name": "Paneer",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640778",
                                    "groupName": "Non-Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "121424326",
                                        "name": "Chicken Pepperoni",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424344",
                                        "name": "Chicken Keema",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424339",
                                        "name": "Peri - Peri Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424330",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424342",
                                        "name": "Chicken Sausage",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424333",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424336",
                                        "name": "Chicken Tikka",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 19900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.6",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520642",
                                "name": "Corn n Cheese Paratha Pizza",
                                "category": "Flavours of India",
                                "description": "A crazy fusion like never before. A delicious fusion of corn stuffed paratha and cheesy pizza.",
                                "imageId": "4632dbb593cccf672f8e28638ce3e8f8",
                                "inStock": 1,
                                "isVeg": 1,
                                "finalPrice": 17900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732349",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "default": 1,
                                          "id": "114432399",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732350",
                                            "variationId": "114432400"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732350",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114432400",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732349",
                                          "variationId": "114432399"
                                        },
                                        {
                                          "groupId": "36732350",
                                          "variationId": "114432400"
                                        }
                                      ],
                                      "price": 19900,
                                      "finalPrice": {
                                        "units": "179"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 19900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "22 ratings",
                                    "ratingCountV2": "22"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520668",
                                "name": "Indi Tandoori Paneer Pizza",
                                "category": "Flavours of India",
                                "description": "It is hot. It is spicy. It is oh-so-Indian. Tandoori paneer with capsicum, red paprika & mint mayo. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                                "imageId": "010b29da595df93d828ca0dca935821a",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732147",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "114431782",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732148",
                                            "variationId": "114431787"
                                          }
                                        },
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "id": "114431783",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732148",
                                            "variationId": "114431787"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "id": "114431784",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732148",
                                            "variationId": "114431787"
                                          }
                                        },
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114431785",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732148",
                                            "variationId": "114431787"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "id": "114431786",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732148",
                                            "variationId": "114431787"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155660696",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732148",
                                            "variationId": "114431787"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155660699",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732148",
                                            "variationId": "114431787"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155660701",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732148",
                                            "variationId": "114431787"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732148",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114431787",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "114431788",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large",
                                          "id": "114431789",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732147",
                                          "variationId": "155660701"
                                        },
                                        {
                                          "groupId": "36732148",
                                          "variationId": "114431787"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847003",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732147",
                                          "variationId": "155660701"
                                        },
                                        {
                                          "groupId": "36732148",
                                          "variationId": "114431788"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847011",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732147",
                                          "variationId": "155660696"
                                        },
                                        {
                                          "groupId": "36732148",
                                          "variationId": "114431787"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847003",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732147",
                                          "variationId": "155660696"
                                        },
                                        {
                                          "groupId": "36732148",
                                          "variationId": "114431788"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847011",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732147",
                                          "variationId": "155660699"
                                        },
                                        {
                                          "groupId": "36732148",
                                          "variationId": "114431787"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847003",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732147",
                                          "variationId": "155660699"
                                        },
                                        {
                                          "groupId": "36732148",
                                          "variationId": "114431788"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847011",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732147",
                                          "variationId": "114431782"
                                        },
                                        {
                                          "groupId": "36732148",
                                          "variationId": "114431787"
                                        }
                                      ],
                                      "price": 31900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847003",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732147",
                                          "variationId": "114431782"
                                        },
                                        {
                                          "groupId": "36732148",
                                          "variationId": "114431789"
                                        }
                                      ],
                                      "price": 84900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "166640763",
                                          "addonId": "121424326"
                                        },
                                        {
                                          "groupId": "166640763",
                                          "addonId": "121424344"
                                        },
                                        {
                                          "groupId": "166640763",
                                          "addonId": "121424339"
                                        },
                                        {
                                          "groupId": "166640763",
                                          "addonId": "121424330"
                                        },
                                        {
                                          "groupId": "166640763",
                                          "addonId": "121424342"
                                        },
                                        {
                                          "groupId": "166640763",
                                          "addonId": "121424333"
                                        },
                                        {
                                          "groupId": "166640763",
                                          "addonId": "121424336"
                                        },
                                        {
                                          "groupId": "131847006",
                                          "addonId": "100000673"
                                        },
                                        {
                                          "groupId": "131847008",
                                          "addonId": "100000685"
                                        },
                                        {
                                          "groupId": "131847008",
                                          "addonId": "100000699"
                                        },
                                        {
                                          "groupId": "131847008",
                                          "addonId": "100000695"
                                        },
                                        {
                                          "groupId": "131847008",
                                          "addonId": "100000698"
                                        },
                                        {
                                          "groupId": "131847008",
                                          "addonId": "100000684"
                                        },
                                        {
                                          "groupId": "131847008",
                                          "addonId": "100000697"
                                        },
                                        {
                                          "groupId": "131847008",
                                          "addonId": "100000679"
                                        },
                                        {
                                          "groupId": "131847008",
                                          "addonId": "100000681"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732147",
                                          "variationId": "114431782"
                                        },
                                        {
                                          "groupId": "36732148",
                                          "variationId": "114431788"
                                        }
                                      ],
                                      "price": 58900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847011",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732147",
                                          "variationId": "114431784"
                                        },
                                        {
                                          "groupId": "36732148",
                                          "variationId": "114431788"
                                        }
                                      ],
                                      "price": 68800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847011",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732147",
                                          "variationId": "114431784"
                                        },
                                        {
                                          "groupId": "36732148",
                                          "variationId": "114431787"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847003",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732147",
                                          "variationId": "114431786"
                                        },
                                        {
                                          "groupId": "36732148",
                                          "variationId": "114431787"
                                        }
                                      ],
                                      "price": 31900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847003",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732147",
                                          "variationId": "114431785"
                                        },
                                        {
                                          "groupId": "36732148",
                                          "variationId": "114431787"
                                        }
                                      ],
                                      "price": 34900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847003",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732147",
                                          "variationId": "114431785"
                                        },
                                        {
                                          "groupId": "36732148",
                                          "variationId": "114431788"
                                        }
                                      ],
                                      "price": 63900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847011",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732147",
                                          "variationId": "114431783"
                                        },
                                        {
                                          "groupId": "36732148",
                                          "variationId": "114431787"
                                        }
                                      ],
                                      "price": 34900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847003",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847004",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640762",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732147",
                                          "variationId": "114431783"
                                        },
                                        {
                                          "groupId": "36732148",
                                          "variationId": "114431788"
                                        }
                                      ],
                                      "price": 63900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847014",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640764",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847011",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "131847003",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640762",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847004",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847011",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847014",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640764",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847006",
                                    "groupName": "Extra Cheese Large",
                                    "choices": [
                                      {
                                        "id": "100000673",
                                        "name": "Extra Cheese",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847008",
                                    "groupName": "Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "100000685",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000699",
                                        "name": "Black Olive",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000695",
                                        "name": "Grilled Mushrooms",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000698",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000684",
                                        "name": "Crisp Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000697",
                                        "name": "Fresh Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000679",
                                        "name": "Red Pepper",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000681",
                                        "name": "Paneer",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640763",
                                    "groupName": "Non-Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "121424326",
                                        "name": "Chicken Pepperoni",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424344",
                                        "name": "Chicken Keema",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424339",
                                        "name": "Peri - Peri Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424330",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424342",
                                        "name": "Chicken Sausage",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424333",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424336",
                                        "name": "Chicken Tikka",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 31900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "48 ratings",
                                    "ratingCountV2": "48"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520644",
                                "name": "Chicken Keema Paratha Pizza",
                                "category": "Flavours of India",
                                "description": "Flavourful & meaty chicken keema paratha and goodness of cheesy pizza coming together in an epic crossover!",
                                "imageId": "47eaf1f74ab478d1604f4f4da9a3c617",
                                "inStock": 1,
                                "finalPrice": 17900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732050",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "default": 1,
                                          "id": "114431494",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732051",
                                            "variationId": "114431495"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732051",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114431495",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732050",
                                          "variationId": "114431494"
                                        },
                                        {
                                          "groupId": "36732051",
                                          "variationId": "114431495"
                                        }
                                      ],
                                      "price": 26900,
                                      "finalPrice": {
                                        "units": "179"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 26900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "17 ratings",
                                    "ratingCountV2": "17"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520696",
                                "name": "Indi Chicken Tikka Pizza",
                                "category": "Flavours of India",
                                "description": "The wholesome flavour of tandoori masala with Chicken tikka, onion, red paprika & mint mayo",
                                "imageId": "0e1a0ba55f0f03990c7e4331b404845a",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732497",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "114432869",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732498",
                                            "variationId": "114432874"
                                          }
                                        },
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "id": "114432870",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732498",
                                            "variationId": "114432874"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "id": "114432871",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732498",
                                            "variationId": "114432874"
                                          }
                                        },
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114432872",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732498",
                                            "variationId": "114432874"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "id": "114432873",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732498",
                                            "variationId": "114432874"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "155660582",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732498",
                                            "variationId": "114432874"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "155660583",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732498",
                                            "variationId": "114432874"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "155660584",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732498",
                                            "variationId": "114432874"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732498",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114432874",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "114432875",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large",
                                          "id": "114432876",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732497",
                                          "variationId": "155660584"
                                        },
                                        {
                                          "groupId": "36732498",
                                          "variationId": "114432875"
                                        }
                                      ],
                                      "price": 72800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847727",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732497",
                                          "variationId": "155660582"
                                        },
                                        {
                                          "groupId": "36732498",
                                          "variationId": "114432874"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847722",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732497",
                                          "variationId": "155660582"
                                        },
                                        {
                                          "groupId": "36732498",
                                          "variationId": "114432875"
                                        }
                                      ],
                                      "price": 72800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847727",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732497",
                                          "variationId": "155660583"
                                        },
                                        {
                                          "groupId": "36732498",
                                          "variationId": "114432874"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847722",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732497",
                                          "variationId": "155660583"
                                        },
                                        {
                                          "groupId": "36732498",
                                          "variationId": "114432875"
                                        }
                                      ],
                                      "price": 72800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847727",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732497",
                                          "variationId": "155660584"
                                        },
                                        {
                                          "groupId": "36732498",
                                          "variationId": "114432874"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847722",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732497",
                                          "variationId": "114432869"
                                        },
                                        {
                                          "groupId": "36732498",
                                          "variationId": "114432874"
                                        }
                                      ],
                                      "price": 37900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847722",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732497",
                                          "variationId": "114432869"
                                        },
                                        {
                                          "groupId": "36732498",
                                          "variationId": "114432876"
                                        }
                                      ],
                                      "price": 96900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "166640793",
                                          "addonId": "121424326"
                                        },
                                        {
                                          "groupId": "166640793",
                                          "addonId": "121424344"
                                        },
                                        {
                                          "groupId": "166640793",
                                          "addonId": "121424339"
                                        },
                                        {
                                          "groupId": "166640793",
                                          "addonId": "121424330"
                                        },
                                        {
                                          "groupId": "166640793",
                                          "addonId": "121424342"
                                        },
                                        {
                                          "groupId": "166640793",
                                          "addonId": "121424333"
                                        },
                                        {
                                          "groupId": "166640793",
                                          "addonId": "121424336"
                                        },
                                        {
                                          "groupId": "131847725",
                                          "addonId": "100000673"
                                        },
                                        {
                                          "groupId": "131847726",
                                          "addonId": "100000685"
                                        },
                                        {
                                          "groupId": "131847726",
                                          "addonId": "100000699"
                                        },
                                        {
                                          "groupId": "131847726",
                                          "addonId": "100000695"
                                        },
                                        {
                                          "groupId": "131847726",
                                          "addonId": "100000698"
                                        },
                                        {
                                          "groupId": "131847726",
                                          "addonId": "100000684"
                                        },
                                        {
                                          "groupId": "131847726",
                                          "addonId": "100000697"
                                        },
                                        {
                                          "groupId": "131847726",
                                          "addonId": "100000679"
                                        },
                                        {
                                          "groupId": "131847726",
                                          "addonId": "100000681"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732497",
                                          "variationId": "114432869"
                                        },
                                        {
                                          "groupId": "36732498",
                                          "variationId": "114432875"
                                        }
                                      ],
                                      "price": 62900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847727",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732497",
                                          "variationId": "114432871"
                                        },
                                        {
                                          "groupId": "36732498",
                                          "variationId": "114432875"
                                        }
                                      ],
                                      "price": 72800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847727",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732497",
                                          "variationId": "114432871"
                                        },
                                        {
                                          "groupId": "36732498",
                                          "variationId": "114432874"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847722",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732497",
                                          "variationId": "114432873"
                                        },
                                        {
                                          "groupId": "36732498",
                                          "variationId": "114432874"
                                        }
                                      ],
                                      "price": 37900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847722",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732497",
                                          "variationId": "114432872"
                                        },
                                        {
                                          "groupId": "36732498",
                                          "variationId": "114432874"
                                        }
                                      ],
                                      "price": 40900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847722",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732497",
                                          "variationId": "114432872"
                                        },
                                        {
                                          "groupId": "36732498",
                                          "variationId": "114432875"
                                        }
                                      ],
                                      "price": 67900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847727",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732497",
                                          "variationId": "114432870"
                                        },
                                        {
                                          "groupId": "36732498",
                                          "variationId": "114432874"
                                        }
                                      ],
                                      "price": 40900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847722",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847723",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640792",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732497",
                                          "variationId": "114432870"
                                        },
                                        {
                                          "groupId": "36732498",
                                          "variationId": "114432875"
                                        }
                                      ],
                                      "price": 67900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847728",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640794",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847727",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "131847727",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847728",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640794",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847722",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640792",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847723",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847725",
                                    "groupName": "Extra Cheese Large",
                                    "choices": [
                                      {
                                        "id": "100000673",
                                        "name": "Extra Cheese",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847726",
                                    "groupName": "Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "100000685",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000699",
                                        "name": "Black Olive",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000695",
                                        "name": "Grilled Mushrooms",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000698",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000684",
                                        "name": "Crisp Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000697",
                                        "name": "Fresh Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000679",
                                        "name": "Red Pepper",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000681",
                                        "name": "Paneer",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640793",
                                    "groupName": "Non-Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "121424326",
                                        "name": "Chicken Pepperoni",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424344",
                                        "name": "Chicken Keema",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424339",
                                        "name": "Peri - Peri Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424330",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424342",
                                        "name": "Chicken Sausage",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424333",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424336",
                                        "name": "Chicken Tikka",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 37900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.7",
                                    "ratingCount": "25 ratings",
                                    "ratingCountV2": "25"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "101726646",
                                "name": "Malai Paneer Pizza",
                                "category": "Flavours of India",
                                "description": "A enticing combination of spicy jalapenos and Masala Paneer which is built around the traditional combination of coconut , Panchphoran and mustard",
                                "imageId": "d5b7f13bedb72defa1f5fed95a3b3860",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732157",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "114431805",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732158",
                                            "variationId": "114431810"
                                          }
                                        },
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "id": "114431806",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732158",
                                            "variationId": "114431810"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "id": "114431807",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732158",
                                            "variationId": "114431810"
                                          }
                                        },
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114431808",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732158",
                                            "variationId": "114431810"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "id": "114431809",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732158",
                                            "variationId": "114431810"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732158",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114431810",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "114431811",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large",
                                          "id": "114431812",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732157",
                                          "variationId": "114431805"
                                        },
                                        {
                                          "groupId": "36732158",
                                          "variationId": "114431810"
                                        }
                                      ],
                                      "price": 30500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847018",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732157",
                                          "variationId": "114431805"
                                        },
                                        {
                                          "groupId": "36732158",
                                          "variationId": "114431812"
                                        }
                                      ],
                                      "price": 81500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "166640784",
                                          "addonId": "121424326"
                                        },
                                        {
                                          "groupId": "166640784",
                                          "addonId": "121424344"
                                        },
                                        {
                                          "groupId": "166640784",
                                          "addonId": "121424339"
                                        },
                                        {
                                          "groupId": "166640784",
                                          "addonId": "121424330"
                                        },
                                        {
                                          "groupId": "166640784",
                                          "addonId": "121424342"
                                        },
                                        {
                                          "groupId": "166640784",
                                          "addonId": "121424333"
                                        },
                                        {
                                          "groupId": "166640784",
                                          "addonId": "121424336"
                                        },
                                        {
                                          "groupId": "131847023",
                                          "addonId": "100000673"
                                        },
                                        {
                                          "groupId": "131847027",
                                          "addonId": "100000685"
                                        },
                                        {
                                          "groupId": "131847027",
                                          "addonId": "100000699"
                                        },
                                        {
                                          "groupId": "131847027",
                                          "addonId": "100000695"
                                        },
                                        {
                                          "groupId": "131847027",
                                          "addonId": "100000698"
                                        },
                                        {
                                          "groupId": "131847027",
                                          "addonId": "100000684"
                                        },
                                        {
                                          "groupId": "131847027",
                                          "addonId": "100000697"
                                        },
                                        {
                                          "groupId": "131847027",
                                          "addonId": "100000679"
                                        },
                                        {
                                          "groupId": "131847027",
                                          "addonId": "100000681"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732157",
                                          "variationId": "114431805"
                                        },
                                        {
                                          "groupId": "36732158",
                                          "variationId": "114431811"
                                        }
                                      ],
                                      "price": 55900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847035",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847035",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847035",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847035",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847035",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847035",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847035",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847035",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640785",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640785",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640785",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640785",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640785",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640785",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640785",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847031",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732157",
                                          "variationId": "114431807"
                                        },
                                        {
                                          "groupId": "36732158",
                                          "variationId": "114431811"
                                        }
                                      ],
                                      "price": 67800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847035",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847035",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847035",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847035",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847035",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847035",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847035",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847035",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640785",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640785",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640785",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640785",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640785",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640785",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640785",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847031",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732157",
                                          "variationId": "114431807"
                                        },
                                        {
                                          "groupId": "36732158",
                                          "variationId": "114431810"
                                        }
                                      ],
                                      "price": 40000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847018",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732157",
                                          "variationId": "114431809"
                                        },
                                        {
                                          "groupId": "36732158",
                                          "variationId": "114431810"
                                        }
                                      ],
                                      "price": 30500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847018",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732157",
                                          "variationId": "114431808"
                                        },
                                        {
                                          "groupId": "36732158",
                                          "variationId": "114431810"
                                        }
                                      ],
                                      "price": 35000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847018",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732157",
                                          "variationId": "114431808"
                                        },
                                        {
                                          "groupId": "36732158",
                                          "variationId": "114431811"
                                        }
                                      ],
                                      "price": 61400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847035",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847035",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847035",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847035",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847035",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847035",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847035",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847035",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640785",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640785",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640785",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640785",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640785",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640785",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640785",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847031",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732157",
                                          "variationId": "114431806"
                                        },
                                        {
                                          "groupId": "36732158",
                                          "variationId": "114431810"
                                        }
                                      ],
                                      "price": 35000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847018",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847020",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640783",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732157",
                                          "variationId": "114431806"
                                        },
                                        {
                                          "groupId": "36732158",
                                          "variationId": "114431811"
                                        }
                                      ],
                                      "price": 62400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847035",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847035",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847035",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847035",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847035",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847035",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847035",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847035",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640785",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640785",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640785",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640785",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640785",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640785",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640785",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847031",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "131847018",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640783",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847020",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847023",
                                    "groupName": "Extra Cheese Large",
                                    "choices": [
                                      {
                                        "id": "100000673",
                                        "name": "Extra Cheese",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847027",
                                    "groupName": "Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "100000685",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000699",
                                        "name": "Black Olive",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000695",
                                        "name": "Grilled Mushrooms",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000698",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000684",
                                        "name": "Crisp Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000697",
                                        "name": "Fresh Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000679",
                                        "name": "Red Pepper",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000681",
                                        "name": "Paneer",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640784",
                                    "groupName": "Non-Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "121424326",
                                        "name": "Chicken Pepperoni",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424344",
                                        "name": "Chicken Keema",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424339",
                                        "name": "Peri - Peri Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424330",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424342",
                                        "name": "Chicken Sausage",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424333",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424336",
                                        "name": "Chicken Tikka",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847031",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847035",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640785",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 30500,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.3",
                                    "ratingCount": "4 ratings",
                                    "ratingCountV2": "4"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "101726644",
                                "name": "Kosha Veg Pizza",
                                "category": "Flavours of India",
                                "description": "A veg cheesy pizzas loaded with onion and mushroom made in the authentic Bengali Kosha recipe",
                                "imageId": "b49a49795c7b422e9588bda3e4c1549a",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732090",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "114431604",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732091",
                                            "variationId": "114431609"
                                          }
                                        },
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "id": "114431605",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732091",
                                            "variationId": "114431609"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "id": "114431606",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732091",
                                            "variationId": "114431609"
                                          }
                                        },
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114431607",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732091",
                                            "variationId": "114431609"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "id": "114431608",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732091",
                                            "variationId": "114431609"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732091",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114431609",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "114431610",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large",
                                          "id": "114431611",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732090",
                                          "variationId": "114431604"
                                        },
                                        {
                                          "groupId": "36732091",
                                          "variationId": "114431611"
                                        }
                                      ],
                                      "price": 81500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "166640800",
                                          "addonId": "121424326"
                                        },
                                        {
                                          "groupId": "166640800",
                                          "addonId": "121424344"
                                        },
                                        {
                                          "groupId": "166640800",
                                          "addonId": "121424339"
                                        },
                                        {
                                          "groupId": "166640800",
                                          "addonId": "121424330"
                                        },
                                        {
                                          "groupId": "166640800",
                                          "addonId": "121424342"
                                        },
                                        {
                                          "groupId": "166640800",
                                          "addonId": "121424333"
                                        },
                                        {
                                          "groupId": "166640800",
                                          "addonId": "121424336"
                                        },
                                        {
                                          "groupId": "131846882",
                                          "addonId": "100000673"
                                        },
                                        {
                                          "groupId": "131846884",
                                          "addonId": "100000685"
                                        },
                                        {
                                          "groupId": "131846884",
                                          "addonId": "100000699"
                                        },
                                        {
                                          "groupId": "131846884",
                                          "addonId": "100000695"
                                        },
                                        {
                                          "groupId": "131846884",
                                          "addonId": "100000698"
                                        },
                                        {
                                          "groupId": "131846884",
                                          "addonId": "100000684"
                                        },
                                        {
                                          "groupId": "131846884",
                                          "addonId": "100000697"
                                        },
                                        {
                                          "groupId": "131846884",
                                          "addonId": "100000679"
                                        },
                                        {
                                          "groupId": "131846884",
                                          "addonId": "100000681"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732090",
                                          "variationId": "114431604"
                                        },
                                        {
                                          "groupId": "36732091",
                                          "variationId": "114431610"
                                        }
                                      ],
                                      "price": 55900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846889",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846889",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846889",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846889",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846889",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846889",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846889",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846889",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640801",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640801",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640801",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640801",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640801",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640801",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640801",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846887",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732090",
                                          "variationId": "114431606"
                                        },
                                        {
                                          "groupId": "36732091",
                                          "variationId": "114431610"
                                        }
                                      ],
                                      "price": 67800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846889",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846889",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846889",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846889",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846889",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846889",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846889",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846889",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640801",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640801",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640801",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640801",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640801",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640801",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640801",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846887",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732090",
                                          "variationId": "114431606"
                                        },
                                        {
                                          "groupId": "36732091",
                                          "variationId": "114431609"
                                        }
                                      ],
                                      "price": 40000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846892",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732090",
                                          "variationId": "114431608"
                                        },
                                        {
                                          "groupId": "36732091",
                                          "variationId": "114431609"
                                        }
                                      ],
                                      "price": 30500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846892",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732090",
                                          "variationId": "114431607"
                                        },
                                        {
                                          "groupId": "36732091",
                                          "variationId": "114431609"
                                        }
                                      ],
                                      "price": 35000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846892",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732090",
                                          "variationId": "114431607"
                                        },
                                        {
                                          "groupId": "36732091",
                                          "variationId": "114431610"
                                        }
                                      ],
                                      "price": 61400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846889",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846889",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846889",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846889",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846889",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846889",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846889",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846889",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640801",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640801",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640801",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640801",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640801",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640801",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640801",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846887",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732090",
                                          "variationId": "114431605"
                                        },
                                        {
                                          "groupId": "36732091",
                                          "variationId": "114431609"
                                        }
                                      ],
                                      "price": 35000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846892",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732090",
                                          "variationId": "114431605"
                                        },
                                        {
                                          "groupId": "36732091",
                                          "variationId": "114431610"
                                        }
                                      ],
                                      "price": 62400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846889",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131846889",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131846889",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131846889",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131846889",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131846889",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131846889",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131846889",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640801",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640801",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640801",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640801",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640801",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640801",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640801",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131846887",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732090",
                                          "variationId": "114431604"
                                        },
                                        {
                                          "groupId": "36732091",
                                          "variationId": "114431609"
                                        }
                                      ],
                                      "price": 30500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131846892",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131846894",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640802",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "131846882",
                                    "groupName": "Extra Cheese Large",
                                    "choices": [
                                      {
                                        "id": "100000673",
                                        "name": "Extra Cheese",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131846884",
                                    "groupName": "Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "100000685",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000699",
                                        "name": "Black Olive",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000695",
                                        "name": "Grilled Mushrooms",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000698",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000684",
                                        "name": "Crisp Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000697",
                                        "name": "Fresh Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000679",
                                        "name": "Red Pepper",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000681",
                                        "name": "Paneer",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640800",
                                    "groupName": "Non-Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "121424326",
                                        "name": "Chicken Pepperoni",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424344",
                                        "name": "Chicken Keema",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424339",
                                        "name": "Peri - Peri Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424330",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424342",
                                        "name": "Chicken Sausage",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424333",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424336",
                                        "name": "Chicken Tikka",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131846887",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131846889",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640801",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131846892",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640802",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131846894",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 30500,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "106720169",
                                "name": "Champaran Veg Pizza",
                                "category": "Flavours of India",
                                "description": "Inspired by the authentic flavours of Champaran, a cheesy veg pizza loaded with red paparika, capsicum and mushrooms.",
                                "imageId": "7c2aeba3013425989fe8c1d662f3450f",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732477",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "114432806",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732478",
                                            "variationId": "114432811"
                                          }
                                        },
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "id": "114432807",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732478",
                                            "variationId": "114432811"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "id": "114432808",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732478",
                                            "variationId": "114432811"
                                          }
                                        },
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114432809",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732478",
                                            "variationId": "114432811"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "id": "114432810",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732478",
                                            "variationId": "114432811"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732478",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114432811",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "114432812",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large",
                                          "id": "114432813",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732477",
                                          "variationId": "114432806"
                                        },
                                        {
                                          "groupId": "36732478",
                                          "variationId": "114432811"
                                        }
                                      ],
                                      "price": 30500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847681",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732477",
                                          "variationId": "114432806"
                                        },
                                        {
                                          "groupId": "36732478",
                                          "variationId": "114432813"
                                        }
                                      ],
                                      "price": 81500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "166640790",
                                          "addonId": "121424326"
                                        },
                                        {
                                          "groupId": "166640790",
                                          "addonId": "121424344"
                                        },
                                        {
                                          "groupId": "166640790",
                                          "addonId": "121424339"
                                        },
                                        {
                                          "groupId": "166640790",
                                          "addonId": "121424330"
                                        },
                                        {
                                          "groupId": "166640790",
                                          "addonId": "121424342"
                                        },
                                        {
                                          "groupId": "166640790",
                                          "addonId": "121424333"
                                        },
                                        {
                                          "groupId": "166640790",
                                          "addonId": "121424336"
                                        },
                                        {
                                          "groupId": "131847683",
                                          "addonId": "100000673"
                                        },
                                        {
                                          "groupId": "131847684",
                                          "addonId": "100000685"
                                        },
                                        {
                                          "groupId": "131847684",
                                          "addonId": "100000699"
                                        },
                                        {
                                          "groupId": "131847684",
                                          "addonId": "100000695"
                                        },
                                        {
                                          "groupId": "131847684",
                                          "addonId": "100000698"
                                        },
                                        {
                                          "groupId": "131847684",
                                          "addonId": "100000684"
                                        },
                                        {
                                          "groupId": "131847684",
                                          "addonId": "100000697"
                                        },
                                        {
                                          "groupId": "131847684",
                                          "addonId": "100000679"
                                        },
                                        {
                                          "groupId": "131847684",
                                          "addonId": "100000681"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732477",
                                          "variationId": "114432806"
                                        },
                                        {
                                          "groupId": "36732478",
                                          "variationId": "114432812"
                                        }
                                      ],
                                      "price": 55900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847688",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847688",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847688",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847688",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847688",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847688",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847688",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847688",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640791",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640791",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640791",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640791",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640791",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640791",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640791",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847685",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732477",
                                          "variationId": "114432808"
                                        },
                                        {
                                          "groupId": "36732478",
                                          "variationId": "114432812"
                                        }
                                      ],
                                      "price": 67800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847688",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847688",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847688",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847688",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847688",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847688",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847688",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847688",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640791",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640791",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640791",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640791",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640791",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640791",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640791",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847685",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732477",
                                          "variationId": "114432808"
                                        },
                                        {
                                          "groupId": "36732478",
                                          "variationId": "114432811"
                                        }
                                      ],
                                      "price": 40000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847681",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732477",
                                          "variationId": "114432810"
                                        },
                                        {
                                          "groupId": "36732478",
                                          "variationId": "114432811"
                                        }
                                      ],
                                      "price": 30500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847681",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732477",
                                          "variationId": "114432809"
                                        },
                                        {
                                          "groupId": "36732478",
                                          "variationId": "114432811"
                                        }
                                      ],
                                      "price": 35000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847681",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732477",
                                          "variationId": "114432809"
                                        },
                                        {
                                          "groupId": "36732478",
                                          "variationId": "114432812"
                                        }
                                      ],
                                      "price": 61400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847688",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847688",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847688",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847688",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847688",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847688",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847688",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847688",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640791",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640791",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640791",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640791",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640791",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640791",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640791",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847685",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732477",
                                          "variationId": "114432807"
                                        },
                                        {
                                          "groupId": "36732478",
                                          "variationId": "114432811"
                                        }
                                      ],
                                      "price": 35000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847681",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847682",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640789",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732477",
                                          "variationId": "114432807"
                                        },
                                        {
                                          "groupId": "36732478",
                                          "variationId": "114432812"
                                        }
                                      ],
                                      "price": 62400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847688",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847688",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847688",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847688",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847688",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847688",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847688",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847688",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640791",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640791",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640791",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640791",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640791",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640791",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640791",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847685",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "131847681",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640789",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847682",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847683",
                                    "groupName": "Extra Cheese Large",
                                    "choices": [
                                      {
                                        "id": "100000673",
                                        "name": "Extra Cheese",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847684",
                                    "groupName": "Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "100000685",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000699",
                                        "name": "Black Olive",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000695",
                                        "name": "Grilled Mushrooms",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000698",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000684",
                                        "name": "Crisp Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000697",
                                        "name": "Fresh Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000679",
                                        "name": "Red Pepper",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000681",
                                        "name": "Paneer",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640790",
                                    "groupName": "Non-Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "121424326",
                                        "name": "Chicken Pepperoni",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424344",
                                        "name": "Chicken Keema",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424339",
                                        "name": "Peri - Peri Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424330",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424342",
                                        "name": "Chicken Sausage",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424333",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424336",
                                        "name": "Chicken Tikka",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847685",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847688",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640791",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 30500,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "126407821",
                                "name": "Malai Chingri Pizza",
                                "category": "Flavours of India",
                                "description": "An irresistible fusion of authentic Malai sauce, succulent Chingri (Prawns) & Red Paprika with a sprinkle of Panch phoran seasoning",
                                "imageId": "a9860da5707872e2f0a8231bb542efbf",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732271",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "114432173",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732272",
                                            "variationId": "114432180"
                                          }
                                        },
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "id": "114432175",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732272",
                                            "variationId": "114432180"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "id": "114432177",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732272",
                                            "variationId": "114432180"
                                          }
                                        },
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114432178",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732272",
                                            "variationId": "114432180"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "id": "114432179",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732272",
                                            "variationId": "114432180"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732272",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114432180",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "114432181",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large",
                                          "id": "114432182",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732271",
                                          "variationId": "114432177"
                                        },
                                        {
                                          "groupId": "36732272",
                                          "variationId": "114432181"
                                        }
                                      ],
                                      "price": 80800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847263",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847263",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847263",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847263",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847263",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847263",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847263",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847263",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640768",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640768",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640768",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640768",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640768",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640768",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640768",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847261",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732271",
                                          "variationId": "114432177"
                                        },
                                        {
                                          "groupId": "36732272",
                                          "variationId": "114432180"
                                        }
                                      ],
                                      "price": 48000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847265",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732271",
                                          "variationId": "114432178"
                                        },
                                        {
                                          "groupId": "36732272",
                                          "variationId": "114432181"
                                        }
                                      ],
                                      "price": 75900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847263",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847263",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847263",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847263",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847263",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847263",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847263",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847263",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640768",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640768",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640768",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640768",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640768",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640768",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640768",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847261",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732271",
                                          "variationId": "114432178"
                                        },
                                        {
                                          "groupId": "36732272",
                                          "variationId": "114432180"
                                        }
                                      ],
                                      "price": 43500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847265",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732271",
                                          "variationId": "114432173"
                                        },
                                        {
                                          "groupId": "36732272",
                                          "variationId": "114432181"
                                        }
                                      ],
                                      "price": 70900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847263",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847263",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847263",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847263",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847263",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847263",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847263",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847263",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640768",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640768",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640768",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640768",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640768",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640768",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640768",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847261",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732271",
                                          "variationId": "114432179"
                                        },
                                        {
                                          "groupId": "36732272",
                                          "variationId": "114432180"
                                        }
                                      ],
                                      "price": 40500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847265",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732271",
                                          "variationId": "114432173"
                                        },
                                        {
                                          "groupId": "36732272",
                                          "variationId": "114432180"
                                        }
                                      ],
                                      "price": 40500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847265",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732271",
                                          "variationId": "114432175"
                                        },
                                        {
                                          "groupId": "36732272",
                                          "variationId": "114432180"
                                        }
                                      ],
                                      "price": 43500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847265",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847267",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640769",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732271",
                                          "variationId": "114432173"
                                        },
                                        {
                                          "groupId": "36732272",
                                          "variationId": "114432182"
                                        }
                                      ],
                                      "price": 104900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "166640770",
                                          "addonId": "121424326"
                                        },
                                        {
                                          "groupId": "166640770",
                                          "addonId": "121424344"
                                        },
                                        {
                                          "groupId": "166640770",
                                          "addonId": "121424339"
                                        },
                                        {
                                          "groupId": "166640770",
                                          "addonId": "121424330"
                                        },
                                        {
                                          "groupId": "166640770",
                                          "addonId": "121424342"
                                        },
                                        {
                                          "groupId": "166640770",
                                          "addonId": "121424333"
                                        },
                                        {
                                          "groupId": "166640770",
                                          "addonId": "121424336"
                                        },
                                        {
                                          "groupId": "131847270",
                                          "addonId": "100000673"
                                        },
                                        {
                                          "groupId": "131847275",
                                          "addonId": "100000685"
                                        },
                                        {
                                          "groupId": "131847275",
                                          "addonId": "100000699"
                                        },
                                        {
                                          "groupId": "131847275",
                                          "addonId": "100000695"
                                        },
                                        {
                                          "groupId": "131847275",
                                          "addonId": "100000698"
                                        },
                                        {
                                          "groupId": "131847275",
                                          "addonId": "100000684"
                                        },
                                        {
                                          "groupId": "131847275",
                                          "addonId": "100000697"
                                        },
                                        {
                                          "groupId": "131847275",
                                          "addonId": "100000679"
                                        },
                                        {
                                          "groupId": "131847275",
                                          "addonId": "100000681"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732271",
                                          "variationId": "114432175"
                                        },
                                        {
                                          "groupId": "36732272",
                                          "variationId": "114432181"
                                        }
                                      ],
                                      "price": 75900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847263",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847263",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847263",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847263",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847263",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847263",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847263",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847263",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640768",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640768",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640768",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640768",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640768",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640768",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640768",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847261",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "131847261",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847263",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640768",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847265",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640769",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847267",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847270",
                                    "groupName": "Extra Cheese Large",
                                    "choices": [
                                      {
                                        "id": "100000673",
                                        "name": "Extra Cheese",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847275",
                                    "groupName": "Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "100000685",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000699",
                                        "name": "Black Olive",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000695",
                                        "name": "Grilled Mushrooms",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000698",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000684",
                                        "name": "Crisp Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000697",
                                        "name": "Fresh Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000679",
                                        "name": "Red Pepper",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000681",
                                        "name": "Paneer",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640770",
                                    "groupName": "Non-Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "121424326",
                                        "name": "Chicken Pepperoni",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424344",
                                        "name": "Chicken Keema",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424339",
                                        "name": "Peri - Peri Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424330",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424342",
                                        "name": "Chicken Sausage",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424333",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424336",
                                        "name": "Chicken Tikka",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 40500,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "126407822",
                                "name": "Kosha Mangsho Pizza",
                                "category": "Flavours of India",
                                "description": "A first of its kind Kosha Mangsho pizza. Made with our authentic Kosha sauce topped with our delectable Mutton meatball & Onion",
                                "imageId": "e42cc4ef8ebb2ee8f2ec61a1f90e8c21",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732367",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "114432456",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732369",
                                            "variationId": "114432465"
                                          }
                                        },
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "id": "114432457",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732369",
                                            "variationId": "114432465"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "id": "114432459",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732369",
                                            "variationId": "114432465"
                                          }
                                        },
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114432461",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732369",
                                            "variationId": "114432465"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "id": "114432463",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732369",
                                            "variationId": "114432465"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732369",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114432465",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "114432467",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large",
                                          "id": "114432468",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732367",
                                          "variationId": "114432459"
                                        },
                                        {
                                          "groupId": "36732369",
                                          "variationId": "114432467"
                                        }
                                      ],
                                      "price": 80800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847445",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847445",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847445",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847445",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847445",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847445",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847445",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847445",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640756",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640756",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640756",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640756",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640756",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640756",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640756",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847442",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732367",
                                          "variationId": "114432459"
                                        },
                                        {
                                          "groupId": "36732369",
                                          "variationId": "114432465"
                                        }
                                      ],
                                      "price": 48000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847447",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732367",
                                          "variationId": "114432461"
                                        },
                                        {
                                          "groupId": "36732369",
                                          "variationId": "114432467"
                                        }
                                      ],
                                      "price": 75900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847445",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847445",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847445",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847445",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847445",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847445",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847445",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847445",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640756",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640756",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640756",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640756",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640756",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640756",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640756",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847442",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732367",
                                          "variationId": "114432461"
                                        },
                                        {
                                          "groupId": "36732369",
                                          "variationId": "114432465"
                                        }
                                      ],
                                      "price": 43500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847447",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732367",
                                          "variationId": "114432456"
                                        },
                                        {
                                          "groupId": "36732369",
                                          "variationId": "114432467"
                                        }
                                      ],
                                      "price": 70900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847445",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847445",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847445",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847445",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847445",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847445",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847445",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847445",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640756",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640756",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640756",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640756",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640756",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640756",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640756",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847442",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732367",
                                          "variationId": "114432463"
                                        },
                                        {
                                          "groupId": "36732369",
                                          "variationId": "114432465"
                                        }
                                      ],
                                      "price": 40500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847447",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732367",
                                          "variationId": "114432456"
                                        },
                                        {
                                          "groupId": "36732369",
                                          "variationId": "114432465"
                                        }
                                      ],
                                      "price": 40500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847447",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732367",
                                          "variationId": "114432457"
                                        },
                                        {
                                          "groupId": "36732369",
                                          "variationId": "114432465"
                                        }
                                      ],
                                      "price": 43500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847447",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847450",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640757",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732367",
                                          "variationId": "114432456"
                                        },
                                        {
                                          "groupId": "36732369",
                                          "variationId": "114432468"
                                        }
                                      ],
                                      "price": 104900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "166640758",
                                          "addonId": "121424326"
                                        },
                                        {
                                          "groupId": "166640758",
                                          "addonId": "121424344"
                                        },
                                        {
                                          "groupId": "166640758",
                                          "addonId": "121424339"
                                        },
                                        {
                                          "groupId": "166640758",
                                          "addonId": "121424330"
                                        },
                                        {
                                          "groupId": "166640758",
                                          "addonId": "121424342"
                                        },
                                        {
                                          "groupId": "166640758",
                                          "addonId": "121424333"
                                        },
                                        {
                                          "groupId": "166640758",
                                          "addonId": "121424336"
                                        },
                                        {
                                          "groupId": "131847453",
                                          "addonId": "100000673"
                                        },
                                        {
                                          "groupId": "131847456",
                                          "addonId": "100000685"
                                        },
                                        {
                                          "groupId": "131847456",
                                          "addonId": "100000699"
                                        },
                                        {
                                          "groupId": "131847456",
                                          "addonId": "100000695"
                                        },
                                        {
                                          "groupId": "131847456",
                                          "addonId": "100000698"
                                        },
                                        {
                                          "groupId": "131847456",
                                          "addonId": "100000684"
                                        },
                                        {
                                          "groupId": "131847456",
                                          "addonId": "100000697"
                                        },
                                        {
                                          "groupId": "131847456",
                                          "addonId": "100000679"
                                        },
                                        {
                                          "groupId": "131847456",
                                          "addonId": "100000681"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732367",
                                          "variationId": "114432457"
                                        },
                                        {
                                          "groupId": "36732369",
                                          "variationId": "114432467"
                                        }
                                      ],
                                      "price": 75900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847445",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847445",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847445",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847445",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847445",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847445",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847445",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847445",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640756",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640756",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640756",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640756",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640756",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640756",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640756",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847442",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "131847442",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847445",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640756",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847447",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640757",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847450",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847453",
                                    "groupName": "Extra Cheese Large",
                                    "choices": [
                                      {
                                        "id": "100000673",
                                        "name": "Extra Cheese",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847456",
                                    "groupName": "Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "100000685",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000699",
                                        "name": "Black Olive",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000695",
                                        "name": "Grilled Mushrooms",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000698",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000684",
                                        "name": "Crisp Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000697",
                                        "name": "Fresh Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000679",
                                        "name": "Red Pepper",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000681",
                                        "name": "Paneer",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640758",
                                    "groupName": "Non-Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "121424326",
                                        "name": "Chicken Pepperoni",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424344",
                                        "name": "Chicken Keema",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424339",
                                        "name": "Peri - Peri Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424330",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424342",
                                        "name": "Chicken Sausage",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424333",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424336",
                                        "name": "Chicken Tikka",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 40500,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "126407823",
                                "name": "Champaran Mutton Pizza",
                                "category": "Flavours of India",
                                "description": "Savor the infusion of authentic Champaran sauce topped with our delectable Mutton meatball & a dash of Red Paprika",
                                "imageId": "f5da86b3de65f32fa2540dcb070f9e68",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732339",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "114432360",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732340",
                                            "variationId": "114432365"
                                          }
                                        },
                                        {
                                          "name": "100% Wheat Thin Crust",
                                          "id": "114432361",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732340",
                                            "variationId": "114432365"
                                          }
                                        },
                                        {
                                          "name": "Cheese Burst",
                                          "id": "114432362",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732340",
                                            "variationId": "114432365"
                                          }
                                        },
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114432363",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732340",
                                            "variationId": "114432365"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "id": "114432364",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732340",
                                            "variationId": "114432365"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732340",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114432365",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "114432366",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large",
                                          "id": "114432367",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732339",
                                          "variationId": "114432362"
                                        },
                                        {
                                          "groupId": "36732340",
                                          "variationId": "114432366"
                                        }
                                      ],
                                      "price": 80800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847396",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847396",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847396",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847396",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847396",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847396",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847396",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847396",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640818",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640818",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640818",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640818",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640818",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640818",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640818",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847393",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732339",
                                          "variationId": "114432362"
                                        },
                                        {
                                          "groupId": "36732340",
                                          "variationId": "114432365"
                                        }
                                      ],
                                      "price": 48000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847399",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732339",
                                          "variationId": "114432363"
                                        },
                                        {
                                          "groupId": "36732340",
                                          "variationId": "114432366"
                                        }
                                      ],
                                      "price": 75900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847396",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847396",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847396",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847396",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847396",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847396",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847396",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847396",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640818",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640818",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640818",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640818",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640818",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640818",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640818",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847393",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732339",
                                          "variationId": "114432363"
                                        },
                                        {
                                          "groupId": "36732340",
                                          "variationId": "114432365"
                                        }
                                      ],
                                      "price": 43500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847399",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732339",
                                          "variationId": "114432360"
                                        },
                                        {
                                          "groupId": "36732340",
                                          "variationId": "114432366"
                                        }
                                      ],
                                      "price": 70900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847396",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847396",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847396",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847396",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847396",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847396",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847396",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847396",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640818",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640818",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640818",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640818",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640818",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640818",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640818",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847393",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732339",
                                          "variationId": "114432364"
                                        },
                                        {
                                          "groupId": "36732340",
                                          "variationId": "114432365"
                                        }
                                      ],
                                      "price": 40500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847399",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732339",
                                          "variationId": "114432360"
                                        },
                                        {
                                          "groupId": "36732340",
                                          "variationId": "114432365"
                                        }
                                      ],
                                      "price": 40500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847399",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732339",
                                          "variationId": "114432361"
                                        },
                                        {
                                          "groupId": "36732340",
                                          "variationId": "114432365"
                                        }
                                      ],
                                      "price": 43500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847399",
                                          "addonId": "100000680"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000691"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000676"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000692"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000677"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000689"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000694"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000674"
                                        },
                                        {
                                          "groupId": "131847402",
                                          "addonId": "100000683"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424338"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424328"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424340"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424331"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424346"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424334"
                                        },
                                        {
                                          "groupId": "166640819",
                                          "addonId": "121424337"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732339",
                                          "variationId": "114432360"
                                        },
                                        {
                                          "groupId": "36732340",
                                          "variationId": "114432367"
                                        }
                                      ],
                                      "price": 104900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "166640820",
                                          "addonId": "121424326"
                                        },
                                        {
                                          "groupId": "166640820",
                                          "addonId": "121424344"
                                        },
                                        {
                                          "groupId": "166640820",
                                          "addonId": "121424339"
                                        },
                                        {
                                          "groupId": "166640820",
                                          "addonId": "121424330"
                                        },
                                        {
                                          "groupId": "166640820",
                                          "addonId": "121424342"
                                        },
                                        {
                                          "groupId": "166640820",
                                          "addonId": "121424333"
                                        },
                                        {
                                          "groupId": "166640820",
                                          "addonId": "121424336"
                                        },
                                        {
                                          "groupId": "131847403",
                                          "addonId": "100000673"
                                        },
                                        {
                                          "groupId": "131847405",
                                          "addonId": "100000685"
                                        },
                                        {
                                          "groupId": "131847405",
                                          "addonId": "100000699"
                                        },
                                        {
                                          "groupId": "131847405",
                                          "addonId": "100000695"
                                        },
                                        {
                                          "groupId": "131847405",
                                          "addonId": "100000698"
                                        },
                                        {
                                          "groupId": "131847405",
                                          "addonId": "100000684"
                                        },
                                        {
                                          "groupId": "131847405",
                                          "addonId": "100000697"
                                        },
                                        {
                                          "groupId": "131847405",
                                          "addonId": "100000679"
                                        },
                                        {
                                          "groupId": "131847405",
                                          "addonId": "100000681"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732339",
                                          "variationId": "114432361"
                                        },
                                        {
                                          "groupId": "36732340",
                                          "variationId": "114432366"
                                        }
                                      ],
                                      "price": 75900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "131847396",
                                          "addonId": "100000682"
                                        },
                                        {
                                          "groupId": "131847396",
                                          "addonId": "100000678"
                                        },
                                        {
                                          "groupId": "131847396",
                                          "addonId": "100000686"
                                        },
                                        {
                                          "groupId": "131847396",
                                          "addonId": "100000675"
                                        },
                                        {
                                          "groupId": "131847396",
                                          "addonId": "100000690"
                                        },
                                        {
                                          "groupId": "131847396",
                                          "addonId": "100000693"
                                        },
                                        {
                                          "groupId": "131847396",
                                          "addonId": "100000696"
                                        },
                                        {
                                          "groupId": "131847396",
                                          "addonId": "100000688"
                                        },
                                        {
                                          "groupId": "166640818",
                                          "addonId": "121424327"
                                        },
                                        {
                                          "groupId": "166640818",
                                          "addonId": "121424329"
                                        },
                                        {
                                          "groupId": "166640818",
                                          "addonId": "121424345"
                                        },
                                        {
                                          "groupId": "166640818",
                                          "addonId": "121424341"
                                        },
                                        {
                                          "groupId": "166640818",
                                          "addonId": "121424332"
                                        },
                                        {
                                          "groupId": "166640818",
                                          "addonId": "121424343"
                                        },
                                        {
                                          "groupId": "166640818",
                                          "addonId": "121424335"
                                        },
                                        {
                                          "groupId": "131847393",
                                          "addonId": "100000687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "131847393",
                                    "groupName": "Extra Cheese Medium",
                                    "choices": [
                                      {
                                        "id": "100000687",
                                        "name": "Extra Cheese",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847396",
                                    "groupName": "Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "100000682",
                                        "name": "Onion",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000678",
                                        "name": "Black Olive",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000686",
                                        "name": "Grilled Mushrooms",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000675",
                                        "name": "Fresh Tomato",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000690",
                                        "name": "Crisp Capsicum",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000693",
                                        "name": "Paneer",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000696",
                                        "name": "Jalapeno",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000688",
                                        "name": "Red Pepper",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640818",
                                    "groupName": "Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "121424327",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424329",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424345",
                                        "name": "Chicken Keema",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424341",
                                        "name": "Peri - Peri Chicken",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424332",
                                        "name": "Chicken Tikka",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424343",
                                        "name": "Chicken Sausage",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424335",
                                        "name": "Chicken Pepperoni",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847399",
                                    "groupName": "Extra Cheese Regular",
                                    "choices": [
                                      {
                                        "id": "100000680",
                                        "name": "Extra Cheese",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640819",
                                    "groupName": "Non-Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "121424338",
                                        "name": "Peri - Peri Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424328",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424340",
                                        "name": "Chicken Sausage",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424331",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424346",
                                        "name": "Chicken Keema",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424334",
                                        "name": "Chicken Tikka",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424337",
                                        "name": "Chicken Pepperoni",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847402",
                                    "groupName": "Veg Toppings Regular",
                                    "choices": [
                                      {
                                        "id": "100000691",
                                        "name": "Black Olive",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000676",
                                        "name": "Grilled Mushrooms",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000692",
                                        "name": "Onion",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000677",
                                        "name": "Crisp Capsicum",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000689",
                                        "name": "Fresh Tomato",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000694",
                                        "name": "Red Pepper",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000674",
                                        "name": "Paneer",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000683",
                                        "name": "Jalapeno",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847403",
                                    "groupName": "Extra Cheese Large",
                                    "choices": [
                                      {
                                        "id": "100000673",
                                        "name": "Extra Cheese",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "131847405",
                                    "groupName": "Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "100000685",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000699",
                                        "name": "Black Olive",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000695",
                                        "name": "Grilled Mushrooms",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000698",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000684",
                                        "name": "Crisp Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000697",
                                        "name": "Fresh Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000679",
                                        "name": "Red Pepper",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "100000681",
                                        "name": "Paneer",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "166640820",
                                    "groupName": "Non-Veg Toppings Large",
                                    "choices": [
                                      {
                                        "id": "121424326",
                                        "name": "Chicken Pepperoni",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424344",
                                        "name": "Chicken Keema",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424339",
                                        "name": "Peri - Peri Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424330",
                                        "name": "Pepper Barbecue Chicken",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424342",
                                        "name": "Chicken Sausage",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424333",
                                        "name": "Grilled Chicken Rasher",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "121424336",
                                        "name": "Chicken Tikka",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 40500,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {
                          
                        }
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "PIZZA MANIA",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "110256290",
                                "name": "Chicken Keema & Onion with Desi Makhani Sauce",
                                "category": "PIZZA MANIA",
                                "description": "Authentic Indian Flavor of Makhani Sauce loaded with meaty Chicken Keema and crunchy Onion.",
                                "imageId": "3df23818f7ab45dbd2268ca1d67cb1ad",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732006",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114431369",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732007",
                                            "variationId": "114431371"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "default": 1,
                                          "id": "114431370",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732007",
                                            "variationId": "114431371"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732007",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114431371",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732006",
                                          "variationId": "114431370"
                                        },
                                        {
                                          "groupId": "36732007",
                                          "variationId": "114431371"
                                        }
                                      ],
                                      "price": 14900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732006",
                                          "variationId": "114431369"
                                        },
                                        {
                                          "groupId": "36732007",
                                          "variationId": "114431371"
                                        }
                                      ],
                                      "price": 19400
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 14900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.5",
                                    "ratingCount": "37 ratings",
                                    "ratingCountV2": "37"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "110256291",
                                "name": "Paneer, Onion & Capsicum with Desi Makhani Sauce",
                                "category": "PIZZA MANIA",
                                "description": "Authentic Indian Flavor of Makhani Sauce loaded with juicy Paneer, crisp Capsicum and crunchy Onion.",
                                "imageId": "d3dcf25529b780071e99443e0fff16d2",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732216",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114431992",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732218",
                                            "variationId": "114431997"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "default": 1,
                                          "id": "114431994",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732218",
                                            "variationId": "114431997"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732218",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114431997",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732216",
                                          "variationId": "114431994"
                                        },
                                        {
                                          "groupId": "36732218",
                                          "variationId": "114431997"
                                        }
                                      ],
                                      "price": 13500
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732216",
                                          "variationId": "114431992"
                                        },
                                        {
                                          "groupId": "36732218",
                                          "variationId": "114431997"
                                        }
                                      ],
                                      "price": 18000
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 13500,
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.5",
                                    "ratingCount": "146 ratings",
                                    "ratingCountV2": "146"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520733",
                                "name": "Non Veg Loaded",
                                "category": "PIZZA MANIA",
                                "description": "Chicken sausage, pepper barbecue chicken & peri-peri chicken in a fresh pan crust",
                                "imageId": "fe37811c8d1a9b0c5923ff1a60926b7d",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732211",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "default": 1,
                                          "id": "114431982",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732212",
                                            "variationId": "114431983"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732212",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114431983",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732211",
                                          "variationId": "114431982"
                                        },
                                        {
                                          "groupId": "36732212",
                                          "variationId": "114431983"
                                        }
                                      ],
                                      "price": 20500
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 20500,
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "245 ratings",
                                    "ratingCountV2": "245"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520734",
                                "name": "Veg Loaded",
                                "category": "PIZZA MANIA",
                                "description": "Tomato, Jalapeno, Corn, Grilled Mushroom & crushed Aranchini Patty in a fresh pan crust",
                                "imageId": "67f137415f266758203dea6e20d5ee66",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732058",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "default": 1,
                                          "id": "114431514",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732061",
                                            "variationId": "114431517"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732061",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114431517",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732058",
                                          "variationId": "114431514"
                                        },
                                        {
                                          "groupId": "36732061",
                                          "variationId": "114431517"
                                        }
                                      ],
                                      "price": 19500
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 19500,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "173 ratings",
                                    "ratingCountV2": "173"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "110256293",
                                "name": "Paneer & Capsicum with Videshi Hot Sauce",
                                "category": "PIZZA MANIA",
                                "description": "Internationally inspired Hot sauce to cater your spice cravings loaded with juicy Paneer and crisp Capsicum.",
                                "imageId": "19e473103f43185544a02acd6c842b94",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732144",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114431773",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732145",
                                            "variationId": "114431778"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "default": 1,
                                          "id": "114431775",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732145",
                                            "variationId": "114431778"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732145",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114431778",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732144",
                                          "variationId": "114431775"
                                        },
                                        {
                                          "groupId": "36732145",
                                          "variationId": "114431778"
                                        }
                                      ],
                                      "price": 11500
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732144",
                                          "variationId": "114431773"
                                        },
                                        {
                                          "groupId": "36732145",
                                          "variationId": "114431778"
                                        }
                                      ],
                                      "price": 16000
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 11500,
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "71 ratings",
                                    "ratingCountV2": "71"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "110256295",
                                "name": "Capsicum & Red Paprika with Videshi Hot Sauce",
                                "category": "PIZZA MANIA",
                                "description": "Internationally inspired Hot sauce to cater your spice cravings loaded with crisp Capsicum and spicy Red Paprika.",
                                "imageId": "8a2543c260fc6d8f461de94481723cc6",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732463",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114432760",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732465",
                                            "variationId": "114432765"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "default": 1,
                                          "id": "114432762",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732465",
                                            "variationId": "114432765"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732465",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114432765",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732463",
                                          "variationId": "114432762"
                                        },
                                        {
                                          "groupId": "36732465",
                                          "variationId": "114432765"
                                        }
                                      ],
                                      "price": 9500
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732463",
                                          "variationId": "114432760"
                                        },
                                        {
                                          "groupId": "36732465",
                                          "variationId": "114432765"
                                        }
                                      ],
                                      "price": 14000
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 9500,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "48 ratings",
                                    "ratingCountV2": "48"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520736",
                                "name": "Pepper Barbecue Chicken",
                                "category": "PIZZA MANIA",
                                "description": "Pepper barbecue chicken for that extra zing",
                                "imageId": "352e0cafc4caef8ef5f4eac224b1db46",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732393",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114432550",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732394",
                                            "variationId": "114432552"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "default": 1,
                                          "id": "114432551",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732394",
                                            "variationId": "114432552"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732394",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114432552",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732393",
                                          "variationId": "114432551"
                                        },
                                        {
                                          "groupId": "36732394",
                                          "variationId": "114432552"
                                        }
                                      ],
                                      "price": 12500
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732393",
                                          "variationId": "114432550"
                                        },
                                        {
                                          "groupId": "36732394",
                                          "variationId": "114432552"
                                        }
                                      ],
                                      "price": 15500
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 12500,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "103 ratings",
                                    "ratingCountV2": "103"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520738",
                                "name": "Chicken Sausage",
                                "category": "PIZZA MANIA",
                                "description": "American classic! Spicy, herbed chicken sausage on pizza",
                                "imageId": "991a7fd58aa8d1598537b965937fd904",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732088",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114431601",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732089",
                                            "variationId": "114431603"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "default": 1,
                                          "id": "114431602",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732089",
                                            "variationId": "114431603"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732089",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114431603",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732088",
                                          "variationId": "114431602"
                                        },
                                        {
                                          "groupId": "36732089",
                                          "variationId": "114431603"
                                        }
                                      ],
                                      "price": 10900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732088",
                                          "variationId": "114431601"
                                        },
                                        {
                                          "groupId": "36732089",
                                          "variationId": "114431603"
                                        }
                                      ],
                                      "price": 13900
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 10900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "44 ratings",
                                    "ratingCountV2": "44"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520739",
                                "name": "Golden Corn",
                                "category": "PIZZA MANIA",
                                "description": "Sweet & juicy golden corn for that lipsmacking taste",
                                "imageId": "a302da0d414837495c1576b64dd943e0",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732279",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "id": "114432207",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732280",
                                            "variationId": "114432209"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "default": 1,
                                          "id": "114432208",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732280",
                                            "variationId": "114432209"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732280",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114432209",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732279",
                                          "variationId": "114432208"
                                        },
                                        {
                                          "groupId": "36732280",
                                          "variationId": "114432209"
                                        }
                                      ],
                                      "price": 9500
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732279",
                                          "variationId": "114432207"
                                        },
                                        {
                                          "groupId": "36732280",
                                          "variationId": "114432209"
                                        }
                                      ],
                                      "price": 12500
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 9500,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "104 ratings",
                                    "ratingCountV2": "104"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520742",
                                "name": "Onion",
                                "category": "PIZZA MANIA",
                                "description": "Our classic Pizza Mania topped with crunchy Onions",
                                "imageId": "2cdd0e3b01910393d5e9361822b1b02c",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732283",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "default": 1,
                                          "id": "114432213",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732284",
                                            "variationId": "114432215"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "id": "114432214",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732284",
                                            "variationId": "114432215"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732284",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114432215",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732283",
                                          "variationId": "114432213"
                                        },
                                        {
                                          "groupId": "36732284",
                                          "variationId": "114432215"
                                        }
                                      ],
                                      "price": 10500
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732283",
                                          "variationId": "114432214"
                                        },
                                        {
                                          "groupId": "36732284",
                                          "variationId": "114432215"
                                        }
                                      ],
                                      "price": 7500
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 10500,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "49 ratings",
                                    "ratingCountV2": "49"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "110432585",
                                "name": "Classic",
                                "category": "PIZZA MANIA",
                                "description": "A classic pizza topped with sprinkle of basil and parsley herbs",
                                "imageId": "f05bf56a2943904aff5e4a8357a4c3c8",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36732207",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Fresh Pan Pizza",
                                          "default": 1,
                                          "id": "114431971",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732208",
                                            "variationId": "114431973"
                                          }
                                        },
                                        {
                                          "name": "Classic Hand Tossed",
                                          "id": "114431972",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36732208",
                                            "variationId": "114431973"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36732208",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "114431973",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732207",
                                          "variationId": "114431971"
                                        },
                                        {
                                          "groupId": "36732208",
                                          "variationId": "114431973"
                                        }
                                      ],
                                      "price": 7900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36732207",
                                          "variationId": "114431972"
                                        },
                                        {
                                          "groupId": "36732208",
                                          "variationId": "114431973"
                                        }
                                      ],
                                      "price": 4900
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 7900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "45 ratings",
                                    "ratingCountV2": "45"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {
                          
                        }
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "GARLIC BREADS & MORE",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334594",
                                "name": "Korean Corn & Jalapeno Garlic Bread",
                                "category": "GARLIC BREADS & MORE",
                                "description": "Freshly baked garlic bread infused with Korean Sweet Chili Sauce, Molten cheese, juicy corn & tangy jalapeno",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/35184d75-6f5c-41b3-8828-62bf49504081_cb9a47d7-033c-45ab-8d8e-1df1e10e7702.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 17900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334606",
                                "name": "Fiery Corn & Jalapeno Garlic Bread",
                                "category": "GARLIC BREADS & MORE",
                                "description": "Freshly baked garlic bread infused with Spicy Guntur Sauce, Molten cheese, juicy corn & tangy jalapeno",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/41506801-397d-47b4-b3e8-83941a532d4b_c2dae010-a077-4d16-a92f-8bfc6ce60b9c.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 17900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334613",
                                "name": "Makhani Corn & Jalapeno Garlic Bread",
                                "category": "GARLIC BREADS & MORE",
                                "description": "Freshly baked garlic bread infused with Creamy Makhani Sauce, Molten cheese, juicy corn & tangy jalapeno",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/06e38828-8fb8-4c1a-9345-38ed7c870837_bf157858-e0d7-48c0-baeb-6268b4011ea9.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 17900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334604",
                                "name": "Korean Paneer Tikka Garlic Bread",
                                "category": "GARLIC BREADS & MORE",
                                "description": "Freshly Baked Stuffed Garlic Bread infused with Korean Sweet Chili Sauce, Molten Cheese, Onion and Paneer Tikka fillings",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/fc919fcc-93d6-4e06-9863-b156f17b3b5c_c3be0537-efb5-48b8-b9e3-2d8e953523c7.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 17900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334567",
                                "name": "Fiery Paneer Tikka Garlic Bread",
                                "category": "GARLIC BREADS & MORE",
                                "description": "Freshly Baked Stuffed Garlic Bread infused with Spicy Guntur Sauce, Molten Cheese, Onion and Paneer Tikka fillings",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/e93f73f1-046f-4f4d-9b79-fb363adf2f95_1a3b165d-a610-4a6b-8b82-403695d85f7d.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 17900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334566",
                                "name": "Makhani Paneer Tikka Garlic Bread",
                                "category": "GARLIC BREADS & MORE",
                                "description": "Freshly Baked Stuffed Garlic Bread infused with Creamy Makhani Sauce, Molten Cheese, Onion and Paneer Tikka fillings",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/4acaeb70-60a1-42c2-a96b-6f6589066c0a_eb8c9567-ebe8-468b-abb4-194bccfd736f.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 17900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334580",
                                "name": "Korean Pepperoni Garlic Bread",
                                "category": "GARLIC BREADS & MORE",
                                "description": "Freshly Baked Garlic Bread infused with Korean Sweet Chili Sauce, Delectable Chicken Pepperoni & molten Cheese",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/14f097d9-4137-44e5-adf7-1946955691a4_60ca9cf7-9667-4b7c-8c83-822dee18ed70.jpg",
                                "inStock": 1,
                                "price": 17900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334584",
                                "name": "Fiery Pepperoni Garlic Bread",
                                "category": "GARLIC BREADS & MORE",
                                "description": "Freshly Baked Garlic Bread infused with Spicy Guntur Sauce, Delectable Chicken Pepperoni & molten Cheese",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/d4615d55-3524-4a49-9a7b-4d552501c547_9b9d462d-8eac-47d0-9030-42f9cb88370d.jpg",
                                "inStock": 1,
                                "price": 17900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "153334601",
                                "name": "Makhani Pepperoni Garlic Bread",
                                "category": "GARLIC BREADS & MORE",
                                "description": "Freshly Baked Garlic Bread infused with Creamy Makhani Sauce, Delectable Chicken Pepperoni & molten Cheese",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/17/433d39f6-fd23-4139-9bbe-9633e924a12d_28f705a6-d03d-48ca-8d94-3a39f4e90f88.jpg",
                                "inStock": 1,
                                "price": 17900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520707",
                                "name": "Garlic Breadsticks",
                                "category": "GARLIC BREADS & MORE",
                                "description": "Baked to perfection. Your perfect pizza partner! Tastes best with dip",
                                "imageId": "1633e1c6916141a456e5c4dbda6c0b4e",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 11500,
                                "finalPrice": 8900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.5",
                                    "ratingCount": "104 ratings",
                                    "ratingCountV2": "104"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520708",
                                "name": "Classic Stuffed Garlic Bread",
                                "category": "GARLIC BREADS & MORE",
                                "description": "Freshly baked garlic bread with cheese, juicy corn & tangy jalapeno",
                                "imageId": "676c42f9653340f8fec500bedbab2714",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 16500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "79 ratings",
                                    "ratingCountV2": "79"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520710",
                                "name": "Cheesy Dip",
                                "category": "GARLIC BREADS & MORE",
                                "description": "An all-time favorite with your Garlic Breadsticks & Stuffed Garlic Bread for a Cheesy indulgence",
                                "imageId": "a325ca68cb886844e4864a43f7cdf48a",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 2857,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "72 ratings",
                                    "ratingCountV2": "72"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520651",
                                "name": "Paneer Tikka Stuffed Garlic Bread",
                                "category": "GARLIC BREADS & MORE",
                                "description": "Freshly Baked Stuffed Garlic Bread with Cheese, Onion and Paneer Tikka fillings. Comes with a dash of Basil Parsley Sprinkle on top",
                                "imageId": "a3aea7aa78dad6063b9e58dffe137ad4",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 17500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "38 ratings",
                                    "ratingCountV2": "38"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520652",
                                "name": "Chicken Pepperoni Stuffed Garlic Bread",
                                "category": "GARLIC BREADS & MORE",
                                "description": "Freshly Baked Garlic Bread stuffed with Delectable Chicken Pepperoni, Cheese and sprinkled with Basil Parsley",
                                "imageId": "bef98f394ddb464599cad2b3fe34d7d0",
                                "inStock": 1,
                                "price": 17500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "49 ratings",
                                    "ratingCountV2": "49"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520730",
                                "name": "Taco Mexicana Veg",
                                "category": "GARLIC BREADS & MORE",
                                "description": "Truly irresistible! Crispy taco with veg patty & creamy harissa sauce",
                                "imageId": "bff19c7eeec11a2f3da22516d169b178",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 14900,
                                "finalPrice": 8900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "31 ratings",
                                    "ratingCountV2": "31"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520729",
                                "name": "Taco Mexicana Non Veg",
                                "category": "GARLIC BREADS & MORE",
                                "description": "Truly irresistible! Crispy taco with non-veg patty & creamy harissa sauce",
                                "imageId": "118610bb1b497c0090177b709a452636",
                                "inStock": 1,
                                "price": 18500,
                                "finalPrice": 8900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "71 ratings",
                                    "ratingCountV2": "71"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520732",
                                "name": "Veg Parcel",
                                "category": "GARLIC BREADS & MORE",
                                "description": "Snacky bites! Pizza rolls with paneer & creamy harissa sauce",
                                "imageId": "8ba74a9b3310071b1d40233779a13e1e",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 4900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "86 ratings",
                                    "ratingCountV2": "86"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520713",
                                "name": "Chicken Parcel",
                                "category": "GARLIC BREADS & MORE",
                                "description": "Snacky bites! Pizza rolls with chicken sausage & creamy harissa sauce",
                                "imageId": "71db5a4175ec65fee10846a8eae012c5",
                                "inStock": 1,
                                "price": 5900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "66 ratings",
                                    "ratingCountV2": "66"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520715",
                                "name": "Burger Pizza - Classic Veg",
                                "category": "GARLIC BREADS & MORE",
                                "description": "Oven-baked buns with cheese, tomato & capsicum in creamy mayo",
                                "imageId": "afe9096778a80464e5fe9e31ee4fa85d",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 12900,
                                "finalPrice": 8900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "29 ratings",
                                    "ratingCountV2": "29"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "101995983",
                                "name": "Harissa Dip",
                                "category": "GARLIC BREADS & MORE",
                                "description": "A spicy & peppery pizza dip which can help you add the right amount of spiciness to your favorite pizza slices.",
                                "imageId": "9a27f14dd6535b2e4017451a6b7ea895",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 4667,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "6 ratings",
                                    "ratingCountV2": "6"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "101995982",
                                "name": "Basil Pesto Dip",
                                "category": "GARLIC BREADS & MORE",
                                "description": "Your perfect pizza partner!  Savour your pizza slices with this new rich, herby & salty dip with the goodness of basil leaves & nuts that will surely give you a new flavor dimension!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/11/443745b1-c046-4cfb-99ed-bd62664ef368_d6669a4f-ffd1-4900-98c6-fa165e4bf7ee.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 4667,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.7",
                                    "ratingCount": "9 ratings",
                                    "ratingCountV2": "9"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520731",
                                "name": "Taco Mexicana Veg (Single)",
                                "category": "GARLIC BREADS & MORE",
                                "description": "Truly irresistible! Crispy taco with veg patty & creamy harissa sauce",
                                "imageId": "50bf5f2488d4d147fbd6adf0c47b63b6",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 8500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "49 ratings",
                                    "ratingCountV2": "49"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {
                          
                        }
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "DESSERTS",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "151984660",
                                "name": "Choco Lava Cake Gift Hamper",
                                "category": "DESSERTS",
                                "description": "Dive into the ultimate dessert experience with our Lavalicious Combo that’s Made to Share. \n*We don't include a spoon or napkin to support sustainability",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/29/d5e06efa-1d18-4955-b228-d59f8be72347_1a9248a1-9e49-49d7-bb98-3e75101a2de4.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 34500,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.6",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520653",
                                "name": "Red Velvet Lava Cake",
                                "category": "DESSERTS",
                                "description": "A truly indulgent experience with sweet and rich red velvet cake on a creamy cheese flavoured base to give a burst of flavour in every bite!",
                                "imageId": "5b3d592a85ad33a732d18bb41fdfc59f",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 14500,
                                "finalPrice": 8900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "8 ratings",
                                    "ratingCountV2": "8"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520709",
                                "name": "Choco Lava Cake",
                                "category": "DESSERTS",
                                "description": "Chocolate lovers delight! Indulgent, gooey molten lava inside chocolate cake",
                                "imageId": "517791a68253a9a5084664b470f6e115",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 11500,
                                "finalPrice": 8900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.5",
                                    "ratingCount": "77 ratings",
                                    "ratingCountV2": "77"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520712",
                                "name": "Butterscotch Mousse Cake",
                                "category": "DESSERTS",
                                "description": "Sweet temptation! Butterscotch flavored mousse",
                                "imageId": "e91002ccf7239fffeceaab4956a15a3a",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 10381,
                                "finalPrice": 8900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "19 ratings",
                                    "ratingCountV2": "19"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {
                          
                        }
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "BEVERAGES",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520673",
                                "name": "Pepsi 475ml",
                                "category": "BEVERAGES",
                                "description": "Sparkling and Refreshing Beverage",
                                "imageId": "f6af24125864ca5dcd44bd41b5fc9f47",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 5714,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "103 ratings",
                                    "ratingCountV2": "103"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520677",
                                "name": "Pepsi Black Can 300ml",
                                "category": "BEVERAGES",
                                "description": "Maximum Taste Zero Calories",
                                "imageId": "1100f94a18b2801492c0909f06eafce1",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 5714,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "25 ratings",
                                    "ratingCountV2": "25"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520674",
                                "name": "7Up 475ml",
                                "category": "BEVERAGES",
                                "description": "Refreshing clear drink with a natural lemon flavor",
                                "imageId": "216209b36b8c5be6dc19d1e371027bc1",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 5714,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "2.8",
                                    "ratingCount": "6 ratings",
                                    "ratingCountV2": "6"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520676",
                                "name": "Mirinda 475ml",
                                "category": "BEVERAGES",
                                "description": "Delicious Orange Flavoured beverage",
                                "imageId": "5490c2372f73e90456bc8dbf1e0ad590",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 5714,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.9",
                                    "ratingCount": "11 ratings",
                                    "ratingCountV2": "11"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "104954946",
                                "name": "Nagpur Orange",
                                "category": "BEVERAGES",
                                "description": "Enjoy Oranges from Nagpur with the goodness of Fiber",
                                "imageId": "cace054d6d50a3af9f62284a5ce99192",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 7143,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520682",
                                "name": "B Natural Mixed Fruit from Himalayas (300 ml)",
                                "category": "BEVERAGES",
                                "description": "Premium fruits from Himalayas with the Goodness of Fiber",
                                "imageId": "7f82838f68c1908ca6db2141cf7c5e8c",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 7143,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520685",
                                "name": "Lipton Ice Tea ( 350 ml)",
                                "category": "BEVERAGES",
                                "description": "Refreshment Sahi, Gas Nahi",
                                "imageId": "357a369a728d26d67e6dafdef7f608e8",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 5714,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "6 ratings",
                                    "ratingCountV2": "6"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "94520678",
                                "name": "Mountain Dew 475ml",
                                "category": "BEVERAGES",
                                "description": "Strong and Refreshing",
                                "imageId": "f918a51abf521e6fd8a950ce759a7fbf",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 5714,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "2.8",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "155724791",
                                "name": "Aquavess Water (500ml)",
                                "category": "BEVERAGES",
                                "description": "Packaged Drinking Water",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/5/8c6e7af7-c041-498c-9f32-1d7791c25ee0_a8905b77-9e95-4236-a6f4-700034950fc0.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 2858,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {
                          
                        }
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Pizza & More",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "150740129",
                                "name": "Margherita Pizza Regular",
                                "category": "Pizza & More",
                                "description": "Classic delight with 100% real mozzarella cheese.",
                                "imageId": "7850b115687ee8594f9d7f0a66c2ee84",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 10900,
                                "finalPrice": 8900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {
                          
                        }
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Deal on Regular Pizza",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "150146038",
                                "name": "Mexican Green Wave Pizza - Regular",
                                "category": "Deal on Regular Pizza",
                                "description": "Mexican herbs sprinkled on onion, capsicum, tomato & jalapeno",
                                "imageId": "0d1949eef23c572096269d890e438efb",
                                "inStock": 1,
                                "isVeg": 1,
                                "finalPrice": 17900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528198",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "164203779",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528199",
                                            "variationId": "164203780"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528199",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "164203780",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528198",
                                          "variationId": "164203779"
                                        },
                                        {
                                          "groupId": "52528199",
                                          "variationId": "164203780"
                                        }
                                      ],
                                      "price": 27900,
                                      "finalPrice": {
                                        "units": "179"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 27900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "150146037",
                                "name": "Veggie Paradise Pizza - Regular",
                                "category": "Deal on Regular Pizza",
                                "description": "The awesome foursome! Golden corn, black olives, capsicum, red paprika",
                                "imageId": "2a8ea479040d62f82871e1be7470672a",
                                "inStock": 1,
                                "isVeg": 1,
                                "finalPrice": 17900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528194",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "164203775",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528195",
                                            "variationId": "164203776"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528195",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "164203776",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528194",
                                          "variationId": "164203775"
                                        },
                                        {
                                          "groupId": "52528195",
                                          "variationId": "164203776"
                                        }
                                      ],
                                      "price": 27900,
                                      "finalPrice": {
                                        "units": "179"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 27900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.7",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "150146040",
                                "name": "Double Cheese Margherita Pizza - Regular",
                                "category": "Deal on Regular Pizza",
                                "description": "A classic delight loaded with extra 100% real mozzarella cheese",
                                "imageId": "15c3a34b64ec4298f2a0778d1b008919",
                                "inStock": 1,
                                "isVeg": 1,
                                "finalPrice": 17900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528204",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "164203791",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528205",
                                            "variationId": "164203792"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528205",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "164203792",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528204",
                                          "variationId": "164203791"
                                        },
                                        {
                                          "groupId": "52528205",
                                          "variationId": "164203792"
                                        }
                                      ],
                                      "price": 22900,
                                      "finalPrice": {
                                        "units": "179"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 22900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "150146042",
                                "name": "Farmhouse Pizza - Regular",
                                "category": "Deal on Regular Pizza",
                                "description": "Delightful combination of onion, capsicum, tomato & grilled mushroom. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                                "imageId": "740a92bd202ffd40813bc354b86005db",
                                "inStock": 1,
                                "isVeg": 1,
                                "finalPrice": 17900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528232",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "164203840",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528233",
                                            "variationId": "164203841"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528233",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "164203841",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528232",
                                          "variationId": "164203840"
                                        },
                                        {
                                          "groupId": "52528233",
                                          "variationId": "164203841"
                                        }
                                      ],
                                      "price": 27900,
                                      "finalPrice": {
                                        "units": "179"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 27900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.5",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "150146041",
                                "name": "Peppy Paneer Pizza - Regular",
                                "category": "Deal on Regular Pizza",
                                "description": "Flavorful trio of juicy paneer, crisp capsicum with spicy red paprika",
                                "imageId": "0581f2e3b7d0b3ede4b476c1d64a6434",
                                "inStock": 1,
                                "isVeg": 1,
                                "finalPrice": 17900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528228",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "164203833",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528229",
                                            "variationId": "164203834"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528229",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "164203834",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528228",
                                          "variationId": "164203833"
                                        },
                                        {
                                          "groupId": "52528229",
                                          "variationId": "164203834"
                                        }
                                      ],
                                      "price": 27900,
                                      "finalPrice": {
                                        "units": "179"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 27900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "150146036",
                                "name": "Cheese n Corn Pizza - Regular",
                                "category": "Deal on Regular Pizza",
                                "description": "A delectable combination of sweet & juicy golden corn",
                                "imageId": "25f8cd12a914066c7c9627d42eafd926",
                                "inStock": 1,
                                "isVeg": 1,
                                "finalPrice": 17900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528184",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "164203759",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528185",
                                            "variationId": "164203760"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528185",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "164203760",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528184",
                                          "variationId": "164203759"
                                        },
                                        {
                                          "groupId": "52528185",
                                          "variationId": "164203760"
                                        }
                                      ],
                                      "price": 22900,
                                      "finalPrice": {
                                        "units": "179"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 22900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "152102026",
                                "name": "Fresh Veggie Pizza - Regular",
                                "category": "Deal on Regular Pizza",
                                "description": "Delectable combination of onion & capsicum, a veggie lovers pick",
                                "imageId": "d9c548f1cb841844f151ffa3de873e4b",
                                "inStock": 1,
                                "isVeg": 1,
                                "finalPrice": 17900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528220",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "164203819",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528221",
                                            "variationId": "164203820"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528221",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "164203820",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528220",
                                          "variationId": "164203819"
                                        },
                                        {
                                          "groupId": "52528221",
                                          "variationId": "164203820"
                                        }
                                      ],
                                      "price": 22900,
                                      "finalPrice": {
                                        "units": "179"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 22900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "150146043",
                                "name": "Fiery Sausage & Paprika - Regular",
                                "category": "Deal on Regular Pizza",
                                "description": "Spiciest non veg pizza with spicy & herby chicken sausage and red paprika toppings on a new spicy peri peri sauce base.",
                                "imageId": "2190eb54162d9a61e34e6970d53cbcc2",
                                "inStock": 1,
                                "finalPrice": 17900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528238",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "164203849",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528239",
                                            "variationId": "164203850"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528239",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "164203850",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528238",
                                          "variationId": "164203849"
                                        },
                                        {
                                          "groupId": "52528239",
                                          "variationId": "164203850"
                                        }
                                      ],
                                      "price": 25500,
                                      "finalPrice": {
                                        "units": "179"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 25500,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "150146044",
                                "name": "Pepper Barbecue Chicken Pizza - Regular",
                                "category": "Deal on Regular Pizza",
                                "description": "Pepper barbecue chicken for that extra zing. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                                "imageId": "7602a3d88b2aeb0053954d96be9a9829",
                                "inStock": 1,
                                "finalPrice": 17900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528242",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "164203856",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528243",
                                            "variationId": "164203857"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528243",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "164203857",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528242",
                                          "variationId": "164203856"
                                        },
                                        {
                                          "groupId": "52528243",
                                          "variationId": "164203857"
                                        }
                                      ],
                                      "price": 26900,
                                      "finalPrice": {
                                        "units": "179"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 26900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.7",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "150146035",
                                "name": "Blazing Chicken & Paprika - Regular",
                                "category": "Deal on Regular Pizza",
                                "description": "Hot & spicy chicken pizza with a combination of chicken keema & red paprika toppings and a new spicy peri peri sauce.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/8/2/381126cc-5ec8-4475-9e13-7100a1238287_f147bac1-9e8e-43fa-921d-3a8f3958c8e8.jpg",
                                "inStock": 1,
                                "finalPrice": 17900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528182",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "164203757",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528183",
                                            "variationId": "164203758"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528183",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "164203758",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528182",
                                          "variationId": "164203757"
                                        },
                                        {
                                          "groupId": "52528183",
                                          "variationId": "164203758"
                                        }
                                      ],
                                      "price": 25500,
                                      "finalPrice": {
                                        "units": "179"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 25500,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "152102025",
                                "name": "Chicken Sausage Pizza - Regular",
                                "category": "Deal on Regular Pizza",
                                "description": "American classic! Spicy, herbed chicken sausage on pizza",
                                "imageId": "5779285fbfb3c04730f0b71ba4132255",
                                "inStock": 1,
                                "finalPrice": 17900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528190",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "New Hand Tossed",
                                          "default": 1,
                                          "id": "164203768",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528191",
                                            "variationId": "164203769"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528191",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "164203769",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528190",
                                          "variationId": "164203768"
                                        },
                                        {
                                          "groupId": "52528191",
                                          "variationId": "164203769"
                                        }
                                      ],
                                      "price": 21900,
                                      "finalPrice": {
                                        "units": "179"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 21900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {
                          
                        }
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Deal on Cheesy Pizzas",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "150740121",
                                "name": "Farmhouse Pizza – Cheese Burst (Reg)",
                                "category": "Deal on Cheesy Pizzas",
                                "description": "Delightful combination of onion, capsicum, tomato & grilled mushroom. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                                "imageId": "96df50829eda0c0ffcc5169aeeb86a14",
                                "inStock": 1,
                                "isVeg": 1,
                                "finalPrice": 25900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528202",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "164203786",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528203",
                                            "variationId": "164203790"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "164203787",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528203",
                                            "variationId": "164203790"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "164203788",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528203",
                                            "variationId": "164203790"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "164203789",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528203",
                                            "variationId": "164203790"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528203",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "164203790",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528202",
                                          "variationId": "164203788"
                                        },
                                        {
                                          "groupId": "52528203",
                                          "variationId": "164203790"
                                        }
                                      ],
                                      "price": 35400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528202",
                                          "variationId": "164203789"
                                        },
                                        {
                                          "groupId": "52528203",
                                          "variationId": "164203790"
                                        }
                                      ],
                                      "price": 35400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528202",
                                          "variationId": "164203787"
                                        },
                                        {
                                          "groupId": "52528203",
                                          "variationId": "164203790"
                                        }
                                      ],
                                      "price": 35400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528202",
                                          "variationId": "164203786"
                                        },
                                        {
                                          "groupId": "52528203",
                                          "variationId": "164203790"
                                        }
                                      ],
                                      "price": 35400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 35400,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "150740117",
                                "name": "Peppy Paneer Pizza – Cheese Burst (Reg)",
                                "category": "Deal on Cheesy Pizzas",
                                "description": "Flavorful trio of juicy paneer, crisp capsicum with spicy red paprika",
                                "imageId": "0581f2e3b7d0b3ede4b476c1d64a6434",
                                "inStock": 1,
                                "isVeg": 1,
                                "finalPrice": 25900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528180",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "164203752",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528181",
                                            "variationId": "164203756"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "164203753",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528181",
                                            "variationId": "164203756"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "164203754",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528181",
                                            "variationId": "164203756"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "164203755",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528181",
                                            "variationId": "164203756"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528181",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "164203756",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528180",
                                          "variationId": "164203754"
                                        },
                                        {
                                          "groupId": "52528181",
                                          "variationId": "164203756"
                                        }
                                      ],
                                      "price": 35400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528180",
                                          "variationId": "164203755"
                                        },
                                        {
                                          "groupId": "52528181",
                                          "variationId": "164203756"
                                        }
                                      ],
                                      "price": 35400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528180",
                                          "variationId": "164203753"
                                        },
                                        {
                                          "groupId": "52528181",
                                          "variationId": "164203756"
                                        }
                                      ],
                                      "price": 35400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528180",
                                          "variationId": "164203752"
                                        },
                                        {
                                          "groupId": "52528181",
                                          "variationId": "164203756"
                                        }
                                      ],
                                      "price": 35400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 35400,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "150740122",
                                "name": "Indi Tandoori Paneer Pizza – Cheese Burst (Reg)",
                                "category": "Deal on Cheesy Pizzas",
                                "description": "It is hot. It is spicy. It is oh-so-Indian. Tandoori paneer with capsicum, red paprika & mint mayo. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                                "imageId": "010b29da595df93d828ca0dca935821a",
                                "inStock": 1,
                                "isVeg": 1,
                                "finalPrice": 25900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528206",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "164203793",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528207",
                                            "variationId": "164203797"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "164203794",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528207",
                                            "variationId": "164203797"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "164203795",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528207",
                                            "variationId": "164203797"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "164203796",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528207",
                                            "variationId": "164203797"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528207",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "164203797",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528206",
                                          "variationId": "164203795"
                                        },
                                        {
                                          "groupId": "52528207",
                                          "variationId": "164203797"
                                        }
                                      ],
                                      "price": 39400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528206",
                                          "variationId": "164203796"
                                        },
                                        {
                                          "groupId": "52528207",
                                          "variationId": "164203797"
                                        }
                                      ],
                                      "price": 39400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528206",
                                          "variationId": "164203794"
                                        },
                                        {
                                          "groupId": "52528207",
                                          "variationId": "164203797"
                                        }
                                      ],
                                      "price": 39400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528206",
                                          "variationId": "164203793"
                                        },
                                        {
                                          "groupId": "52528207",
                                          "variationId": "164203797"
                                        }
                                      ],
                                      "price": 39400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 39400,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "150740116",
                                "name": "Veg Extravaganza Pizza – Cheese Burst (Reg)",
                                "category": "Deal on Cheesy Pizzas",
                                "description": "Black olives, capsicum, onion, grilled mushroom, corn, tomato, jalapeno & extra cheese. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                                "imageId": "80355befb12f52c22eb75c6f865ca328",
                                "inStock": 1,
                                "isVeg": 1,
                                "finalPrice": 25900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528178",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "164203750",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528179",
                                            "variationId": "164203751"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528179",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "164203751",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528178",
                                          "variationId": "164203750"
                                        },
                                        {
                                          "groupId": "52528179",
                                          "variationId": "164203751"
                                        }
                                      ],
                                      "price": 39400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 39400,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "150740119",
                                "name": "Veggie Paradise Pizza – Cheese Burst (Reg)",
                                "category": "Deal on Cheesy Pizzas",
                                "description": "The awesome foursome! Golden corn, black olives, capsicum, red paprika",
                                "imageId": "2a8ea479040d62f82871e1be7470672a",
                                "inStock": 1,
                                "isVeg": 1,
                                "finalPrice": 25900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528192",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "164203770",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528193",
                                            "variationId": "164203774"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "164203771",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528193",
                                            "variationId": "164203774"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "164203772",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528193",
                                            "variationId": "164203774"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "164203773",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528193",
                                            "variationId": "164203774"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528193",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "164203774",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528192",
                                          "variationId": "164203772"
                                        },
                                        {
                                          "groupId": "52528193",
                                          "variationId": "164203774"
                                        }
                                      ],
                                      "price": 35400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528192",
                                          "variationId": "164203773"
                                        },
                                        {
                                          "groupId": "52528193",
                                          "variationId": "164203774"
                                        }
                                      ],
                                      "price": 35400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528192",
                                          "variationId": "164203771"
                                        },
                                        {
                                          "groupId": "52528193",
                                          "variationId": "164203774"
                                        }
                                      ],
                                      "price": 35400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528192",
                                          "variationId": "164203770"
                                        },
                                        {
                                          "groupId": "52528193",
                                          "variationId": "164203774"
                                        }
                                      ],
                                      "price": 35400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 35400,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "150740126",
                                "name": "Double Cheese Margherita Pizza – Cheese Burst (Reg)",
                                "category": "Deal on Cheesy Pizzas",
                                "description": "A classic delight loaded with extra 100% real mozzarella cheese",
                                "imageId": "15c3a34b64ec4298f2a0778d1b008919",
                                "inStock": 1,
                                "isVeg": 1,
                                "finalPrice": 25900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528222",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "164203821",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528223",
                                            "variationId": "164203825"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "164203822",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528223",
                                            "variationId": "164203825"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "164203823",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528223",
                                            "variationId": "164203825"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "164203824",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528223",
                                            "variationId": "164203825"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528223",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "164203825",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528222",
                                          "variationId": "164203823"
                                        },
                                        {
                                          "groupId": "52528223",
                                          "variationId": "164203825"
                                        }
                                      ],
                                      "price": 30400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528222",
                                          "variationId": "164203824"
                                        },
                                        {
                                          "groupId": "52528223",
                                          "variationId": "164203825"
                                        }
                                      ],
                                      "price": 30400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528222",
                                          "variationId": "164203822"
                                        },
                                        {
                                          "groupId": "52528223",
                                          "variationId": "164203825"
                                        }
                                      ],
                                      "price": 30400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528222",
                                          "variationId": "164203821"
                                        },
                                        {
                                          "groupId": "52528223",
                                          "variationId": "164203825"
                                        }
                                      ],
                                      "price": 30400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 30400,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "150740127",
                                "name": "Cheese n Corn Pizza – Cheese Burst (Reg)",
                                "category": "Deal on Cheesy Pizzas",
                                "description": "A delectable combination of sweet & juicy golden corn",
                                "imageId": "25f8cd12a914066c7c9627d42eafd926",
                                "inStock": 1,
                                "isVeg": 1,
                                "finalPrice": 25900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528224",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "164203826",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528225",
                                            "variationId": "164203830"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "164203827",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528225",
                                            "variationId": "164203830"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "164203828",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528225",
                                            "variationId": "164203830"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "164203829",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528225",
                                            "variationId": "164203830"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528225",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "164203830",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528224",
                                          "variationId": "164203828"
                                        },
                                        {
                                          "groupId": "52528225",
                                          "variationId": "164203830"
                                        }
                                      ],
                                      "price": 30400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528224",
                                          "variationId": "164203829"
                                        },
                                        {
                                          "groupId": "52528225",
                                          "variationId": "164203830"
                                        }
                                      ],
                                      "price": 30400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528224",
                                          "variationId": "164203827"
                                        },
                                        {
                                          "groupId": "52528225",
                                          "variationId": "164203830"
                                        }
                                      ],
                                      "price": 30400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528224",
                                          "variationId": "164203826"
                                        },
                                        {
                                          "groupId": "52528225",
                                          "variationId": "164203830"
                                        }
                                      ],
                                      "price": 30400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 30400,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "150740130",
                                "name": "Pepper Barbecue Chicken Pizza – Cheese Burst (Reg)",
                                "category": "Deal on Cheesy Pizzas",
                                "description": "Pepper barbecue chicken for that extra zing. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                                "imageId": "7602a3d88b2aeb0053954d96be9a9829",
                                "inStock": 1,
                                "finalPrice": 25900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528236",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "164203844",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528237",
                                            "variationId": "164203848"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "164203845",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528237",
                                            "variationId": "164203848"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "164203846",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528237",
                                            "variationId": "164203848"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "164203847",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528237",
                                            "variationId": "164203848"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528237",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "164203848",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528236",
                                          "variationId": "164203846"
                                        },
                                        {
                                          "groupId": "52528237",
                                          "variationId": "164203848"
                                        }
                                      ],
                                      "price": 34400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528236",
                                          "variationId": "164203847"
                                        },
                                        {
                                          "groupId": "52528237",
                                          "variationId": "164203848"
                                        }
                                      ],
                                      "price": 34400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528236",
                                          "variationId": "164203845"
                                        },
                                        {
                                          "groupId": "52528237",
                                          "variationId": "164203848"
                                        }
                                      ],
                                      "price": 34400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528236",
                                          "variationId": "164203844"
                                        },
                                        {
                                          "groupId": "52528237",
                                          "variationId": "164203848"
                                        }
                                      ],
                                      "price": 34400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 34400,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "150740123",
                                "name": "Mexican Green Wave Pizza – Cheese Burst (Reg)",
                                "category": "Deal on Cheesy Pizzas",
                                "description": "Mexican herbs sprinkled on onion, capsicum, tomato & jalapeno",
                                "imageId": "0d1949eef23c572096269d890e438efb",
                                "inStock": 1,
                                "isVeg": 1,
                                "finalPrice": 25900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528208",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "164203798",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528209",
                                            "variationId": "164203802"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "164203799",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528209",
                                            "variationId": "164203802"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "164203800",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528209",
                                            "variationId": "164203802"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "164203801",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528209",
                                            "variationId": "164203802"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528209",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "164203802",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528208",
                                          "variationId": "164203800"
                                        },
                                        {
                                          "groupId": "52528209",
                                          "variationId": "164203802"
                                        }
                                      ],
                                      "price": 35400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528208",
                                          "variationId": "164203801"
                                        },
                                        {
                                          "groupId": "52528209",
                                          "variationId": "164203802"
                                        }
                                      ],
                                      "price": 35400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528208",
                                          "variationId": "164203799"
                                        },
                                        {
                                          "groupId": "52528209",
                                          "variationId": "164203802"
                                        }
                                      ],
                                      "price": 35400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528208",
                                          "variationId": "164203798"
                                        },
                                        {
                                          "groupId": "52528209",
                                          "variationId": "164203802"
                                        }
                                      ],
                                      "price": 35400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 35400,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "150740120",
                                "name": "Fiery Sausage & Paprika – Cheese Burst (Reg)",
                                "category": "Deal on Cheesy Pizzas",
                                "description": "Spiciest non veg pizza with spicy & herby chicken sausage and red paprika toppings on a new spicy peri peri sauce base.",
                                "imageId": "2190eb54162d9a61e34e6970d53cbcc2",
                                "inStock": 1,
                                "finalPrice": 25900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528200",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "164203781",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528201",
                                            "variationId": "164203785"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "164203782",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528201",
                                            "variationId": "164203785"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "164203783",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528201",
                                            "variationId": "164203785"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "164203784",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528201",
                                            "variationId": "164203785"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528201",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "164203785",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528200",
                                          "variationId": "164203783"
                                        },
                                        {
                                          "groupId": "52528201",
                                          "variationId": "164203785"
                                        }
                                      ],
                                      "price": 33000,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528200",
                                          "variationId": "164203784"
                                        },
                                        {
                                          "groupId": "52528201",
                                          "variationId": "164203785"
                                        }
                                      ],
                                      "price": 33000,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528200",
                                          "variationId": "164203782"
                                        },
                                        {
                                          "groupId": "52528201",
                                          "variationId": "164203785"
                                        }
                                      ],
                                      "price": 33000,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528200",
                                          "variationId": "164203781"
                                        },
                                        {
                                          "groupId": "52528201",
                                          "variationId": "164203785"
                                        }
                                      ],
                                      "price": 33000,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 33000,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "150740118",
                                "name": "Blazing Chicken & Paprika – Cheese Burst (Reg)",
                                "category": "Deal on Cheesy Pizzas",
                                "description": "Hot & spicy chicken pizza with a combination of chicken keema & red paprika toppings and a new spicy peri peri sauce.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/8/2/381126cc-5ec8-4475-9e13-7100a1238287_f147bac1-9e8e-43fa-921d-3a8f3958c8e8.jpg",
                                "inStock": 1,
                                "finalPrice": 25900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528188",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "164203763",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528189",
                                            "variationId": "164203767"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "164203764",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528189",
                                            "variationId": "164203767"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "164203765",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528189",
                                            "variationId": "164203767"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "164203766",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528189",
                                            "variationId": "164203767"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528189",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "164203767",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528188",
                                          "variationId": "164203765"
                                        },
                                        {
                                          "groupId": "52528189",
                                          "variationId": "164203767"
                                        }
                                      ],
                                      "price": 33000,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528188",
                                          "variationId": "164203766"
                                        },
                                        {
                                          "groupId": "52528189",
                                          "variationId": "164203767"
                                        }
                                      ],
                                      "price": 33000,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528188",
                                          "variationId": "164203764"
                                        },
                                        {
                                          "groupId": "52528189",
                                          "variationId": "164203767"
                                        }
                                      ],
                                      "price": 33000,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528188",
                                          "variationId": "164203763"
                                        },
                                        {
                                          "groupId": "52528189",
                                          "variationId": "164203767"
                                        }
                                      ],
                                      "price": 33000,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 33000,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "150740131",
                                "name": "Chicken Fiesta Pizza – Cheese Burst (Reg)",
                                "category": "Deal on Cheesy Pizzas",
                                "description": "Grilled chicken rashers, peri-peri chicken, onion & capsicum, a complete fiesta",
                                "imageId": "274348f5f584d2893c654f7880c3eacb",
                                "inStock": 1,
                                "finalPrice": 25900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528240",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "164203851",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528241",
                                            "variationId": "164203855"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "164203852",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528241",
                                            "variationId": "164203855"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "164203853",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528241",
                                            "variationId": "164203855"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "164203854",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528241",
                                            "variationId": "164203855"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528241",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "164203855",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528240",
                                          "variationId": "164203853"
                                        },
                                        {
                                          "groupId": "52528241",
                                          "variationId": "164203855"
                                        }
                                      ],
                                      "price": 40400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528240",
                                          "variationId": "164203854"
                                        },
                                        {
                                          "groupId": "52528241",
                                          "variationId": "164203855"
                                        }
                                      ],
                                      "price": 40400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528240",
                                          "variationId": "164203852"
                                        },
                                        {
                                          "groupId": "52528241",
                                          "variationId": "164203855"
                                        }
                                      ],
                                      "price": 40400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528240",
                                          "variationId": "164203851"
                                        },
                                        {
                                          "groupId": "52528241",
                                          "variationId": "164203855"
                                        }
                                      ],
                                      "price": 40400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 40400,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "150740128",
                                "name": "Chicken Golden Delight – Cheese Burst (Reg)",
                                "category": "Deal on Cheesy Pizzas",
                                "description": "Double pepper barbecue chicken, golden corn and extra cheese, true delight",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/27/3d22946c-ef95-495c-bedf-658566549a56_e29b66d9-60a0-4a1e-abe3-bec70737fab1.jpg",
                                "inStock": 1,
                                "finalPrice": 25900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528230",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "164203835",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528231",
                                            "variationId": "164203839"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "164203836",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528231",
                                            "variationId": "164203839"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "164203837",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528231",
                                            "variationId": "164203839"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "164203838",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528231",
                                            "variationId": "164203839"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528231",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "164203839",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528230",
                                          "variationId": "164203837"
                                        },
                                        {
                                          "groupId": "52528231",
                                          "variationId": "164203839"
                                        }
                                      ],
                                      "price": 40400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528230",
                                          "variationId": "164203838"
                                        },
                                        {
                                          "groupId": "52528231",
                                          "variationId": "164203839"
                                        }
                                      ],
                                      "price": 40400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528230",
                                          "variationId": "164203836"
                                        },
                                        {
                                          "groupId": "52528231",
                                          "variationId": "164203839"
                                        }
                                      ],
                                      "price": 40400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528230",
                                          "variationId": "164203835"
                                        },
                                        {
                                          "groupId": "52528231",
                                          "variationId": "164203839"
                                        }
                                      ],
                                      "price": 40400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 40400,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "150740124",
                                "name": "Fresh Veggie Pizza – Cheese Burst (Reg)",
                                "category": "Deal on Cheesy Pizzas",
                                "description": "Delectable combination of onion & capsicum, a veggie lovers pick",
                                "imageId": "d9c548f1cb841844f151ffa3de873e4b",
                                "inStock": 1,
                                "isVeg": 1,
                                "finalPrice": 25900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528210",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "164203803",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528211",
                                            "variationId": "164203807"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "164203804",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528211",
                                            "variationId": "164203807"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "164203805",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528211",
                                            "variationId": "164203807"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "164203806",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528211",
                                            "variationId": "164203807"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528211",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "164203807",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528210",
                                          "variationId": "164203805"
                                        },
                                        {
                                          "groupId": "52528211",
                                          "variationId": "164203807"
                                        }
                                      ],
                                      "price": 30400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528210",
                                          "variationId": "164203806"
                                        },
                                        {
                                          "groupId": "52528211",
                                          "variationId": "164203807"
                                        }
                                      ],
                                      "price": 30400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528210",
                                          "variationId": "164203804"
                                        },
                                        {
                                          "groupId": "52528211",
                                          "variationId": "164203807"
                                        }
                                      ],
                                      "price": 30400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528210",
                                          "variationId": "164203803"
                                        },
                                        {
                                          "groupId": "52528211",
                                          "variationId": "164203807"
                                        }
                                      ],
                                      "price": 30400,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 30400,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "150740125",
                                "name": "Spiced Double Chicken – Cheese Burst (Reg)",
                                "category": "Deal on Cheesy Pizzas",
                                "description": "Delightful combination of our spicy duo- Pepper Barbecue Chicken and Peri Peri Chicken for Chicken Lovers.",
                                "imageId": "613401a1232b2bd8ba3c5ecb6173dc38",
                                "inStock": 1,
                                "finalPrice": 25900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528212",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Cheese Burst",
                                          "default": 1,
                                          "id": "164203808",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528213",
                                            "variationId": "164203812"
                                          }
                                        },
                                        {
                                          "name": "Korean Sweet Chilli Cheese Burst",
                                          "id": "164203809",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528213",
                                            "variationId": "164203812"
                                          }
                                        },
                                        {
                                          "name": "Hot n Fiery Cheese Burst",
                                          "id": "164203810",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528213",
                                            "variationId": "164203812"
                                          }
                                        },
                                        {
                                          "name": "Creamy Makhani Cheese Burst",
                                          "id": "164203811",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528213",
                                            "variationId": "164203812"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528213",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular",
                                          "default": 1,
                                          "id": "164203812",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528212",
                                          "variationId": "164203810"
                                        },
                                        {
                                          "groupId": "52528213",
                                          "variationId": "164203812"
                                        }
                                      ],
                                      "price": 39000,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528212",
                                          "variationId": "164203811"
                                        },
                                        {
                                          "groupId": "52528213",
                                          "variationId": "164203812"
                                        }
                                      ],
                                      "price": 39000,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528212",
                                          "variationId": "164203809"
                                        },
                                        {
                                          "groupId": "52528213",
                                          "variationId": "164203812"
                                        }
                                      ],
                                      "price": 39000,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528212",
                                          "variationId": "164203808"
                                        },
                                        {
                                          "groupId": "52528213",
                                          "variationId": "164203812"
                                        }
                                      ],
                                      "price": 39000,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 39000,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "158463013",
                                "name": "Cheese Volcano Farmhouse (Reg Plus)",
                                "category": "Deal on Cheesy Pizzas",
                                "description": "Centre loaded with Molten Cheese & topped with Onion, Capsicum, Tomato & Grilled Mushroom\n*Contains non-edible container under the Pizza",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/4e30b1ff-dbe8-41d3-b083-d46b9d742ffc_636d161e-7f34-4371-b63c-bf9e3d091a0f.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "finalPrice": 25900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528196",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Cheese Volcano Crust",
                                          "default": 1,
                                          "id": "164203777",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528197",
                                            "variationId": "164203778"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528197",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular Plus",
                                          "default": 1,
                                          "id": "164203778",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528196",
                                          "variationId": "164203777"
                                        },
                                        {
                                          "groupId": "52528197",
                                          "variationId": "164203778"
                                        }
                                      ],
                                      "price": 31900,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 31900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "158463018",
                                "name": "Cheese Volcano Peppy Paneer (Reg Plus)",
                                "category": "Deal on Cheesy Pizzas",
                                "description": "Centre loaded with Molten Cheese & topped with peppy Paneer, Capsicum & Red Paprika\n*Contains non-edible container under the Pizza",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/3ab84285-8164-4447-b534-f371913491c6_f91a0f02-a155-4a2a-8567-ae9d56ec5b2b.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "finalPrice": 25900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528234",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Cheese Volcano Crust",
                                          "default": 1,
                                          "id": "164203842",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528235",
                                            "variationId": "164203843"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528235",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular Plus",
                                          "default": 1,
                                          "id": "164203843",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528234",
                                          "variationId": "164203842"
                                        },
                                        {
                                          "groupId": "52528235",
                                          "variationId": "164203843"
                                        }
                                      ],
                                      "price": 31900,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 31900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "158463011",
                                "name": "Cheese Volcano Veg Paradise (Reg Plus)",
                                "category": "Deal on Cheesy Pizzas",
                                "description": "Centre loaded with Molten Cheese & topped with Golden Corn, Black Olives, Capsicum & Red Paprika\n*Contains non-edible container under the Pizza",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/3e08f33d-98b7-41d2-acca-182da98e80f4_dd0b2e67-2a47-4a5e-b906-63e1277e7fa2.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "finalPrice": 25900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528176",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Cheese Volcano Crust",
                                          "default": 1,
                                          "id": "164203748",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528177",
                                            "variationId": "164203749"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528177",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular Plus",
                                          "default": 1,
                                          "id": "164203749",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528176",
                                          "variationId": "164203748"
                                        },
                                        {
                                          "groupId": "52528177",
                                          "variationId": "164203749"
                                        }
                                      ],
                                      "price": 31900,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 31900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "158463012",
                                "name": "Corn & Cheese Volcano (Reg Plus)",
                                "category": "Deal on Cheesy Pizzas",
                                "description": "Centre loaded with Molten Cheese & topped with juicy Golden Corn\n*Contains non-edible container under the Pizza",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/375ae4df-de00-4235-97c5-3de32ebd969c_c7ea4a4e-86a9-467b-a42d-13e058670d28.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "finalPrice": 25900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528186",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Cheese Volcano Crust",
                                          "default": 1,
                                          "id": "164203761",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528187",
                                            "variationId": "164203762"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528187",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular Plus",
                                          "default": 1,
                                          "id": "164203762",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528186",
                                          "variationId": "164203761"
                                        },
                                        {
                                          "groupId": "52528187",
                                          "variationId": "164203762"
                                        }
                                      ],
                                      "price": 31900,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 31900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "158463017",
                                "name": "Cheese Volcano BBQ Chicken (Reg Plus)",
                                "category": "Deal on Cheesy Pizzas",
                                "description": "Centre loaded with Molten Cheese & topped with Pepper BBQ Chicken\n*Contains non-edible container under the Pizza",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/bb8bf7b5-d084-4690-893e-ea5af460ad5d_fd69db19-9923-4ab7-936c-e2b1300a9b25.jpg",
                                "inStock": 1,
                                "finalPrice": 25900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528226",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Cheese Volcano Crust",
                                          "default": 1,
                                          "id": "164203831",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528227",
                                            "variationId": "164203832"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528227",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular Plus",
                                          "default": 1,
                                          "id": "164203832",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528226",
                                          "variationId": "164203831"
                                        },
                                        {
                                          "groupId": "52528227",
                                          "variationId": "164203832"
                                        }
                                      ],
                                      "price": 36900,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 36900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "158463014",
                                "name": "Cheese Volcano Double Chicken (Reg Plus)",
                                "category": "Deal on Cheesy Pizzas",
                                "description": "Centre loaded with Molten Cheese & topped with Pepper BBQ Chicken & Peri Peri Chicken.\n*Contains non-edible container under the Pizza",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/a842381d-5d56-4a1e-99b8-4594170ae2c1_6d79c2a4-5aec-4067-acea-0afdfd875830.jpg",
                                "inStock": 1,
                                "finalPrice": 25900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528214",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Cheese Volcano Crust",
                                          "default": 1,
                                          "id": "164203813",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528215",
                                            "variationId": "164203814"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528215",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular Plus",
                                          "default": 1,
                                          "id": "164203814",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528214",
                                          "variationId": "164203813"
                                        },
                                        {
                                          "groupId": "52528215",
                                          "variationId": "164203814"
                                        }
                                      ],
                                      "price": 36900,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 36900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "158463015",
                                "name": "Cheese Volcano Blazing Chicken (Reg Plus)",
                                "category": "Deal on Cheesy Pizzas",
                                "description": "Centre loaded with Molten Cheese & topped with Chicken Keema & Red Paprika with our spicy Peri Peri Sauce\n*Contains non-edible container under the Pizza",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/e0d6d213-d5ac-45a7-b53f-d6c836d53659_33957602-94cc-4a32-9a21-6b65d35815fc.jpg",
                                "inStock": 1,
                                "finalPrice": 25900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528216",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Cheese Volcano Crust",
                                          "default": 1,
                                          "id": "164203815",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528217",
                                            "variationId": "164203816"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528217",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular Plus",
                                          "default": 1,
                                          "id": "164203816",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528216",
                                          "variationId": "164203815"
                                        },
                                        {
                                          "groupId": "52528217",
                                          "variationId": "164203816"
                                        }
                                      ],
                                      "price": 36900,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 36900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "158463016",
                                "name": "Cheese Volcano Chicken Delight (Reg Plus)",
                                "category": "Deal on Cheesy Pizzas",
                                "description": "Centre loaded with Molten Cheese & topped with Pepper BBQ Chicken & Golden Corn\n*Contains non-edible container under the Pizza",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/4/ec91a814-b0f9-4911-b972-3c2a3583c684_d8de24fd-5109-4870-bf74-66f9ebb4ace5.jpg",
                                "inStock": 1,
                                "finalPrice": 25900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "52528218",
                                      "name": "Crust",
                                      "variations": [
                                        {
                                          "name": "Cheese Volcano Crust",
                                          "default": 1,
                                          "id": "164203817",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "52528219",
                                            "variationId": "164203818"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "52528219",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Regular Plus",
                                          "default": 1,
                                          "id": "164203818",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "52528218",
                                          "variationId": "164203817"
                                        },
                                        {
                                          "groupId": "52528219",
                                          "variationId": "164203818"
                                        }
                                      ],
                                      "price": 36900,
                                      "finalPrice": {
                                        "units": "259"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 36900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {
                          
                        }
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Lunch Feast @149",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "156696940",
                                "name": "5 Course Meal: Classic Pizza",
                                "category": "Lunch Feast @149",
                                "description": "Pizza Mania Classic + Creamy Tomato Meltz + Crispy Veggie Bites + Choco Bomb + Pepsi (295ml)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/21/ab698d6c-bb29-4c9f-b133-b7e464057e21_1fa409ff-2851-4b24-9809-6657fe6a769d.jpg",
                                "isVeg": 1,
                                "price": 14900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "nextAvailableAtMessage": "Next available at 11 am, tomorrow",
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "156696937",
                                "name": "5 Course Meal: Onion Pizza",
                                "category": "Lunch Feast @149",
                                "description": "Pizza Mania Onion + Creamy Tomato Meltz + Crispy Veggie Bites + Choco Bomb + Pepsi (295ml)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/21/8fd5b172-dc3e-425a-91e1-226b1fb8d850_5588d22d-7578-47e2-a185-0a4aa4a7f71a.jpg",
                                "isVeg": 1,
                                "price": 14900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "nextAvailableAtMessage": "Next available at 11 am, tomorrow",
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "156696939",
                                "name": "5 Course Meal: Golden Corn Pizza",
                                "category": "Lunch Feast @149",
                                "description": "Pizza Mania Golden Corn + Creamy Tomato Meltz + Crispy Veggie Bites + Choco Bomb + Pepsi (295ml)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/21/d930050d-9544-4079-a296-8a28e7ed4ce8_a2cf77de-7aa5-4186-b79a-e32fbaa535cb.jpg",
                                "isVeg": 1,
                                "price": 14900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "nextAvailableAtMessage": "Next available at 11 am, tomorrow",
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "156696938",
                                "name": "5 Course Meal: Sausage Pizza",
                                "category": "Lunch Feast @149",
                                "description": "Pizza Mania Chicken Sausage + Creamy Tomato Meltz + Crispy Veggie Bites + Choco Bomb + Pepsi (295ml)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/21/4ef6d858-1925-458d-99f8-cbcbdf5f8b3c_edc0bec2-9f5a-4004-a90c-c302d5d3d69f.jpg",
                                "price": 14900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "nextAvailableAtMessage": "Next available at 11 am, tomorrow",
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "156696936",
                                "name": "5 Course Meal: Pepper BBQ Pizza",
                                "category": "Lunch Feast @149",
                                "description": "Pizza Mania Pepper Barbecue Chicken + Creamy Tomato Meltz + Crispy Veggie Bites + Choco Bomb + Pepsi (295ml)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/21/1e1bee49-56e3-4a2a-9deb-05da97b5aec3_1486d080-e316-42fa-8111-11092580fd19.jpg",
                                "price": 14900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "nextAvailableAtMessage": "Next available at 11 am, tomorrow",
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                },
                                "itemPriceStrikeOff": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {
                          
                        }
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                        "type": "FSSAI",
                        "imageId": "fssai_final_edss9i",
                        "text": [
                          "License No. 12022033000199"
                        ]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                        "name": "Domino's Pizza",
                        "area": "Saheed Nagar",
                        "completeAddress": "First Floor, PAL Heights, J/7, Jayadev Vihar,Bhubaneswar 751013, Odisha"
                      }
                    }
                  }
                ]
              }
            }
          }
        }
      ],
      "firstOffsetRequest": true,
      "isQCLink": false
    },
    "tid": "bab4715f-39ae-42e7-b52d-6bd9deddb0b1",
    "sid": "hzye31f9-2cea-4491-9146-60fc1133aaa7",
    "deviceId": "aeaa645f-e1be-73a6-e16e-df98125d9e85",
    "csrfToken": "fZlh9fWJT130-RVraGBPhvpoU5a6xDBQK1Y6BDhM"
  }

]


export default menu;